import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link, NavLink } from 'react-router-dom';
import 'moment/locale/fr';
import moment from 'moment';

var black = '#000';
var white = '#fff';
var orange1 = '#ff7900';
var orange2 = '#f16e00';
var functionalGreen = '#32c832';
var functionalRed = '#cd3c14';
var functionalBlue = '#527edb';
var functionalYellow = '#ffcc00';
var supportingBlue = '#4bb4e6';
var supportingLavender = '#a885d8';
var supportingEmerald = '#50be87';
var supportingGold = '#ffd200';
var supportingCandy = '#ffb4e6';
var supportingDarkerBlue = '#085ebd';
var supportingDarkerLavender = '#492191';
var supportingDarkerEmerald = '#0a6e31';
var supportingDarkerGold = '#ffb400';
var supportingDarkerCandy = '#ff8ad4';
var supportingLighterBlue = '#b5e8f7';
var supportingLighterLavender = '#d9c2f0';
var supportingLighterEmerald = '#b8ebd6';
var supportingLighterGold = '#fff6b6';
var supportingLighterCandy = '#ffe8f7';
var grey1 = '#333';
var grey2 = '#666';
var grey3 = '#999';
var grey4 = '#ccc';
var grey5 = '#ddd';
var grey6 = '#eee';
var obsGrey = '#595959';
var seeThroughRed = 'rgba(255, 0, 0, 0.1)';
var seeThroughBlue = 'rgba(0, 0, 255, 0.1)';
var seeThroughGreen = 'rgba(0, 255, 0, 0.1)';
var seeThroughYellow = 'rgba(255, 255, 0, 0.1)';

var colors = /*#__PURE__*/Object.freeze({
	__proto__: null,
	black: black,
	white: white,
	orange1: orange1,
	orange2: orange2,
	functionalGreen: functionalGreen,
	functionalRed: functionalRed,
	functionalBlue: functionalBlue,
	functionalYellow: functionalYellow,
	supportingBlue: supportingBlue,
	supportingLavender: supportingLavender,
	supportingEmerald: supportingEmerald,
	supportingGold: supportingGold,
	supportingCandy: supportingCandy,
	supportingDarkerBlue: supportingDarkerBlue,
	supportingDarkerLavender: supportingDarkerLavender,
	supportingDarkerEmerald: supportingDarkerEmerald,
	supportingDarkerGold: supportingDarkerGold,
	supportingDarkerCandy: supportingDarkerCandy,
	supportingLighterBlue: supportingLighterBlue,
	supportingLighterLavender: supportingLighterLavender,
	supportingLighterEmerald: supportingLighterEmerald,
	supportingLighterGold: supportingLighterGold,
	supportingLighterCandy: supportingLighterCandy,
	grey1: grey1,
	grey2: grey2,
	grey3: grey3,
	grey4: grey4,
	grey5: grey5,
	grey6: grey6,
	obsGrey: obsGrey,
	seeThroughRed: seeThroughRed,
	seeThroughBlue: seeThroughBlue,
	seeThroughGreen: seeThroughGreen,
	seeThroughYellow: seeThroughYellow
});

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var descriptors = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasOwnProperty = {}.hasOwnProperty;

var has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
var f$1 = descriptors ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$1
};

var anObject = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
var f$2 = descriptors ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f$2
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var setGlobal = function (key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});

var sharedStore = store;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof sharedStore.inspectSource != 'function') {
  sharedStore.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap = global_1.WeakMap;

var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));

var shared = createCommonjsModule(function (module) {
(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.4',
  mode:  'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var postfix = Math.random();

var uid = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var WeakMap$1 = global_1.WeakMap;
var set, get, has$1;

var enforce = function (it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (nativeWeakMap) {
  var store$1 = new WeakMap$1();
  var wmget = store$1.get;
  var wmhas = store$1.has;
  var wmset = store$1.set;
  set = function (it, metadata) {
    wmset.call(store$1, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store$1, it) || {};
  };
  has$1 = function (it) {
    return wmhas.call(store$1, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return has(it, STATE) ? it[STATE] : {};
  };
  has$1 = function (it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var redefine = createCommonjsModule(function (module) {
var getInternalState = internalState.get;
var enforceInternalState = internalState.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global_1) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});
});

var path = global_1;

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace])
    : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;


var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
	f: f$3
};

var f$4 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$4
};

// all object keys, includes non-enumerable and symbols
var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};

var aFunction$1 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
var functionBind = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction$1(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};

// `Function.prototype.bind` method
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
_export({ target: 'Function', proto: true }, {
  bind: functionBind
});

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
_export({ target: 'Object', stat: true, forced: !descriptors, sham: !descriptors }, {
  defineProperty: objectDefineProperty.f
});

var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

var slice$1 = [].slice;
var MSIE = /MSIE .\./.test(engineUserAgent); // <- dirty ie9- check

var wrap = function (scheduler) {
  return function (handler, timeout /* , ...arguments */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice$1.call(arguments, 2) : undefined;
    return scheduler(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof handler == 'function' ? handler : Function(handler)).apply(this, args);
    } : handler, timeout);
  };
};

// ie9- setTimeout & setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
_export({ global: true, bind: true, forced: MSIE }, {
  // `setTimeout` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
  setTimeout: wrap(global_1.setTimeout),
  // `setInterval` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
  setInterval: wrap(global_1.setInterval)
});

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
var isArray = Array.isArray || function isArray(arg) {
  return classofRaw(arg) == 'Array';
};

var createProperty = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var useSymbolAsUid = nativeSymbol
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (nativeSymbol && has(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var process = global_1.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

var SPECIES = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

var arrayMethodUsesToLength = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !descriptors) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES$1 = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max$1 = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES$1];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max$1(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);
  return O;
};

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
_export({ target: 'Object', stat: true, forced: !descriptors, sham: !descriptors }, {
  defineProperties: objectDefineProperties
});

var freezing = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});

var internalMetadata = createCommonjsModule(function (module) {
var defineProperty = objectDefineProperty.f;



var METADATA = uid('meta');
var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (freezing && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;
});
var internalMetadata_1 = internalMetadata.REQUIRED;
var internalMetadata_2 = internalMetadata.fastKey;
var internalMetadata_3 = internalMetadata.getWeakData;
var internalMetadata_4 = internalMetadata.onFreeze;

var onFreeze = internalMetadata.onFreeze;

var nativeFreeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { nativeFreeze(1); });

// `Object.freeze` method
// https://tc39.github.io/ecma262/#sec-object.freeze
_export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !freezing }, {
  freeze: function freeze(it) {
    return nativeFreeze && isObject(it) ? nativeFreeze(onFreeze(it)) : it;
  }
});

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var html = getBuiltIn('document', 'documentElement');

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties(result, Properties);
};

var nativeGetOwnPropertyNames = objectGetOwnPropertyNames.f;

var toString$1 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var f$5 = function getOwnPropertyNames(it) {
  return windowNames && toString$1.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};

var objectGetOwnPropertyNamesExternal = {
	f: f$5
};

var f$6 = wellKnownSymbol;

var wellKnownSymbolWrapped = {
	f: f$6
};

var defineProperty$1 = objectDefineProperty.f;

var defineWellKnownSymbol = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty$1(Symbol, NAME, {
    value: wellKnownSymbolWrapped.f(NAME)
  });
};

var defineProperty$2 = objectDefineProperty.f;



var TO_STRING_TAG = wellKnownSymbol('toStringTag');

var setToStringTag = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty$2(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var SPECIES$2 = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES$2];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6)
};

var $forEach = arrayIteration.forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE$1 = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = internalState.set;
var getInternalState = internalState.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE$1];
var $Symbol = global_1.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var nativeDefineProperty$1 = objectDefineProperty.f;
var nativeGetOwnPropertyNames$1 = objectGetOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable$1 = objectPropertyIsEnumerable.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore$1 = shared('wks');
var QObject = global_1.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = descriptors && fails(function () {
  return objectCreate(nativeDefineProperty$1({}, 'a', {
    get: function () { return nativeDefineProperty$1(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$1(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty$1(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty$1(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty$1;

var wrap$1 = function (tag, description) {
  var symbol = AllSymbols[tag] = objectCreate($Symbol[PROTOTYPE$1]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!descriptors) symbol.description = description;
  return symbol;
};

var isSymbol = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty$1(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = objectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty$1(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!descriptors || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? objectCreate(O) : $defineProperties(objectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable$1.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor$1(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames$1(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames$1(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!nativeSymbol) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (descriptors && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap$1(tag, description);
  };

  redefine($Symbol[PROTOTYPE$1], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap$1(uid(description), description);
  });

  objectPropertyIsEnumerable.f = $propertyIsEnumerable;
  objectDefineProperty.f = $defineProperty;
  objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor;
  objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  objectGetOwnPropertySymbols.f = $getOwnPropertySymbols;

  wellKnownSymbolWrapped.f = function (name) {
    return wrap$1(wellKnownSymbol(name), name);
  };

  if (descriptors) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty$1($Symbol[PROTOTYPE$1], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

_export({ global: true, wrap: true, forced: !nativeSymbol, sham: !nativeSymbol }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore$1), function (name) {
  defineWellKnownSymbol(name);
});

_export({ target: SYMBOL, stat: true, forced: !nativeSymbol }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

_export({ target: 'Object', stat: true, forced: !nativeSymbol, sham: !descriptors }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

_export({ target: 'Object', stat: true, forced: !nativeSymbol }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
_export({ target: 'Object', stat: true, forced: fails(function () { objectGetOwnPropertySymbols.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return objectGetOwnPropertySymbols.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !nativeSymbol || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  _export({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE$1][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE$1], TO_PRIMITIVE, $Symbol[PROTOTYPE$1].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
_export({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  objectDefineProperty.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $find = arrayIteration.find;



var FIND = 'find';
var SKIPS_HOLES = true;

var USES_TO_LENGTH$1 = arrayMethodUsesToLength(FIND);

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH$1 }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $indexOf = arrayIncludes.indexOf;



var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');
var USES_TO_LENGTH$2 = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
_export({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH$2 }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var nativeJoin = [].join;

var ES3_STRINGS = indexedObject != Object;
var STRICT_METHOD$1 = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.github.io/ecma262/#sec-array.prototype.join
_export({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD$1 }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});

var $map = arrayIteration.map;



var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH$3 = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 || !USES_TO_LENGTH$3 }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var defineProperty$3 = objectDefineProperty.f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (descriptors && !(NAME in FunctionPrototype)) {
  defineProperty$3(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}

var nativeAssign = Object.assign;
var defineProperty$4 = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
var objectAssign = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors && nativeAssign({ b: 1 }, nativeAssign(defineProperty$4({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$4(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;
  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!descriptors || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
_export({ target: 'Object', stat: true, forced: Object.assign !== objectAssign }, {
  assign: objectAssign
});

var FAILS_ON_PRIMITIVES$1 = fails(function () { objectKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
_export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$1 }, {
  keys: function keys(it) {
    return objectKeys(toObject(it));
  }
});

var icons = [
	{
		name: "pack",
		paths: [
			"M1024 83.177l-0.032-0.032-2.593 728.341-563.77-1.958c-44.443-0.196-80.327-36.529-80.184-81.186l2.593-728.341 563.77 1.975c43.942 0.146 79.508 37.259 80.216 81.202zM941.754 568.462l1.224-343.923c0.112-32.263-24.916-58.976-56.973-60.808v-0.146l-426.098-1.473-1.24 347.985h0.145c1.994 31.915 28.29 56.801 60.114 56.892h0.805l220.676 0.761 120.389 121.811 0.419-121.39 80.539 0.291zM459.070 848.243h330.208l-407.268 169.606c-19.71 8.205-41.858 8.201-61.565-0.011s-35.358-23.958-43.505-43.771l-276.94-672.615 338.262-140.958v175.109l-202.426 84.358 132.325 321.344h0.145c14.059 28.607 47.792 41.35 77.124 29.134l0.725-0.324 0.274-0.113c17.525 45.351 61.387 78.24 112.641 78.24zM338.262 503.769v44.898l-127.67-52.085-22.229-53.978 149.898 61.164z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Funeral-services",
		paths: [
			"M903.68 903.68v-512c0-216.319-175.361-391.68-391.68-391.68s-391.68 175.361-391.68 391.68v0 512c-33.225 0-60.16 26.935-60.16 60.16v0 60.16h903.68v-60.16c0-33.225-26.935-60.16-60.16-60.16v0zM722.88 451.84c0 16.613-13.467 30.080-30.080 30.080v0h-120.64v240.96c0 16.613-13.467 30.080-30.080 30.080v0h-60.16c-16.613 0-30.080-13.467-30.080-30.080v-240.96h-120.64c-16.613 0-30.080-13.467-30.080-30.080v0-60.16c0-0.017 0-0.037 0-0.058 0-16.998 13.253-30.9 29.989-31.938l0.091-0.005h120.64v-118.72c0-16.613 13.467-30.080 30.080-30.080h60.16c16.613 0 30.080 13.467 30.080 30.080v0 120.32h120.64c16.827 1.042 30.080 14.945 30.080 31.942 0 0.020 0 0.041 0 0.061v-0.003z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Funny",
		paths: [
			"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512c282.77 0 512-229.23 512-512v0c0-282.77-229.23-512-512-512v0zM512 963.84c-249.544 0-451.84-202.296-451.84-451.84s202.296-451.84 451.84-451.84c249.544 0 451.84 202.296 451.84 451.84v0c0 249.544-202.296 451.84-451.84 451.84v0zM361.28 512c0.499 0.030 1.082 0.046 1.669 0.046 16.613 0 30.080-13.467 30.080-30.080 0-8.415-3.455-16.022-9.024-21.481l-60.165-60.165c-5.426-5.343-12.878-8.642-21.1-8.642-0.12 0-0.239 0.001-0.358 0.002h0.018c-0.084-0.001-0.184-0.001-0.284-0.001-8.139 0-15.506 3.303-20.835 8.641v0l-61.76 60.16c-5.282 5.462-8.537 12.912-8.537 21.123 0 16.641 13.371 30.159 29.955 30.397h0.022c8.279-0.047 15.749-3.467 21.115-8.954l0.005-0.006 39.040-38.72 39.040 38.72c5.371 5.493 12.841 8.913 21.111 8.96h0.009zM745.28 400.32c-5.329-5.339-12.697-8.641-20.836-8.641-0.1 0-0.2 0-0.299 0.001h0.015c-0.101-0.001-0.22-0.002-0.34-0.002-8.222 0-15.674 3.299-21.104 8.646l0.004-0.004-62.72 60.16c-5.574 5.464-9.029 13.072-9.029 21.486 0 16.613 13.467 30.080 30.080 30.080 0.587 0 1.17-0.017 1.749-0.050l-0.080 0.004c8.279-0.047 15.749-3.467 21.115-8.954l0.005-0.006 39.040-38.72 39.040 38.72c5.422 5.629 13.025 9.125 21.444 9.125 16.436 0 29.76-13.324 29.76-29.76 0-0.17-0.001-0.341-0.004-0.51v0.026c0.001-0.101 0.002-0.22 0.002-0.34 0-8.222-3.299-15.674-8.646-21.104l0.004 0.004zM642.88 678.080c-35.296 27.663-80.338 44.361-129.28 44.361s-93.984-16.698-129.74-44.708l0.46 0.347c-5.060-3.999-11.531-6.414-18.567-6.414-8.229 0-15.685 3.304-21.116 8.658l0.004-0.004c-5.459 5.446-8.836 12.977-8.836 21.296 0 9.668 4.561 18.27 11.648 23.773l0.068 0.051c45.431 35.602 103.406 57.092 166.4 57.092s120.969-21.49 166.992-57.539l-0.592 0.447c6.947-5.558 11.357-14.036 11.357-23.543 0-8.3-3.362-15.815-8.798-21.257v0c-5.74-5.512-13.549-8.907-22.152-8.907-7.209 0-13.861 2.384-19.211 6.406l0.082-0.059z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Healthcare",
		paths: [
			"M224 459.52c0-26.863-21.777-48.64-48.64-48.64s-48.64 21.777-48.64 48.64c0 26.863 21.777 48.64 48.64 48.64v0c26.863 0 48.64-21.777 48.64-48.64v0zM133.76 721.6h69.76v-119.36c68.164-13.472 118.853-72.775 118.853-143.917 0-80.943-65.617-146.56-146.56-146.56s-146.56 65.617-146.56 146.56c0 65.946 43.555 121.72 103.469 140.123l1.038 0.274zM87.36 459.52c0-48.247 39.113-87.359 87.36-87.359s87.36 39.112 87.36 87.36c0 48.248-39.112 87.36-87.36 87.36-0.113 0-0.225 0-0.337-0.001h0.017c0 0 0 0-0.001 0-48.071 0-87.040-38.969-87.040-87.040 0-0.112 0-0.225 0.001-0.337v0.017zM600.96 886.080c-42.133 42.010-100.273 67.986-164.481 67.986-128.487 0-232.678-104.018-232.959-232.439v-0.027h-69.76c5.464 162.899 138.833 292.879 302.56 292.879s297.095-129.979 302.547-292.379l0.013-0.5h-69.76c0 0.066 0 0.144 0 0.223 0 64.169-26.052 122.253-68.155 164.253l-0.005 0.005zM855.36 0h-69.76c-0.191-0.002-0.416-0.004-0.641-0.004-31.7 0-57.42 25.608-57.599 57.266v0.017c0.344 31.902 26.286 57.632 58.237 57.632 27.869 0 51.167-19.575 56.892-45.726l0.071-0.385h12.8c0.191-0.002 0.417-0.003 0.643-0.003 37.95 0 68.757 30.584 69.117 68.449v206.434c0 0.106 0 0.232 0 0.358 0 30.293-6.358 59.1-17.813 85.161l0.533-1.359c-11.854 27.021-27.927 50.065-47.645 69.406l-0.035 0.034c-19.735 19.364-43.087 35.125-68.938 46.165l-1.462 0.555c-25.319 10.926-54.797 17.281-85.76 17.281s-60.441-6.355-87.202-17.831l1.442 0.55c-27.313-11.595-50.665-27.356-70.435-46.754l0.035 0.034c-19.753-19.375-35.826-42.419-47.129-68.039l-0.551-1.401c-10.922-24.702-17.28-53.509-17.28-83.802 0-0.126 0-0.252 0-0.378v0.020-206.4c0.36-37.899 31.167-68.483 69.117-68.483 0.226 0 0.452 0.001 0.677 0.003h12.766c5.796 26.536 29.094 46.112 56.963 46.112 31.951 0 57.893-25.729 58.237-57.599v-0.033c-0.18-31.675-25.899-57.284-57.599-57.284-0.225 0-0.45 0.001-0.675 0.004h-69.726c-0.381-0.004-0.832-0.006-1.283-0.006-76.012 0-137.696 61.35-138.236 137.235v206.451c1.083 146.918 112.009 267.597 254.666 284.035l1.334 0.125v93.76h69.76v-93.76c143.991-16.563 254.917-137.242 255.999-284.049l0.001-0.111v-206.4c-0.541-75.936-62.224-137.286-138.237-137.286-0.451 0-0.902 0.002-1.352 0.006l0.069-0.001z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Hide",
		paths: [
			"M864 333.44l-49.28 50.56c50.002 33.095 92.365 73.013 127.070 119.032l0.93 1.288c-41.44 53.835-91.68 98.568-148.948 132.746l-2.412 1.334c-18.252 10.798-40.321 22.039-63.081 31.994l-4.119 1.606c36.891-46.099 59.201-105.262 59.201-169.636 0-0.212 0-0.425-0.001-0.637v0.033c-0.019-27.832-4.11-54.702-11.708-80.055l0.508 1.975-57.92 57.92q0 10.24 0 20.16c0 0.095 0 0.208 0 0.32 0 112.931-91.549 204.48-204.48 204.48-0.113 0-0.225 0-0.338 0h0.018q-9.92 0-20.16 0l-73.28 73.92c24.084 4.368 51.862 6.924 80.216 7.040h27.624c213.44 0 429.44-150.4 499.52-284.48-40.308-68.773-93.84-125.575-157.531-168.44l-1.829-1.16zM214.080 626.88c-52.472-33.69-96.867-74.724-133.165-122.271l-0.915-1.249c41.44-53.835 91.68-98.568 148.948-132.746l2.412-1.334c17.571-10.949 38.558-22.266 60.235-32.348l3.765-1.572c-35.913 45.587-57.6 103.842-57.6 167.162 0 0.182 0 0.364 0.001 0.546v-0.028c-0.003 0.441-0.004 0.962-0.004 1.484 0 30.511 5.157 59.817 14.647 87.095l-0.563-1.86 56.32-56.64c-1.429-8.636-2.245-18.588-2.245-28.73 0-0.475 0.002-0.949 0.005-1.423v0.073c0.181-113.148 91.947-204.802 205.12-204.802 0.338 0 0.675 0.001 1.013 0.002h-0.052c10.709 0.107 21.128 0.918 31.334 2.388l-1.254-0.148 73.6-73.6c-26.109-4.976-56.196-7.882-86.94-8h-27.62c-215.040 0-431.040 150.4-501.12 284.16 41.492 70.521 96.899 128.586 162.851 171.918l1.949 1.202zM628.16 461.44l312-311.68-60.48-60.48-477.12 477.12-306.56 307.84 60.48 60.48 313.6-313.6z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Home-appliance",
		paths: [
			"M512 331.2c-133.079 0-240.96 107.881-240.96 240.96s107.881 240.96 240.96 240.96c133.079 0 240.96-107.881 240.96-240.96v0c0-133.079-107.881-240.96-240.96-240.96v0zM720.96 599.68c-17.666-19.826-43.271-32.251-71.778-32.251-2.443 0-4.864 0.091-7.261 0.271l0.32-0.019c-60.48 0-70.080 38.72-130.24 38.72s-66.24-38.72-126.4-38.72c-1.945-0.127-4.216-0.2-6.505-0.2-29.83 0-56.779 12.331-76.029 32.173l-0.026 0.027c-1.222-8.24-1.92-17.752-1.92-27.426 0-0.145 0-0.291 0-0.436v0.022c0-116.466 94.414-210.88 210.88-210.88s210.88 94.414 210.88 210.88v0c0 0.149 0.001 0.326 0.001 0.502 0 9.644-0.698 19.124-2.047 28.394l0.126-1.056zM813.12 0h-602.24c0 0 0 0-0.001 0-49.902 0-90.377 40.363-90.559 90.223v843.537c0.182 49.877 40.657 90.24 90.559 90.24 0 0 0 0 0.001 0h602.24c0 0 0 0 0.001 0 49.902 0 90.377-40.363 90.559-90.223v-843.537c-0.182-49.877-40.657-90.24-90.559-90.24 0 0 0 0-0.001 0v0zM677.76 60.16c23.402 2.028 41.63 21.525 41.63 45.28s-18.228 43.252-41.46 45.268l-0.17 0.012c-1.141 0.102-2.469 0.16-3.81 0.16-25.096 0-45.44-20.344-45.44-45.44s20.344-45.44 45.44-45.44c1.341 0 2.669 0.058 3.98 0.172l-0.17-0.012zM180.8 120.32v-30.080c0-16.613 13.467-30.080 30.080-30.080v0h150.4c0.017 0 0.037 0 0.058 0 16.998 0 30.9 13.253 31.938 29.989l0.005 0.091v30.080c0 17.673-14.327 32-32 32v0h-150.4c-16.827-1.042-30.080-14.945-30.080-31.942 0-0.020 0-0.041 0-0.061v0.003zM512 843.2c-149.691 0-271.040-121.349-271.040-271.040s121.349-271.040 271.040-271.040c149.691 0 271.040 121.349 271.040 271.040v0c0 149.691-121.349 271.040-271.040 271.040v0zM798.080 150.72c-0.095 0.001-0.207 0.001-0.32 0.001-25.096 0-45.44-20.344-45.44-45.44s20.344-45.44 45.44-45.44c25.095 0 45.439 20.344 45.44 45.439v0c0 0 0 0.001 0 0.001 0 24.983-20.162 45.257-45.103 45.439h-0.017z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Invoice-euro",
		paths: [
			"M716.16 240.96h187.52l-240.96-240.96v180.8c-0.061 0.987-0.096 2.141-0.096 3.303 0 30.253 23.586 54.998 53.373 56.849l0.163 0.008zM602.24 180.8v0-180.8h-481.92v963.52c0 33.402 27.078 60.48 60.48 60.48h722.88v-722.88h-180.8c-0.095 0-0.207 0-0.32 0-66.451 0-120.32-53.869-120.32-120.32 0 0 0 0 0 0v0zM232.64 292.48c-0.038-0.479-0.060-1.037-0.060-1.6 0-11.841 9.599-21.44 21.44-21.44 0.021 0 0.042 0 0.063 0h15.037c0-5.12 0-10.88 0-13.44s0-4.8 0-11.52h-15.040c-11.896-0.159-21.478-9.84-21.478-21.758 0-0.451 0.014-0.899 0.041-1.343l-0.003 0.061c-0.054-0.59-0.084-1.276-0.084-1.97 0-12.191 9.469-22.171 21.453-22.986l0.071-0.004h19.84c5.503-30.773 19.745-57.558 40.034-78.435l-0.034 0.035c20.456-18.705 47.81-30.164 77.841-30.164 1.547 0 3.087 0.030 4.62 0.091l-0.22-0.007c3.077-0.33 6.646-0.519 10.26-0.519 42.795 0 79.42 26.417 94.457 63.834l0.243 0.684c1.617 3.443 2.56 7.477 2.56 11.732 0 0.038 0 0.076 0 0.114v-0.006c-0.174 10.702-6.972 19.772-16.465 23.303l-0.175 0.057c-1.996 0.518-4.287 0.815-6.647 0.815-11.333 0-21.066-6.85-25.284-16.636l-0.069-0.179c-6.797-22.047-26.99-37.791-50.86-37.791-2.149 0-4.269 0.128-6.351 0.376l0.252-0.024c-0.519-0.014-1.13-0.021-1.742-0.021-35.692 0-65.264 26.204-70.527 60.423l-0.050 0.398h112.64c11.846 0.652 21.205 10.417 21.205 22.368 0 0.687-0.031 1.367-0.092 2.038l0.006-0.087c0.075 0.672 0.117 1.452 0.117 2.241 0 11.77-9.484 21.324-21.227 21.439h-121.291c0 6.72 0 7.68 0 11.52v13.44h98.88c0.048 0 0.104-0.001 0.161-0.001 11.311 0 20.48 9.169 20.48 20.48 0 0.903-0.058 1.792-0.172 2.664l0.011-0.103c0.041 0.48 0.064 1.039 0.064 1.604 0 11.134-9.026 20.16-20.16 20.16-0.135 0-0.27-0.001-0.404-0.004h-95.98c6.015 32.734 34.326 57.21 68.354 57.21 2.072 0 4.122-0.091 6.148-0.268l-0.263 0.019c2.352 0.385 5.063 0.605 7.825 0.605 22.601 0 41.761-14.737 48.394-35.125l0.101-0.36c3.523-9.899 12.776-16.875 23.67-16.96h0.010c1.346-0.201 2.9-0.315 4.48-0.315s3.134 0.115 4.653 0.336l-0.173-0.021c10.817 2.689 18.824 12 19.516 23.288l0.004 0.072c0.002 0.118 0.003 0.257 0.003 0.396 0 3.58-0.828 6.966-2.303 9.978l0.059-0.134c-15.353 38.17-52.067 64.625-94.96 64.625-3.974 0-7.895-0.227-11.751-0.669l0.471 0.044c-1.494 0.068-3.246 0.107-5.007 0.107-31.194 0-59.532-12.229-80.482-32.154l0.049 0.046c-19.528-19.591-33.229-45.001-38.277-73.403l-0.123-0.837h-16.32c-0.412 0.030-0.893 0.046-1.377 0.046-9.855 0-18.083-6.96-20.039-16.233l-0.024-0.134zM512 903.68h-210.88c-15.395-1.632-27.285-14.548-27.285-30.24s11.89-28.608 27.152-30.229l0.133-0.011h210.88c15.395 1.632 27.285 14.548 27.285 30.24s-11.89 28.608-27.152 30.229l-0.133 0.011zM722.88 752.96h-421.76c-16.613 0-30.080-13.467-30.080-30.080s13.467-30.080 30.080-30.080h421.76c16.613 0 30.080 13.467 30.080 30.080s-13.467 30.080-30.080 30.080v0zM752.96 572.16c0 16.613-13.467 30.080-30.080 30.080h-421.76c-16.613 0-30.080-13.467-30.080-30.080s13.467-30.080 30.080-30.080h421.76c16.613 0 30.080 13.467 30.080 30.080v0z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Money-box",
		paths: [
			"M1024 527.040c0-239.040-207.68-424.64-464.32-424.64-66.318 0.257-129.633 12.798-187.889 35.462l3.569-1.222c0.161-3.339 0.253-7.253 0.253-11.188 0-46.259-12.698-89.553-34.799-126.585l0.626 1.132c-96 81.92-101.44 156.48-103.36 192 0.075 0.481 0.118 1.035 0.118 1.6s-0.043 1.119-0.126 1.661l0.008-0.061s0 15.68 0 25.92c-58.921 49.12-105.189 111.415-134.538 182.478l-1.142 3.122h-46.080c-31.661 2.528-56.397 28.844-56.397 60.937 0 1.077 0.028 2.148 0.083 3.212l-0.006-0.149v175.68c-0.049 0.915-0.077 1.985-0.077 3.063 0 32.093 24.736 58.409 56.182 60.923l0.215 0.014h46.080c25.28 49.28 96 93.76 137.28 130.88 0 0 0 1.92 0 3.52v112c-0.209 1.896-0.328 4.095-0.328 6.322 0 31.843 24.352 57.999 55.448 60.86l0.24 0.018h59.2c31.528-4.314 55.559-31.071 55.559-63.441 0-1.774-0.072-3.53-0.214-5.267l0.015 0.228v-27.52c44.594 15.919 96.051 25.567 149.624 26.553l0.456 0.007c70.615-1.071 138.022-13.288 201.029-34.96l-4.549 1.36v32c-0.277 2.237-0.435 4.826-0.435 7.451 0 32.794 24.664 59.826 56.455 63.56l0.3 0.029h51.52c31.987-3.866 56.535-30.848 56.535-63.563 0-1.843-0.078-3.668-0.231-5.472l0.016 0.235s0-136 0-136c81.92-77.44 103.68-176 103.68-292.16zM443.52 160s106.56-53.12 272.96 0v44.48c-40.46-16.259-87.369-25.691-136.48-25.691s-96.020 9.432-139.013 26.583l2.533-0.892z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "My-vacation",
		paths: [
			"M955.84 887.68h-54.080l49.28 85.12c2.010 4.227 3.184 9.186 3.184 14.419 0 18.91-15.33 34.24-34.24 34.24-11.616 0-21.88-5.784-28.071-14.629l-0.073-0.11-68.8-119.040h-515.84c-1.63 0.158-3.525 0.248-5.44 0.248s-3.81-0.090-5.679-0.266l0.239 0.018c-2.449 0.305-5.284 0.479-8.16 0.479s-5.711-0.174-8.495-0.512l0.335 0.033-69.12 119.040c-6.264 8.955-16.529 14.739-28.144 14.739-18.91 0-34.24-15.33-34.24-34.24 0-5.233 1.174-10.192 3.273-14.627l-0.089 0.208 69.76-120.96-201.6-201.6c-15.022-12.59-24.507-31.361-24.507-52.347 0-37.644 30.516-68.16 68.16-68.16 20.986 0 39.757 9.484 52.26 24.401l0.086 0.106 173.76 173.44 199.36-345.6 59.84 33.92v1.6l-192 333.44h599.040c35.753 2.523 63.802 32.146 63.802 68.32s-28.049 65.797-63.584 68.308l-0.217 0.012zM916.16 599.68l-212.16-123.52 17.28-84.8-23.68-13.76-64 57.28-188.8-109.12 17.28-84.8-23.68-13.76-64 57.6-214.4-123.2 17.28-84.48c144.32-97.6 345.6-101.76 513.6-16.96l13.12-24.64c4.983-8.4 14.004-13.942 24.32-13.942 15.565 0 28.182 12.618 28.182 28.182 0 5.249-1.435 10.162-3.934 14.37l0.071-0.13-14.4 24.64c146.74 91.743 242.906 252.432 242.906 435.583 0 6.617-0.126 13.206-0.374 19.762l0.028-0.945z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Sunglasses",
		paths: [
			"M1024 493.12c-2.24-8.32-8.96-11.84-17.92-14.4l-16.96-3.84c-50.983-17.238-109.702-27.187-170.745-27.187-6.462 0-12.898 0.111-19.305 0.333l0.93-0.025c-4.382-0.093-9.547-0.146-14.724-0.146-73.425 0-144.354 10.692-211.313 30.603l5.237-1.336h-134.72c-61.716-18.571-132.637-29.261-206.055-29.261-5.072 0-10.132 0.051-15.18 0.153l0.755-0.012c-6.287-0.258-13.666-0.404-21.079-0.404-59.689 0-117.156 9.512-170.969 27.104l3.888-1.1-17.28 6.4c-8.96 2.56-15.68 6.080-17.92 14.4-0.231 1.251-0.363 2.69-0.363 4.16s0.132 2.909 0.385 4.306l-0.022-0.146c0 9.92 3.52 26.88 6.4 45.44 0 7.68 5.12 28.48 23.36 28.48s18.88 9.6 26.24 33.92 27.52 106.88 27.52 106.88c9.92 66.88 88.32 105.28 181.76 105.28s171.84-38.4 182.080-105.28l27.84-118.72c7.36-32 28.16-29.44 28.16-29.44h16.64s20.8-1.6 28.16 29.44l27.2 117.44c10.24 66.88 88.32 105.28 182.080 105.28s171.84-38.4 181.76-105.28c0 0 21.76-87.040 27.52-106.88s12.8-33.92 26.24-33.92c18.24 0 22.4-20.8 23.36-28.48 2.88-18.56 4.8-35.52 6.4-45.44 0.48-1.792 0.755-3.85 0.755-5.973 0-0.827-0.042-1.643-0.123-2.449l0.008 0.101zM120 576c-4.485 18.747-7.057 40.271-7.057 62.396 0 17.648 1.636 34.914 4.766 51.654l-0.269-1.729c-15.983-36.789-25.281-79.639-25.281-124.662 0-8.721 0.349-17.36 1.033-25.904l-0.073 1.126c8.32-34.24 104.32-34.56 104.32-34.56-35.176 11.976-62.901 37.821-77.121 70.848l-0.319 0.832zM625.92 581.44c-4.485 18.747-7.057 40.271-7.057 62.396 0 17.648 1.636 34.914 4.766 51.654l-0.269-1.729c-15.996-36.802-25.302-79.67-25.302-124.712 0-8.816 0.357-17.549 1.056-26.184l-0.074 1.136c8.96-34.56 104.96-34.56 104.96-34.56-35.436 11.822-63.406 37.702-77.76 70.851l-0.32 0.829zM199.040 409.92c14.138-49.227 28.74-89.718 45.586-129.019l-2.706 7.099c7.565-16.3 23.752-27.421 42.547-27.52h28.173c15.056-1.614 26.678-14.25 26.678-29.6s-11.622-27.987-26.547-29.589l-0.131-0.011h-78.080c-1.010-0.15-2.175-0.236-3.36-0.236s-2.35 0.086-3.49 0.252l0.13-0.016c-12.513 2.706-22.798 10.578-28.688 21.22l-0.112 0.22-142.4 207.36c35.555-13.243 76.633-20.906 119.501-20.906 8.057 0 16.050 0.271 23.972 0.803l-1.073-0.058zM711.040 261.76h28.48c0.074 0 0.161-0.001 0.248-0.001 18.349 0 34.228 10.578 41.87 25.969l0.122 0.272c14.041 31.641 28.736 71.677 41.139 112.708l2.061 7.932c6.767-0.464 14.666-0.728 22.628-0.728 42.85 0 83.912 7.657 121.891 21.676l-2.439-0.788-142.080-204.8c-6.133-10.873-16.514-18.738-28.834-21.388l-0.286-0.052c-1.010-0.15-2.175-0.236-3.36-0.236s-2.35 0.086-3.49 0.252l0.13-0.016h-78.080c-15.056 1.614-26.678 14.25-26.678 29.6s11.622 27.987 26.547 29.589l0.131 0.011z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Ticket",
		paths: [
			"M1024 391.68v-187.84c-1.381-29.651-25.756-53.167-55.623-53.167-0.808 0-1.611 0.017-2.411 0.051l0.114-0.004h-220.48c0 16.613-13.467 30.080-30.080 30.080s-30.080-13.467-30.080-30.080v0h-627.52c-0.685-0.030-1.489-0.047-2.297-0.047-29.867 0-54.242 23.517-55.619 53.044l-0.005 0.124v187.84c65.741 1.735 118.585 54.579 120.317 120.157l0.003 0.163c-1.735 65.741-54.579 118.585-120.157 120.317l-0.163 0.003v187.84c1.381 29.651 25.756 53.167 55.623 53.167 0.808 0 1.611-0.017 2.411-0.051l-0.114 0.004h627.52c0-16.613 13.467-30.080 30.080-30.080s30.080 13.467 30.080 30.080v0h220.48c0.685 0.030 1.489 0.047 2.297 0.047 29.867 0 54.242-23.517 55.619-53.044l0.005-0.124v-187.84c-65.741-1.735-118.585-54.579-120.317-120.157l-0.003-0.163c1.735-65.741 54.579-118.585 120.157-120.317l0.163-0.003zM715.52 813.12c-16.613 0-30.080-13.467-30.080-30.080s13.467-30.080 30.080-30.080c16.613 0 30.080 13.467 30.080 30.080v0c0 16.613-13.467 30.080-30.080 30.080v0zM715.52 722.88c-16.613 0-30.080-13.467-30.080-30.080s13.467-30.080 30.080-30.080c16.613 0 30.080 13.467 30.080 30.080v0c0 16.613-13.467 30.080-30.080 30.080v0zM715.52 632.32c-16.613 0-30.080-13.467-30.080-30.080s13.467-30.080 30.080-30.080c16.613 0 30.080 13.467 30.080 30.080v0c0 16.613-13.467 30.080-30.080 30.080v0zM715.52 542.080c-16.613 0-30.080-13.467-30.080-30.080s13.467-30.080 30.080-30.080c16.613 0 30.080 13.467 30.080 30.080v0c0 16.613-13.467 30.080-30.080 30.080v0zM715.52 451.84c-16.613 0-30.080-13.467-30.080-30.080s13.467-30.080 30.080-30.080c16.613 0 30.080 13.467 30.080 30.080v0c0 16.613-13.467 30.080-30.080 30.080v0zM715.52 361.28c-16.613 0-30.080-13.467-30.080-30.080s13.467-30.080 30.080-30.080c16.613 0 30.080 13.467 30.080 30.080v0c0 16.613-13.467 30.080-30.080 30.080v0zM715.52 271.040c-16.613 0-30.080-13.467-30.080-30.080s13.467-30.080 30.080-30.080c16.613 0 30.080 13.467 30.080 30.080v0c0 16.613-13.467 30.080-30.080 30.080v0z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Train",
		paths: [
			"M700.8 768h3.2c70.692 0 128-57.308 128-128v0l-33.92-512c0-70.692-57.308-128-128-128v0h-320c-70.692 0-128 57.308-128 128v0l-30.080 512c0 70.692 57.308 128 128 128v0h2.56l-162.56 256h96l81.92-128h348.8l81.28 128h96zM448 64h128c17.673 0 32 14.327 32 32s-14.327 32-32 32v0h-128c-17.673 0-32-14.327-32-32s14.327-32 32-32v0zM292.48 256c0-35.346 28.654-64 64-64v0h311.040c35.346 0 64 28.654 64 64v0l4.48 96c0 35.346-28.654 64-64 64v0h-320c-35.346 0-64-28.654-64-64v0zM288 640c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64v0c-35.346 0-64-28.654-64-64v0zM377.6 832l40.96-64h185.6l40.96 64zM672 704c-35.346 0-64-28.654-64-64s28.654-64 64-64c35.346 0 64 28.654 64 64v0c0 35.346-28.654 64-64 64v0z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "euro-full",
		paths: [
			"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512c282.77 0 512-229.23 512-512v0c0-282.77-229.23-512-512-512v0zM736 713.92c-37.44 88.96-102.72 128-211.52 128-3.439 0.183-7.466 0.288-11.517 0.288-61.078 0-116.614-23.734-157.886-62.482l0.123 0.114c-39.763-39.14-67.652-90.236-77.835-147.459l-0.245-1.661h-36.48c-23.254-0.098-42.067-18.972-42.067-42.24 0-1.239 0.053-2.466 0.158-3.678l-0.011 0.158c-0.133-1.249-0.209-2.697-0.209-4.163 0-22.975 18.625-41.6 41.6-41.6 0.186 0 0.372 0.001 0.557 0.004h28.132v-25.6c0-7.36 0-12.48 0-20.16h-28.8c-22.965-0.47-41.402-19.198-41.402-42.232 0-1.129 0.044-2.248 0.131-3.355l-0.009 0.146c-0.111-1.151-0.175-2.488-0.175-3.84 0-23.278 18.829-42.157 42.087-42.24h38.088c12.346-62.522 41.182-116.923 81.762-160.175l-0.162 0.175c40.804-38.506 95.973-62.173 156.669-62.173 2.297 0 4.585 0.034 6.866 0.101l-0.335-0.008c104.96 0 173.12 42.24 208.64 128 3.244 6.579 5.141 14.322 5.141 22.508 0 0.524-0.008 1.047-0.023 1.568l0.002-0.076c-0.16 20.689-13.296 38.268-31.665 45.012l-0.335 0.108h-1.28c-6.365 2.263-13.71 3.654-21.354 3.838l-0.086 0.002c-20.528-0.143-37.939-13.324-44.379-31.668l-0.101-0.332c-12.844-43.895-52.738-75.412-99.994-75.412-4.684 0-9.296 0.31-13.816 0.91l0.53-0.057c-70.4 0-120.96 40.96-143.36 124.8h224c22.706 0.351 40.977 18.839 40.977 41.595 0 2.603-0.239 5.15-0.697 7.621l0.039-0.256c0.13 1.248 0.204 2.696 0.204 4.162 0 23.352-18.807 42.311-42.101 42.558h-236.503c0 7.68 0 12.48 0 20.16v25.6h195.84c0.263-0.006 0.574-0.009 0.885-0.009 22.798 0 41.28 18.482 41.28 41.28 0 1.582-0.089 3.142-0.262 4.678l0.017-0.188c0.077 0.959 0.121 2.076 0.121 3.203 0 23.323-18.76 42.264-42.013 42.557h-185.948c9.54 65.341 65.192 114.955 132.431 114.955 4.864 0 9.667-0.26 14.396-0.766l-0.588 0.051c64 0 93.12-19.2 112.32-67.84v0c6.837-19.638 25.147-33.497 46.708-33.6h0.012c6.313 0.077 12.356 1.125 18.020 3.001l-0.42-0.121c21.673 5.226 37.788 23.729 39.351 46.24l0.009 0.16c0.047 0.754 0.073 1.636 0.073 2.524 0 6.262-1.322 12.214-3.703 17.594l0.11-0.278z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Calendar-event-info",
		paths: [
			"M924.8 99.2h-132.16v-50.24c0 0 0-0.001 0-0.001 0-27.040-21.92-48.96-48.96-48.96-0.113 0-0.225 0-0.337 0.001h0.017c-0.095-0.001-0.208-0.001-0.321-0.001-27.217 0-49.28 22.063-49.28 49.28 0 0.113 0 0.226 0.001 0.338v-0.017 49.6h-363.52v-49.6c0.102-1.192 0.16-2.58 0.16-3.981 0-27.393-22.207-49.6-49.6-49.6s-49.6 22.207-49.6 49.6c0 1.401 0.058 2.789 0.172 4.16l-0.012-0.18v49.6h-231.36v825.6c0 54.787 44.413 99.2 99.2 99.2v0h924.8v-825.92c0 0 0 0 0-0.001 0-54.61-44.27-98.88-98.88-98.88-0.112 0-0.225 0-0.337 0.001h0.017zM693.76 148.8v65.92c-0.102 1.192-0.16 2.58-0.16 3.981 0 27.393 22.207 49.6 49.6 49.6s49.6-22.207 49.6-49.6c0-1.401-0.058-2.789-0.172-4.16l0.012 0.18v-65.28c19.406 14.843 31.841 37.953 32 63.974v0.026c0 0.024 0 0.052 0 0.080 0 45.597-36.963 82.56-82.56 82.56s-82.56-36.963-82.56-82.56c0-26.889 12.855-50.776 32.754-65.85l0.206-0.15zM231.36 148.8v65.92c-0.102 1.192-0.16 2.58-0.16 3.981 0 27.393 22.207 49.6 49.6 49.6s49.6-22.207 49.6-49.6c0-1.401-0.058-2.789-0.172-4.16l0.012 0.18v-65.92c20.387 15.272 33.44 39.371 33.44 66.519 0 45.773-37.107 82.88-82.88 82.88s-82.88-37.107-82.88-82.88c0-27.148 13.053-51.247 33.225-66.365l0.215-0.154zM958.080 958.080h-842.56c-27.321-0.18-49.42-22.279-49.6-49.583v-512.017h842.56c27.393 0 49.6 22.207 49.6 49.6v0zM512 462.4c-118.587 0-214.72 96.133-214.72 214.72s96.133 214.72 214.72 214.72c118.587 0 214.72-96.133 214.72-214.72v0c0-118.587-96.133-214.72-214.72-214.72v0zM490.56 526.4c6.444-6.526 15.39-10.568 25.28-10.568s18.836 4.042 25.276 10.564l0.004 0.004c6.33 6.363 10.243 15.136 10.243 24.823 0 0.161-0.001 0.321-0.003 0.481v-0.024c-0.353 19.474-16.046 35.167-35.487 35.52h-0.033c-0.097 0.001-0.211 0.001-0.326 0.001-19.617 0-35.52-15.903-35.52-35.52 0-0.226 0.002-0.451 0.006-0.675v0.034c0-0.042 0-0.092 0-0.142 0-9.844 4.041-18.744 10.555-25.133l0.006-0.006zM578.88 819.52h-116.48v-12.16h2.56c4.299-0.1 8.354-1.032 12.046-2.64l-0.206 0.080c2.495-0.981 4.626-2.392 6.401-4.161l-0.001 0.001c0-1.6 4.16-6.72 4.16-24v-116.48c0.193-1.523 0.303-3.285 0.303-5.072 0-7.403-1.89-14.365-5.214-20.429l0.111 0.221c-1.535-1.45-3.337-2.637-5.322-3.476l-0.118-0.044c-3.627-1.175-7.804-1.873-12.137-1.92h-2.583v-14.080h91.52v160c0 16.32 2.24 22.72 4.48 24.96 4.379 3.609 10.046 5.797 16.224 5.797 0.484 0 0.965-0.013 1.443-0.040l-0.066 0.003h2.88z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Calendar-latest",
		paths: [
			"M924.8 99.2h-132.16v-50.24c0 0 0-0.001 0-0.001 0-27.040-21.92-48.96-48.96-48.96-0.113 0-0.225 0-0.337 0.001h0.017c-0.095-0.001-0.208-0.001-0.321-0.001-27.217 0-49.28 22.063-49.28 49.28 0 0.113 0 0.226 0.001 0.338v-0.017 49.6h-363.52v-49.6c0.102-1.192 0.16-2.58 0.16-3.981 0-27.393-22.207-49.6-49.6-49.6s-49.6 22.207-49.6 49.6c0 1.401 0.058 2.789 0.172 4.16l-0.012-0.18v49.6h-231.36v825.6c0 54.787 44.413 99.2 99.2 99.2v0h924.8v-825.92c0 0 0 0 0-0.001 0-54.61-44.27-98.88-98.88-98.88-0.112 0-0.225 0-0.337 0.001h0.017zM693.76 148.8v65.92c-0.102 1.192-0.16 2.58-0.16 3.981 0 27.393 22.207 49.6 49.6 49.6s49.6-22.207 49.6-49.6c0-1.401-0.058-2.789-0.172-4.16l0.012 0.18v-65.28c19.406 14.843 31.841 37.953 32 63.974v0.026c0 0.024 0 0.052 0 0.080 0 45.597-36.963 82.56-82.56 82.56s-82.56-36.963-82.56-82.56c0-26.889 12.855-50.776 32.754-65.85l0.206-0.15zM231.36 148.8v65.92c-0.102 1.192-0.16 2.58-0.16 3.981 0 27.393 22.207 49.6 49.6 49.6s49.6-22.207 49.6-49.6c0-1.401-0.058-2.789-0.172-4.16l0.012 0.18v-65.92c20.387 15.272 33.44 39.371 33.44 66.519 0 45.773-37.107 82.88-82.88 82.88s-82.88-37.107-82.88-82.88c0-27.148 13.053-51.247 33.225-66.365l0.215-0.154zM958.080 958.080h-842.56c-27.321-0.18-49.42-22.279-49.6-49.583v-512.017h842.56c27.393 0 49.6 22.207 49.6 49.6v0zM712.96 584.96c-2.826-8.151-10.439-13.897-19.393-13.897-2.695 0-5.268 0.52-7.625 1.466l0.138-0.049-131.84 48.32v-138.56c0-0.001 0-0.002 0-0.002 0-11.664-9.456-21.12-21.12-21.12-0.113 0-0.225 0.001-0.337 0.003h-56.623c-0.095-0.002-0.207-0.002-0.32-0.002-11.664 0-21.12 9.456-21.12 21.12 0 0.001 0 0.002 0 0.003v0 138.56l-124.8-48.32c-2.219-0.897-4.792-1.417-7.487-1.417-8.955 0-16.567 5.747-19.35 13.754l-0.043 0.144-20.48 58.56c-0.785 2.087-1.239 4.498-1.239 7.016 0 9.125 5.968 16.857 14.214 19.504l0.145 0.040 128 43.2-81.92 108.8c-2.622 3.443-4.201 7.805-4.201 12.535 0 6.939 3.398 13.084 8.621 16.863l0.061 0.042 51.52 37.76c3.344 2.395 7.518 3.829 12.026 3.829 7.054 0 13.288-3.512 17.049-8.882l0.044-0.067 77.76-114.24 82.24 114.56c3.821 5.283 9.966 8.681 16.905 8.681 4.73 0 9.092-1.579 12.586-4.239l-0.051 0.037 50.56-37.44c5.094-3.897 8.346-9.978 8.346-16.819 0-4.756-1.572-9.145-4.225-12.675l0.039 0.054-81.92-108.8 130.88-43.2c8.391-2.687 14.359-10.419 14.359-19.544 0-2.518-0.454-4.929-1.286-7.158l0.046 0.141z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Calendar-no-access",
		paths: [
			"M924.8 99.2h-132.16v-50.24c0 0 0-0.001 0-0.001 0-27.040-21.92-48.96-48.96-48.96-0.113 0-0.225 0-0.337 0.001h0.017c-0.095-0.001-0.208-0.001-0.321-0.001-27.217 0-49.28 22.063-49.28 49.28 0 0.113 0 0.226 0.001 0.338v-0.017 49.6h-363.52v-49.6c0.102-1.192 0.16-2.58 0.16-3.981 0-27.393-22.207-49.6-49.6-49.6s-49.6 22.207-49.6 49.6c0 1.401 0.058 2.789 0.172 4.16l-0.012-0.18v49.6h-231.36v825.6c0 54.787 44.413 99.2 99.2 99.2v0h924.8v-825.92c0 0 0 0 0-0.001 0-54.61-44.27-98.88-98.88-98.88-0.112 0-0.225 0-0.337 0.001h0.017zM693.76 148.8v65.92c-0.102 1.192-0.16 2.58-0.16 3.981 0 27.393 22.207 49.6 49.6 49.6s49.6-22.207 49.6-49.6c0-1.401-0.058-2.789-0.172-4.16l0.012 0.18v-65.28c19.406 14.843 31.841 37.953 32 63.974v0.026c0 0.024 0 0.052 0 0.080 0 45.597-36.963 82.56-82.56 82.56s-82.56-36.963-82.56-82.56c0-26.889 12.855-50.776 32.754-65.85l0.206-0.15zM231.36 148.8v65.92c-0.102 1.192-0.16 2.58-0.16 3.981 0 27.393 22.207 49.6 49.6 49.6s49.6-22.207 49.6-49.6c0-1.401-0.058-2.789-0.172-4.16l0.012 0.18v-65.92c20.387 15.272 33.44 39.371 33.44 66.519 0 45.773-37.107 82.88-82.88 82.88s-82.88-37.107-82.88-82.88c0-27.148 13.053-51.247 33.225-66.365l0.215-0.154zM958.080 958.080h-842.56c-27.321-0.18-49.42-22.279-49.6-49.583v-512.017h842.56c27.393 0 49.6 22.207 49.6 49.6v0zM512 462.4c-118.587 0-214.72 96.133-214.72 214.72s96.133 214.72 214.72 214.72c118.587 0 214.72-96.133 214.72-214.72v0c0-118.587-96.133-214.72-214.72-214.72v0zM576 828.48c-18.904 8.094-40.903 12.8-64 12.8s-45.096-4.706-65.088-13.211l1.088 0.411c-39.463-17.073-70.288-47.897-86.947-86.292l-0.413-1.068c-8.094-18.904-12.8-40.903-12.8-64s4.706-45.096 13.211-65.088l-0.411 1.088c4.092-9.317 8.37-17.195 13.21-24.676l-0.41 0.676 226.56 226.56c-6.881 4.623-14.77 8.91-23.057 12.443l-0.943 0.357zM663.36 741.12c-4.092 9.317-8.37 17.195-13.21 24.676l0.41-0.676-226.56-226.56c6.805-4.43 14.683-8.708 22.9-12.363l1.1-0.437c18.904-8.094 40.903-12.8 64-12.8s45.096 4.706 65.088 13.211l-1.088-0.411c39.463 17.073 70.288 47.897 86.947 86.292l0.413 1.068c8.094 18.904 12.8 40.903 12.8 64s-4.706 45.096-13.211 65.088l0.411-1.088z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Calendar-time",
		paths: [
			"M924.8 99.2h-132.16v-50.24c0 0 0-0.001 0-0.001 0-27.040-21.92-48.96-48.96-48.96-0.113 0-0.225 0-0.337 0.001h0.017c-0.095-0.001-0.208-0.001-0.321-0.001-27.217 0-49.28 22.063-49.28 49.28 0 0.113 0 0.226 0.001 0.338v-0.017 49.6h-363.52v-49.6c0.102-1.192 0.16-2.58 0.16-3.981 0-27.393-22.207-49.6-49.6-49.6s-49.6 22.207-49.6 49.6c0 1.401 0.058 2.789 0.172 4.16l-0.012-0.18v49.6h-231.36v825.6c0 54.787 44.413 99.2 99.2 99.2v0h924.8v-825.92c0 0 0 0 0-0.001 0-54.61-44.27-98.88-98.88-98.88-0.112 0-0.225 0-0.337 0.001h0.017zM693.76 148.8v65.92c-0.102 1.192-0.16 2.58-0.16 3.981 0 27.393 22.207 49.6 49.6 49.6s49.6-22.207 49.6-49.6c0-1.401-0.058-2.789-0.172-4.16l0.012 0.18v-65.28c19.406 14.843 31.841 37.953 32 63.974v0.026c0 0.024 0 0.052 0 0.080 0 45.597-36.963 82.56-82.56 82.56s-82.56-36.963-82.56-82.56c0-26.889 12.855-50.776 32.754-65.85l0.206-0.15zM231.36 148.8v65.92c-0.102 1.192-0.16 2.58-0.16 3.981 0 27.393 22.207 49.6 49.6 49.6s49.6-22.207 49.6-49.6c0-1.401-0.058-2.789-0.172-4.16l0.012 0.18v-65.92c20.387 15.272 33.44 39.371 33.44 66.519 0 45.773-37.107 82.88-82.88 82.88s-82.88-37.107-82.88-82.88c0-27.148 13.053-51.247 33.225-66.365l0.215-0.154zM958.080 958.080h-842.56c-27.321-0.18-49.42-22.279-49.6-49.583v-512.017h842.56c27.393 0 49.6 22.207 49.6 49.6v0zM512 462.4c-118.587 0-214.72 96.133-214.72 214.72s96.133 214.72 214.72 214.72c118.587 0 214.72-96.133 214.72-214.72v0c0-118.587-96.133-214.72-214.72-214.72v0zM599.040 745.6c-3.211 3.363-7.73 5.454-12.737 5.454-0.247 0-0.493-0.005-0.738-0.015l0.035 0.001c-0.157 0.005-0.341 0.008-0.526 0.008-4.961 0-9.434-2.091-12.586-5.439l-0.008-0.009-74.24-73.6v-152.64c0-10.427 8.453-18.88 18.88-18.88v0c0.096-0.002 0.209-0.003 0.323-0.003 10.25 0 18.56 8.31 18.56 18.56 0 0.114-0.001 0.227-0.003 0.34v-0.017 130.88l68.48 68.48c2.071 3.019 3.308 6.752 3.308 10.774 0 6.718-3.45 12.63-8.675 16.061l-0.073 0.045z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Clock-white",
		paths: [
			"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512c282.77 0 512-229.23 512-512v0c0-282.77-229.23-512-512-512v0zM512 933.76c-232.932 0-421.76-188.828-421.76-421.76s188.828-421.76 421.76-421.76c232.932 0 421.76 188.828 421.76 421.76v0c0 232.932-188.828 421.76-421.76 421.76v0zM556.48 485.76v-314.24c0-24.919-20.201-45.12-45.12-45.12s-45.12 20.201-45.12 45.12v0 347.84h1.6l176.64 176.32c8.010 8.105 19.126 13.124 31.414 13.124 0.206 0 0.411-0.001 0.617-0.004h-0.031c0.253 0.005 0.551 0.008 0.85 0.008 12.206 0 23.239-5.025 31.142-13.12l0.008-0.009c8.301-8.138 13.447-19.468 13.447-32s-5.146-23.862-13.439-31.993l-0.007-0.007z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Cooking-pot",
		paths: [
			"M978.88 393.92h-933.76c-1.129-0.102-2.442-0.16-3.769-0.16-24.566 0-44.48 19.914-44.48 44.48s19.914 44.48 44.48 44.48c1.327 0 2.64-0.058 3.937-0.172l-0.168 0.012h38.4c0.112-0.003 0.243-0.005 0.375-0.005 7.681 0 13.987 5.883 14.661 13.388l0.004 0.057 19.84 246.72c-0.038 1.254-0.059 2.728-0.059 4.208 0 81.027 64.625 146.961 145.144 149.068l0.195 0.004h496.64c80.704-2.125 145.315-68.053 145.315-149.071 0-1.142-0.013-2.282-0.038-3.418l0.003 0.169 19.84-246.72c0.677-7.562 6.984-13.445 14.665-13.445 0.132 0 0.264 0.002 0.395 0.005h38.381c1.129 0.102 2.442 0.16 3.769 0.16 24.566 0 44.48-19.914 44.48-44.48s-19.914-44.48-44.48-44.48c-1.327 0-2.64 0.058-3.937 0.172l0.168-0.012zM90.24 334.72h843.52c0.096 0.001 0.209 0.002 0.322 0.002 16.324 0 29.578-13.143 29.758-29.425v-0.017c-0.037-13.261-8.836-24.457-20.911-28.106l-0.209-0.054c-9.92-3.2-19.52-6.4-28.8-10.24-109.48-48.145-236.868-77.409-370.75-80.301l-1.090-0.019v-14.72c0.179-7.991 6.699-14.4 14.717-14.4 0.001 0 0.002 0 0.004 0v0c0.1 0.002 0.218 0.004 0.336 0.004 7.351 0 13.496-5.164 15.005-12.062l0.019-0.102c0.107-0.673 0.168-1.45 0.168-2.241 0-8.306-6.734-15.040-15.040-15.040-0.059 0-0.118 0-0.177 0.001h-89.911c-0.1-0.002-0.218-0.004-0.336-0.004-7.351 0-13.496 5.164-15.005 12.062l-0.019 0.102c-0.107 0.673-0.168 1.45-0.168 2.241 0 8.306 6.734 15.040 15.040 15.040 0.059 0 0.118 0 0.177-0.001h-0.009c0.001 0 0.002 0 0.003 0 8.194 0 14.857 6.552 15.036 14.703v14.417c-134.972 2.911-262.36 32.175-378.265 82.822l6.425-2.502c-9.28 3.84-18.88 7.040-28.8 10.24-12.284 3.703-21.083 14.899-21.12 28.156v0.004c0.18 16.299 13.434 29.442 29.758 29.442 0.113 0 0.226-0.001 0.339-0.002h-0.017z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Drive",
		paths: [
			"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512c282.77 0 512-229.23 512-512v0c0-282.77-229.23-512-512-512v0zM512 90.24c191.066 0.093 352.437 127.127 404.356 301.333l0.764 2.987c0.883 2.977 1.392 6.396 1.392 9.935 0 19.971-16.189 36.16-36.16 36.16-1.732 0-3.436-0.122-5.103-0.357l0.192 0.022-197.12-26.24c-11.291-1.632-21.009-7.361-27.779-15.604l-0.061-0.076c-33.353-41.113-83.873-67.173-140.48-67.173s-107.127 26.060-140.217 66.838l-0.263 0.335c-6.831 8.319-16.549 14.048-27.604 15.652l-0.236 0.028-197.12 26.24c-1.476 0.213-3.179 0.335-4.912 0.335-19.971 0-36.16-16.189-36.16-36.16 0-3.539 0.508-6.959 1.456-10.191l-0.064 0.256c52.683-177.193 214.054-304.227 405.109-304.32h0.011zM146.56 583.68l197.12 26.24c11.291 1.632 21.009 7.361 27.779 15.604l0.061 0.076c6.515 8.11 13.432 15.332 20.926 21.913l0.194 0.167c7.628 6.542 12.874 15.67 14.373 26.012l0.027 0.228 32 202.24c0.24 1.572 0.377 3.385 0.377 5.231 0 20.147-16.333 36.48-36.48 36.48-3.553 0-6.988-0.508-10.235-1.455l0.258 0.064c-138.131-42.152-244.495-149.362-284.679-285.007l-0.761-2.993c-0.637-2.551-1.003-5.48-1.003-8.494 0-20.147 16.333-36.48 36.48-36.48 1.255 0 2.494 0.063 3.717 0.187l-0.154-0.013zM513.6 602.24c-0.472 0.009-1.028 0.014-1.586 0.014-49.838 0-90.24-40.402-90.24-90.24s40.402-90.24 90.24-90.24c49.838 0 90.24 40.402 90.24 90.24 0 0.558-0.005 1.114-0.015 1.669l0.001-0.083c-0.71 48.666-39.974 87.93-88.573 88.639l-0.067 0.001zM585.6 876.16l32-202.24c1.526-10.57 6.772-19.698 14.343-26.192l0.057-0.048c7.688-6.748 14.605-13.97 20.86-21.746l0.26-0.334c6.831-8.319 16.549-14.048 27.604-15.652l0.236-0.028 197.12-26.24c1.371-0.183 2.956-0.287 4.565-0.287 20.147 0 36.48 16.333 36.48 36.48 0 3.52-0.499 6.924-1.429 10.144l0.064-0.258c-40.945 138.638-147.309 245.848-282.443 287.211l-2.997 0.789c-3.252 1.052-6.993 1.659-10.875 1.659-20.147 0-36.48-16.333-36.48-36.48 0-2.397 0.231-4.741 0.673-7.009l-0.037 0.23z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "accessibility-vision",
		paths: [
			"M476.019 227.945c-0.228 0.228-5.351 0.683-11.272 1.025-82.201 5.351-176.925 36.204-259.012 84.478-52.485 30.853-92.561 61.593-132.637 101.784-26.868 26.983-46.223 50.892-62.846 77.532-12.41 20.037-11.954 18.103-6.944 27.096 10.019 18.103 29.032 44.858 45.427 63.529 84.478 97.002 212.333 172.598 339.164 200.834 15.483 3.416 38.482 7.4 50.095 8.652 3.757 0.341 7.742 0.911 8.767 1.139 11.613 2.164 88.463 3.074 111.916 1.366 108.159-7.97 225.539-54.421 324.363-128.196 40.645-30.399 83.681-72.296 109.639-106.679 8.995-11.954 19.241-27.438 25.958-38.937l5.351-9.336-5.351-9.449c-7.856-13.662-23.112-36.091-31.992-47.248-14.118-17.647-41.328-46.338-58.633-61.936-8.652-7.742-11.613-10.247-21.518-18.558-74.345-62.162-173.51-112.371-262.427-132.865-27.211-6.262-43.491-9.108-63.187-11.272-6.603-0.683-13.434-1.594-15.37-1.821-3.985-0.797-88.691-1.821-89.487-1.139zM539.889 309.349c56.47 8.539 108.045 40.986 139.468 87.779 31.65 47.248 42.238 101.784 30.626 158.709-12.068 59.772-55.559 114.421-112.371 141.289-20.265 9.564-39.848 15.37-61.593 18.216-11.272 1.48-44.515 1.48-53.054 0-23.112-3.871-35.863-7.514-53.851-15.029-42.808-17.988-81.062-53.851-102.010-95.635-11.499-23.112-16.508-39.735-21.176-71.498-0.911-5.92-0.911-36.204 0-42.125 4.667-31.423 9.677-48.5 21.176-71.498 29.26-58.406 87.893-100.758 152.447-109.98 4.667-0.683 9.791-1.48 11.385-1.708 5.579-0.797 40.531 0.228 48.956 1.48zM744.024 351.018c77.988 38.368 147.551 93.358 193.091 152.447 5.123 6.603 5.92 8.198 4.895 10.247-4.441 9.905-47.931 56.128-71.385 76.052-26.186 22.088-63.643 48.387-92.902 65.009-12.068 6.831-51.347 26.983-52.713 26.983-0.341 0 3.302-5.465 7.97-12.182 37.458-53.397 54.307-115.9 49.069-181.365-3.871-48.5-24.022-101.1-53.851-140.265-5.92-7.742-6.375-7.856 15.826 3.074zM287.481 353.523c-18.216 25.617-32.106 54.421-40.189 83.225-15.029 53.282-13.89 109.525 3.416 161.897 8.198 25.047 23.795 55.218 38.254 74.231 2.846 3.757 5.010 6.944 4.782 7.172-0.456 0.569-33.473-16.053-45.313-22.657-62.732-35.635-118.861-81.86-157.343-129.791-5.010-6.148-9.564-12.41-10.247-13.89-1.139-2.277 0-4.098 10.019-16.622 21.86-27.211 58.861-62.049 92.106-86.868 14.231-10.702 44.289-30.512 58.633-38.823 11.841-6.831 50.55-26.642 51.005-26.072 0.228 0.228-2.049 3.871-5.123 8.198z",
			"M498.333 387.564c-52.485 5.465-95.294 41.784-109.297 92.675-3.871 14.003-4.895 39.848-2.164 54.079 6.49 33.814 25.503 62.618 53.282 81.176 13.434 8.995 25.047 14.118 41.1 18.216 19.811 5.010 47.248 3.871 67.628-2.733 8.767-2.846 27.552-12.637 34.838-18.103 36.774-27.666 54.649-68.88 50.208-115.559-1.139-11.841-9.108-38.823-10.929-36.774-0.456 0.456-1.708 3.302-2.733 6.375-2.733 7.4-10.702 17.76-17.306 22.657-11.499 8.425-20.949 11.385-34.725 11.272-23.681-0.228-44.289-15.939-51.347-39.165-2.96-10.019-2.505-25.389 1.366-34.953 4.782-12.41 15.142-23.567 27.894-30.057 3.188-1.594 5.465-2.96 5.123-2.96s-5.579-1.252-11.613-2.733c-10.816-2.846-31.081-4.441-41.328-3.416z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Add",
		paths: [
			"M431.131 2.261c-22.143 5.887-41.086 25.855-45.822 48.639-1.024 4.736-1.407 55.806-1.407 169.851v163.195l-163.835 0.127c-90.11 0.127-164.219 0.256-164.731 0.384-0.64 0.127-3.327 0.64-6.016 1.28-14.592 2.816-31.999 15.616-40.446 29.695-8.703 14.336-8.832 16-8.832 94.717-0.127 45.951 0.384 73.085 1.28 78.078 4.48 24.319 24.959 45.055 49.535 50.302 4.864 1.024 53.631 1.407 169.851 1.407h163.195v162.299c0 109.82 0.384 164.859 1.407 169.979 4.096 23.039 23.039 43.262 46.335 49.279 8.32 2.176 14.976 2.432 78.974 2.432 44.671 0 72.702-0.512 77.565-1.407 24.192-4.352 45.182-25.087 50.302-49.535 1.024-4.736 1.407-55.806 1.407-169.851v-163.195l333.43-0.64 7.552-2.944c20.863-7.936 35.583-24.063 41.086-45.182 2.304-8.832 2.816-143.1 0.512-155.388-4.48-24.703-25.727-45.951-50.302-50.431-5.247-1.024-58.878-1.407-169.979-1.407h-162.299v-163.579c0-156.412-0.127-164.091-2.432-172.795-1.28-5.12-4.352-12.543-6.656-16.383-8.576-14.336-25.727-26.495-41.855-29.823-4.48-0.896-30.847-1.407-78.078-1.28-63.102 0-72.318 0.256-79.741 2.176z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Add-person",
		paths: [
			"M483.188 1.247c-34.111 5.063-63.281 16.031-90.884 34.111-13.62 8.92-21.214 15.308-34.955 29.049-32.786 33.027-52.674 72.563-60.509 120.655-1.928 12.174-1.928 52.433 0.12 63.884 4.099 23.866 10.728 44.357 20.611 64.125 28.326 56.532 78.831 97.392 139.701 113.183 76.42 19.768 157.901-3.616 211.781-60.75 29.651-31.459 48.937-70.152 56.652-113.545 2.652-14.826 3.013-54.241 0.603-68.102-2.169-13.018-7.955-34.714-11.692-44.237-21.816-55.929-63.642-99.442-118.125-122.705-17.96-7.715-30.014-11.089-55.929-15.67-8.92-1.688-46.406-1.567-57.374 0z",
			"M316.969 420.59c-1.325 0.844-7.835 5.063-14.464 9.402-66.174 42.79-111.254 115.834-120.777 195.629-0.483 4.58-0.964 73.285-0.964 152.477v144.040l3.133 11.451c7.473 26.759 22.902 49.902 43.875 65.692 10.125 7.593 23.866 14.826 35.197 18.563 19.286 6.388 6.629 6.147 304.352 6.147h275.906l-0.483-198.039c-0.241-108.843-0.844-200.089-1.325-202.741-3.616-20.491-7.352-37.486-10.004-45.803-20.008-63.522-60.268-115.955-116.317-151.152-6.388-4.099-12.295-7.352-13.018-7.352s-3.375 1.808-5.785 4.099c-29.411 27.241-74.732 51.589-115.231 61.714-25.071 6.388-40.862 8.317-68.223 8.317-24.71 0-35.197-0.964-55.688-4.941-34.353-6.629-68.946-20.974-98.598-40.621-10.487-6.991-28.206-20.852-32.424-25.432-3.255-3.496-5.544-3.857-9.16-1.447zM686.41 724.218c6.027 4.701 6.027 4.821 6.027 48.094v40.741h40.379c26.398 0 41.223 0.483 43.151 1.325 6.027 2.772 6.871 6.268 6.871 29.049 0 17.719-0.361 21.335-2.049 23.866-4.099 6.027-3.375 5.907-47.009 6.027h-41.343v40.499c0 43.995-0.241 45.562-6.871 48.576-3.857 1.808-42.67 1.808-46.526 0-6.629-3.013-6.871-4.58-6.871-48.576v-40.499h-40.499c-43.995 0-45.562-0.241-48.576-6.871-1.808-4.099-1.808-42.67 0.12-46.767 2.893-6.388 4.701-6.629 48.576-6.629h40.379v-40.379c0-26.156 0.483-41.223 1.325-43.151 2.772-6.027 5.907-6.75 29.411-6.75 15.187 0 22.299 0.361 23.504 1.447z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "aeroplane",
		paths: [
			"M981.97 0.131c-8.462 0.682-20.745 3.412-30.707 6.688-21.018 6.96-59.231 27.295-82.568 43.808-7.233 5.186-98.399 73.151-185.881 138.797l-52.817 39.714-75.88-25.521c-363.71-121.873-399.603-133.747-406.427-133.883-7.915 0-15.559 2.183-21.427 6.141-5.732 3.958-70.421 68.238-69.876 69.603 0.273 1.092 39.169 24.975 89.665 55.273 8.598 5.050 36.302 21.836 61.414 36.985 25.112 15.286 47.631 28.796 49.814 30.161 2.32 1.365 11.191 6.688 19.789 11.874 16.924 10.236 99.901 60.459 153.945 93.077 18.151 10.918 33.028 20.198 33.028 20.745 0 0.409-5.050 6.96-11.191 14.466-15.012 18.288-73.151 89.528-90.348 110.819-7.642 9.28-22.655 27.704-33.573 41.079s-31.116 38.213-45.037 55.273c-24.839 30.571-64.008 78.61-64.962 79.703-0.409 0.409-125.694-52.544-131.564-55.682-1.092-0.546-13.239-5.868-27.022-11.736-22.655-9.553-25.657-10.509-31.799-9.963-6.551 0.682-7.642 1.365-17.742 11.465-5.868 5.868-10.645 11.327-10.372 11.874 0.546 1.638 381.999 383.090 382.953 383.090 1.638 0 19.38-18.971 21.29-22.792 1.092-2.047 2.047-5.868 2.047-8.325 0-3.821-11.601-32.754-25.931-65.1-9.007-20.336-51.861-121.191-51.861-122.147 0-0.682 4.094-4.503 9.28-8.598 5.050-4.094 25.112-20.336 44.628-36.302s42.444-34.666 50.906-41.489c8.598-6.96 16.241-13.239 17.060-13.921 0.956-0.818 9.963-8.189 20.062-16.377s22.109-18.015 26.749-21.7c4.503-3.821 10.918-9.144 14.194-11.736s9.417-7.506 13.512-10.918c4.23-3.412 12.556-10.236 18.56-15.148 33.846-27.704 62.915-51.315 74.244-60.596 10.509-8.598 13.101-10.1 14.466-8.598 0.818 0.956 10.782 17.060 21.836 35.893 27.842 47.084 82.704 139.206 92.122 154.901 4.368 7.097 25.248 42.172 46.402 77.792 21.29 35.62 44.219 74.38 51.179 85.98s16.924 28.387 22.245 37.258c5.323 8.871 10.1 16.104 10.782 16.104 0.546 0 16.513-15.422 35.484-34.255 36.985-36.849 39.714-40.67 40.943-54.317 0.546-7.37-3.276-19.243-79.156-246.887l-79.839-239.107 85.298-113.685c90.348-120.509 95.67-127.742 108.499-149.033 27.295-45.037 39.714-84.342 33.71-106.588-2.047-7.779-7.642-15.422-14.194-19.243-5.595-3.276-18.015-5.595-25.931-4.913z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "alarm-clock",
		paths: [
			"M210.362 1.203c-19.55 3.629-31.022 10.301-56.425 32.427-10.77 9.482-34.183 29.851-51.859 45.304s-34.065 29.735-36.29 31.724c-2.225 1.99-9.131 8.078-15.218 13.462-13.462 11.941-14.984 13.579-21.54 23.296-9.599 14.164-13.579 27.159-14.164 45.655-0.702 20.486 4.448 37.929 15.453 52.913 4.214 5.619 47.527 55.839 65.439 75.857 1.99 2.225 6.789 7.726 10.652 12.175l6.907 7.96-6.088 14.282c-15.102 35.119-27.861 83.7-31.49 120.106-0.469 4.214-1.054 8.896-1.405 10.536-1.054 6.088-1.287 61.927-0.234 74.335 2.225 26.105 8.078 59.351 14.164 80.774 1.287 4.448 2.81 10.067 3.395 12.292 3.512 14.048 15.569 44.484 26.339 66.141 18.614 37.811 41.441 71.058 72.228 105.123l7.96 8.78-29.968 51.742c-16.389 28.446-30.671 53.615-31.724 55.956-9.365 21.773-5.502 45.538 10.301 62.863 14.399 15.687 35.588 22.359 56.307 17.559 11.121-2.576 19.199-7.14 27.744-15.804 6.673-6.673 11.004-13.462 33.832-53.264 14.399-25.169 26.456-45.889 26.69-46.24 0.234-0.234 2.225 0.469 4.214 1.639 51.859 30.085 117.063 50.103 180.512 55.371 13.579 1.171 55.020 1.171 70.472 0.117 60.171-4.448 124.204-23.647 177.351-53.264 4.332-2.341 8.078-4.097 8.311-3.746 0.469 0.469 27.393 47.176 44.25 76.56 14.282 25.052 27.276 35.821 47.060 39.216 38.162 6.673 71.877-24.583 68.248-63.331-0.351-4.448-1.756-10.77-3.161-14.164-1.287-3.395-12.292-23.296-24.467-44.25-12.057-20.955-25.754-44.601-30.32-52.562l-8.311-14.399 3.746-4.332c1.99-2.341 5.619-6.322 8.078-8.896 9.365-10.067 24.349-28.797 33.832-42.494 45.069-64.97 70.121-133.218 77.847-212.704 2.107-21.773 1.522-68.482-1.054-89.553-5.502-43.899-15.92-83.466-31.607-120.224l-6.088-14.164 19.081-21.891c10.536-12.057 22.125-25.403 25.988-29.617 37.226-42.143 41.441-47.645 47.060-61.107 11.238-27.159 8.429-57.595-7.726-81.944-5.853-8.896-10.185-13.346-25.871-27.041-38.747-33.948-51.742-45.304-54.903-47.996-1.873-1.756-10.652-9.365-19.315-16.858-8.663-7.609-17.91-15.687-20.486-18.028-22.008-19.901-30.436-25.988-42.962-31.022-23.296-9.248-47.762-8.545-70.355 2.107-12.175 5.619-21.54 13.228-34.417 27.979-6.322 7.258-11.941 13.697-12.643 14.399-1.522 1.522-9.248 10.419-34.417 39.333l-20.135 22.944-5.97-2.225c-17.559-6.322-55.254-15.569-73.516-18.028-2.927-0.351-6.555-0.936-8.194-1.171-16.974-2.81-37.46-3.863-66.726-3.512-28.33 0.469-31.49 0.702-53.264 3.629-25.403 3.395-54.669 10.185-77.496 17.91l-9.716 3.278-14.867-17.091c-8.194-9.365-16.389-18.73-18.028-20.603-16.389-18.614-24.7-28.212-30.787-35.119-16.623-19.315-27.276-27.861-42.377-33.832-15.102-6.088-32.778-7.96-47.879-5.268zM549.26 177.266c83.232 10.652 153.002 44.015 209.192 99.855 55.488 55.020 89.553 122.566 101.143 200.413 3.512 23.529 3.746 75.622 0.469 94.821-0.234 1.639-1.287 8.194-2.458 14.633-6.789 40.856-22.593 83.7-44.133 119.405-57.712 95.992-156.748 158.855-267.139 169.858-11.706 1.171-53.029 1.287-65.555 0.234-82.881-7.258-160.493-43.899-218.792-103.25-55.839-56.892-89.202-126.545-99.269-206.733-0.936-7.375-1.522-23.998-1.405-41.557 0.117-31.49 1.873-47.996 8.194-76.676 20.369-91.309 79.369-172.785 160.845-222.186 44.953-27.276 101.611-45.771 149.841-48.932 6.088-0.469 11.355-1.054 11.706-1.287 0.702-0.702 50.572 0.585 57.361 1.405z",
			"M500.679 221.165c-10.419 2.576-20.017 9.248-25.637 17.794-8.194 12.526-7.843 3.863-7.493 159.089l0.351 139.774 3.395 6.907c2.927 6.088 14.164 17.676 82.179 85.691 85.105 85.105 83.7 83.817 98.217 85.691 29.617 3.863 53.849-20.252 49.635-49.401-1.99-14.516-1.522-13.931-77.027-89.553l-69.769-69.769-0.585-127.599c-0.585-127.365-0.585-127.599-3.043-132.867-6.088-12.877-15.102-20.837-27.626-24.818-7.14-2.107-16.272-2.576-22.593-0.936z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Alias-numbers",
		paths: [
			"M598.59 0.457c-1.687 0.361-8.435 1.325-15.062 2.41-69.407 11.086-130.26 63.745-152.191 131.827-5.784 17.955-5.905 16.509 2.651 17.472 16.509 1.807 35.427 6.507 53.020 13.255 69.287 26.39 121.705 86.037 139.057 158.457 4.338 17.834 6.266 37.716 6.266 63.504v3.495l8.194-0.964c81.578-9.76 150.263-71.577 167.736-150.986 5.422-24.341 6.145-55.912 1.807-77.722-3.856-19.762-8.194-33.137-16.509-50.49-10.122-21.207-23.015-38.921-41.090-56.274-27.354-26.39-63.142-44.826-100.858-51.695-10.604-2.049-45.307-3.495-53.020-2.29z",
			"M388.801 180.966c-0.241 0.241-3.495 0.844-7.11 1.205-15.062 1.807-27.835 4.94-44.465 11.206-26.871 10.001-47.236 23.256-68.926 44.946-28.679 28.559-45.67 60.25-54.225 101.22-3.976 18.436-3.976 55.31-0.12 73.505 8.917 41.934 26.751 74.71 56.274 103.388 27.956 27.112 61.455 44.705 99.653 52.176 19.521 3.856 53.622 3.976 72.782 0.12 84.23-16.75 147.612-84.35 158.216-168.941 1.928-15.062 0.844-45.79-2.169-60.25-14.821-72.059-64.226-127.61-133.513-149.781-18.557-6.025-33.86-8.435-56.515-8.796-10.725-0.241-19.641-0.241-19.882 0z",
			"M743.792 404.252c-21.57 13.135-54.105 25.787-78.205 30.366-13.014 2.53-29.161 4.579-38.68 4.82-3.374 0.12-3.735 0.723-6.025 7.591-11.327 36.15-37.716 75.795-66.636 100.015l-5.061 4.217 11.086 3.856c17.592 6.145 46.754 20.726 58.201 29.281 42.295 31.45 70.131 66.516 87.362 109.896 7.23 18.316 13.616 43.741 15.182 60.491 0.482 5.181 0.964 10.604 1.205 11.93 0.12 1.325 0.361 19.039 0.361 39.404l0.12 37.114h180.869l-0.482-132.911c-0.241-73.022-0.723-134.718-1.205-137.008s-1.446-6.989-2.169-10.242c-3.976-19.4-10.242-38.077-18.075-53.984-22.172-44.585-58.442-79.41-104.112-99.773-7.712-3.374-24.461-9.52-26.149-9.52-0.241 0-3.615 1.928-7.591 4.459z",
			"M258.179 585.242c-71.456 27.232-120.62 86.157-135.080 161.59-2.049 10.484-2.169 20.967-2.53 118.090-0.361 116.041-0.602 111.945 6.386 126.405 4.338 8.796 17.111 21.57 25.907 25.907 14.821 7.11-3.254 6.748 279.8 6.748h260.038l-0.482-132.791c-0.241-73.143-0.844-135.080-1.325-137.731-7.11-37.475-17.714-64.467-35.789-90.375-24.582-35.547-60.009-62.78-101.702-78.325l-12.050-4.579-6.627 3.856c-45.187 26.149-85.072 36.632-134.357 35.667-44.102-0.844-82.783-12.050-120.741-34.945-3.856-2.29-7.471-4.217-8.194-4.217-0.602 0-6.627 2.169-13.255 4.7z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "arrow-down",
		paths: [
			"M0 322.389l512 530.944 512-530.944-146.219-151.723-365.781 379.349-365.653-379.349-146.347 151.723z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "arrow-up",
		paths: [
			"M1023.982 701.593l-511.98-530.923-511.98 530.923 146.213 151.717 365.767-379.334 365.639 379.334 146.341-151.717z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "arrow-next",
		paths: [
			"M151.73 1023.992l530.944-512-530.944-512-151.723 146.219 379.349 365.781-379.349 365.653 151.723 146.347z"
		],
		height: 1024,
		width: 691.1999999999997
	},
	{
		name: "arrow-previous",
		paths: [
			"M530.947 0l-530.944 512 530.944 512 151.723-146.219-379.349-365.781 379.349-365.653-151.723-146.347z"
		],
		height: 1024,
		width: 681.6
	},
	{
		name: "assistance",
		paths: [
			"M484.157 0.198c-0.241 0.241-5.667 0.723-11.937 1.206-10.731 0.723-43.889 4.823-50.641 6.149-1.688 0.361-4.34 0.844-5.909 1.206-8.199 1.567-35.569 8.079-42.924 10.369-4.582 1.326-11.937 3.497-16.277 4.703-7.717 2.291-32.072 10.972-36.775 13.263-1.326 0.603-5.909 2.532-10.249 4.34-17.966 7.234-52.088 25.32-71.138 37.619-23.27 14.952-28.093 18.447-45.698 32.555-75.358 60.528-131.425 139.021-163.738 229.331-9.043 25.32-18.569 61.975-22.065 85.004-2.894 18.809-3.497 23.392-4.22 31.349-0.483 4.582-1.086 10.007-1.447 12.057-1.086 6.873-1.326 67.641-0.361 79.578 1.206 13.866 3.617 36.292 4.34 39.789 0.361 1.326 1.688 8.682 3.014 16.277 11.334 64.748 37.981 131.305 75.6 188.456 4.34 6.752 8.44 12.78 8.923 13.504 0.603 0.603 2.653 3.376 4.582 6.029s5.306 7.234 7.476 10.129c8.682 11.575 33.64 39.909 46.179 52.329 60.889 60.528 131.545 102.367 217.032 128.531 11.454 3.617 39.186 10.007 53.655 12.66 30.988 5.426 54.258 7.354 90.43 7.354 28.696 0 51.967-1.326 65.11-3.617 1.688-0.241 6.029-0.844 9.646-1.206 13.746-1.567 39.669-7.234 62.698-13.504 96.217-26.285 184.116-81.99 249.948-158.312 40.754-47.265 70.777-97.906 92.962-156.384 5.184-13.746 14.227-42.562 16.397-52.208 7.114-31.952 11.454-56.308 12.78-72.344 0.361-4.943 0.964-10.369 1.326-12.057 1.086-5.426 1.326-67.762 0.241-79.578-1.447-16.397-3.497-34.605-4.703-41.598-0.603-3.376-1.688-9.526-2.411-13.866-8.923-53.172-33.761-119.729-62.939-167.958-23.753-39.428-48.712-71.38-80.664-103.21-60.287-60.045-138.659-105.984-219.323-128.652-22.306-6.149-53.775-12.902-68.124-14.469-2.653-0.241-5.909-0.723-7.234-0.964-1.326-0.361-5.909-0.844-10.249-1.326-4.34-0.361-10.249-0.964-13.263-1.326-6.149-0.723-69.45-1.809-70.053-1.206zM545.167 188.293c2.050 0.361 6.029 0.964 9.043 1.326 44.371 5.909 82.593 22.186 112.977 47.868 13.504 11.454 21.583 20.618 30.988 35.086 11.093 17.122 17.242 30.866 22.065 49.676 2.411 9.887 3.134 15.675 3.497 31.952 0.723 34.846-5.064 55.825-23.512 83.798-13.263 20.256-25.562 32.796-76.081 78.373-43.286 39.066-53.172 49.676-61.010 66.315-3.497 7.354-7.837 21.583-9.526 30.746-1.809 10.249-6.993 27.49-9.766 32.435-5.909 10.972-17.603 20.015-28.817 22.547-6.993 1.447-22.065 1.567-28.576 0-13.383-3.134-27.249-13.625-32.796-24.597-5.184-10.61-6.149-16.519-6.029-37.619 0.12-16.88 0.603-21.945 3.256-33.519 4.703-20.256 14.107-40.633 26.767-57.514 10.369-13.746 34.002-36.895 74.153-72.344 22.065-19.533 32.313-30.263 40.875-42.924 10.369-15.192 12.78-23.392 12.78-42.081 0-13.625-0.361-16.036-3.497-24.476-13.143-35.689-47.385-56.79-90.31-55.584-30.263 0.964-50.641 8.079-65.471 23.029-13.263 13.504-25.562 34.966-35.449 61.854-8.32 22.909-10.972 28.817-16.277 36.052-9.887 13.383-22.789 20.377-39.066 21.22-17.363 0.964-31.349-4.34-43.286-16.157-12.177-12.177-17.122-23.632-17.122-39.669 0-9.284 2.411-25.803 4.943-33.881 3.376-11.093 9.163-25.44 12.78-31.832 2.17-3.979 3.979-7.354 3.979-7.596 0-0.361 2.773-4.703 6.149-9.766 35.328-52.208 93.806-85.607 162.654-92.48 13.383-1.447 52.329-1.567 59.684-0.241zM523.344 711.581c7.837 2.291 14.349 5.909 22.186 12.299 15.554 12.419 23.512 30.866 22.668 52.329-0.723 18.569-5.667 30.505-17.603 42.201-21.462 21.22-54.258 25.079-81.387 9.646-8.199-4.703-18.447-14.952-22.668-22.547-6.873-12.78-9.284-35.81-5.064-50.279 6.873-23.753 29.058-42.442 54.258-45.698 6.873-0.844 21.1 0.241 27.612 2.050z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "avatar",
		paths: [
			"M492.463 0.474c-82.661 8.676-150.983 59.405-181.59 134.837-6.989 16.99-11.567 33.498-13.255 47.597-0.361 3.012-1.085 7.832-1.566 10.845-1.085 5.784-0.723 44.343 0.602 52.416 4.459 29.522 16.508 62.539 31.449 85.914 13.135 20.365 31.812 41.089 50.489 55.67 61.334 48.079 145.561 59.044 217.498 28.558 71.816-30.486 121.944-97.121 130.981-174.36 1.687-14.34 0.964-46.633-1.325-60.129-6.145-35.547-20.002-68.081-40.969-95.916-8.676-11.327-29.642-32.776-39.884-40.608-31.088-23.617-67.84-38.8-105.194-43.74-10.725-1.325-38.318-2.049-47.235-1.085z",
			"M313.524 422.939c-21.931 13.737-40.247 28.076-55.911 44.223-41.813 43.138-67.599 96.88-75.431 157.972-1.325 10.122-1.566 40.849-1.325 154.839 0.241 130.981 0.361 142.79 2.29 150.019 3.254 11.809 6.869 21.57 10.725 28.799 17.955 33.257 46.272 54.585 82.902 62.659 11.447 2.41 12.532 2.41 288.953 2.53h277.506l-0.482-197.857c-0.12-108.93-0.723-199.303-1.085-200.99-0.482-1.687-1.446-7.11-2.169-12.050-6.266-42.657-26.751-89.168-55.068-124.956-15.665-19.882-37.595-40.487-57.959-54.344-12.291-8.435-22.774-14.701-24.461-14.701-0.602 0-3.254 1.927-5.784 4.217-30.607 28.317-73.745 51.211-116.763 61.936-24.22 6.145-38.198 7.832-64.707 7.832-32.654 0.12-51.331-2.169-78.203-9.64-25.907-7.23-59.526-22.774-78.443-36.029-11.567-8.194-22.895-16.99-28.678-22.292-3.615-3.254-7.35-6.025-8.194-5.905-0.964 0-4.337 1.687-7.712 3.735z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "birthday",
		paths: [
			"M204.316 7.349c-3.975 4.096-7.71 7.95-8.433 8.794-13.251 14.215-37.947 46.741-49.272 65.173-28.43 46.019-32.768 76.738-15.541 110.711 11.203 22.167 31.081 38.43 55.898 45.417 10.481 3.012 12.769 2.771 5.421-0.722-8.553-3.855-16.383-11.324-20.721-19.516s-5.421-12.408-5.421-21.804c0-16.022 13.734-40.237 39.634-69.389l4.939-5.662 5.421 5.782c13.854 14.817 28.43 35.538 34.575 49.031 3.494 7.469 5.903 18.553 5.301 23.13-1.205 9.035-2.048 12.167-4.699 17.348-5.421 10.722-13.974 18.431-24.576 22.287-6.143 2.289-1.325 2.168 7.589-0.12 9.517-2.409 24.455-9.879 31.683-15.781 21.443-17.348 32.888-38.67 34.936-65.173 1.566-21.082-6.867-45.658-26.262-76.738-12.529-19.997-36.623-51.199-53.006-68.667-3.132-3.373-6.746-7.228-8.072-8.794l-2.409-2.651-6.987 7.348z",
			"M508.618 3.495c-1.687 1.927-7.348 8.313-12.529 14.215-36.382 40.598-63.607 83.605-71.317 112.999-4.699 17.348-2.529 40.718 5.301 57.222 12.408 26.744 38.911 47.344 65.896 51.199l4.819 0.722-5.060-2.168c-16.986-7.108-28.069-23.009-28.31-40.718-0.361-17.227 13.010-41.441 39.032-70.354l5.541-6.143 4.819 5.060c18.311 19.395 33.129 41.803 38.189 57.464 7.228 22.167-4.819 46.741-26.985 55.174l-4.336 1.687 5.421-0.722c8.674-1.205 21.082-6.023 30.478-11.927 36.020-22.648 51.319-64.57 37.947-103.603-9.396-27.466-31.081-61.68-61.8-97.699-8.915-10.36-23.13-25.901-23.732-25.901-0.241 0-1.687 1.566-3.373 3.494z",
			"M806.415 7.591c-40.718 42.164-74.69 95.411-81.557 127.937-5.782 27.346 3.494 57.222 24.335 78.304 11.203 11.203 24.816 19.275 39.996 23.611 10.12 2.892 14.576 2.892 6.987-0.12-21.443-8.313-32.888-33.731-25.178-55.776 5.060-14.095 18.793-35.056 33.972-51.801 6.867-7.348 8.915-9.035 10.12-7.83 5.782 5.903 22.648 27.105 27.828 35.177 11.324 17.348 15.541 28.43 15.3 40.718-0.241 17.107-12.649 34.453-28.792 40.237-5.541 1.927-1.807 2.289 5.060 0.361 33.249-8.915 58.066-33.249 66.257-65.053 5.782-22.407 2.892-42.044-10.24-69.149-11.927-24.576-38.67-62.643-60.836-86.737-1.807-2.048-6.265-6.746-9.757-10.481l-6.385-6.867-7.108 7.469z",
			"M170.222 273.103c-2.892 1.085-7.589 4.216-10.36 6.987-9.396 9.396-9.035 4.939-9.035 109.265v92.519h-18.914c-29.032 0-45.417 3.253-64.45 12.649-31.322 15.541-54.091 43.369-63.366 77.461l-3.132 11.686-0.482 71.076c-0.241 50.958 0 72.401 0.964 75.895 3.132 11.083 13.010 19.997 23.491 21.564l5.421 0.844v270.933h963.745v-270.451l6.385-1.566c8.192-1.927 14.939-6.746 19.516-14.095l3.614-5.782v-148.417l-3.253-11.806c-5.782-20.962-16.263-39.152-31.683-54.452-16.022-16.022-34.333-26.503-56.259-32.044-7.95-2.048-15.059-2.651-34.333-3.132l-24.455-0.602v-91.797c0-104.085 0.241-100.471-9.035-109.746-8.313-8.433-12.047-9.035-51.801-9.035-38.911 0-42.164 0.602-50.597 9.035-9.396 9.276-9.035 4.939-9.035 109.265v92.519h-180.702v-91.917c0-50.838-0.602-93.965-1.205-96.494-1.566-6.746-6.987-13.974-13.734-18.19l-5.903-3.614-36.623-0.361c-42.164-0.482-44.814 0-53.728 8.674-9.637 9.396-9.276 4.699-9.276 109.385v92.519h-180.702v-93.243c0-82.641-0.241-93.724-1.927-97.82-2.892-7.108-7.228-12.167-13.493-15.781l-5.662-3.373-37.345-0.241c-31.563-0.241-38.189 0-42.646 1.687zM240.937 696.307c15.42 4.336 25.178 9.999 47.224 27.225 17.588 13.734 26.142 19.034 37.706 23.13 11.806 4.216 14.576 4.819 29.756 5.782 27.346 1.807 49.392-4.939 71.559-22.045 31.563-24.335 40.116-29.515 56.861-34.333 13.734-3.855 42.525-3.975 56.259 0 16.143 4.578 25.659 10.12 48.428 27.828 30.117 23.611 43.249 28.551 74.69 28.31 16.022-0.12 19.275-0.482 28.912-3.373 13.613-4.096 24.576-10.36 41.2-23.25 33.37-26.142 46.139-31.563 75.654-32.285 18.070-0.482 28.19 0.602 43.369 4.939 40.959 11.444 67.703 39.996 77.943 83.003 2.529 10.481 2.651 13.974 3.012 96.616l0.482 85.893h-843.396v-80.472c0-85.412 0.482-94.809 6.023-112.035 11.806-36.623 36.984-61.559 73.366-72.522 21.202-6.506 53.006-7.589 70.956-2.409z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "buy",
		paths: [
			"M497.728 56.224c-0.236 0.236-4.238 0.824-8.714 1.177-17.779 1.766-46.274 10.714-64.172 20.37-50.514 27.082-87.015 77.006-97.023 132.7-2.826 16.013-2.944 19.192-2.944 96.787l-0.117 72.178h-136.35c-148.713 0-142.355-0.236-156.838 6.712-3.768 1.766-9.773 6.476-14.247 10.833-12.599 12.599-18.604 28.495-17.073 45.215 0.942 10.126 2.472 15.66 7.536 26.14 2.238 4.474 9.302 19.9 15.778 34.146s12.835 28.259 14.13 31.203c1.413 2.944 5.181 11.422 8.595 18.839s7.536 16.484 9.184 20.017c1.649 3.532 28.142 62.052 59.109 130.109 30.85 67.94 57.46 126.577 59.109 130.109 1.53 3.532 13.541 29.79 26.493 58.284s24.844 54.752 26.493 58.284c1.649 3.532 4.238 9.302 5.77 12.716l2.826 6.123 547.872-0.589 9.773-21.194c13.658-29.554 15.543-33.793 26.376-57.107 5.299-11.303 10.714-22.96 12.010-25.904s7.771-16.72 14.13-30.614c13.424-28.73 15.543-33.44 25.433-54.752 7.889-17.426 12.010-26.14 19.075-41.211 2.708-5.887 6.24-13.305 7.653-16.484 3.415-7.536 7.771-17.073 17.662-38.267 7.065-15.307 46.627-100.673 54.752-118.335 1.766-3.885 6.829-14.718 11.186-24.138 11.069-23.902 13.541-29.084 21.783-47.098 4.004-8.714 9.537-20.488 12.363-26.021 7.3-14.365 9.302-22.019 8.478-32.263-1.766-22.725-16.367-41.8-39.328-50.984l-8.007-3.179-276.114-0.589-0.117-72.767c0-39.916-0.236-74.297-0.353-76.182-1.53-17.779-5.299-34.852-11.539-51.691-27.199-73.591-96.905-122.339-175.913-122.927-7.889-0.117-14.483 0.117-14.718 0.353zM537.762 147.477c34.735 9.655 61.111 35.677 71.001 70.176 2.591 9.184 2.591 10.597 3.061 85.483l0.353 76.299h-199.227l0.471-75.71c0.117-41.564 0.706-77.241 1.177-79.126 7.771-31.203 22.254-51.22 48.393-66.998 6.476-3.885 16.837-8.36 22.489-9.773 18.957-4.474 36.973-4.593 52.28-0.353zM324.052 500.362c0.353 1.883 1.766 10.48 3.061 19.192 4.357 29.437 8.242 54.635 10.008 65.938 1.060 6.123 2.591 16.249 3.532 22.372s2.472 16.484 3.532 22.96c0.942 6.476 1.766 12.128 1.766 12.599 0 0.589-35.795 0.942-79.596 0.942h-79.479l-5.063-10.95c-2.826-5.887-8.36-17.662-12.363-26.021-3.885-8.242-7.182-15.19-7.182-15.424 0-0.117-4.121-8.948-9.302-19.545-5.063-10.597-10.361-21.9-11.775-24.962s-5.77-12.363-9.773-20.606c-3.885-8.242-8.595-18.251-10.48-22.372l-3.297-7.3h205.703l0.706 3.179zM612.059 498.125c0 0.471-0.824 7.3-1.766 14.954-2.591 19.664-2.591 20.37-4.71 38.856-1.883 16.249-2.472 21.312-3.532 28.259-0.236 1.883-0.824 5.887-1.060 8.831-1.060 9.067-5.534 46.392-6.005 49.453-0.236 1.649-0.471 3.65-0.471 4.357-0.117 1.177-16.837 1.53-79.596 1.53-43.683 0-79.479-0.353-79.596-0.942 0-0.471-0.236-2.119-0.589-3.768-1.649-9.655-6.476-39.562-7.536-46.51-0.589-4.593-1.413-9.537-1.766-11.186-0.236-1.53-0.824-4.946-1.177-7.653-0.471-2.591-2.472-15.896-4.71-29.437-2.238-13.658-4.593-28.495-5.299-32.969-0.706-4.593-1.53-9.655-1.883-11.539l-0.706-3.179h100.201c55.105 0 100.201 0.471 100.201 0.942zM900.184 498.596c-0.353 0.824-6.24 14.483-13.188 30.378s-18.015 41.564-24.727 57.107c-6.712 15.543-15.071 34.852-18.604 42.977l-6.359 14.718-161.665 0.589 0.589-2.591c0.236-1.53 3.768-28.73 7.653-60.403 4.004-31.791 7.418-58.99 7.653-60.639s0.824-6.359 1.295-10.597c0.471-4.238 1.060-8.007 1.177-8.595 0.117-0.471 0.236-1.649 0.353-2.591 0.117-1.53 12.481-1.766 103.264-1.766 82.069 0 103.028 0.353 102.556 1.413zM360.554 737.62c0.706 4.474 2.355 14.718 7.889 50.984 0.706 4.474 1.649 11.186 2.238 14.718s3.179 20.488 5.77 37.679c2.591 17.19 5.063 32.969 5.534 34.971l0.824 3.885h-88.781l-6.24-13.305c-3.532-7.182-10.126-21.194-14.836-30.85-4.71-9.773-11.069-22.96-14.13-29.437s-9.067-18.957-13.305-27.67c-4.121-8.714-10.597-22.254-14.365-30.025-3.65-7.771-6.947-14.483-7.3-15.071-0.236-0.471 30.261-0.824 67.704-0.824h68.175l0.824 4.946zM582.151 735.854c-0.353 1.883-2.355 13.658-4.357 26.257s-4.357 27.435-5.181 32.969c-6.123 38.032-7.771 48.393-9.891 62.994-1.413 9.067-2.826 17.662-3.179 19.192l-0.471 2.591h-93.961l-0.706-3.297c-0.353-1.766-0.942-5.299-1.295-7.889s-0.942-6.005-1.177-7.653c-0.353-1.649-0.824-4.593-1.060-6.476-0.353-2.002-1.883-11.775-3.532-21.783s-4.357-26.964-6.005-37.679c-1.766-10.714-3.297-20.723-3.65-22.372-0.236-1.649-1.060-6.359-1.649-10.597s-1.883-12.128-2.944-17.662c-0.942-5.534-1.766-10.361-1.766-10.95 0-0.471 31.791-0.824 70.765-0.824h70.765l-0.706 3.179zM793.505 747.040c-6.712 14.012-12.363 25.904-28.965 60.403-4.357 9.067-10.48 21.783-13.541 28.259s-9.067 19.075-13.305 27.906l-7.771 16.249h-44.272c-34.499 0-44.155-0.353-44.155-1.53 0-0.706 0.824-5.77 1.649-11.069 0.942-5.299 2.119-11.892 2.472-14.718 1.649-11.069 12.363-77.241 13.424-82.775 0.706-3.297 2.002-11.422 3.061-18.251 0.942-6.829 2.119-13.777 2.472-15.66l0.706-3.179h135.055l-6.829 14.365z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "calendar alarm",
		paths: [
			"M267.585 1.621c-14.402 4.493-25.235 13.741-31.578 27.085l-4.095 8.72-0.396 30.653-0.529 30.784h-230.951l0.265 421.738 0.396 421.869 2.774 8.72c4.095 12.552 7.531 19.687 13.608 28.803 10.834 15.986 28.275 30.124 44.79 36.334 20.611 7.796-14.665 7.267 494.801 7.398h467.32v-416.453c0-272.703-0.529-419.36-1.321-424.776-4.756-29.463-23.253-56.152-49.282-70.95-7.796-4.493-21.932-9.645-29.199-10.701-2.907-0.529-6.606-1.057-8.059-1.321s-34.22-0.529-72.932-0.529l-70.29-0.132-0.396-30.784c-0.396-30.257-0.396-30.784-3.964-38.447-9.117-19.422-24.574-29.199-45.979-29.199-9.778 0-12.42 0.529-19.818 4.095-5.020 2.378-10.966 6.606-14.269 10.041-13.081 13.741-14.798 20.083-14.798 56.417v27.877h-363.207l-0.396-30.784-0.396-30.653-4.095-8.588c-8.324-17.308-24.178-27.877-42.676-28.538-5.549-0.132-12.42 0.396-15.326 1.321zM236.007 234.95c5.417 11.099 13.344 19.158 24.178 24.311 7.927 3.699 9.909 4.095 21.271 4.095 11.495-0.132 13.212-0.396 20.611-4.228 10.57-5.549 18.366-13.608 23.518-24.178l4.095-8.588 1.321-77.953 8.984 9.249c31.445 32.37 30.917 83.502-1.321 115.079-32.899 32.37-84.163 32.239-116.268-0.265-31.71-32.239-31.974-83.238-0.792-114.947l8.984-9.117 1.321 77.953 4.095 8.588zM696.854 232.308c2.774 6.606 10.701 17.308 15.855 21.271 1.85 1.453 6.738 4.228 10.966 6.21 6.475 3.039 9.38 3.568 18.893 3.568 17.572 0 29.199-5.681 39.901-19.158 9.249-11.759 10.305-17.441 10.305-58.795 0-19.95 0.529-36.334 1.057-36.334 2.511 0 17.176 17.572 21.8 26.16 33.031 61.702-21.14 134.37-89.448 119.836-51.793-10.966-80.066-67.779-57.605-115.343 4.493-9.38 13.608-21.932 20.083-27.35l4.36-3.699 0.661 38.845c0.661 34.22 1.057 39.505 3.171 44.79zM927.54 401.029c13.741 6.738 23.253 17.044 27.746 30.124 2.642 7.531 2.642 11.495 2.642 267.021v259.491h-849.156l-8.456-2.774c-13.477-4.36-22.99-12.816-29.463-26.293l-4.095-8.588-0.396-262-0.265-261.868 852.855 0.661 8.588 4.228z",
			"M498.669 464.845c-11.759 4.624-18.497 13.081-22.329 28.010l-2.642 10.701-15.194 6.077c-16.251 6.738-26.689 12.816-38.316 22.461-26.16 21.669-43.469 49.678-51.66 84.030-2.774 11.362-2.907 15.194-3.171 79.935-0.265 55.492-0.661 68.969-2.246 73.328-1.057 3.039-7.002 14.005-13.344 24.707-12.156 20.215-13.608 25.235-9.513 31.049 1.19 1.717 4.228 3.303 7.002 3.832 2.642 0.529 77.424 0.925 166.079 0.925 122.346 0 162.38-0.396 165.946-1.586 6.475-2.113 8.72-7.135 6.475-14.137-0.925-2.774-5.814-11.891-10.966-20.215-16.119-26.425-14.665-17.441-14.93-92.751-0.265-54.302-0.661-67.779-2.511-78.613-5.417-31.313-20.479-59.984-43.205-81.916-14.534-14.137-26.954-21.932-52.849-33.427-9.513-4.095-11.759-7.002-13.477-16.647-1.982-10.57-9.117-19.818-19.422-25.235-6.738-3.435-21.8-3.699-29.728-0.529z",
			"M464.317 847.606c3.568 19.289 11.627 30.257 28.142 38.184 8.72 4.228 11.23 4.889 20.215 4.889 9.249 0.132 11.23-0.265 20.215-4.756 16.515-8.192 26.16-21.14 27.877-37.655l0.529-5.549h-97.771l0.792 4.889z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "calendar-30",
		paths: [
			"M268.906 1.062c-13.212 3.039-26.556 14.402-32.899 27.614l-4.095 8.72-0.396 30.653-0.529 30.784h-230.951l0.265 421.738 0.396 421.869 2.907 8.984c12.023 37.391 39.108 62.362 76.367 70.157 8.059 1.717 68.308 1.982 476.7 2.113h467.32v-416.453c0-272.703-0.529-419.36-1.321-424.776-4.756-29.463-23.253-56.152-49.282-70.95-7.796-4.493-21.932-9.645-29.199-10.701-2.907-0.529-6.606-1.057-8.059-1.321s-34.22-0.529-72.932-0.529l-70.29-0.132-0.396-30.784c-0.396-30.257-0.396-30.784-3.964-38.447-9.117-19.422-24.574-29.199-45.979-29.199-9.778 0-12.287 0.529-19.818 4.095-10.834 5.153-18.893 13.212-24.311 24.311l-4.095 8.588-0.396 30.653-0.396 30.784h-363.074l-0.396-30.784-0.396-30.653-4.095-8.588c-8.324-17.308-24.178-27.877-42.676-28.406-5.549-0.265-11.759 0.132-14.005 0.661zM236.007 234.921c5.417 11.099 13.344 19.158 24.178 24.311 7.927 3.699 9.909 4.095 21.271 4.095 11.495-0.132 13.212-0.396 20.479-4.228 10.701-5.417 18.629-13.741 23.651-24.178l4.095-8.588 1.321-77.953 8.984 9.117c31.313 31.974 30.917 83.238-1.057 115.079-32.635 32.37-84.427 32.37-116.533-0.132-31.71-32.239-31.974-83.238-0.792-114.947l8.984-9.117 1.321 77.953 4.095 8.588zM698.438 234.921c5.417 11.099 13.344 19.158 24.178 24.311 7.663 3.568 10.174 4.095 19.95 4.095 17.572 0 29.199-5.681 39.901-19.158 9.249-11.759 10.305-17.441 10.305-58.795 0-19.95 0.529-36.334 1.057-36.334 2.511 0 17.176 17.572 21.8 26.16 33.031 61.702-21.14 134.37-89.448 119.836-16.647-3.568-33.691-13.344-44.393-25.5-28.671-32.635-27.746-81.387 2.246-112.040l8.984-9.117 1.321 77.953 4.095 8.588zM927.805 401.131c10.57 5.153 21.008 15.326 25.896 25.235l3.568 7.398 0.396 261.868 0.265 262h-849.156l-8.456-2.774c-13.477-4.36-22.99-12.816-29.463-26.293l-4.095-8.588-0.396-262-0.265-261.868 852.855 0.661 8.853 4.36z",
			"M325.059 464.154c-21.932 3.568-45.847 13.081-60.248 23.782-33.691 25.368-51.66 60.908-56.417 111.909-0.396 4.756-0.265 5.020 3.699 5.020 4.624 0.132 70.29 0.132 73.46 0 1.717 0 2.246-2.113 3.039-10.438 2.378-28.936 16.251-50.471 37.787-58.795 13.477-5.153 31.71-5.549 45.583-1.057 24.972 8.192 38.051 26.029 38.051 51.924 0 14.665-3.039 22.593-12.42 31.974-13.477 13.344-31.974 19.422-59.984 19.422h-15.194v6.871c-0.265 38.845-0.132 50.207 0.661 50.999 0.396 0.529 6.475 0.925 13.344 1.057 53.245 0.925 77.292 15.855 80.727 50.075 1.057 10.834 1.057 12.023-0.132 21.669-2.774 23.122-17.176 41.223-39.901 49.811-10.966 4.095-31.445 5.681-42.676 3.303-19.026-4.095-37.655-18.629-45.979-35.938-4.756-10.041-9.38-26.689-9.778-35.938-0.265-3.435-1.057-6.738-1.717-7.398-0.792-0.529-18.629-0.925-39.769-0.925l-38.316 0.132 0.265 14.665c0.661 31.71 11.759 62.627 30.52 84.955 9.909 11.627 14.798 15.986 27.614 24.707 24.707 16.647 56.417 25.235 93.543 25.235 92.751 0.265 157.623-58.399 154.32-139.39-1.717-42.676-25.235-74.254-64.476-86.937-7.135-2.246-8.588-3.171-6.606-3.832 27.35-9.778 44.79-28.671 52.453-56.813 4.889-17.837 3.832-44.657-2.246-62.098-4.624-13.081-17.044-31.181-28.936-42.015-16.251-14.798-40.429-27.481-61.569-32.37-3.303-0.792-8.853-2.113-12.552-2.907-10.57-2.378-43.205-2.907-56.152-0.661z",
			"M651.007 464.286c-11.099 1.717-31.71 7.927-39.901 12.156-16.119 8.059-35.673 26.16-46.243 42.411-16.515 25.5-29.067 63.288-33.162 99.885-0.396 4.36-1.19 9.117-1.453 10.57-1.586 6.871-1.321 77.821 0.396 94.864 6.606 66.854 29.728 118.25 64.609 142.958 11.759 8.456 18.497 11.759 32.37 16.384 34.748 11.759 76.367 10.174 109.662-3.964 16.647-7.002 36.73-23.518 48.886-40.166 15.986-21.669 31.049-62.627 35.013-95.129 0.529-3.699 1.057-7.531 1.321-8.588 2.511-9.38 3.568-78.745 1.717-102.66-6.871-85.219-40.958-143.089-95.658-162.115-22.196-7.796-53.51-10.438-77.557-6.606zM696.721 534.84c14.269 5.417 28.538 22.065 35.144 41.354 4.095 12.023 8.059 31.974 10.041 50.471 1.586 16.251 1.85 92.618 0.132 101.074-0.265 1.85-0.925 6.871-1.453 11.23-4.493 38.976-19.422 68.836-39.637 78.745-14.665 7.135-36.863 6.871-50.471-0.925-14.798-8.456-27.481-30.917-33.295-59.059-5.020-23.386-5.814-36.202-5.946-82.842 0-55.888 2.246-74.518 12.156-101.735 5.549-15.194 18.366-31.313 28.936-36.334 12.816-6.077 31.181-6.871 44.393-1.982z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "calendar-day",
		paths: [
			"M267.585 1.621c-14.402 4.493-25.235 13.741-31.578 27.085l-4.095 8.72-0.396 30.653-0.529 30.784h-230.951l0.265 421.738 0.396 421.869 2.774 8.72c4.095 12.552 7.531 19.687 13.608 28.803 10.834 15.986 28.275 30.124 44.79 36.334 20.611 7.796-14.665 7.267 494.801 7.398h467.32v-416.453c0-272.703-0.529-419.36-1.321-424.776-4.756-29.463-23.253-56.152-49.282-70.95-7.796-4.493-21.932-9.645-29.199-10.701-2.907-0.529-6.606-1.057-8.059-1.321s-34.22-0.529-72.932-0.529l-70.29-0.132-0.396-30.784c-0.396-30.257-0.396-30.784-3.964-38.447-9.117-19.422-24.574-29.199-45.979-29.199-9.778 0-12.42 0.529-19.818 4.095-5.020 2.378-10.966 6.606-14.269 10.041-13.081 13.741-14.798 20.083-14.798 56.417v27.877h-363.207l-0.396-30.784-0.396-30.653-4.095-8.588c-8.324-17.308-24.178-27.877-42.676-28.538-5.549-0.132-12.42 0.396-15.326 1.321zM236.007 234.95c5.417 11.099 13.344 19.158 24.178 24.311 7.927 3.699 9.909 4.095 21.271 4.095 11.495-0.132 13.212-0.396 20.611-4.228 10.57-5.549 18.366-13.608 23.518-24.178l4.095-8.588 1.321-77.953 8.984 9.249c31.445 32.37 30.917 83.502-1.321 115.079-32.899 32.37-84.163 32.239-116.268-0.265-31.71-32.239-31.974-83.238-0.792-114.947l8.984-9.117 1.321 77.953 4.095 8.588zM696.854 232.308c2.774 6.606 10.701 17.308 15.855 21.271 1.85 1.453 6.738 4.228 10.966 6.21 6.475 3.039 9.38 3.568 18.893 3.568 17.572 0 29.199-5.681 39.901-19.158 9.249-11.759 10.305-17.441 10.305-58.795 0-19.95 0.529-36.334 1.057-36.334 2.511 0 17.176 17.572 21.8 26.16 33.031 61.702-21.14 134.37-89.448 119.836-51.793-10.966-80.066-67.779-57.605-115.343 4.493-9.38 13.608-21.932 20.083-27.35l4.36-3.699 0.661 38.845c0.661 34.22 1.057 39.505 3.171 44.79zM927.54 401.029c13.741 6.738 23.253 17.044 27.746 30.124 2.642 7.531 2.642 11.495 2.642 267.021v259.491h-849.156l-8.456-2.774c-13.477-4.36-22.99-12.816-29.463-26.293l-4.095-8.588-0.396-262-0.265-261.868 852.855 0.661 8.588 4.228z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Calendar-fixtures-results",
		paths: [
			"M268.906 1.062c-13.212 3.039-26.556 14.402-32.899 27.614l-4.095 8.72-0.396 30.653-0.529 30.784h-230.951l0.265 421.738 0.396 421.869 2.907 8.984c12.023 37.391 39.108 62.362 76.367 70.157 8.059 1.717 68.308 1.982 476.7 2.113h467.32v-416.453c0-272.703-0.529-419.36-1.321-424.776-4.756-29.463-23.253-56.152-49.282-70.95-7.796-4.493-21.932-9.645-29.199-10.701-2.907-0.529-6.606-1.057-8.059-1.321s-34.22-0.529-72.932-0.529l-70.29-0.132-0.396-30.784c-0.396-30.257-0.396-30.784-3.964-38.447-9.117-19.422-24.574-29.199-45.979-29.199-9.778 0-12.287 0.529-19.818 4.095-10.834 5.153-18.893 13.212-24.311 24.311l-4.095 8.588-0.396 30.653-0.396 30.784h-363.074l-0.396-30.784-0.396-30.653-4.095-8.588c-8.324-17.308-24.178-27.877-42.676-28.406-5.549-0.265-11.759 0.132-14.005 0.661zM236.007 234.921c5.417 11.099 13.344 19.158 24.178 24.311 7.927 3.699 9.909 4.095 21.271 4.095 11.495-0.132 13.212-0.396 20.479-4.228 10.701-5.417 18.629-13.741 23.651-24.178l4.095-8.588 1.321-77.953 8.853 9.117c31.445 32.502 31.049 83.238-0.925 115.079-32.635 32.37-84.427 32.37-116.533-0.132-31.71-32.239-31.974-83.238-0.792-114.947l8.984-9.117 1.321 77.953 4.095 8.588zM698.438 234.921c5.417 11.099 13.344 19.158 24.178 24.311 7.663 3.568 10.174 4.095 19.95 4.095 17.572 0 29.199-5.681 39.901-19.158 9.249-11.759 10.305-17.441 10.305-58.795 0-19.95 0.396-36.334 0.925-36.334 0.396 0 4.493 3.832 8.853 8.456 31.181 32.899 30.52 83.502-1.453 115.343-38.316 38.051-101.47 29.728-129.216-17.044-18.366-31.049-13.212-72.272 12.156-98.3l8.984-9.117 1.321 77.953 4.095 8.588zM927.672 400.867c13.608 6.475 24.047 18.497 28.803 33.427 1.057 3.039 1.453 82.577 1.453 263.85v259.491h-424.645c-421.605 0-424.645 0-433.233-2.642-13.344-4.095-24.707-14.798-30.784-29.067-2.378-5.814-2.511-13.344-2.907-267.946l-0.265-261.868 852.855 0.661 8.72 4.095z",
			"M166.379 562.19c-0.132 0.661-0.132 4.889 0 9.645 0.529 42.015 8.984 86.672 22.593 119.307 18.366 44.261 48.754 79.935 82.842 97.375l8.192 4.228 7.531-3.435c23.914-10.966 52.32-36.863 68.44-62.627 25.5-40.694 38.051-86.805 41.090-150.62l0.661-14.798h-115.608c-63.551 0-115.608 0.396-115.739 0.925z",
			"M626.96 576.724c1.982 47.96 10.438 87.862 25.896 122.61 16.647 37.524 46.375 71.215 78.217 88.523l8.984 4.889 6.871-2.907c3.832-1.586 12.552-6.738 19.422-11.23 33.691-22.593 59.984-59.587 75.179-105.83 5.681-17.441 11.362-42.411 12.683-56.681 0.529-5.153 1.19-9.645 1.453-10.174 0.396-0.529 0.925-10.701 1.453-22.725l0.792-21.932h-231.612l0.661 15.459z",
			"M462.467 660.622c0.132 0.265 7.398 22.329 16.384 49.282l16.384 48.886 16.515 0.396c14.798 0.265 16.515 0.132 17.441-1.982 0.529-1.321 6.077-17.572 12.552-36.069 6.342-18.497 13.212-38.184 15.194-43.601s4.095-11.495 4.624-13.608l1.19-3.568h-33.823l-2.113 5.549c-1.19 3.171-4.889 14.137-8.324 24.574-3.435 10.305-6.342 18.629-6.475 18.497-0.265-0.265-3.435-9.645-7.135-20.875-3.832-11.23-7.531-22.065-8.324-24.178l-1.321-3.568h-16.384c-8.984 0-16.384 0.132-16.384 0.265z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Calendar-football-match",
		paths: [
			"M268.906 1.062c-13.212 3.039-26.556 14.402-32.899 27.614l-4.095 8.72-0.396 30.653-0.529 30.784h-230.951l0.265 421.738 0.396 421.869 2.907 8.984c12.023 37.391 39.108 62.362 76.367 70.157 8.059 1.717 68.308 1.982 476.7 2.113h467.32v-416.453c0-272.703-0.529-419.36-1.321-424.776-4.756-29.463-23.253-56.152-49.282-70.95-7.796-4.493-21.932-9.645-29.199-10.701-2.907-0.529-6.606-1.057-8.059-1.321s-34.22-0.529-72.932-0.529l-70.29-0.132-0.396-30.784c-0.396-30.257-0.396-30.784-3.964-38.447-9.117-19.422-24.574-29.199-45.979-29.199-9.778 0-12.287 0.529-19.818 4.095-10.834 5.153-18.893 13.212-24.311 24.311l-4.095 8.588-0.396 30.653-0.396 30.784h-363.074l-0.396-30.784-0.396-30.653-4.095-8.588c-8.324-17.308-24.178-27.877-42.676-28.406-5.549-0.265-11.759 0.132-14.005 0.661zM236.007 234.921c5.417 11.099 13.344 19.158 24.178 24.311 7.927 3.699 9.909 4.095 21.271 4.095 11.495-0.132 13.212-0.396 20.479-4.228 10.701-5.417 18.629-13.741 23.651-24.178l4.095-8.588 1.321-77.953 8.984 9.117c31.313 31.974 30.917 83.238-1.057 115.079-32.635 32.37-84.427 32.37-116.533-0.132-31.71-32.239-31.974-83.238-0.792-114.947l8.984-9.117 1.321 77.953 4.095 8.588zM698.438 234.921c5.417 11.099 13.344 19.158 24.178 24.311 7.663 3.568 10.174 4.095 19.95 4.095 17.572 0 29.199-5.681 39.901-19.158 9.249-11.759 10.305-17.441 10.305-58.795 0-19.95 0.529-36.334 1.057-36.334 2.511 0 17.176 17.572 21.8 26.16 33.031 61.702-21.14 134.37-89.448 119.836-16.647-3.568-33.691-13.344-44.393-25.5-28.671-32.635-27.746-81.387 2.246-112.040l8.984-9.117 1.321 77.953 4.095 8.588zM927.54 401c13.741 6.738 23.253 17.044 27.746 30.124 2.642 7.531 2.642 11.099 2.642 267.153v259.358h-849.156l-8.456-2.774c-13.477-4.36-22.99-12.816-29.463-26.293l-4.095-8.588-0.396-262-0.265-261.868 852.855 0.661 8.588 4.228z",
			"M489.552 430.067c-47.3 4.228-96.054 24.047-132.784 53.906-47.696 38.58-77.557 89.844-89.315 152.602-3.171 17.044-3.435 56.284-0.529 75.31 8.456 55.756 32.37 102.925 72.007 141.901 36.334 35.673 85.748 60.777 133.444 67.514 3.699 0.529 7.796 1.321 9.249 1.586s13.344 0.792 26.425 1.057c27.481 0.396 47.433-1.982 71.215-8.72 124.196-35.144 200.827-160.001 175.724-286.576-19.687-100.018-99.092-177.441-200.563-195.807-14.005-2.511-50.867-4.095-64.872-2.774zM446.744 485.823l-7.927 15.723 35.938 14.269c19.818 7.796 36.863 14.137 37.92 14.137 1.057-0.132 17.837-6.606 37.259-14.269l35.277-14.137-7.796-15.723c-4.36-8.588-7.663-15.723-7.398-15.723s5.153 1.586 10.834 3.435c21.669 7.002 45.979 20.347 64.609 35.277 12.948 10.438 32.37 30.653 40.033 41.619 5.285 7.663 5.549 8.192 2.642 7.531-3.039-0.661-16.119-2.774-27.085-4.228l-5.681-0.792-0.132 7.135c0 3.964-0.265 8.324-0.529 9.778s-0.792 9.513-1.19 17.837c-1.586 29.463-2.378 40.298-2.774 41.75-0.529 1.85 48.621 61.702 50.338 61.306 0.661-0.132 6.342-5.153 12.683-11.362 6.475-6.077 12.023-11.099 12.42-11.099 0.529 0 0.529 7.927 0.132 17.572-1.982 41.090-13.212 75.839-35.542 109.531-5.153 7.796-9.909 14.269-10.438 14.269s-1.982-7.135-3.171-15.723c-1.321-8.72-2.774-16.384-3.171-17.176-0.661-0.925-3.568-0.661-8.72 0.661-4.36 1.19-8.853 2.378-9.909 2.511-20.479 4.624-56.681 14.798-58.266 16.384-2.246 2.246-38.845 60.248-40.166 63.551-0.529 1.453 3.435 4.095 14.798 9.778l15.59 7.796-4.624 1.982c-6.21 2.642-20.744 6.475-33.691 8.984-21.536 4.228-58.795 3.303-84.559-2.113-7.002-1.453-28.671-8.059-28.142-8.588 0.265-0.265 7.002-3.699 15.194-7.796s15.194-8.059 15.59-8.588c0.396-0.661-1.453-4.36-3.964-8.192-2.511-3.964-11.891-18.762-20.875-32.899l-16.251-25.764-37.524-9.513c-20.744-5.285-37.92-9.117-38.447-8.588-0.396 0.529-1.85 8.192-3.303 17.044-1.321 8.984-2.774 16.251-3.171 16.251-0.792 0-9.778-12.683-15.723-22.461-9.909-15.986-21.14-43.997-25.235-62.759-3.964-17.705-6.871-56.152-4.36-56.152 0.529 0 6.475 5.417 12.948 11.891l11.891 11.891 2.378-2.907c1.321-1.717 12.683-15.459 25.103-30.52 12.552-15.194 22.593-28.406 22.593-29.463-0.132-1.057-0.661-9.249-1.19-18.101-0.396-8.853-1.057-18.762-1.321-22.065s-0.925-12.552-1.453-20.479c-0.396-8.059-1.057-14.798-1.19-15.063-0.265-0.265-8.324 0.661-17.705 2.113-9.513 1.321-17.308 2.378-17.308 2.246s3.568-4.889 7.927-10.57c20.611-26.954 46.904-48.489 77.292-63.288 12.023-5.946 31.313-13.477 35.409-13.741 0.529-0.132-2.642 7.002-6.871 15.59z",
			"M476.075 621.249c-20.479 14.269-35.938 26.029-35.938 27.217 0 1.057 6.475 20.744 14.137 43.601l14.137 41.619 43.865 0.396 43.732 0.265 9.645-28.671c5.285-15.855 11.891-35.542 14.534-43.732l4.889-14.798-13.344-9.513c-7.398-5.153-22.329-15.723-33.295-23.386-10.834-7.796-21.271-14.93-23.122-16.119-3.303-2.113-3.832-1.717-39.241 23.122z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "calendar-month",
		paths: [
			"M267.585 1.621c-14.402 4.493-25.235 13.741-31.578 27.085l-4.095 8.72-0.396 30.653-0.529 30.784h-230.951l0.265 421.738 0.396 421.869 2.774 8.72c4.095 12.552 7.531 19.687 13.608 28.803 10.834 15.986 28.275 30.124 44.79 36.334 20.611 7.796-14.665 7.267 494.801 7.398h467.32v-416.453c0-272.703-0.529-419.36-1.321-424.776-4.756-29.463-23.253-56.152-49.282-70.95-7.796-4.493-21.932-9.645-29.199-10.701-2.907-0.529-6.606-1.057-8.059-1.321s-34.22-0.529-72.932-0.529l-70.29-0.132-0.396-30.784c-0.396-30.257-0.396-30.784-3.964-38.447-9.117-19.422-24.574-29.199-45.979-29.199-9.778 0-12.42 0.529-19.818 4.095-5.020 2.378-10.966 6.606-14.269 10.041-13.081 13.741-14.798 20.083-14.798 56.417v27.877h-363.207l-0.396-30.784-0.396-30.653-4.095-8.588c-8.324-17.308-24.178-27.877-42.676-28.538-5.549-0.132-12.42 0.396-15.326 1.321zM236.007 234.95c5.417 11.099 13.344 19.158 24.178 24.311 7.927 3.699 9.909 4.095 21.271 4.095 11.495-0.132 13.212-0.396 20.611-4.228 10.57-5.549 18.366-13.608 23.518-24.178l4.095-8.588 1.321-77.953 8.984 9.117c31.445 32.106 30.917 83.634-1.321 115.212-11.099 10.966-23.386 17.968-38.184 21.669-41.487 10.57-85.484-14.137-98.3-55.096-8.984-28.803-1.321-60.908 19.554-81.916l8.853-8.984 1.321 77.953 4.095 8.588zM696.854 232.308c2.774 6.606 10.701 17.308 15.855 21.271 1.85 1.453 6.738 4.228 10.966 6.21 6.475 3.039 9.38 3.568 18.893 3.568 17.572 0 29.199-5.681 39.901-19.158 9.249-11.759 10.305-17.441 10.305-58.795 0-19.95 0.529-36.334 1.057-36.334 2.511 0 17.176 17.572 21.8 26.16 33.031 61.702-21.14 134.37-89.448 119.836-16.647-3.568-33.691-13.344-44.393-25.5-28.803-32.766-27.746-81.387 2.246-112.040l8.984-9.117 0.661 38.976c0.661 34.352 1.057 39.637 3.171 44.922zM242.217 396.141h22.065v165.154h-198.185v-165.022l10.966-0.396c5.946-0.265 40.562-0.265 76.896-0.132s75.971 0.396 88.258 0.396zM484.663 396.141h10.834v165.154h-198.185v-165.022l3.699-0.396c1.982-0.265 41.619-0.265 88.126-0.132 46.508 0.265 89.448 0.396 95.525 0.396zM713.236 396.141h13.477v165.154h-198.185v-82.313c0-45.318 0.265-82.709 0.529-82.973s38.845-0.396 85.616-0.265c46.772 0.265 91.033 0.396 98.563 0.396zM907.193 396.537c11.495 0.396 14.534 1.057 21.8 4.493 11.099 5.285 18.233 12.287 23.782 23.518l4.493 9.249 0.396 63.684 0.396 63.815h-198.316v-165.022l5.020-0.396c6.606-0.529 125.517 0 142.429 0.661zM264.282 676.902v82.577h-198.185v-165.154h198.185v82.577zM495.497 676.902v82.577h-198.185v-165.154h198.185v82.577zM726.713 676.902v82.577h-198.185v-165.154h198.185v82.577zM957.929 676.902v82.577h-198.185v-165.154h198.185v82.577zM264.282 875.087v82.577h-77.028c-82.181 0-83.238-0.132-96.054-6.606-7.531-3.832-15.986-13.212-20.347-22.461l-4.095-8.588-0.396-63.815-0.396-63.684h198.316v82.577zM495.497 875.087v82.577h-198.185v-165.154h198.185v82.577zM726.713 875.087v82.577h-198.185v-165.154h198.185v82.577z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "calendar-week",
		paths: [
			"M267.585 1.621c-14.402 4.493-25.235 13.741-31.578 27.085l-4.095 8.72-0.396 30.653-0.529 30.784h-230.951l0.265 421.738 0.396 421.869 2.774 8.72c4.095 12.552 7.531 19.687 13.608 28.803 10.834 15.986 28.275 30.124 44.79 36.334 20.611 7.796-14.665 7.267 494.801 7.398h467.32v-416.453c0-272.703-0.529-419.36-1.321-424.776-4.756-29.463-23.253-56.152-49.282-70.95-7.796-4.493-21.932-9.645-29.199-10.701-2.907-0.529-6.606-1.057-8.059-1.321s-34.22-0.529-72.932-0.529l-70.29-0.132-0.396-30.784c-0.396-30.257-0.396-30.784-3.964-38.447-9.117-19.422-24.574-29.199-45.979-29.199-9.778 0-12.42 0.529-19.818 4.095-5.020 2.378-10.966 6.606-14.269 10.041-13.081 13.741-14.798 20.083-14.798 56.417v27.877h-363.207l-0.396-30.784-0.396-30.653-4.095-8.588c-8.324-17.308-24.178-27.877-42.676-28.538-5.549-0.132-12.42 0.396-15.326 1.321zM236.007 234.95c5.417 11.099 13.344 19.158 24.178 24.311 7.927 3.699 9.909 4.095 21.271 4.095 11.495-0.132 13.212-0.396 20.611-4.228 10.57-5.549 18.366-13.608 23.518-24.178l4.095-8.588 1.321-77.953 8.984 9.249c31.445 32.37 30.917 83.502-1.321 115.079-32.899 32.37-84.163 32.239-116.268-0.265-31.71-32.239-31.974-83.238-0.792-114.947l8.984-9.117 1.321 77.953 4.095 8.588zM696.854 232.308c2.774 6.606 10.701 17.308 15.855 21.271 1.85 1.453 6.738 4.228 10.966 6.21 6.475 3.039 9.38 3.568 18.893 3.568 17.572 0 29.199-5.681 39.901-19.158 9.249-11.759 10.305-17.441 10.305-58.795 0-19.95 0.529-36.334 1.057-36.334 2.511 0 17.176 17.572 21.8 26.16 33.031 61.702-21.14 134.37-89.448 119.836-51.793-10.966-80.066-67.779-57.605-115.343 4.493-9.38 13.608-21.932 20.083-27.35l4.36-3.699 0.661 38.845c0.661 34.22 1.057 39.505 3.171 44.79zM264.282 676.902v280.762h-77.688c-75.31 0-78.084-0.132-86.276-2.774-13.477-4.36-22.99-12.816-29.463-26.293l-4.095-8.588-0.396-262-0.265-261.868h198.185v280.762zM495.497 676.902v280.762h-198.185v-561.524h198.185v280.762zM726.713 676.902v280.762h-198.185v-561.524h198.185v280.762zM927.54 401.029c13.741 6.738 23.253 17.044 27.746 30.124 2.642 7.531 2.642 11.495 2.642 267.021v259.491h-198.185v-561.655l159.208 0.792 8.588 4.228z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Coat-hanger",
		paths: [
			"M498.286 99.759c-0.228 0.228-3.528 0.683-7.286 1.025s-11.839 1.935-17.872 3.528c-28.914 7.627-52.591 21.515-73.535 43.37-29.141 30.166-43.939 67.161-43.712 108.71 0.113 15.709 0.228 17.188 3.187 31.645 9.334 45.533 38.931 84.236 81.846 107.23 15.481 8.196 20.946 13.888 25.84 26.295 2.163 5.578 2.39 8.765 2.505 32.101 0.113 14.229-0.113 26.295-0.456 26.751-0.341 0.569-3.643 2.618-7.399 4.781-7.627 4.212-61.697 34.606-86.969 48.835-8.993 5.122-16.619 9.22-16.961 9.22-0.228 0-1.821 0.91-3.415 2.049-1.707 1.252-6.602 4.098-11.042 6.489-4.325 2.39-20.034 11.042-34.719 19.352-36.313 20.49-35.175 19.921-40.98 23.108-2.846 1.48-6.602 3.643-8.537 4.781-1.821 1.138-5.92 3.415-9.107 5.122-3.074 1.707-11.27 6.261-18.213 10.245-19.124 10.814-138.648 77.975-167.903 94.253-32.442 18.1-51.68 41.777-59.99 73.65-9.789 37.906 1.025 78.658 28.345 107.116 16.619 17.416 37.565 28.572 62.38 33.353 12.749 2.505 821.188 2.505 834.848 0.113 36.768-6.602 66.933-29.255 83.439-62.608 16.278-32.67 15.026-74.674-3.187-105.409-12.863-21.969-24.702-32.556-55.665-49.973-19.579-11.042-51.566-29.027-60.331-33.922-5.692-3.187-75.699-42.574-81.959-46.102-2.163-1.252-8.31-4.667-13.66-7.627-8.993-5.009-169.497-95.164-212.298-119.296-10.586-6.033-21.856-12.294-25.043-14.001l-5.578-3.187-0.228-29.938c-0.228-25.612-0.569-31.532-2.618-40.866-8.651-38.931-30.735-68.072-67.275-88.107-20.262-11.155-29.596-20.262-36.996-36.426-5.009-10.701-6.717-18.554-6.602-30.166 0.456-40.866 35.516-73.309 76.040-70.12 18.1 1.366 33.808 8.765 46.216 21.969s18.213 27.206 19.807 47.582c1.138 15.823 5.805 25.954 15.709 33.922 6.489 5.35 10.473 7.171 18.782 8.879 17.757 3.643 36.882-5.35 45.42-21.4 4.325-8.082 5.692-15.14 5.236-27.092-1.707-43.37-22.311-84.805-56.347-113.491-18.896-15.937-43.826-27.889-69.779-33.467-8.082-1.707-42.574-3.528-43.939-2.277zM530.613 565.107c10.132 5.692 20.718 11.611 23.564 13.204 7.74 4.325 30.166 16.961 40.183 22.539 16.278 9.22 26.295 14.912 45.761 25.84 10.701 5.92 21.4 11.952 23.905 13.432 2.505 1.366 10.701 5.92 18.213 10.132s42.574 23.905 77.975 43.826c35.401 19.921 66.933 37.678 70.007 39.386 57.485 31.873 97.555 55.095 100.97 58.396 11.952 11.839 8.993 33.467-5.692 42.346-3.302 1.935-7.855 3.871-10.132 4.325-7.627 1.252-802.975 0.797-808.439-0.569-15.367-3.528-25.157-21.059-20.149-36.085 2.732-7.968 8.31-13.204 23.564-21.628 7.171-3.871 15.595-8.537 18.669-10.358 3.187-1.707 34.832-19.579 70.576-39.614 35.744-20.149 66.933-37.678 69.438-39.044 2.505-1.48 8.424-4.781 13.091-7.399 12.294-6.83 155.040-87.082 171.318-96.189 7.513-4.325 23.677-13.432 35.857-20.262 12.18-6.943 22.311-12.635 22.539-12.635 0.113-0.113 8.537 4.553 18.782 10.358z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "currency-euro",
		paths: [
			"M0.019 468.104v292.564h936.205v-585.128h-936.205v292.564zM790.41 241.659c3.276 31.597 20.596 56.992 48.215 70.684 11.117 5.5 19.309 7.841 30.661 9.011l8.426 0.819v292.213h-4.33c-12.522 0.117-31.128 6.202-44.001 14.628-22.586 14.512-38.618 42.949-39.32 69.279l-0.117 3.862h-643.641l-0.117-2.691c-0.702-34.523-23.756-66.821-56.523-79.343-5.5-2.106-21.766-5.968-23.756-5.617-0.585 0.117-2.341 0.117-4.096 0l-3.276-0.117v-292.213l8.075-0.819c31.48-3.16 58.279-22.235 71.971-51.375 3.511-7.372 7.607-24.575 7.723-31.597v-4.33h643.29l0.819 7.607z",
			"M446.822 293.852c-72.087 9.362-130.484 60.619-148.272 130.015-4.564 17.554-4.798 19.66-5.383 40.14-0.585 24.107 0.819 34.406 8.192 57.928 14.745 47.161 49.385 85.663 96.195 106.844 11.703 5.266 27.15 9.831 42.949 12.522 13.107 2.341 45.523 2.341 56.289 0.117 3.276-0.702 7.138-1.521 8.777-1.755 23.99-4.564 53.948-19.309 74.428-36.512 32.182-26.916 52.193-61.088 60.853-103.451 2.224-11.001 2.926-43.65 1.287-55.002-6.202-40.725-23.639-75.013-52.193-102.866-26.214-25.395-56.407-40.257-96.078-47.512-6.905-1.17-38.735-1.521-47.045-0.469zM503.229 359.387c21.766 4.212 37.917 16.384 47.279 35.693 4.915 9.947 5.5 16.618 1.872 22.351-3.16 5.266-10.416 8.777-16.734 8.075-6.905-0.936-10.064-3.745-15.33-13.575-8.66-16.267-17.905-22.235-35.224-22.351-10.883-0.117-16.267 0.936-23.99 4.798-9.011 4.564-15.798 11.819-21.181 22.937-4.564 9.362-5.383 12.053-3.627 12.288 0.469 0.117 18.256 0.234 39.438 0.351 43.768 0.234 43.299 0.117 46.927 9.479 2.691 7.138 1.521 14.394-3.16 18.841l-3.511 3.394-27.735 0.234c-15.213 0.117-34.406 0.234-42.598 0.351h-14.979v16.267l72.79 0.702 3.394 4.096c2.691 3.16 3.394 5.15 3.394 9.713 0 6.436-2.341 11.819-6.202 13.927-1.872 0.936-11.937 1.405-35.576 1.521-18.139 0-33.236 0.351-33.703 0.702-0.819 0.936 2.457 10.064 5.851 15.682 6.086 10.298 16.5 17.67 28.671 20.363 2.926 0.702 10.532 1.054 16.969 0.936 18.49-0.469 26.096-5.266 34.054-20.948 4.681-9.362 9.011-12.639 16.618-12.639 6.787 0 12.639 2.926 16.149 8.075 4.681 7.022 3.16 14.043-6.202 28.437-13.224 20.129-33.118 29.373-63.545 29.373-16.149 0-27.384-2.341-39.789-8.192-11.703-5.617-25.629-19.426-32.065-31.713-4.564-8.893-10.064-23.756-10.064-27.384 0-2.341 0-2.341-9.362-2.575-12.053-0.351-17.32-4.681-17.788-14.512-0.117-5.5 3.511-12.053 7.841-14.043 1.639-0.819 6.086-1.405 9.713-1.405h6.671v-16.149l-8.075-0.585c-7.607-0.469-8.426-0.819-12.053-4.798-3.16-3.394-3.862-5.15-3.862-9.479 0-12.404 5.15-17.32 17.905-17.554 7.723 0 8.543-0.234 9.831-2.926 0.819-1.639 1.521-3.745 1.521-4.798 0-3.16 7.723-21.65 11.703-28.203 10.298-16.852 22.351-26.565 40.14-32.416 13.107-4.33 32.299-5.266 47.63-2.341z",
			"M182.579 424.921c-7.607 1.405-18.608 7.256-23.522 12.404-24.225 25.277-11.468 66.47 22.703 73.61 3.862 0.819 8.075 1.287 9.479 1.054s4.798-0.702 7.607-1.054c18.256-2.691 35.224-22.937 35.224-42.129 0-27.267-25.277-48.682-51.491-43.885z",
			"M740.791 424.57c-33.001 4.564-49.267 41.31-30.543 68.577 15.33 22.118 47.161 25.161 66.119 6.202 21.65-21.65 16.149-56.641-10.767-70.332-7.372-3.745-17.437-5.5-24.81-4.447z",
			"M965.48 526.617v263.308h-906.948v58.513h965.461v-585.128h-58.513v263.308z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "delete",
		paths: [
			"M165.676 3.122c-6.002 1.385-14.771 5.078-19.542 8.002-10.463 6.463-125.56 120.944-133.717 132.948-10.924 16.31-15.079 38.777-10.618 57.703 5.539 23.85-1.077 16.465 152.182 170.031l140.333 140.333-140.333 140.487c-139.564 139.564-140.333 140.333-145.872 152.182-6.616 14.465-8.463 23.081-7.694 37.699 0.616 14.926 5.386 28.775 14.002 41.238 5.078 7.232 123.407 124.33 129.87 128.485 16.926 10.924 40.93 14.618 60.164 9.386 21.696-5.847 18.312-2.769 167.876-152.182l139.717-139.564 140.333 140.333c135.256 135.101 140.948 140.487 151.719 145.719 25.389 12.002 55.703 10.31 76.476-4.463 9.54-6.771 124.022-120.791 130.177-129.562 11.387-16.465 16.157-41.085 11.387-59.858-6.002-24.004 0.769-16.465-152.027-169.569l-140.333-140.333 140.178-140.487c99.402-99.402 141.411-142.487 144.333-147.872 14.157-26.005 12.618-57.549-3.847-81.706-4.769-7.078-121.407-123.868-128.331-128.638-13.695-9.232-30.159-13.849-46.623-12.926-14.618 0.616-26.005 4.155-37.238 11.079-5.539 3.539-56.78 53.703-147.258 144.025l-138.948 138.795-140.333-140.333c-153.413-153.104-146.18-146.641-169.877-152.182-12.31-2.769-21.696-2.461-36.16 1.231z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "email",
		paths: [
			"M0.034 460.048c0 381.798-0.512 359.144 7.552 379.751 12.032 30.845 38.141 55.676 70.268 66.683 16.639 5.632 0.127 5.376 485.728 5.503h460.386v-350.44c-0.127-374.375 0.127-357.224-6.143-375.271-9.216-26.238-28.286-48.124-53.373-60.923-12.032-6.272-19.326-8.703-33.278-11.392-9.087-1.664-64.379-1.92-470.625-1.92h-460.513v348.009zM914.917 364.695c-48.253 46.589-69.243 66.812-76.795 73.851-9.856 9.599-56.444 54.396-82.298 79.227-9.727 9.472-25.086 24.191-33.918 32.638-8.832 8.576-23.166 22.399-31.998 30.974-8.832 8.447-18.686 17.919-21.886 20.991s-15.999 15.359-28.414 27.262c-24.831 23.806-36.99 33.278-53.373 41.341-22.911 11.136-43.133 15.871-71.035 16.383-36.605 0.767-67.068-7.423-94.33-25.342-14.847-9.727-21.502-15.743-75.259-67.963-25.342-24.575-87.034-84.347-95.866-92.794-3.967-3.84-15.871-15.359-26.366-25.598-10.623-10.239-35.070-33.918-54.396-52.604s-43.645-42.237-54.013-52.477l-19.071-18.559 0.767-109.56 21.375 20.862c11.647 11.519 42.493 41.725 68.475 67.196 25.855 25.342 51.837 50.684 57.469 56.316 5.76 5.503 29.054 28.158 51.709 50.3 22.782 22.142 45.564 44.285 50.557 49.277 5.12 4.863 24.446 23.678 43.005 41.853 53.244 51.837 53.884 52.349 61.82 57.469 16.639 10.879 38.654 16.383 62.972 15.871 21.119-0.512 40.19-6.527 57.212-17.791 7.167-4.736 9.087-6.527 60.54-56.572 18.303-17.791 36.35-35.198 40.19-38.91 3.84-3.84 23.166-22.526 42.877-41.597 19.711-19.199 39.677-38.525 44.413-43.005 4.607-4.48 22.655-22.015 40.061-38.91s35.198-34.045 39.55-38.27c13.312-12.799 80.378-77.947 84.474-82.171l3.967-3.967 0.767 111.609-13.183 12.672z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "error-severe",
		paths: [
			"M493.967 46.154c-26.092 4.098-54.098 20.356-70.082 40.71-5.328 6.695-22.95 35.383-34.562 56.284-1.776 3.415-3.825 6.695-4.372 7.514-0.547 0.683-6.695 11.202-13.661 23.224-15.027 25.956-19.126 32.923-28.688 49.18-3.825 6.695-8.333 14.48-9.836 17.076-2.459 4.098-18.033 31.011-36.612 62.841-2.868 4.917-8.88 15.163-13.525 22.95-4.508 7.65-9.563 16.257-11.065 19.126-1.502 2.732-3.415 6.011-4.098 7.104-1.23 1.776-18.716 31.83-25.956 44.399-1.23 2.185-18.443 31.694-38.251 65.574-19.809 33.743-40.3 69.125-45.765 78.552-12.705 21.858-77.869 133.743-93.579 160.519-23.634 40.3-50.273 86.201-53.142 91.803-6.011 12.022-9.972 28.962-10.519 45.491-0.273 8.606 0.136 18.716 0.819 22.541 2.185 11.202 7.923 27.322 13.114 36.476 4.372 7.787 17.076 24.317 21.448 27.732 15.984 13.114 26.23 19.262 39.344 23.907 19.945 6.967-2.185 6.695 435.108 6.695 441.256 0.136 420.764 0.41 439.343-6.831 19.673-7.514 36.749-19.809 48.907-34.972 26.639-33.060 33.060-76.093 17.35-115.163-1.776-4.234-20.901-38.115-42.623-75.272-21.584-37.159-41.257-70.902-43.716-75-8.744-15.027-29.781-51.365-67.623-116.12-21.311-36.476-46.312-79.508-55.737-95.628-22.131-38.115-23.634-40.71-37.842-64.891-6.557-11.339-13.525-23.224-15.301-26.639-1.913-3.415-4.781-8.333-6.557-10.929-3.279-5.191-9.836-16.257-29.235-49.863-6.967-12.022-13.114-22.814-13.935-23.907-1.366-2.323-12.431-21.448-16.393-28.415-4.645-8.061-7.65-13.114-14.891-25.547-3.962-6.831-10.382-17.896-14.344-24.59-3.962-6.831-11.339-19.399-16.393-28.005s-10.382-17.896-11.885-20.492c-11.612-20.082-22.95-38.661-27.186-44.399-13.252-17.896-32.651-31.285-56.558-39.208-9.972-3.279-15.301-4.098-28.005-4.508-8.606-0.273-19.262 0-23.497 0.683zM392.465 413.64c5.328 2.459 19.399 15.574 63.115 59.29l56.42 56.147 56.284-56.284c64.617-64.344 62.294-62.568 83.060-62.568 11.612 0 13.797 0.41 20.218 3.825 21.448 11.202 30.738 34.153 23.497 57.241l-3.142 9.972-113.524 114.071 57.513 57.786c63.115 63.115 63.661 63.798 65.438 81.284 1.776 16.257-7.24 34.426-21.311 43.306-12.978 8.197-30.464 9.289-44.399 2.868-7.24-3.279-15.027-10.519-65.847-61.339l-57.786-57.65-57.65 57.65c-49.454 49.454-58.879 58.196-65.574 61.202-23.771 10.793-50.137 1.366-62.022-22.541-3.279-6.421-3.825-9.289-3.825-19.126-0.136-20.628-1.23-19.262 65.164-85.656l57.65-57.786-55.601-55.601c-63.934-64.071-63.251-63.115-63.251-83.743 0-9.699 0.547-12.842 3.551-19.262 5.601-11.748 16.94-21.722 29.918-25.956 6.695-2.185 24.864-0.547 32.104 2.868z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "event-agenda",
		paths: [
			"M267.595 1.956c-14.532 4.624-25.101 13.74-31.576 27.215l-4.095 8.587-0.396 30.651-0.396 30.782h-231.066l0.396 421.705c0.264 400.699 0.396 422.233 2.642 429.499 7.531 24.573 21.93 43.993 42.672 57.734 8.456 5.549 14.664 8.323 30.254 13.476 4.359 1.321 90.497 1.717 476.664 2.113l471.248 0.264-0.264-421.705-0.396-421.837-2.774-8.587c-6.21-18.76-13.607-31.311-25.498-43.333-11.23-11.361-28.536-21.667-42.408-25.366-3.303-0.925-7.135-1.982-8.587-2.378s-36.067-1.057-76.89-1.19l-74.379-0.529v-27.348c0-15.061-0.661-29.857-1.321-33.028-3.434-14.797-13.476-26.952-27.744-33.82-7.662-3.567-9.908-4.095-20.478-4.095s-12.815 0.396-20.609 4.095c-10.834 5.153-18.76 13.211-24.176 24.309l-4.095 8.587-0.396 30.651-0.529 30.782h-362.782l-0.529-30.782-0.396-30.651-4.095-8.587c-10.569-22.063-36.2-34.085-57.998-27.215zM236.019 235.267c5.285 10.965 13.476 19.156 24.309 24.309 7.662 3.699 9.908 4.095 20.478 4.095s12.815-0.396 20.478-4.095c10.965-5.285 19.156-13.476 24.309-24.309l4.095-8.587 1.321-77.947 8.587 8.719c24.837 24.97 30.518 62.093 14.401 94.725-13.080 26.687-42.805 45.183-72.531 45.183-47.561 0-86.005-40.426-82.835-87.063 1.453-21.403 8.983-38.313 23.78-53.241l8.191-8.323 1.321 77.947 4.095 8.587zM698.415 235.267c7.002 14.268 17.967 23.516 32.632 27.215 22.988 5.945 46.371-5.285 56.94-27.215l4.095-8.587 1.321-77.947 8.719 8.983c14.401 14.532 21.93 31.576 23.251 52.449 3.434 54.827-48.75 98.16-101.859 84.552-15.061-3.832-27.612-10.965-38.577-21.93-31.839-31.707-32.103-83.892-0.529-115.467l8.587-8.587 1.321 77.947 4.095 8.587zM929.481 401.333c9.644 5.020 14.797 9.644 20.213 17.835 8.719 12.815 8.191-4.756 8.191 280.080v258.677l-854.111-0.661-7.266-3.434c-9.644-4.624-16.779-10.437-22.063-18.364-8.852-13.211-8.323 5.153-8.323-280.344v-258.677l855.432 0.661 7.927 4.228z",
			"M170.095 463.823c-14.268 3.699-26.423 13.607-32.764 27.083-11.89 24.97-1.321 54.035 23.78 65.925 7.662 3.567 10.040 4.095 20.609 4.095 10.701 0 12.815-0.396 20.478-4.228 13.607-6.606 21.799-15.589 26.423-29.461 10.173-30.122-12.286-62.885-43.993-64.206-5.285-0.264-11.759 0.132-14.532 0.792z",
			"M320.44 479.941c-8.983 3.171-14.664 8.456-19.817 18.496-7.795 14.797-1.19 33.953 14.532 42.408l5.285 2.907h515.241l5.416-2.907c20.213-10.834 23.516-37.123 6.737-53.374-10.305-9.908 11.361-9.116-270.303-8.983-175.181 0-254.318 0.529-257.092 1.453z",
			"M170.095 628.964c-14.136 3.567-26.554 14.003-33.16 27.744-3.699 7.662-4.095 9.908-4.095 20.478s0.529 12.815 4.095 20.478c8.191 17.175 24.441 28.14 42.805 28.669 21.27 0.529 38.048-9.908 47.296-29.594 3.038-6.606 3.567-9.248 3.567-19.552-0.132-10.569-0.529-12.947-4.228-20.478-8.058-17.043-23.912-27.744-41.88-28.536-5.153-0.264-11.626 0.132-14.401 0.792z",
			"M321.232 644.949c-14.401 4.228-23.251 16.514-23.251 32.236 0.132 13.343 5.681 22.591 17.175 28.8l5.285 2.907h257.621c243.88 0 257.885-0.132 261.848-2.378 7.795-4.228 13.211-10.040 16.25-17.439 6.474-16.118-0.661-34.481-16.646-42.408-5.020-2.511-10.834-2.511-259.471-2.774-162.368-0.132-255.903 0.264-258.81 1.057z",
			"M168.51 794.634c-14.401 4.492-25.233 13.872-31.576 27.083-3.567 7.795-4.095 10.040-4.095 20.609s0.396 12.815 4.095 20.478c5.285 10.965 13.476 19.156 24.309 24.309 7.531 3.567 9.908 4.095 20.478 4.095s12.815-0.396 20.478-4.095c10.834-5.153 19.025-13.343 24.309-24.309 3.699-7.662 4.095-9.777 4.095-20.478-0.132-10.437-0.529-12.947-4.095-20.478-8.058-17.175-24.441-28.14-42.805-28.536-5.416-0.132-12.286 0.396-15.193 1.321z",
			"M321.1 810.223c-14.136 4.095-23.12 16.514-23.12 32.103 0.132 13.343 5.549 22.591 17.175 28.8l5.285 2.907 254.714 0.396c173.333 0.132 256.431-0.132 259.998-1.057 7.002-1.982 15.722-8.983 19.685-15.854 2.642-4.756 3.303-7.795 3.303-15.193-0.132-14.003-6.341-24.441-18.627-30.518-5.020-2.511-10.834-2.511-259.471-2.774-165.802-0.132-255.903 0.264-258.942 1.19z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "favourite",
		paths: [
			"M507.003 33.403c-2.537 5.558-9.424 19.816-15.224 31.778-15.224 31.778-23.562 48.936-31.295 65.247-3.867 7.974-11.116 23.199-16.312 33.832-5.075 10.633-11.599 24.166-14.499 30.207-2.779 5.921-9.666 20.057-15.104 31.415-5.437 11.237-12.807 26.462-16.312 33.832-3.505 7.25-10.029 20.903-14.499 30.207s-11.358 23.562-15.224 31.657c-5.437 11.599-7.612 14.862-9.787 15.345-2.054 0.484-92.072 15.345-110.316 18.366-2.779 0.362-16.796 2.779-21.145 3.625-1.692 0.242-5.679 0.846-9.062 1.208-3.263 0.484-6.404 0.966-6.766 1.208-0.484 0.242-2.9 0.724-5.437 1.088-2.658 0.484-11.237 1.812-19.212 3.141s-15.95 2.658-17.762 2.9c-1.933 0.362-4.833 0.846-6.646 1.208-1.933 0.242-9.908 1.571-17.882 2.9s-26.22 4.349-40.478 6.766c-24.89 4.109-28.515 4.713-35.886 5.921-1.933 0.362-8.578 1.45-14.862 2.537s-12.807 2.175-14.499 2.417c-6.283 0.966-34.556 5.558-37.215 6.162-2.537 0.484-2.296 0.966 3.141 5.679 3.263 2.779 10.995 9.666 17.278 15.224 6.283 5.679 15.104 13.533 19.695 17.52 4.471 4.109 9.424 8.458 10.875 9.787 1.571 1.329 4.833 4.349 7.492 6.646s9.304 8.338 14.983 13.291c5.679 4.953 15.708 13.895 22.353 19.937 6.646 5.921 16.191 14.379 21.025 18.728 4.953 4.349 11.479 10.029 14.499 12.807 3.021 2.658 14.016 12.445 24.286 21.629 10.27 9.062 20.661 18.366 22.957 20.42s13.775 12.203 25.374 22.474c11.599 10.27 21.387 18.97 21.749 19.333s7.733 6.887 16.312 14.499c8.7 7.612 16.312 14.379 17.036 15.104 0.724 0.604 3.263 2.9 5.679 5.075l4.471 3.867-36.249 145.357c-19.937 79.989-36.732 147.29-37.457 149.586-0.604 2.296-4.471 17.52-8.578 33.832-3.987 16.312-7.612 30.569-7.854 31.778-0.724 2.175 4.471-0.242 19.453-8.82 2.054-1.208 7.492-4.109 12.083-6.646 4.713-2.537 11.237-6.041 14.499-7.854 3.383-1.812 24.286-13.291 46.519-25.374 53.044-28.878 50.506-27.549 65.852-35.886 7.37-4.109 16.554-9.062 20.541-11.237s10.029-5.437 13.291-7.25c12.807-7.008 46.399-25.254 55.581-30.207 5.317-2.9 10.27-5.558 10.875-6.041 0.724-0.484 6.646-3.745 13.291-7.25s12.687-6.766 13.291-7.25c0.724-0.484 6.162-3.505 12.083-6.646 6.041-3.141 15.587-8.458 21.387-11.721 5.921-3.263 11.599-6.041 12.687-6.041 1.208-0.12 13.291 6.041 26.945 13.533 13.653 7.37 28.032 15.345 32.020 17.52s28.515 15.466 54.373 29.603c74.793 40.84 138.228 75.397 148.015 80.713 4.953 2.658 22.957 12.567 39.873 21.749 16.916 9.304 30.932 16.796 31.053 16.674s-20.179-81.439-44.948-180.759l-45.311-180.639 6.404-6.041c3.383-3.383 10.27-9.546 15.224-13.895 10.754-9.424 31.899-28.153 32.744-28.999 0.362-0.362 7.37-6.646 15.708-13.895 8.338-7.37 15.345-13.533 15.708-13.895s12.807-11.479 27.791-24.77c14.983-13.291 27.428-24.408 27.791-24.77s7.733-6.887 16.312-14.499c8.7-7.612 15.95-14.137 16.312-14.499s5.195-4.713 10.875-9.666c5.558-4.953 10.875-9.666 11.599-10.27 0.724-0.724 5.317-4.833 10.27-9.182 55.823-49.54 64.039-57.031 63.073-57.877-0.484-0.484-6.887-1.692-14.258-2.9-7.25-1.088-19.574-3.021-27.186-4.349s-20.42-3.383-28.395-4.713c-7.974-1.329-27.67-4.591-43.74-7.25-16.191-2.779-42.41-7.129-58.36-9.787s-42.048-7.008-57.998-9.666c-15.95-2.658-42.17-7.008-58.24-9.666-16.191-2.779-38.785-6.525-50.264-8.338-11.599-1.933-21.387-3.867-21.991-4.471-0.484-0.604-7.008-13.653-14.258-28.878-7.25-15.345-18.004-37.577-23.803-49.54s-13.171-27.186-16.312-33.832c-3.141-6.646-9.424-19.695-13.895-28.999-10.633-22.233-20.661-42.894-43.498-90.621-3.505-7.37-11.479-23.924-17.762-36.853s-13.533-28.032-16.070-33.59c-2.658-5.437-5.075-9.908-5.437-9.908s-2.779 4.471-5.437 9.908z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "football",
		paths: [
			"M483.445 0.188c-0.242 0.242-6.036 0.724-12.917 1.207-6.76 0.483-13.037 1.087-13.882 1.327-0.724 0.242-4.949 0.724-9.295 1.087s-9.054 0.965-10.623 1.327c-1.569 0.242-9.174 1.569-16.9 2.898-107.556 18.711-211.734 76.533-286.577 158.981-55.408 61.081-94.037 131.459-116.248 211.612-7.123 25.712-13.279 61.081-15.935 92.467-1.449 16.78-1.087 74.36 0.724 90.536 11.71 110.937 54.442 208.474 127.474 291.405 12.433 14.244 39.474 40.439 53.114 51.424 3.26 2.656 7.485 6.277 9.537 7.967 27.523 22.936 74.119 51.304 111.903 67.962 48.889 21.608 107.798 37.421 153.187 41.163 4.949 0.483 10.381 1.087 12.071 1.449s18.227 0.724 36.818 0.965c36.456 0.242 60.599-1.327 89.329-6.156 81.12-13.52 158.619-46.475 223.322-95.003 25.833-19.435 60.599-51.545 78.585-72.67 19.073-22.452 25.108-30.179 38.508-49.976 28.006-41.526 46.837-79.551 62.288-125.663 7.967-24.023 11.588-37.421 16.658-63.375 3.863-19.435 4.105-21.125 7.001-44.061 2.052-17.504 3.018-75.326 1.449-92.95-5.432-60.599-17.987-112.264-39.836-163.326-13.279-31.024-24.385-51.304-44.302-81.482-71.705-108.523-181.313-185.177-308.184-215.717-18.591-4.467-48.769-9.657-63.858-10.864-4.949-0.483-10.381-1.087-12.071-1.449-3.501-0.604-70.618-1.69-71.342-1.087zM381.923 106.779c-20.763 40.56-21.367 41.888-20.521 42.733 0.483 0.483 16.296 6.881 35.249 14.365s52.752 20.883 75.205 29.695l40.681 16.176 72.791-29.092c39.956-16.055 73.878-29.575 75.447-30.179 2.656-0.965 2.173-1.931-15.451-37.301-9.899-19.918-18.107-36.456-18.107-36.698 0-0.845 18.591 4.587 33.8 9.777 79.551 27.523 152.584 79.188 205.094 145.099 9.657 12.192 26.919 36.456 26.437 37.060-0.242 0.12-6.639-0.724-14.244-1.931-7.605-1.327-17.383-2.898-21.729-3.501-4.345-0.724-16.417-2.656-27.041-4.345-10.502-1.69-19.314-2.898-19.556-2.776-0.483 0.604-1.931 19.676-3.501 46.233-0.242 3.983-0.724 12.917-1.207 19.918-1.207 18.349-1.449 21.97-2.294 38.025-0.483 7.967-1.087 16.055-1.327 18.107-0.362 3.018-1.569 22.694-2.294 37.301-0.12 3.018 7.846 13.158 51.183 65.427 28.248 34.042 51.907 61.806 52.752 61.685s14.727-13.399 30.902-29.455c29.455-29.092 29.575-29.213 30.179-25.35 0.724 4.708 0 60.841-0.965 68.445-3.501 29.817-6.76 47.441-12.675 71.342-9.174 36.094-25.712 77.257-44.423 109.73-12.675 22.212-40.801 62.41-44.302 63.617-0.845 0.242-1.931-3.742-2.776-9.537-1.69-10.985-3.501-23.056-7.485-48.044-1.449-8.933-2.898-18.469-3.26-21.125s-0.965-5.19-1.327-5.674c-0.483-0.483-4.949 0.242-9.899 1.569-10.623 2.776-88.845 22.816-124.094 31.748l-24.626 6.277-7.967 12.917c-4.467 7.123-23.539 37.421-42.492 67.358-18.952 30.058-34.766 55.167-35.249 55.891-0.724 1.327 10.019 7.243 60.841 33.317 8.57 4.345 15.451 8.208 15.451 8.692 0 2.173-40.923 15.331-65.186 20.883-35.007 7.967-61.806 10.864-102.004 10.864-42.854 0-70.86-3.38-110.816-13.399-19.918-4.949-58.667-17.866-57.46-19.073 0.483-0.483 32.835-17.020 64.22-32.955 7.123-3.621 12.917-7.001 12.917-7.485s-1.69-3.621-3.863-6.881c-7.846-12.192-12.071-18.831-34.766-54.805-12.795-20.28-24.988-39.594-27.161-42.854-2.173-3.38-7.485-11.83-11.951-19.073-4.467-7.123-9.054-13.399-10.14-14.002-1.207-0.604-20.763-5.794-43.699-11.588s-57.339-14.486-76.654-19.314c-19.194-4.949-35.369-8.57-35.852-8.088-0.362 0.483-3.26 16.296-6.398 35.249-3.018 18.952-6.277 37.663-7.001 41.647l-1.449 7.123-10.381-13.762c-49.855-66.755-80.395-143.167-88.605-222.115-0.483-4.345-1.087-8.933-1.449-10.261-0.965-4.345-1.69-61.444-0.845-65.548l0.845-4.105 29.333 29.333c29.213 29.092 29.455 29.333 31.748 27.041 2.294-2.414 30.42-36.094 38.749-46.475 2.294-2.898 6.156-7.485 8.45-10.261 7.485-8.692 48.769-58.667 52.269-63.133 2.898-3.863 3.26-5.19 2.776-9.899-0.362-3.018-0.965-11.468-1.327-18.711-0.362-7.363-0.965-15.451-1.207-18.107s-0.845-10.864-1.207-18.107c-0.362-7.363-0.965-15.451-1.207-18.107s-0.845-11.106-1.327-18.711c-0.483-7.605-0.965-15.813-1.087-18.107-0.242-2.294-0.724-10.261-1.207-17.504-0.483-7.363-1.087-15.21-1.207-17.504-0.242-2.294-0.483-5.794-0.483-7.726-0.12-3.38-0.242-3.38-5.19-2.656-2.898 0.483-12.192 1.931-20.883 3.26-8.57 1.207-17.020 2.535-18.711 2.776-1.69 0.362-5.19 0.845-7.846 1.207s-10.019 1.449-16.296 2.414c-6.277 1.087-11.588 1.569-11.83 1.327-0.724-0.724 14.365-21.97 24.988-35.369 55.77-69.773 129.888-120.956 214.992-148.479 8.33-2.776 17.020-5.432 19.314-6.156 2.294-0.604 4.345-1.207 4.587-1.207 0.12-0.12-6.881 13.882-15.693 30.902z",
			"M487.548 362.694c-42.974 30.179-93.192 65.427-109.85 77.257l-15.813 11.226 1.087 3.863c0.604 2.173 14.124 42.854 29.937 90.294l28.851 86.311h181.555l30.058-89.932c23.177-69.531 29.575-90.294 28.488-91.26-0.845-0.845-18.227-13.279-38.87-27.644-73.998-51.907-85.828-60.357-98.020-68.928l-12.313-8.692-25.108 17.504z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Football-match",
		paths: [
			"M650.614 0.269c-36.166 5.908-65.581 32.066-74.984 66.786-3.255 12.055-2.894 35.080 0.603 47.618 19.047 66.062 101.987 87.52 150.932 39.059 16.516-16.516 25.075-36.648 25.919-60.879s-6.872-45.81-22.785-63.17c-17.119-18.927-38.094-28.691-62.807-29.535-7.233-0.241-14.828-0.12-16.877 0.12z",
			"M184.318 211.838c-11.935 2.772-24.833 13.019-29.897 23.869-10.97 23.266-1.447 49.788 21.819 60.879l7.836 3.737 364.068 0.603-152.619 152.86c-173.475 173.595-159.612 158.043-159.612 179.261 0 11.452 0.241 12.417 4.099 19.65 12.175 22.422 37.733 31.102 60.276 20.614 4.219-2.050 26.039-23.025 88.365-85.351l82.94-82.578 3.737 3.496c8.8 8.439 16.757 16.636 16.757 17.6 0 0.483-95.116 96.080-211.449 212.292-116.213 116.333-212.775 213.619-214.463 216.271-6.51 10.488-8.319 23.146-5.063 35.804 6.148 23.388 30.861 37.854 54.49 31.705 4.219-0.964 9.764-3.255 12.417-4.942s149.485-147.676 326.335-324.527l321.272-321.272 39.902 39.782 39.902 39.902-54.61 54.61c-70.040 70.040-69.197 69.076-72.331 77.636-6.63 17.721-2.411 36.889 10.97 49.426 7.956 7.353 16.516 11.211 27.607 12.055 10.73 0.844 21.338-2.17 30.018-8.559 9.403-7.113 158.646-157.441 161.901-163.348 3.978-6.992 6.148-18.686 5.305-27.366-1.567-15.43 1.326-12.055-110.425-123.927-91.5-91.62-103.313-102.952-110.547-106.689l-8.077-4.219-273.171-0.241c-156.235 0-275.1 0.361-277.753 0.964z",
			"M434.825 845.22c-39.059 8.8-65.821 37.010-71.849 75.707-6.992 44.724 22.422 88.726 67.027 100.42 11.332 3.014 34.237 3.014 45.207 0 31.464-8.559 56.057-33.272 64.616-64.857 3.014-10.85 3.014-33.755 0-45.207-8.319-32.549-34.96-58.106-68.473-65.701-10.006-2.291-27.244-2.531-36.527-0.361z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "games",
		paths: [
			"M277.736 181.639c-49.905 7.233-93.3 37.609-117.167 81.848-3.736 7.112-6.027 12.537-56.413 133.801-18.323 44.118-36.524 87.754-40.381 97.036s-11.813 28.207-17.479 42.19c-10.969 26.399-16.876 40.502-18.684 44.6-0.603 1.325-3.858 9.161-7.233 17.479s-7.112 17.479-8.438 20.492c-25.072 57.86-9.643 131.029 37.368 178.282 62.44 62.562 157.91 60.874 219.747-3.978 14.104-14.826 23.506-29.894 34.596-55.569 7.835-18.081 12.054-25.314 20.372-35.56 16.514-20.372 37.007-33.51 58.583-37.971 8.558-1.688 23.506-1.808 134.404-1.567l124.761 0.361 8.438 2.772c22.783 7.594 42.431 23.386 57.257 45.806 3.255 4.942 9.523 17.358 13.862 27.725 11.331 26.278 22.542 43.154 39.659 59.788 41.104 39.659 100.291 54.124 151.762 36.885 11.451-3.858 29.171-12.295 36.042-17.117 30.858-21.818 50.989-46.77 64.007-79.316 7.474-18.804 10.487-34.113 11.090-56.052 0.723-29.291-2.411-42.672-19.889-84.982-6.63-16.273-12.898-31.221-13.742-33.149-0.964-2.049-12.898-30.738-26.639-63.887s-27.002-65.213-29.653-71.12c-2.531-6.027-18.201-43.636-34.837-83.776s-32.426-77.147-35.077-82.33c-7.715-14.948-14.948-24.591-28.689-38.332-22.3-22.059-45.565-34.837-79.075-42.912-7.835-1.928-26.399-2.049-239.878-2.291-127.292-0.12-234.695 0.241-238.673 0.844zM335.837 289.404c9.041 4.099 17.72 12.777 22.42 22.18l3.858 7.955 0.361 35.801 0.361 35.921h32.185c35.921 0 42.19 0.844 52.436 7.474 11.21 7.233 20.131 23.506 20.131 36.885 0 14.104-7.233 29.171-17.599 36.524-12.657 9.041-15.55 9.523-54.364 9.523h-32.908l-0.12 32.788c0 18.081-0.241 34.113-0.603 35.56-2.531 13.742-12.537 26.76-25.555 33.149-7.233 3.616-9.041 3.978-18.925 3.978s-11.693-0.361-18.804-3.858c-9.643-4.702-18.081-13.38-22.542-23.023l-3.255-6.871-0.361-35.921-0.483-35.801h-32.666c-36.885 0-41.225-0.723-51.953-7.835-25.314-16.756-26.519-55.569-2.291-73.289 11.693-8.558 11.572-8.558 51.35-9.041l35.801-0.483v-32.666c0-35.318 0.723-40.984 6.388-50.628 3.496-6.027 12.054-14.104 17.84-17.237 11.331-5.907 27.845-6.388 39.296-1.085zM728.079 290.851c9.763 4.58 17.358 12.174 22.059 22.059 3.255 6.991 3.736 9.041 3.736 18.684s-0.483 11.693-3.736 18.684c-4.702 9.885-12.174 17.358-22.18 22.18-6.991 3.375-9.041 3.736-18.684 3.736-9.885 0-11.693-0.361-18.925-3.978-10.246-5.063-17.117-11.934-21.939-21.939-3.255-6.991-3.736-9.041-3.736-18.684s0.361-11.693 3.736-18.684c11.090-23.023 37.127-32.666 59.668-22.059zM622.003 395.722c28.689 13.621 35.077 50.748 12.537 73.048-13.38 13.14-33.269 16.393-50.628 8.318-20.612-9.763-30.618-33.149-23.386-54.846 8.558-25.555 37.248-37.971 61.476-26.519zM832.228 395.361c35.56 16.273 35.921 65.213 0.603 81.968-6.991 3.255-9.041 3.736-18.684 3.736s-11.693-0.483-18.684-3.736c-29.653-14.224-35.44-51.472-11.572-74.374 12.054-11.451 32.788-14.706 48.337-7.594zM728.079 500.593c28.086 13.14 35.077 50.145 13.501 71.964-9.763 10.005-20.251 14.104-34.596 13.501-16.876-0.603-31.1-10.246-38.573-26.037-3.375-6.991-3.736-9.041-3.736-18.684 0-9.885 0.361-11.693 3.858-18.804 6.268-12.657 17.358-21.939 30.135-25.194 8.558-2.049 20.975-0.723 29.413 3.255z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Heart-rate",
		paths: [
			"M274.131 16.223c-41.477 4.581-71.74 13.143-106.103 30.143-31.469 15.554-54.257 31.831-79.697 57.271-30.143 30.023-50.157 60.044-66.194 99.23-28.696 70.293-29.54 148.182-2.17 222.212l4.461 11.937 349.776 0.603 3.617 2.773c1.929 1.567 9.284 11.454 16.397 22.064s13.383 19.291 13.866 19.291c0.603 0 1.447-1.567 1.809-3.376 0.964-4.1 27.731-106.705 32.674-125.153 1.929-7.354 3.737-14.107 3.979-15.071 0.361-1.929 9.163-35.448 18.809-72.101 3.134-12.177 6.752-23.753 7.957-25.803 4.34-7.476 15.071-10.249 22.909-6.029 8.199 4.461 8.681 6.149 15.916 48.47 2.050 11.574 5.546 32.434 7.957 46.42 2.411 13.866 4.581 26.887 4.943 28.937 0.361 1.929 4.943 28.576 10.128 59.080 5.306 30.504 10.128 58.477 10.851 62.094s1.447 8.199 1.809 10.249c5.306 32.434 4.461 30.866 8.801 15.674 1.326-4.703 3.497-12.298 4.943-16.88 1.326-4.703 6.029-21.22 10.49-36.774s8.923-29.54 9.887-31.107c2.411-3.617 10.007-7.476 14.83-7.476 5.426 0 11.816 3.497 14.469 7.717 1.206 2.050 3.134 6.752 4.1 10.369s2.291 8.199 2.894 10.249c0.603 1.929 4.22 15.191 8.079 29.299 3.737 14.107 7.354 25.2 7.837 24.717 0.483-0.603 4.461-13.504 8.923-28.696 4.461-15.313 9.163-29.66 10.369-31.951 4.703-9.043 14.469-11.937 23.994-6.993 5.184 2.653 5.908 3.617 16.518 24.958 6.149 12.177 11.574 22.667 12.177 23.27s5.426-6.27 11.574-16.518c8.801-14.71 11.213-17.844 15.191-19.894 4.581-2.411 7.234-2.411 135.522-2.411h130.82l1.809-3.376c3.497-6.873 12.66-35.327 15.674-48.59 5.787-25.803 7.234-38.583 7.234-66.194 0.12-26.043-0.241-31.107-3.497-51.243-5.546-35.327-17.724-69.208-35.81-101.038-38.703-67.52-103.208-118.28-177.601-139.621-10.369-3.014-32.796-7.837-40.994-8.801-3.256-0.483-7.957-1.086-10.249-1.447-8.199-1.206-50.157-1.567-59.683-0.483-35.086 3.979-56.186 9.163-85.606 20.738-31.59 12.54-65.47 33.88-91.754 57.994l-6.631 6.029-3.134-2.894c-1.809-1.567-5.787-5.184-8.801-7.957-39.306-36.291-103.691-65.711-157.345-72.101-3.859-0.483-8.199-1.086-9.646-1.447-4.461-0.964-50.52-1.326-59.080-0.361z",
			"M475.605 369.255c-9.646 37.618-18.327 70.775-28.454 109.358-3.979 15.191-8.923 34.483-11.093 42.683-3.134 12.54-4.34 15.554-7.717 18.809-6.873 6.873-18.327 6.873-24.717 0.12-1.929-2.050-9.526-12.66-16.76-23.631s-13.624-20.497-14.107-21.1c-0.483-0.723-4.1-5.908-7.957-11.816l-6.873-10.49h-156.742c-86.208 0-156.742 0.361-156.742 0.723 0 1.326 12.901 20.014 19.653 28.454 4.703 5.908 51.484 59.2 68.967 78.613 3.497 3.859 18.689 21.1 21.823 24.717 1.929 2.291 4.34 4.943 5.426 6.029 0.964 1.086 9.646 10.851 19.291 21.823 9.526 10.851 18.206 20.617 19.171 21.703s5.306 6.029 9.646 10.972c7.596 8.56 25.32 28.576 33.037 37.257 2.050 2.291 7.596 8.56 12.177 13.866 4.703 5.306 8.681 9.887 9.043 10.249s8.56 9.526 18.086 20.497c9.646 10.851 20.497 23.029 24.114 27.129s18.327 20.617 32.554 36.774c34.966 39.547 61.009 69.087 64.506 72.825 0.723 0.723 7.114 8.079 14.469 16.397 17.483 20.014 24.958 28.454 58.96 66.917 15.916 17.844 30.626 34.483 32.796 36.894 4.22 4.823 4.22 4.823 10.007-1.929 2.291-2.653 7.596-8.681 11.816-13.383 4.22-4.823 8.681-9.766 9.766-10.972 1.086-1.326 5.426-6.149 9.404-10.731 4.1-4.581 16.277-18.327 27.129-30.626 10.731-12.298 23.994-27.249 29.299-33.157 5.426-6.029 13.263-14.951 17.603-19.894s14.83-16.76 23.391-26.406c8.56-9.766 18.93-21.341 22.909-25.923 4.1-4.703 14.348-16.277 22.909-25.923 26.887-30.263 29.66-33.398 68.846-77.888 21.1-23.873 41.959-47.506 46.42-52.448s14.589-16.397 22.426-25.32c7.957-9.043 30.866-34.966 51.123-57.874 20.256-22.788 40.511-45.817 45.214-51.123 4.581-5.426 9.163-10.61 10.249-11.574 4.1-3.979 19.291-21.583 24.958-28.937 6.511-8.44 18.447-25.923 18.447-27.008 0-0.361-51.363-0.723-114.301-0.723h-114.181l-16.518 27.611c-9.163 15.071-17.844 28.334-19.291 29.299-6.993 4.581-16.88 3.979-22.426-1.447-2.050-1.809-7.234-10.851-11.816-20.014l-8.199-16.639-2.532 8.32c-1.447 4.703-6.993 22.788-12.177 40.271-8.32 27.611-10.007 32.193-13.383 35.689-8.079 8.32-22.788 6.27-27.851-3.859-1.326-2.532-6.27-19.533-11.093-37.739-4.943-18.206-9.284-33.64-9.646-34.121-0.483-0.483-7.476 22.547-15.674 51.243s-15.916 54.257-17.121 56.789c-1.567 3.256-3.859 5.306-7.354 6.993-6.511 2.894-10.61 2.894-16.518-0.12-6.27-3.256-8.801-8.44-11.213-23.511-1.086-6.631-2.291-13.383-2.653-15.071-0.241-1.688-4.34-25.32-8.923-52.448-4.703-27.249-9.043-52.207-9.766-55.463-0.603-3.376-1.929-10.972-2.894-16.88-0.964-6.029-2.894-17.121-4.22-24.717s-2.653-15.554-3.014-17.483c-1.809-10.369-9.404-54.257-10.851-62.456-0.844-5.184-1.809-9.526-2.050-9.766-0.241-0.361-4.22 13.986-8.801 31.59z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "home",
		paths: [
			"M499.124 32.187c-0.641 0.257-5.639 1.409-10.892 2.563-18.324 4.228-31.778 12.173-47.539 27.934-11.66 11.532-130.445 132.239-147.103 149.409-6.663 6.791-38.314 38.955-70.476 71.63s-66.248 67.4-75.729 77.14c-19.605 19.989-119.682 121.732-136.34 138.646-6.023 6.023-11.019 11.405-11.019 11.789s42.926 0.768 95.463 0.768h95.463v196.693c0 174.782 0.257 197.847 2.050 206.688 7.304 35.622 32.932 63.045 69.323 74.193 7.048 2.050 21.527 2.306 244.488 2.563 214.632 0.384 237.954 0.257 247.308-1.666 39.723-8.072 69.708-39.082 76.243-78.805 0.768-5.382 1.281-75.602 1.281-203.997v-195.668h192.336l-9.354-9.483c-13.968-14.095-118.528-120.45-136.724-139.031-8.713-8.842-42.158-42.926-74.448-75.729s-66.376-67.4-75.729-77.14c-28.575-29.088-125.063-127.242-140.44-142.747-21.527-21.527-35.238-29.856-57.406-34.47-8.329-1.666-27.037-2.435-30.753-1.281zM585.617 516.679c10.508 4.998 18.452 12.942 23.578 23.578l3.972 8.329 0.384 145.181 0.257 145.053-290.234-0.641-8.329-3.972c-10.635-4.998-18.58-12.942-23.578-23.578l-3.972-8.329-0.384-145.181-0.257-145.053 290.234 0.641 8.329 3.972z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Home-1",
		paths: [
			"M344.337 2.84c-8.191 4.943-8.898 8.051-8.898 39.546v28.247h-105.787l-211.995 211.855v35.309h70.618v670.873h-35.309v35.309h918.037v-35.309h-35.309v-670.873h70.618v-35.168l-105.927-106.068-106.068-105.927h-105.787v-28.671c0-41.099-0.706-41.948-35.309-41.948-23.87 0-27.824 1.13-32.484 8.898-2.542 4.096-2.825 7.203-2.825 33.050v28.671h-211.855v-28.671c0-31.355-0.423-33.473-8.334-38.699-4.52-3.107-6.215-3.248-26.835-3.248-19.35 0-22.598 0.283-26.552 2.825zM278.379 354.659c19.49 3.531 40.676 19.35 49.009 36.581 7.627 15.959 8.051 19.773 8.051 81.494v56.918h-141.236v-57.624c0.141-61.861 0.565-65.392 7.909-80.505 3.954-8.191 16.948-23.021 23.021-26.269 21.326-11.582 33.897-14.124 53.246-10.593zM535.006 357.061c22.598 8.191 39.263 26.552 45.478 49.856 1.695 6.073 2.119 19.773 2.119 65.109v57.624h-141.236v-56.495c0-35.733 0.565-59.037 1.553-63.839 5.226-25.282 26.129-47.174 51.692-54.093 10.027-2.684 30.366-1.836 40.393 1.836zM775.956 355.225c17.655 4.237 34.18 16.525 44.066 33.191 9.040 15.395 9.746 20.762 9.746 85.025v56.212h-141.236v-56.495c0-36.156 0.565-59.037 1.553-63.839 5.509-25.846 25.988-47.174 51.975-54.093 8.615-2.259 23.87-2.259 33.897 0zM289.82 710.858c11.158 4.52 19.632 10.452 27.541 19.208 6.215 6.921 14.124 21.045 16.102 29.094 0.706 2.259 1.412 31.072 1.553 63.839l0.565 59.743h-141.377v-55.506c0-33.756 0.565-58.896 1.553-63.98 4.661-25.846 26.269-48.444 52.54-55.082 11.016-2.825 30.789-1.553 41.524 2.684zM536.984 710.858c21.892 8.757 37.568 26.411 43.501 49.15 1.695 6.215 2.119 27.4 2.119 118.073v110.588h-141.236v-109.458c0-74.29 0.565-111.718 1.553-116.803 5.509-26.269 28.53-49.433 54.235-54.659 11.299-2.259 29.66-0.847 39.829 3.107zM773.555 707.75c26.976 5.649 49.856 28.813 54.659 55.506 0.989 5.084 1.553 30.225 1.553 63.98v55.506h-141.236v-56.495c0-35.733 0.565-59.037 1.553-63.839 2.684-12.994 9.321-24.999 19.49-35.168 17.372-17.231 40.676-24.293 63.98-19.49z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "hotel",
		paths: [
			"M286.889 1.87c-19.733 5.414-35.254 19.612-42.112 38.623-2.287 6.016-2.767 10.468-3.249 28.997l-0.482 22.019h-59.92v60.161l-3.61 0.12c-1.925 0.12-3.97 0.241-4.452 0.361-0.602 0.12-3.128 0.602-5.775 1.203-20.695 4.091-40.427 24.425-45.001 46.204-0.962 4.572-1.323 117.433-1.323 400.309v394.052h-30.080v30.080h842.248v-30.080h-30.080v-394.412c0-380.215-0.12-394.773-2.287-402.956-2.767-10.829-9.265-21.417-17.687-29.238-9.746-8.783-19.853-13.355-33.449-15.040l-6.738-0.842v-59.92h-60.161v-19.251c0-28.516-3.851-40.067-17.928-54.264-8.663-8.663-18.891-14.319-29.96-16.604-9.867-2.046-440.375-1.685-447.955 0.482zM370.632 53.728c4.572 9.626 8.663 17.687 9.024 17.928 0.482 0.361 9.144 1.925 19.371 3.61s19.371 3.369 20.335 3.729c1.323 0.482 0.482 1.805-3.128 5.054-16.002 14.439-23.823 21.417-24.907 22.14-0.962 0.602 0.12 6.738 3.249 19.853 2.526 10.468 4.813 20.335 5.174 21.899 0.721 2.647 0.602 2.767-2.166 0.962-1.564-0.962-10.347-5.896-19.492-10.829l-16.604-9.024-19.132 10.588c-10.588 5.896-19.251 10.227-19.251 9.746s2.166-9.506 4.813-20.094c2.647-10.468 4.813-19.853 4.813-20.574 0-0.842-6.738-7.58-15.040-14.92-8.182-7.46-14.679-13.837-14.439-14.319 0.361-0.482 2.888-1.323 5.775-1.685 2.888-0.482 6.618-1.083 8.182-1.323s7.219-1.083 12.514-1.925c5.295-0.842 10.709-1.805 12.032-2.287 1.685-0.602 5.295-6.618 10.829-18.53 4.693-9.626 8.663-17.566 9.024-17.566s4.452 7.821 9.024 17.566zM540.886 73.943c6.136 1.083 15.401 2.647 20.574 3.369 5.295 0.721 9.506 1.685 9.506 2.287 0 0.482-3.97 4.211-8.663 8.422-4.813 4.211-11.671 10.468-15.281 13.837l-6.498 6.136 5.054 20.574c2.647 11.19 4.933 20.695 4.933 21.056s-8.663-4.211-19.251-9.986l-19.371-10.709-6.859 3.97c-13.837 7.941-30.441 16.604-31.043 16.002-0.241-0.241 1.685-9.144 4.331-19.612 5.054-20.094 5.534-22.861 3.729-23.582-0.602-0.241-3.49-2.526-6.377-5.174s-9.144-8.303-13.957-12.514c-4.813-4.211-8.303-8.062-7.821-8.542 0.721-0.721 36.337-7.219 39.465-7.219 0.361 0 4.452-7.701 9.024-17.206 4.452-9.385 8.663-17.566 9.144-18.048 0.602-0.482 4.813 7.099 9.626 16.965l8.542 17.928 11.19 2.046zM670.833 52.646c4.211 9.144 8.182 17.206 8.904 18.048s9.986 2.888 20.574 4.693c10.588 1.805 19.733 3.61 20.214 4.091s-5.775 6.738-14.078 13.957c-8.182 7.219-15.040 13.837-15.040 14.679-0.12 0.721 2.046 10.347 4.693 21.297s4.813 20.094 4.813 20.335c0 0.241-8.663-4.211-19.251-10.107l-19.251-10.588-18.891 10.468c-10.468 5.775-19.132 10.107-19.371 9.746-0.12-0.482 1.805-9.506 4.572-19.973 2.647-10.468 4.813-19.973 4.693-20.936 0-0.962-2.888-4.211-6.257-7.099-13.596-11.55-23.582-21.056-23.102-21.778 0.482-0.842 4.813-1.685 16.363-3.249 2.406-0.241 8.904-1.444 14.439-2.526 8.182-1.685 10.347-2.526 11.431-4.813 0.721-1.564 4.572-9.506 8.422-17.807 3.851-8.182 7.339-14.92 7.701-14.92 0.482 0 4.211 7.46 8.422 16.484zM301.447 347.192v75.201h-120.321v-150.401h120.321v75.201zM481.929 347.192v75.201h-120.321v-150.401h120.321v75.201zM662.411 347.192v75.201h-120.321v-150.401h120.321v75.201zM842.892 347.192v75.201h-120.321v-150.401h120.321v75.201zM301.447 587.834v75.201h-120.321v-150.401h120.321v75.201zM481.929 587.834v75.201h-120.321v-150.401h120.321v75.201zM662.411 587.834v75.201h-120.321v-150.401h120.321v75.201zM842.892 587.834v75.201h-120.321v-150.401h120.321v75.201zM301.447 828.476v75.201h-120.321v-150.401h120.321v75.201zM497.571 858.557v105.281h-135.963v-210.562h135.963v105.281zM662.411 858.557v105.281h-137.166v-210.562h137.166v105.281zM842.892 828.476v75.201h-120.321v-150.401h120.321v75.201z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Incoming-call-curved-arrow",
		paths: [
			"M881.026 116.833c0 28.881-0.229 53.865-0.344 55.469-2.406 32.892-17.878 70.139-39.768 95.581-26.13 30.37-58.219 49.394-98.217 58.219-10.888 2.406-13.065 2.406-179.701 2.751l-168.813 0.459v-114.146c0-62.689-0.229-114.032-0.573-114.032-0.229 0-84.579 84.121-187.266 186.807-109.792 109.792-188.755 189.558-191.277 193.454-20.056 29.568-20.056 67.158 0.114 97.071 2.979 4.355 72.545 74.723 191.85 194.027l187.15 187.15v-229.325l138.443-0.114c76.098 0 140.621-0.229 143.486-0.573 11.461-1.032 28.308-2.865 31.516-3.438 9.856-1.49 23.38-4.011 26.932-5.043 2.178-0.573 7.335-1.833 11.461-2.865 38.507-9.168 85.954-31.402 121.596-56.73 23.035-16.504 50.77-41.945 68.763-63.033 29.568-34.725 54.323-78.734 68.649-121.825 6.876-20.4 13.065-46.186 15.358-63.835 0.344-2.178 1.146-7.908 1.949-12.607 1.605-10.888 2.292-58.908 0.917-73.347-7.22-80.338-39.195-155.29-91.455-214.885-7.908-8.939-33.006-33.35-41.717-40.455l-8.825-7.22-0.229 52.489z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "info",
		paths: [
			"M499.714 0.711c-0.241 0.241-7.709 0.602-16.621 1.084-96.476 4.457-195.362 39.988-274.614 98.765-64.558 47.817-117.554 110.448-153.206 180.787-21.56 42.397-39.867 97.44-47.335 142.125-1.084 6.624-2.168 12.286-2.409 12.647-0.12 0.361-0.722 5.179-1.204 10.84s-1.084 10.599-1.324 10.96c-2.891 4.818-2.891 105.509 0 110.689 0.241 0.361 0.843 4.096 1.204 8.431 3.733 35.892 16.501 85.396 32.279 125.263 7.588 19.151 25.052 54.561 35.049 71.304 23.728 39.145 46.612 68.412 77.928 99.728 21.56 21.56 23.848 23.728 40.951 37.458 91.177 73.471 204.274 113.579 320.384 113.579 111.653-0.12 215.716-34.086 304.726-99.728 38.181-28.063 76.844-66.245 105.028-103.703 33.845-45.047 59.259-93.345 76.965-146.341 9.153-27.582 17.706-62.992 20.958-86.72 2.529-19.512 3.131-24.811 3.974-36.133 1.084-16.862 1.084-63.716-0.12-79.374-6.504-85.034-36.253-171.514-83.107-241.612-12.647-18.91-15.297-22.523-29.629-40.349-23.848-29.75-60.103-64.558-92.26-88.768-62.751-46.974-141.764-80.698-219.812-93.706-16.501-2.77-16.38-2.77-28.907-4.096-19.753-2.168-67.569-4.216-68.895-3.131zM528.862 122.963c48.298 8.792 81.059 56.729 71.785 105.028-8.311 43.36-44.685 73.351-88.888 73.351-43.48 0.12-80.096-30.352-88.407-73.11-5.54-29.389 3.372-58.416 24.811-79.976 21.8-22.041 50.105-30.833 80.698-25.293zM602.334 563.189c0.722 189.099 0.843 201.625 2.891 209.574 2.289 9.033 8.19 22.643 11.442 26.378 6.624 7.709 21.319 12.406 43.842 13.851 1.807 0.12 2.048 1.687 2.048 15.538v15.297h-270.399l-0.722-31.316 5.179 0.12c8.551 0.12 22.523-2.77 29.509-6.263 12.888-6.263 16.621-12.286 19.753-31.196 1.687-9.997 2.409-314.602 0.843-333.15-1.324-14.814-4.938-29.389-8.792-34.327-5.54-7.227-22.523-13.249-39.386-13.851l-6.986-0.241v-15.297c0-8.431 0.241-15.538 0.482-15.778 0.361-0.241 47.576-0.482 105.148-0.482h104.546l0.602 201.143z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "map-pin",
		paths: [
			"M477.508 1.203c-80.614 8.931-149.282 42.842-206.122 101.613-45.497 47.186-76.512 109.819-87.252 176.194-3.741 23.171-4.947 60.22-2.655 83.632 4.465 46.342 17.982 89.184 42.358 133.714 4.224 7.724 9.775 17.861 12.31 22.568 2.534 4.586 5.431 10.016 6.637 12.068 1.207 1.93 4.344 7.724 6.999 12.671s16.292 30.17 30.412 56.117c14.12 25.826 27.636 50.566 29.929 54.91s8.689 15.93 14.12 25.946c5.431 9.896 11.948 21.843 14.482 26.55 4.947 9.171 10.016 18.585 14.843 27.153 1.569 3.017 10.016 18.464 18.585 34.394 8.689 15.93 18.585 34.152 22.084 40.428 6.999 12.551 9.654 17.499 21.723 39.825 7.603 14.12 10.499 19.309 18.706 34.394 6.034 10.981 69.633 127.801 73.132 134.197 1.81 3.5 3.741 6.396 4.224 6.396s3.017-4.224 5.792-9.413c2.655-5.069 6.999-13.155 9.534-17.74 2.534-4.707 6.879-12.551 9.534-17.499 2.775-4.947 7.724-14.24 11.223-20.516s9.051-16.654 12.31-22.929c3.379-6.276 7.724-13.998 9.534-17.257 1.93-3.137 3.5-5.914 3.5-6.154s4.104-7.964 9.171-17.137c5.069-9.171 11.344-20.878 14.12-25.826 2.655-4.947 14.361-26.43 25.946-47.669s22.929-42.118 25.223-46.462c2.414-4.344 7.603-13.878 11.585-21.119 9.534-17.378 11.585-21.361 25.585-47.065 12.31-22.568 13.516-24.86 25.946-47.669 4.224-7.603 9.171-16.775 10.981-20.274 1.93-3.379 5.069-9.171 6.999-12.671 1.81-3.379 11.706-21.481 21.843-40.066s20.154-37.049 22.326-41.031c2.172-3.982 6.034-11.103 8.448-15.688 2.534-4.707 8.689-15.809 13.637-24.74 11.585-20.999 17.378-32.584 23.774-48.272 24.74-60.461 31.015-126.595 18.102-191.037-14.723-73.735-55.755-142.523-113.32-189.71-3.259-2.655-7.603-6.276-9.654-7.964-10.138-8.568-37.169-25.223-55.633-34.274-35.239-17.378-67.823-26.912-110.423-32.584-11.948-1.569-56.358-1.569-70.598 0zM542.072 91.714c28.48 4.947 37.169 7.121 54.186 13.516 67.943 25.223 122.249 81.821 144.817 150.609 9.051 27.636 11.585 45.497 11.465 78.442-0.242 38.135-6.758 66.858-23.291 101.372-12.551 26.188-28.118 47.91-49.238 68.185-15.085 14.602-18.585 17.499-34.756 28.36-30.412 20.396-70.478 35.118-105.716 38.859-10.981 1.207-45.014 1.207-54.79 0.12-100.407-11.826-182.831-84.235-207.088-182.228-9.413-37.653-8.931-82.666 1.327-121.043 24.86-92.924 106.441-163.884 202.26-176.074 13.033-1.569 51.893-1.69 60.824-0.12z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "menu",
		paths: [
			"M34.857 166.674c-12.9 2.531-25.076 12.539-31.104 25.197-3.255 7.113-3.737 9.162-3.737 18.807 0 9.886 0.361 11.573 3.978 18.928 5.064 10.247 11.936 17.12 21.942 21.942l7.836 3.737h956.029l7.836-3.737c9.886-4.822 17.481-12.297 21.942-21.701 10.73-22.906 1.206-48.946-21.942-60.038l-7.836-3.737-475.001-0.12c-261.251-0.12-477.292 0.241-479.943 0.723z",
			"M33.048 468.553c-12.539 3.375-22.665 11.814-29.054 24.232-3.497 6.511-3.858 8.319-3.858 18.687-0.12 10.368 0.241 12.176 3.617 19.289 4.702 9.886 12.176 17.361 22.183 22.183l7.836 3.737h956.029l7.836-3.858c8.801-4.34 10.85-5.908 16.998-13.623 6.511-8.078 8.922-15.673 8.922-27.728 0-8.922-0.483-11.212-3.737-18.084-4.702-10.006-12.176-17.481-22.183-22.183l-7.836-3.737-475.603-0.241c-374.214-0.12-476.809 0.12-481.149 1.326z",
			"M32.566 769.949c-13.382 4.22-22.786 12.417-28.814 24.835-3.255 6.992-3.737 9.042-3.737 18.687s0.483 11.694 3.737 18.687c4.702 9.886 12.176 17.361 22.183 22.183l7.836 3.737h956.029l7.836-3.737c10.006-4.702 17.481-12.176 22.183-22.183 3.375-6.992 3.737-9.042 3.737-18.687s-0.361-11.694-3.737-18.687c-4.702-9.886-12.176-17.361-22.183-22.183l-7.836-3.737-476.206-0.241c-382.532-0.12-477.17 0.12-481.028 1.326z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "messaging",
		paths: [
			"M0.010 363.382c0 285.213 0.273 330.677 2.048 339.005 9.284 43.826 42.871 75.365 87.38 81.782 2.321 0.273 29.081 0.683 59.8 0.683l55.568 0.136v204.932l102.398-102.534 102.534-102.398h614.252v-327.81c0-231.419-0.409-330.54-1.501-337.367-6.008-38.638-34.679-70.449-74.273-82.465-7.919-2.457-27.715-2.595-478.131-2.867l-470.075-0.409v329.312zM796.666 207.054c8.738 2.867 17.476 11.878 20.48 21.026 4.505 13.244-0.273 29.354-10.649 37.273-10.649 8.192 9.010 7.645-294.36 7.645-312.519 0-286.032 0.956-297.227-10.24-17.476-17.613-10.786-47.376 12.697-55.978 4.369-1.501 49.287-1.912 283.848-1.912 256.131-0.136 279.069 0 285.213 2.184zM793.8 376.761c7.645 1.775 15.837 7.919 20.616 15.565 3.549 5.871 4.096 7.919 3.96 17.066 0 11.878-1.912 16.52-9.966 24.576-10.513 10.513 14.336 9.693-296.954 9.693-226.368-0.136-279.614-0.409-283.71-1.912-12.424-4.505-22.937-18.705-22.937-31.266 0-15.154 10.376-29.49 24.302-33.723 5.188-1.501 558.001-1.639 564.69 0zM523.332 548.243c3.687 1.229 9.010 4.643 12.288 7.919 16.248 15.837 12.97 41.778-6.827 53.52l-6.553 3.96-143.904 0.409c-162.745 0.409-152.505 0.956-163.427-10.104-13.38-13.789-13.244-34.269 0.273-47.786 10.376-10.376 1.639-9.966 160.423-9.966 126.018-0.136 142.128 0.136 147.726 2.048z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "More-dots",
		paths: [
			"M105.447 385.906c-25.492 4.483-48.804 16.652-67.891 35.739-24.595 24.466-37.532 55.722-37.532 90.308 0 70.837 56.875 127.839 127.968 127.839 20.368 0 37.916-4.099 56.875-13.45 57.643-28.438 84.8-95.304 63.792-156.661-14.859-43.169-53.416-75.961-99.018-83.903-11.785-2.049-32.152-2.049-44.193 0.128z",
			"M490.375 385.906c-44.066 7.558-80.7 37.275-97.225 79.035-6.532 16.396-8.967 30.999-8.454 50.214 0.897 34.842 12.81 62.767 37.148 87.105 25.876 25.876 57.13 38.301 94.151 37.275 69.172-1.794 123.997-57.9 123.997-126.943 0-62.895-43.937-115.67-105.679-126.687-11.913-2.178-31.64-2.178-43.937 0z",
			"M871.845 386.418c-13.834 2.818-18.702 4.483-29.206 9.351-13.45 6.277-25.492 14.859-36.507 25.876-18.958 18.958-29.846 39.326-35.226 65.842-13.194 65.713 27.413 130.401 92.997 148.335 11.272 3.075 14.859 3.459 32.537 3.459 17.293-0.128 21.392-0.513 32.28-3.459 48.42-12.937 83.006-50.085 93.766-100.812 2.562-12.042 1.665-39.966-1.537-53.16-10.504-41.375-38.429-73.142-78.907-89.667-19.087-7.686-49.317-10.248-70.196-5.764z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Nature",
		paths: [
			"M515.998 1.335c-51.132 6.472-99.157 27.313-136.309 59.417-24.077 20.712-45.825 48.025-57.864 72.491l-4.143 8.285-14.11 2.201c-106.018 16.31-198.962 85.565-245.045 182.522-15.922 33.528-25.371 66.666-29.902 104.853-1.813 16.052-2.201 52.298-0.518 66.018 0.518 4.919 1.423 11.65 1.683 14.887 2.848 24.336 12.945 60.064 24.336 86.083 27.702 62.911 75.598 116.503 135.791 151.842 11.262 6.472 35.986 18.641 41.552 20.324 1.683 0.518 4.79 1.683 6.86 2.589 7.638 3.365 28.738 9.709 42.718 12.816 25.242 5.696 42.459 7.638 68.607 7.767 28.997 0.129 42.2-0.906 63.818-4.919l15.922-2.848-0.776 13.592c-0.388 7.508-0.906 18.382-1.294 24.077s-0.906 17.604-1.294 26.537c-0.388 8.932-0.906 20.193-1.294 25.242-0.388 4.919-0.906 16.052-1.294 24.595s-1.035 19.029-1.294 23.301c-1.294 19.288-2.46 47.508-2.46 57.604 0.129 8.802 0.776 12.427 3.365 18.123 4.012 8.802 11.779 16.957 20.712 21.618l6.86 3.624h148.865l7.12-3.365c16.828-8.026 26.149-24.207 25.242-43.494-1.423-30.161-2.071-42.33-2.589-49.578-0.388-4.66-0.906-15.405-1.294-23.948s-1.035-19.935-1.294-25.242c-0.388-5.307-0.906-16.181-1.294-23.948-0.388-7.896-0.906-18.899-1.294-24.595-0.259-5.696-0.906-16.957-1.423-24.983-0.388-7.896-0.259-14.498 0.388-14.498 0.518 0 5.696 1.423 11.391 3.236 11.003 3.495 36.764 8.932 48.543 10.356 11.909 1.423 51.779 1.683 63.43 0.518 23.43-2.589 54.368-10.227 76.633-19.158 70.549-28.090 128.672-86.083 155.467-154.95 13.592-34.951 19.158-65.5 18.382-102.782-0.259-12.427-0.776-24.983-1.035-27.831-9.838-80.387-55.403-152.749-124.141-197.537-14.627-9.449-41.552-22.782-57.345-28.35-19.805-7.12-17.864-5.437-16.828-13.851 0.388-3.883 0.776-14.498 0.776-23.56-0.129-86.859-51.779-167.635-134.108-209.447-21.877-11.132-49.449-19.935-75.727-24.336-16.569-2.848-55.144-3.495-72.491-1.294zM552.632 624.239c10.097 5.178 11.003 8.802 12.038 46.472 0.518 17.735 0.906 34.951 1.035 38.316 0.129 6.732 0.776 7.379 4.402 3.883 1.423-1.166 7.379-6.86 13.333-12.557 30.291-29.126 31.844-30.42 36.117-30.42 3.365 0 5.954 1.683 13.721 9.321 8.285 7.896 9.58 9.838 9.58 13.721 0 4.66 0.906 3.624-30.549 36.505-14.887 15.534-30.42 31.974-38.446 40.647l-6.084 6.601 0.647 21.359c0.388 11.779 0.906 30.42 1.294 41.423 1.683 54.239 2.071 66.925 2.718 85.436 0.906 24.466-0.388 29.255-9.19 34.304-5.307 3.236-5.696 3.236-38.058 3.236-36.245 0-38.963-0.518-44.531-8.285-2.589-3.754-2.848-5.307-2.718-23.43 0.129-16.699 0.776-48.672 2.46-102.911 0.259-7.508 0.776-28.219 1.294-45.954 0.388-17.864 1.035-38.446 1.294-45.954s0.906-28.997 1.294-47.896c1.294-48.284 1.294-49.319 3.495-54.497 2.071-4.79 7.379-9.449 12.038-10.615 1.423-0.259 12.945-0.647 25.63-0.776 19.158-0.129 23.689 0.259 27.184 2.071z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "new",
		paths: [
			"M428.753 24.418c-15.951 3.774-29.712 16.074-35.313 31.781-1.096 3.044-1.583 44.567-2.070 166.214l-0.609 162.073-65.755-25.45c-36.165-14.003-71.234-27.642-77.932-30.198s-23.136-8.889-36.53-14.125c-13.395-5.115-25.45-9.863-26.789-10.472-3.774-1.583-41.766-16.317-63.32-24.475-17.413-6.576-20.336-7.306-28.616-7.306-14.491 0-26.789 5.967-35.922 17.413-4.749 5.845-5.845 8.768-17.048 40.671-4.141 12.056-8.768 25.206-10.229 29.224-1.583 4.018-3.409 9.498-4.383 12.177-3.409 10.35-12.907 37.261-18.387 52.36-5.358 14.612-5.723 16.682-5.845 27.398 0 9.985 0.488 12.542 3.165 18.509 3.532 7.794 11.447 16.926 18.265 21.188 4.262 2.679 16.926 7.185 91.082 32.147 15.709 5.358 67.825 22.892 115.68 38.966 47.855 16.195 88.282 29.833 89.743 30.198 1.583 0.488 2.8 1.339 2.923 1.827 0 0.609-2.070 3.897-4.627 7.306-8.28 11.080-79.758 105.695-149.41 197.873-39.575 52.36-38.966 51.264-38.966 69.652-0.121 9.133 0.365 11.324 3.774 18.265 2.070 4.383 5.601 9.985 7.794 12.421 3.288 3.532 46.151 35.434 104.356 77.567 29.833 21.675 35.8 24.232 50.778 22.892 15.83-1.461 26.91-9.133 38.601-26.424 2.923-4.383 11.689-17.291 19.483-28.616 16.804-24.597 34.216-50.29 51.63-76.105 7.062-10.35 23.38-34.339 36.165-53.213 12.907-18.995 32.39-47.855 43.472-64.172 11.080-16.439 20.336-29.833 20.701-29.833s5.601 6.941 11.689 15.465c6.088 8.524 26.545 37.139 45.542 63.563s48.464 67.581 65.634 91.326c17.048 23.745 39.087 54.552 49.072 68.434 23.501 32.756 29.712 37.748 49.925 39.575 6.21 0.488 9.985 0.121 16.439-1.827 7.55-2.314 13.151-6.088 55.283-37.383 25.693-19.239 48.464-36.043 50.534-37.504 12.786-8.889 26.424-19.727 30.321-24.11 2.435-2.8 5.967-8.159 7.794-11.933 2.8-6.088 3.165-8.28 3.165-19.604-0.121-11.689-0.365-13.395-3.532-19.483-1.948-3.653-6.576-10.715-10.35-15.83-3.897-4.992-17.291-22.892-29.955-39.575-12.664-16.804-33.974-44.933-47.368-62.711-13.273-17.778-35.8-47.49-49.925-66.12s-26.545-35.069-27.519-36.53c-0.974-1.461-6.941-9.376-13.029-17.535-6.21-8.159-11.324-15.342-11.324-15.83s11.933-4.871 26.545-9.62c148.801-48.707 274.466-91.082 279.093-94.005 19.848-12.542 26.301-35.313 17.413-60.519-8.889-25.084-32.147-91.326-39.453-112.636-6.941-19.97-7.185-20.336-12.177-27.154-10.715-14.247-31.172-21.918-47.002-17.656-2.557 0.609-27.033 9.498-54.552 19.604-27.398 10.107-94.858 34.948-149.775 55.161l-99.85 36.774-0.609-162.804-0.609-162.682-3.897-7.915c-6.332-13.029-18.63-23.136-32.269-26.545-6.941-1.705-143.808-1.827-151.114-0.121z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Orange-Detente",
		paths: [
			"M57.803 16.692c-6.567 9.242-12.89 18.241-13.985 19.944l-2.189 3.161 22.133 15.688c12.161 8.634 23.713 16.782 25.781 18.241 2.068 1.337 19.214 13.377 38.306 26.754s53.264 37.455 76.005 53.386c22.741 15.93 44.143 31.010 47.548 33.563 17.268 12.769 21.646 25.416 25.416 74.059 0.365 4.985 0.973 11.553 1.216 14.593s1.095 12.525 1.824 21.281c0.729 8.634 1.46 18.485 1.824 21.889 0.365 3.284 1.703 19.214 3.040 35.266 3.161 37.455 3.648 42.563 4.256 49.251 0.243 3.040 0.851 9.607 1.216 14.593 0.729 9.121 1.46 18.849 2.432 29.186 0.365 3.040 1.095 12.282 1.824 20.673 1.703 19.822 2.432 28.457 3.040 35.874 0.365 3.284 0.851 9.85 1.216 14.593 0.365 4.621 0.973 10.945 1.216 13.985 0.365 3.040 0.851 9.242 1.216 13.985 0.365 4.621 0.851 11.188 1.216 14.593 0.851 10.701 1.945 22.984 2.432 27.97 0.243 2.676 0.851 8.634 1.216 13.377 0.973 12.282 1.824 22.133 2.432 29.794 0.365 3.648 0.851 10.458 1.216 15.201 0.851 10.945 1.824 22.254 2.432 26.146 0.243 1.703 0.729 7.904 1.216 13.985 0.365 5.959 0.973 13.133 1.216 15.809s0.851 8.391 1.216 12.769c0.365 4.377 1.095 13.864 1.703 21.281 0.729 7.296 1.581 17.998 2.068 23.713 0.365 5.716 0.973 11.188 1.095 12.404 0.243 1.095 0.851 8.148 1.216 15.809 0.487 7.54 1.095 13.985 1.216 14.349 0.243 0.365 0.729 6.567 1.216 13.985 0.365 7.296 0.973 14.228 1.216 15.201s0.851 6.445 1.216 12.161c0.365 5.716 0.851 12.282 1.216 14.593 0.243 2.311 0.729 8.634 1.216 13.985 0.365 5.351 0.973 12.161 1.216 15.201 0.487 5.351 1.216 13.498 2.432 28.578 0.365 4.013 0.973 10.337 1.216 13.985 0.365 3.648 0.973 10.458 1.337 14.957 0.365 4.621 0.851 9.85 0.973 11.553 0.243 1.824 0.851 8.513 1.337 14.836 0.365 6.324 0.973 12.89 1.216 14.593s0.851 8.026 1.216 14.228c0.487 6.080 0.973 12.161 1.216 13.377s0.487 3.648 0.487 5.472l0.121 3.405h364.579l0.851-7.661c0.365-4.135 0.973-9.485 1.216-11.796s0.851-8.634 1.216-13.985c0.487-5.351 0.973-12.769 1.337-16.417 0.973-11.309 1.46-17.268 2.311-26.754 0.729-8.634 0.973-12.282 2.432-26.51 0.243-3.161 0.851-10.093 1.216-15.444s0.973-11.432 1.216-13.377c0.243-2.068 0.851-8.026 1.216-13.377 0.851-11.796 1.703-21.281 2.432-28.578 0.365-3.040 0.851-9.364 1.216-13.985 0.365-4.743 0.973-10.945 1.216-13.985 0.365-3.040 0.851-8.999 1.216-13.377 0.729-9.85 1.703-20.794 2.432-27.97 0.365-3.040 0.851-9.607 1.216-14.593s0.851-11.066 1.216-13.377c0.487-3.892 0.851-8.634 2.432-28.578 0.365-4.013 0.851-9.729 1.216-12.769s0.851-9.607 1.216-14.593c0.487-4.985 0.973-11.066 1.216-13.377s0.851-9.242 1.216-15.201c0.487-6.080 0.973-12.282 1.216-13.985s0.851-7.175 1.216-12.161c0.365-4.985 0.973-11.553 1.216-14.593s0.851-9.607 1.216-14.593c0.365-4.985 0.973-11.066 1.216-13.377s0.851-8.391 1.216-13.377c0.365-4.985 0.851-11.553 1.216-14.593 0.973-9.364 3.040-33.077 3.648-41.955 0.365-4.743 0.851-10.458 1.095-12.769 0.365-2.311 0.973-8.634 1.337-13.985 0.487-5.351 0.973-11.917 1.216-14.593s0.851-8.999 1.216-13.985c0.365-4.985 0.973-11.066 1.216-13.377s0.851-8.391 1.216-13.377c0.365-4.985 0.973-11.553 1.216-14.593s0.851-9.607 1.337-14.593c0.487-4.985 0.973-10.824 1.095-12.769 0.243-2.068 0.729-8.877 1.216-15.201s0.973-12.89 1.337-14.593c0.243-1.703 0.851-8.513 1.216-15.201s0.973-12.525 1.216-12.89c0.243-0.365 0.729-7.296 1.216-15.201 0.729-14.228 0.608-14.593-2.797-21.16-3.769-7.418-11.188-13.741-18.362-15.809-3.040-0.729-72.478-1.216-210.868-1.216-195.788 0-206.489-0.121-206.612-2.189 0-1.095-0.243-3.405-0.487-5.108-0.365-3.405-1.216-13.256-3.040-34.658-0.608-8.026-1.581-18.12-1.945-22.497-0.729-8.513-4.377-25.294-7.296-34.050-4.743-13.864-16.66-31.983-27.241-41.103-4.013-3.527-69.924-50.467-97.894-69.681-4.621-3.161-22.376-15.566-39.158-27.483-16.904-11.917-39.036-27.483-49.251-34.658-10.216-7.053-21.768-15.201-25.538-17.877l-6.932-4.985-11.796 16.66zM736.615 332.871c-1.945 19.578-2.676 28.213-3.769 41.103-0.365 5.351-0.973 11.917-1.216 14.593s-0.851 9.242-1.216 14.593c-0.365 5.351-0.973 11.674-1.216 13.985s-0.851 8.391-1.216 13.377c-0.973 12.282-1.945 21.16-2.553 22.010-0.851 1.46-15.688 8.148-26.633 12.040-16.782 5.837-35.51 8.634-58.372 8.634-10.701 0-20.794-0.243-22.497-0.608-1.703-0.243-5.716-0.851-8.999-1.337-21.281-2.676-44.143-11.674-72.478-28.457-11.188-6.567-28.334-14.714-38.671-18.362-26.997-9.364-72.235-11.188-104.826-4.135-4.985 1.095-9.729 2.432-10.458 3.040-0.851 0.729-0.973 3.405-0.365 8.026 0.487 3.892 1.216 11.674 1.703 17.39s0.973 11.917 1.216 13.985c0.243 1.945 0.729 8.026 1.216 13.377 0.365 5.351 0.973 11.917 1.216 14.593s0.851 8.634 1.216 13.377c0.487 4.621 0.973 10.093 1.216 12.161 0.243 1.945 0.851 8.026 1.216 13.377 0.729 9.85 1.46 17.998 2.432 26.754 0.243 2.676 0.851 8.634 1.216 13.377 0.365 4.621 0.851 10.701 1.216 13.377 0.243 2.676 0.851 9.242 1.216 14.593 0.487 5.351 0.973 10.945 1.216 12.404s0.729 7.418 1.216 13.377c0.365 5.837 0.973 12.648 1.216 14.957s0.851 8.026 1.216 12.769c0.365 4.621 0.973 10.701 1.216 13.377s0.851 8.634 1.216 13.377c0.365 4.621 0.973 10.701 1.216 13.377 0.973 10.093 1.824 18.485 2.432 25.173 0.365 3.892 0.851 9.972 1.216 13.377 0.365 3.527 0.851 9.729 1.216 13.741 0.608 7.296 1.46 17.025 2.432 27.362 0.487 4.985 2.068 22.984 3.648 41.955 0.365 4.013 0.973 9.485 1.216 12.161 0.608 5.959 2.311 23.713 4.985 54.115 0.243 3.648 0.729 9.364 1.095 12.769 0.487 5.837 0.729 8.634 2.432 27.97 0.487 4.621 0.973 10.093 1.216 12.161 0.243 1.945 0.729 7.418 1.216 12.161 0.365 4.621 0.973 10.824 1.337 13.62l0.608 5.229h-22.010c-16.66 0-21.889-0.365-22.010-1.581 0-0.729-0.243-2.311-0.365-3.284-0.243-0.973-0.729-6.932-1.216-13.012-0.487-6.202-1.095-12.525-1.337-13.985-0.243-1.581-0.729-7.175-1.216-12.525s-0.973-11.674-1.216-13.985c-0.243-2.311-0.729-8.634-1.216-13.864s-0.973-10.458-1.216-11.553c-0.121-1.095-0.729-7.418-1.216-14.106s-0.973-13.012-1.216-13.985c-0.121-0.973-0.729-6.202-1.095-11.553-0.487-5.351-1.095-12.161-1.337-15.201-0.365-3.040-0.851-8.756-1.216-12.769s-0.851-10.093-1.216-13.377c-0.365-3.405-0.851-9.364-1.216-13.377s-0.851-10.093-1.216-13.377c-0.365-3.405-1.703-18.728-3.161-34.050-1.337-15.444-2.676-29.915-2.919-32.226s-0.729-8.634-1.216-13.985c-0.729-9.729-1.46-16.538-2.432-25.538-0.243-2.676-0.851-8.756-1.216-13.377-1.216-14.106-1.824-21.646-2.432-26.754-0.243-2.676-0.851-9.242-1.216-14.593-0.487-5.351-0.973-11.066-1.216-12.769s-0.851-8.026-1.216-13.985c-0.487-6.080-0.973-12.282-1.216-13.985s-0.851-7.418-1.216-12.769c-0.365-5.351-0.973-11.674-1.216-13.985-0.487-4.013-1.337-13.012-2.432-25.538-0.851-8.999-1.945-20.917-2.432-26.146-0.243-2.676-1.095-12.040-1.824-20.673-0.729-8.756-1.581-17.998-1.824-20.673s-0.851-8.148-1.216-12.161c-0.365-4.013-0.973-10.093-1.216-13.377-0.365-3.405-0.851-9.364-1.216-13.377s-0.851-10.216-1.216-13.741c-1.095-10.945-1.703-18.606-3.040-34.294-0.729-8.391-1.581-17.146-1.824-19.457s-0.851-7.661-1.216-11.917l-0.729-7.54h408.966l-0.729 8.148z",
			"M740.142 61.564c-49.251 7.418-91.692 29.429-125.256 65.181-33.563 35.631-52.899 79.045-57.155 128.296l-0.729 8.877h15.201c15.080 0 15.322 0 15.322-2.797 0.365-17.025 8.391-47.791 17.633-67.128 25.659-53.751 75.397-91.327 134.376-101.542 17.39-3.040 49.616-2.797 65.060 0.487 77.708 16.417 134.497 76.248 145.929 153.955 2.189 14.593 1.581 43.050-1.095 57.764-6.81 37.211-24.2 70.168-50.832 96.313-29.673 29.307-60.317 44.751-103.123 51.927-1.703 0.365-4.5 0.608-6.202 0.608-3.161 0.121-3.284 0.365-4.013 10.701-0.487 5.959-1.095 12.89-1.46 15.444l-0.608 4.743 9.485-0.729c43.535-3.284 92.301-26.267 125.62-59.101 43.535-42.806 65.789-98.015 63.965-158.211-1.095-34.294-7.175-58.858-22.010-88.895-31.010-62.507-90.233-105.434-160.278-116.014-14.106-2.068-45.482-2.068-59.831 0.121z",
			"M742.574 116.41c-7.783 1.095-29.673 8.026-39.036 12.404-11.917 5.593-29.065 16.417-31.497 19.944s-2.311 9.242 0.365 13.133c2.311 3.405 87.193 88.652 88.287 88.652 1.46 0 0.851-125.012-0.608-128.052-0.729-1.581-2.797-3.769-4.743-4.864-3.405-2.068-5.351-2.189-12.769-1.216z",
			"M784.529 117.504c-6.202 4.5-5.959 1.945-6.080 70.168v64.087l43.535-43.414c23.835-23.957 44.387-44.874 45.482-46.575 5.108-7.175 1.703-13.498-11.432-22.010-18.241-11.674-43.658-21.402-62.141-23.592-4.985-0.608-6.932-0.243-9.364 1.337z",
			"M646.383 174.417c-3.284 2.311-12.525 16.174-17.998 27.241-4.5 8.999-12.161 30.645-13.256 37.334-0.365 1.945-0.973 5.959-1.46 8.756-1.095 6.445 0.729 11.432 5.351 14.106 3.161 1.824 9.607 2.068 66.884 2.068h63.479l-44.143-44.143c-24.321-24.321-45.359-44.874-46.819-45.603-3.648-1.945-8.999-1.824-12.040 0.243z",
			"M881.207 173.93c-1.337 0.608-22.254 21.038-46.575 45.482l-44.143 44.508h127.809l3.892-3.527c3.648-3.284 4.013-4.135 3.769-10.216-0.729-20.673-18.485-62.384-31.861-74.789-3.040-2.797-8.391-3.405-12.89-1.46z",
			"M835.361 325.939c27.726 27.605 46.211 45.238 48.156 45.724 6.81 1.703 10.824-0.973 18.241-12.282 11.674-17.512 20.065-38.55 23.835-59.952 1.095-6.324 0.973-8.148-0.608-11.674-1.095-2.189-3.284-4.621-4.985-5.472-2.189-0.973-21.525-1.337-66.276-1.337h-63.357l44.995 44.995z",
			"M797.785 316.94c0 2.553-0.243 5.593-0.487 6.81-0.121 1.095-0.729 6.567-1.095 12.161-0.487 5.472-1.337 16.052-1.945 23.47-1.703 17.268-2.068 22.497-3.648 39.522-0.608 7.661-1.46 17.633-1.945 22.133-0.487 5.229-0.243 8.269 0.487 8.269s5.229-0.729 10.216-1.703c20.186-3.892 40.13-12.040 57.764-23.592 12.040-7.904 14.836-13.133 10.701-20.673-0.973-1.824-17.025-18.606-35.874-37.211l-34.050-34.050-0.121 4.864z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "outdoor-sports-mountain-biking",
		paths: [
			"M527.115 2.192c-22.071 4.626-44.406 21.542-54.582 41.102-24.318 46.653-2.643 100.442 47.578 118.153 10.177 3.569 30.926 4.494 42.688 1.851 52.6-12.026 79.826-70.177 55.508-118.416-16.52-32.776-54.582-50.617-91.191-42.688z",
			"M413.456 167.262c-10.441 2.908-19.956 7.798-26.961 14.009-6.343 5.551-139.43 171.149-146.303 182.118-5.022 7.798-7.665 16.652-8.59 29.34-1.586 19.032 5.022 36.213 19.163 49.957 8.987 8.855 6.343 7.137 176.831 109.562l34.626 20.75 0.792 182.382 4.096 8.59c5.286 10.969 13.481 19.163 24.318 24.318 7.665 3.569 9.912 4.096 20.485 4.096s12.82-0.529 20.485-4.096c10.969-5.286 19.163-13.481 24.318-24.318l4.096-8.59 0.396-107.051c0.265-68.724-0.132-109.298-1.057-113.262-3.172-14.802-8.987-22.203-31.058-39.384-62.116-48.503-137.448-108.901-137.316-110.223 0.265-2.247 74.406-94.76 75.596-94.099 0.529 0.265 11.365 4.757 24.054 10.044s25.771 10.705 28.944 12.159c3.304 1.453 8.061 3.436 10.573 4.361 2.643 0.925 44.935 18.503 93.966 38.988s91.984 37.931 95.421 38.723c12.952 3.039 27.885-3.7 35.023-15.859 3.039-5.286 3.7-7.798 3.7-16.256s-0.529-10.837-3.569-15.991c-1.982-3.304-5.551-7.533-7.93-9.383-8.326-6.212-289.829-166.655-297.098-169.166-9.78-3.569-27.489-4.361-37.005-1.718z",
			"M801.349 464.095c-70.177 9.516-127.8 52.6-156.876 116.831-5.418 12.159-10.441 28.018-13.877 44.274-3.569 16.785-3.172 56.565 0.792 74.406 11.498 53.525 41.366 97.668 85.376 126.61 71.896 47.182 166.258 42.952 232.339-10.441 67.006-54.054 92.117-142.999 62.777-222.956-24.054-65.551-82.204-114.716-150.399-126.875-14.934-2.643-47.182-3.7-60.133-1.851zM851.967 531.498c50.486 10.441 90.001 48.503 102.16 98.328 17.049 70.442-26.432 141.809-97.27 159.386-15.859 3.965-40.178 4.494-56.3 1.19-51.939-10.705-90.53-48.107-103.747-100.442-3.833-14.934-3.436-44.142 0.661-60.002 11.763-45.199 43.745-79.957 86.962-94.495 20.089-6.74 46.256-8.326 67.534-3.965z",
			"M173.187 629.43c-85.376 10.969-154.76 76.653-170.223 161.368-1.057 5.947-2.379 18.503-2.775 28.018-3.965 91.984 57.755 175.245 147.624 198.903 18.238 4.757 28.546 5.947 50.221 5.947 20.881 0 31.587-1.19 48.239-5.418 74.275-18.634 130.179-77.314 146.17-153.175 4.096-19.428 4.361-54.186 0.661-74.010-14.273-76.653-71.235-137.977-145.246-156.611-8.194-1.982-17.181-4.096-20.089-4.494-9.516-1.453-44.67-1.851-54.582-0.529zM231.074 698.285c16.652 4.757 26.697 9.251 39.384 17.71 29.472 19.56 49.825 49.429 56.829 83.791 13.612 65.42-24.846 131.104-88.944 151.985-20.881 6.873-50.882 7.93-71.367 2.643-51.014-13.216-88.152-51.807-98.195-102.293-8.722-43.613 4.229-86.697 35.684-118.945 19.295-19.56 44.803-32.909 71.763-37.401 15.595-2.643 40.705-1.453 54.847 2.512z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "outdoor-sports-skiing",
		paths: [
			"M921.988 28.596c-34.972 4.832-63.84 29.376-74.776 63.331-5.341 17.041-4.96 37.897 1.017 55.955 2.417 7.376 10.683 21.746 16.023 28.104 27.851 33.064 73.378 42.093 111.656 22.128 53.666-27.978 64.603-100.465 21.619-143.577-19.712-19.712-48.706-29.631-75.54-25.943z",
			"M289.438 33.683c-14.37 2.798-18.059 22.255-6.232 32.938 1.526 1.526 23.272 14.498 48.070 28.74 24.798 14.37 50.868 29.376 57.863 33.446s14.751 8.393 17.168 9.792c2.417 1.398 13.608 7.885 24.798 14.37 29.504 17.168 84.314 48.834 90.801 52.521 3.179 1.781 8.647 4.832 12.081 6.994 3.561 2.034 9.029 5.214 12.208 6.994s6.74 3.815 8.012 4.706c1.908 1.398-4.324 5.341-48.325 30.648-37.261 21.364-52.521 30.902-57.736 35.862-15.515 14.498-21.746 38.787-15.134 58.244 2.925 8.647 1.017 5.214 88.257 156.039 12.463 21.492 22.51 39.296 22.255 39.55s-15.642 9.157-34.21 19.838c-18.566 10.683-54.048 31.157-78.846 45.527-90.801 52.521-86.35 49.978-89.146 48.58-1.398-0.763-25.308-14.625-53.031-30.776s-52.14-30.394-54.302-31.538c-2.034-1.272-7.249-4.196-11.445-6.613-20.602-11.955-45.782-26.579-84.569-49.088-23.4-13.734-47.689-27.723-53.793-31.284-6.232-3.561-12.208-7.121-13.353-7.757-21.492-12.717-29.885-14.751-44.51-10.936-7.885 2.162-17.931 11.064-22.382 19.457-7.121 13.989-4.324 32.555 6.613 43.874 2.162 2.162 9.283 7.121 15.77 10.936 9.538 5.596 235.14 136.073 283.337 163.924 41.204 23.781 120.686 69.817 130.35 75.412 6.359 3.688 26.070 15.134 43.874 25.434s37.642 21.746 43.874 25.434c6.359 3.688 30.648 17.677 54.048 31.157s49.215 28.359 57.227 33.064c17.423 10.3 118.524 68.672 124.754 72.106 18.566 10.428 42.476 3.561 52.649-15.006 2.798-5.341 3.815-8.902 4.196-16.659 0.509-9.157 0.255-10.555-3.434-18.059-4.96-10.174-8.647-13.353-27.596-24.163-8.266-4.832-20.221-11.7-26.579-15.387-9.157-5.468-207.289-119.795-221.278-127.807-2.034-1.145-15.006-8.647-28.613-16.532s-38.278-22-54.684-31.538c-16.406-9.411-31.538-18.185-33.574-19.33l-3.688-2.289 3.053-1.908c2.417-1.526 134.42-77.829 198.768-114.835 17.804-10.3 26.579-18.44 32.174-30.012 8.266-16.914 8.266-33.574 0.255-51.25-2.034-4.451-30.012-79.737-32.938-88.384-0.636-1.781-3.434-9.411-6.232-17.168-2.798-7.63-4.96-13.989-4.832-13.989 0.127-0.127 10.047-5.087 21.874-11.191 11.955-5.977 29.249-14.879 38.661-19.712l17.041-8.775 32.555 18.694c17.931 10.3 35.227 20.093 38.278 21.874 3.179 1.781 30.902 17.549 61.551 35.227 30.648 17.549 58.499 32.683 61.678 33.574 17.423 5.087 36.625-3.815 45.019-20.729 2.162-4.578 2.798-7.885 2.798-16.532 0-9.538-0.381-11.572-3.688-17.423-1.908-3.561-5.087-8.012-6.994-9.792-3.561-3.434-111.911-66.51-135.818-79.101-7.885-4.070-14.37-7.757-14.37-8.139s11.064-6.613 24.544-13.862c37.515-20.347 45.527-26.197 52.649-38.025 2.925-4.96 3.561-7.504 3.561-14.879 0-10.81 1.017-8.521-26.197-55.955-22.51-39.168-27.978-47.18-36.498-53.539-15.387-11.827-39.932-13.48-56.846-3.815-20.983 12.081-71.978 41.457-100.846 58.244-30.648 17.677-35.099 19.966-37.515 18.694-1.526-0.763-7.885-4.451-14.243-8.139-6.232-3.688-63.84-37.006-127.807-73.886s-122.975-70.961-130.986-75.54c-19.202-11.064-22.128-12.081-30.394-10.555z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Pencil",
		paths: [
			"M761.561 0.623c-17.279 1.536-36.605 9.216-51.069 20.095-4.607 3.456-141.303 139.383-303.852 302.187-257.903 258.159-295.66 296.428-297.068 301.164-12.287 40.317-43.901 144.374-55.676 183.284-8.319 27.391-17.279 56.829-19.839 65.276-8.832 28.798-17.535 57.596-18.559 61.436-0.64 2.047-4.352 14.463-8.319 27.518-6.143 20.095-7.167 24.702-6.656 30.845 1.92 21.886 22.782 36.094 44.413 30.205 3.84-1.024 13.952-3.967 22.399-6.656 8.447-2.56 24.575-7.423 35.838-10.879s44.413-13.567 73.595-22.399c29.182-8.959 55.676-17.023 58.876-17.919 4.736-1.28 119.16-35.965 139.511-42.237 3.2-1.024 11.263-3.456 17.919-5.503l12.159-3.84 296.556-296.684c163.189-163.317 298.988-300.012 301.932-303.852 6.783-8.832 14.207-24.831 17.279-36.478 2.56-10.367 3.456-31.102 1.664-42.237-2.304-14.975-9.472-31.742-19.071-44.925-7.040-9.343-159.733-161.909-169.205-168.949-21.502-15.743-45.053-22.142-72.828-19.455zM786.774 117.863l10.496 10.623-587.993 588.505 48.764 49.020 48.637 49.020 589.017-588.377 12.159 12.159 12.032 12.159-588.248 588.505 23.678 23.551c13.055 13.055 23.678 23.935 23.678 24.318s-4.48 1.92-9.856 3.456c-5.503 1.536-19.199 5.632-30.462 9.087-11.263 3.584-35.71 11.007-54.396 16.639-18.686 5.76-48.253 14.719-65.916 20.095-17.535 5.376-34.814 10.623-38.397 11.647-3.456 0.896-10.752 3.072-16.126 4.863l-9.727 3.072-85.882-86.138 10.496-34.558c5.887-19.071 11.775-38.654 13.312-43.517 16.639-54.653 35.965-118.265 39.677-130.935 2.56-8.576 4.863-15.615 5.376-15.615 0.384 0 11.263 10.623 24.191 23.551l23.422 23.422 293.868-294.124c248.943-249.2 294.124-293.868 295.788-292.588 1.152 0.896 6.656 6.272 12.415 12.159z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Pills",
		paths: [
			"M757.936 1.082c-98.11 10.887-180.852 81.972-205.444 176.369-8.325 31.508-7.557 4.099-7.941 328.146-0.384 304.45-0.384 304.194 4.483 327.249 7.044 33.942 21.261 65.706 42.267 94.14 33.174 45.085 83.381 78.13 137.815 90.938 31.764 7.301 69.548 8.069 100.544 1.921 91.451-18.188 162.407-84.661 186.743-174.831 1.408-5.251 3.715-15.113 4.996-21.774 2.178-11.527 2.305-27.025 2.305-307.396 0-162.407-0.384-299.071-0.897-303.681-6.020-53.281-29.972-102.593-68.651-141.658-38.937-39.192-90.425-63.913-144.605-69.421-13.705-1.408-38.552-1.408-51.617 0zM820.055 68.71c38.041 8.325 71.213 27.794 96.189 56.228 16.138 18.444 26.897 37.016 34.326 59.174 9.606 28.946 8.966 16.010 9.479 180.211l0.384 147.678h-320.332v153.954c0 150.624-0.128 154.211-2.562 158.181-4.739 7.812-13.833 10.119-21.39 5.507-8.838-5.251-8.069 21.006-7.941-305.731 0-165.609 0.513-299.584 1.281-304.578 4.867-38.937 22.414-74.415 50.592-102.593 27.025-27.025 58.79-43.164 97.855-49.824 14.089-2.434 47.518-1.537 62.12 1.794z",
			"M209.106 161.824c-59.814 7.812-113.609 37.144-153.698 84.277-17.291 20.109-34.582 51.36-43.42 78.002-5.507 16.907-8.069 28.562-11.015 50.208-1.153 9.093-0.768 49.311 0.64 56.356 0.384 2.049 1.794 10.119 3.33 17.675 3.074 16.651 10.759 39.065 19.34 56.996 7.301 15.113 22.798 38.681 33.045 50.465 3.842 4.355 97.342 98.239 207.62 208.646 213 212.872 212.743 212.616 240.026 228.113 25.744 14.473 53.154 24.079 83.894 29.202 9.479 1.665 50.465 2.562 58.277 1.408l5.123-0.768-8.325-4.996c-7.812-4.739-22.158-14.729-28.434-19.725-14.986-12.040-26-22.671-37.657-36.247-8.069-9.606-10.247-11.4-16.010-13.321-17.675-5.636-39.065-18.828-56.612-34.582-16.523-14.857-413.96-413.063-415.753-416.522-3.33-6.532-0.64-16.010 5.636-20.109 4.355-2.818 12.552-2.946 16.778-0.256 1.794 1.281 51.617 50.592 110.791 109.766l107.461 107.461 181.876-181.876v-179.442l-56.996-56.869c-58.661-58.405-70.701-69.037-93.372-82.485-23.182-13.705-48.543-23.439-75.825-28.946-21.39-4.483-53.538-5.38-76.721-2.434z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "printer",
		paths: [
			"M180.738 301.062v180.727l-63.496 0.12c-35.061 0-65.062 0.361-66.869 0.602-22.892 3.856-42.411 22.048-48.676 45.423-1.325 5.181-1.687 34.338-1.687 163.739 0 110.966 0.361 159.281 1.325 163.859 4.578 21.928 22.29 40.242 44.579 46.145 9.759 2.651 922.553 2.651 932.312 0 19.88-5.302 35.182-19.158 42.531-38.675l2.771-7.109 0.361-160.606c0.241-144.099 0.12-161.33-1.687-168.076-5.422-21.446-21.928-37.833-43.857-43.616-5.422-1.446-18.314-1.807-70.725-1.807h-64.218v-120.485l-240.97-240.97h-421.697v180.727zM572.314 259.254c0 72.773 0.12 79.4 2.29 87.232 5.663 21.928 24.579 39.64 46.387 43.616 4.699 0.844 34.218 1.325 84.701 1.325h77.472v240.97h-542.182v-451.818h331.333v78.676zM522.313 785.050c16.868 5.663 24.941 27.47 15.904 42.892-3.615 6.144-5.904 8.193-12.771 11.807-23.495 12.169-50.484-11.205-41.687-36.145 5.663-16.385 22.048-24.217 38.555-18.555z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "public-transport",
		paths: [
			"M18.014 244.156c-5.608 1.725-12.186 7.549-15.53 13.588-1.834 3.343-1.941 13.373-2.264 209.757l-0.216 206.090 6.147 0.647c3.451 0.323 8.951 0.863 12.186 1.186s8.088 0.863 10.784 1.078c2.696 0.323 13.588 1.294 24.265 2.157 10.677 0.971 21.353 1.941 23.726 2.157s7.442 0.755 11.324 1.078c3.882 0.323 9.167 0.863 11.863 1.078s8.304 0.755 12.402 1.078c7.872 0.647 14.991 1.294 23.187 2.157 2.696 0.216 8.52 0.755 12.941 1.078s9.274 0.863 10.784 1.186c2.696 0.432 2.804 0.216 4.098-7.117 3.559-21.030 14.343-41.304 30.196-57.050s34.942-25.667 57.050-29.657c10.677-1.941 32.785-1.51 42.706 0.863 45.834 11 79.805 50.364 83.472 96.844l0.647 8.412h242.326v-2.48c0.216-14.020 4.746-31.814 11.324-45.295 14.343-29.011 41.088-50.040 73.334-57.481 11.431-2.696 36.667-2.696 46.912 0 21.676 5.608 36.667 13.912 51.765 28.579 19.305 18.873 31.814 47.236 32.246 73.657l0.107 3.019h83.472c73.873 0 83.903-0.216 87.57-1.725 6.147-2.589 11-6.687 14.236-12.186l2.912-4.96v-419.622l-2.804-5.285c-3.019-6.039-9.813-11.755-15.853-13.481-2.696-0.755-159.286-1.078-493.065-0.971-427.603 0-489.721 0.216-494.251 1.618zM263.251 298.834c1.941 1.294 4.206 3.667 4.96 5.069 1.078 2.049 1.402 18.98 1.402 73.334 0 68.158-0.107 70.745-2.157 74.089-4.314 7.226 1.618 6.794-105.687 6.794s-101.374 0.432-105.687-6.794c-2.049-3.343-2.157-5.931-2.157-73.873 0-77.755-0.216-74.736 6.794-78.942 3.343-2.049 6.147-2.157 101.158-2.157h97.707l3.667 2.48zM531.784 297.971c1.725 0.971 4.206 3.235 5.285 5.176 2.049 3.343 2.157 5.931 2.157 74.197v70.745l-2.48 3.667c-1.294 1.941-3.667 4.206-5.069 4.96-2.157 1.078-24.372 1.402-100.079 1.402-107.521 0-101.59 0.432-105.903-6.794-2.049-3.343-2.157-5.931-2.157-73.873 0-74.736-0.107-73.55 4.96-77.971 1.186-1.078 3.019-2.049 4.206-2.373 1.186-0.216 45.726-0.539 99.001-0.647 85.52-0.107 97.276 0.107 100.079 1.51zM805.169 301.099l3.667 4.206v71.285c0 68.804-0.107 71.393-2.157 74.736-4.314 7.226 1.618 6.794-105.687 6.794s-101.374 0.432-105.687-6.794c-2.049-3.343-2.157-5.931-2.157-73.873 0-77.755-0.216-74.629 6.794-78.942 3.343-2.157 5.716-2.157 102.56-1.941l99.001 0.323 3.667 4.206zM963.809 298.51c7.333 4.421 6.794-7.226 6.794 159.826 0 148.179 0 151.414-2.157 154.757-4.098 6.794-3.99 6.794-51.981 6.794-47.452 0-46.912 0-51.226-6.363l-2.48-3.667v-151.414c0-167.266-0.539-155.512 6.794-159.933 3.235-2.049 5.716-2.157 47.128-2.157s43.893 0.107 47.128 2.157z",
			"M251.82 621.936c-44.648 10.677-71.824 55.324-60.393 99.217 9.49 36.775 44.755 62.55 82.394 60.177 26.206-1.618 48.314-14.127 62.873-35.481 15.745-23.402 18.010-54.030 5.716-80.128-9.599-20.49-29.657-37.099-51.765-43.030-10.353-2.804-28.579-3.128-38.824-0.755z",
			"M714.149 621.072c-30.412 5.069-56.079 28.686-64.491 59.207-2.696 9.599-2.696 31.275-0.107 40.765 9.922 35.481 40.010 59.314 76.246 60.177 24.265 0.647 44.216-7.657 61.255-25.451 18.549-19.412 25.99-48.853 19.196-75.168-6.147-23.402-23.726-44.109-45.726-53.922-13.157-5.824-31.707-8.088-46.373-5.608z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "relationship",
		paths: [
			"M277.149 22.176c-104.685 8.674-196.118 69.75-243.944 162.99-51.198 99.626-42.645 219.609 22.045 310.802 7.83 11.083 21.202 27.466 26.020 31.923 1.085 1.085 4.096 4.336 6.746 7.348 2.65 2.892 9.517 10.481 15.178 16.745s21.925 24.213 36.020 39.754c14.095 15.541 30.116 33.128 35.417 39.031 5.421 5.903 10.722 11.805 11.927 13.251s6.746 7.348 12.167 13.371c11.083 12.047 46.259 50.716 82.639 90.952 11.203 12.408 20.238 22.406 35.537 39.031 0.722 0.722 5.541 6.264 10.842 12.167 5.301 6.023 10.24 11.324 10.962 12.047 0.722 0.602 6.746 7.108 13.251 14.456 17.226 19.155 28.068 30.96 37.827 41.561 0.963 1.085 5.662 6.264 10.24 11.564 4.699 5.18 9.035 9.998 9.757 10.722 1.205 1.085 43.007 47.102 52.403 57.704 2.168 2.529 5.421 6.143 7.108 7.95s7.589 8.313 13.251 14.576c5.662 6.143 12.769 13.974 15.781 17.348 3.132 3.253 7.469 8.071 9.637 10.481l4.096 4.577 25.298-27.827c13.974-15.299 26.503-29.273 28.068-30.96 1.566-1.807 5.060-5.662 7.83-8.674s10.24-11.083 16.504-18.070c6.264-6.987 13.371-14.817 15.781-17.468 2.529-2.65 5.541-5.903 6.746-7.348s6.746-7.589 12.408-13.854c10.24-11.324 34.453-37.947 36.742-40.356 0.722-0.722 5.301-5.782 10.24-11.324s10.722-11.805 12.649-13.974c2.048-2.048 7.108-7.83 11.444-12.649s8.433-9.276 9.155-9.998c1.446-1.566 35.899-39.393 50.355-55.534 10.36-11.324 23.25-25.659 25.418-27.827 0.602-0.722 5.060-5.541 9.637-10.722 4.699-5.18 9.035-9.998 9.637-10.722 0.722-0.722 14.576-16.022 30.719-33.85 16.263-17.95 31.923-35.176 34.935-38.429s6.023-6.506 6.626-7.228c3.734-4.096 26.985-29.875 31.201-34.453 2.77-3.012 10.12-11.083 16.383-18.070s14.215-15.661 17.588-19.275c3.373-3.614 8.553-9.396 11.444-12.649 2.892-3.373 5.541-6.264 5.903-6.626 2.892-2.65 19.516-26.383 25.9-36.862 17.468-28.671 31.321-63.967 37.224-94.446 11.927-61.799 6.384-120.707-16.745-176.483-33.489-80.953-102.396-144.439-186.12-171.303-14.938-4.819-34.694-9.276-51.8-11.805-15.541-2.289-49.15-3.012-65.774-1.446-9.035 0.843-32.406 4.216-35.417 5.060-0.963 0.241-3.132 0.722-4.819 1.085-5.301 0.843-29.153 7.95-39.754 11.805-32.767 11.685-75.652 38.188-99.264 61.318l-5.903 5.662-10.36-9.155c-46.499-41.681-105.167-68.063-166.725-74.93-15.541-1.687-43.127-2.168-58.065-0.963z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Restaurant",
		paths: [
			"M263.894 0.908c-5.904 1.927-12.65 6.265-15.662 9.879-7.711 9.879-7.229-2.168-7.229 171.2 0 172.646-0.241 166.14 7.109 184.212 8.313 20.481 25.783 38.192 47.469 48.071l5.663 2.651v276.498c0 197.102 0.361 278.186 1.325 282.763 9.638 45.902 65.781 63.251 100.358 30.963 8.554-7.951 15.18-19.759 17.469-30.963 0.964-4.458 1.325-87.829 1.325-282.763v-276.378l9.999-5.060c23.493-11.807 39.517-31.083 47.348-57.107 2.048-6.746 2.29-16.867 2.53-167.826 0.241-106.744 0-162.164-0.844-165.176-1.807-6.746-7.47-13.975-14.096-17.831-7.951-4.699-19.879-4.819-28.674-0.241-6.746 3.373-13.133 10.963-15.060 17.711-0.722 2.892-1.205 46.264-1.205 126.985v122.647h-30.12v-122.647c0-80.721-0.482-124.093-1.205-126.985-1.927-6.626-8.313-14.337-14.819-17.589-14.699-7.59-31.686-2.771-40.24 11.565l-3.373 5.663-0.361 124.937-0.241 125.057h-30.12l-0.241-125.057c-0.361-140.358 0.482-127.827-9.518-137.587-6.868-6.746-19.759-10.241-27.59-7.59z",
			"M733.519 1.27c-32.649 3.856-65.3 20.601-89.515 45.902-22.047 23.011-35.782 51.686-40.24 83.613-0.722 5.18-1.205 97.105-1.205 239.994l-0.12 231.68h60.239v183.73c0 129.394 0.361 185.537 1.325 189.995 6.626 31.566 38.553 52.891 69.998 46.745 23.493-4.458 43.011-23.613 47.95-46.987 0.964-4.939 1.205-126.020 0.964-480.71-0.361-454.084-0.482-474.203-2.53-478.059-3.373-6.265-11.204-13.133-17.349-15.18-5.904-2.048-15.903-2.29-29.517-0.722z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "running",
		paths: [
			"M805.612 68.108c-23.917 5.021-44.796 18.631-59.728 38.717-12.289 16.782-17.707 32.771-18.368 54.838-0.529 17.707 1.19 27.221 7.399 41.889 11.497 27.485 36.868 49.684 65.41 57.35 12.818 3.435 40.303 3.435 51.535 0 25.371-7.797 44.532-22.199 58.142-43.871 24.446-38.717 18.631-89.46-14.139-121.966-23.654-23.654-58.010-33.828-90.252-26.957z",
			"M497.063 101.011c-3.964 1.057-9.911 3.7-13.214 5.815s-44.663 42.681-91.97 90.12c-98.974 99.237-93.688 92.763-93.688 115.359 0 11.893 0.396 14.006 3.833 20.878 5.286 10.571 13.61 18.764 24.182 23.654 7.532 3.568 10.44 4.229 19.425 4.229 11.893 0.132 21.274-2.511 28.675-7.797 2.511-1.85 34.225-33.035 70.564-69.374l66.070-66.070 39.774 39.774 39.774 39.642-290.975 290.975c-315.948 316.081-296.656 295.864-299.035 313.439-2.907 21.803 8.458 42.681 28.146 51.667 9.381 4.36 16.649 5.417 27.089 4.229 17.707-2.114 6.739 8.060 206.669-191.869l183.544-183.411 88.27 88.27c48.496 48.496 88.005 88.534 87.742 88.931-0.396 0.265-49.817 0.661-109.942 0.661-108.487 0.265-109.412 0.265-116.416 3.039-20.878 8.458-32.904 27.089-31.714 49.553 1.321 24.050 19.821 43.475 43.871 45.853 4.493 0.396 83.249 0.792 175.218 0.661 187.376-0.132 174.691 0.529 189.358-9.646 20.217-14.139 26.56-44.267 13.743-65.278-1.718-2.774-48.1-50.082-103.070-105.052-54.97-55.103-100.031-100.427-100.031-100.956s24.842-25.636 55.235-56.028l55.103-55.103 1.321 123.948 3.833 7.664c6.475 13.346 17.443 22.86 31.582 27.353 3.964 1.19 34.488 1.586 127.648 1.586 67.392 0 124.609-0.396 127.12-0.925 24.446-5.286 41.228-28.014 38.982-52.725-1.586-17.839-12.024-32.771-28.41-40.832l-8.721-4.229-193.455-0.792-0.792-160.42-4.096-8.589c-3.833-7.928-13.61-18.104-124.212-128.706-66.070-65.939-122.627-121.701-125.665-123.816-10.571-7.268-26.957-9.514-41.36-5.682z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "School",
		paths: [
			"M500.395 137.336c-12.060 9.558-60.415 48.127-63.487 50.63-0.91 0.797-16.27 13.198-34.133 27.42l-32.426 25.941-0.341 28.672-0.228 28.672-256.338 0.569-42.438 70.882-42.553 70.769v426.661h-28.444v28.444h1023.987v-28.444h-28.444v-426.661l-42.553-70.769-42.438-70.882-256.338-0.569v-56.433l-3.072-2.844c-1.82-1.593-4.551-3.869-6.144-5.12-3.072-2.276-22.755-17.863-36.295-28.9-4.21-3.413-12.288-9.784-17.749-14.222-5.575-4.323-10.353-8.192-10.695-8.533-0.569-0.569-8.874-7.282-18.545-14.791-2.048-1.593-11.264-8.989-20.593-16.498s-19.57-15.815-22.983-18.432l-6.030-4.892-11.719 9.33zM530.773 330.415c38.228 13.54 50.403 61.78 23.211 91.59-10.24 11.264-22.414 17.18-37.433 18.432-26.396 2.276-48.014-12.402-59.164-39.935-0.797-1.934-1.593-8.305-1.82-14.222-0.228-8.874 0.113-12.288 2.276-19.001 6.371-19.455 21.845-34.133 40.732-38.456 9.558-2.162 23.552-1.479 32.198 1.593zM199.115 568.889v42.666h-85.332v-85.332h85.332v42.666zM369.78 568.889v42.666h-85.332v-85.332h85.332v42.666zM568.888 568.889v42.666h-113.776v-85.332h113.776v42.666zM739.553 568.889v42.666h-85.332v-85.332h85.332v42.666zM910.217 568.889v42.666h-85.332v-85.332h85.332v42.666zM199.115 739.554v42.666h-85.332v-85.332h85.332v42.666zM369.78 739.554v42.666h-85.332v-85.332h85.332v42.666zM524.174 698.481c21.162 4.551 39.025 22.527 43.463 43.691 0.797 3.982 1.251 26.624 1.251 65.649v59.733h-113.776v-59.733c0-39.139 0.456-61.667 1.251-65.649 2.162-10.468 7.509-20.139 15.701-28.331 14.335-14.335 32.313-19.57 52.109-15.36zM739.553 739.554v42.666h-85.332v-85.332h85.332v42.666zM910.217 739.554v42.666h-85.332v-85.332h85.332v42.666z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "search",
		paths: [
			"M374.696 0.234c-0.256 0.256-5.381 0.768-11.402 1.281-27.159 2.049-61.363 9.224-89.801 18.703-111.195 37.023-200.741 121.060-244.938 229.949-18.703 46.246-27.67 91.082-28.44 143.478-0.641 40.481 2.562 68.536 11.657 104.79 20.24 80.579 65.974 153.47 130.54 208.044 40.226 34.076 89.29 60.722 140.275 76.35 21.778 6.662 48.937 12.426 67.255 14.348 4.227 0.513 9.095 1.153 10.889 1.538 8.327 1.538 60.722 1.409 76.991-0.256 67.639-6.789 129.002-28.567 183.447-64.95l11.273-7.559 146.553 146.553c92.236 92.236 148.346 147.449 151.421 148.986 7.046 3.459 21.137 3.203 27.927-0.384 5.892-3.075 58.288-55.085 62.388-61.875s4.356-19.472 0.513-27.67c-2.435-5.124-29.592-32.923-149.243-152.573l-146.297-146.297 7.559-11.273c33.82-50.602 56.879-112.605 63.669-171.405 0.384-3.587 1.281-10.761 1.922-16.013 1.153-10.121 0.641-66.231-0.641-74.942-0.384-2.819-1.665-11.145-2.69-18.575-17.807-127.081-100.563-240.454-217.907-298.999-38.816-19.343-85.318-33.564-126.568-38.559-3.459-0.384-8.454-1.025-10.889-1.409-4.997-0.768-64.693-1.922-65.461-1.281zM434.392 129.748c62.772 9.48 114.782 35.101 157.57 78.017 43.172 43.299 69.305 96.336 78.144 158.338 1.409 10.376 1.794 52.907 0.513 63.412-5.637 45.734-20.113 84.806-45.093 122.341-43.556 65.461-116.96 110.171-194.72 118.754-11.914 1.281-51.37 1.281-63.028-0.128-30.873-3.459-69.561-15.757-96.72-30.618-79.682-43.683-133.486-123.622-141.941-210.99-1.665-17.422-0.897-53.548 1.409-68.536 13.835-89.93 68.152-164.231 149.243-204.328 30.361-14.989 60.978-23.7 96.336-27.286 6.533-0.641 52.267 0.128 58.288 1.025z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Send",
		paths: [
			"M0.019 1.552c0.362 1.207 3.137 11.343 6.153 22.685 6.757 25.581 9.050 33.907 15.083 56.713 2.655 9.895 6.033 22.443 7.36 27.753 1.448 5.31 3.62 13.153 4.827 17.497s3.74 14.118 5.792 21.72c1.93 7.602 4.706 18.1 6.033 23.168 1.448 5.188 3.62 13.635 4.947 18.703 4.585 17.497 14.721 55.265 16.893 63.108 2.534 9.17 5.068 18.703 13.273 49.715 3.378 12.55 8.808 32.821 12.067 45.25 3.378 12.55 8.205 30.77 10.86 40.785 12.911 48.508 16.773 62.385 17.255 62.866s21.478 2.655 57.558 5.913c4.344 0.483 15.445 1.568 24.737 2.534 14.721 1.448 39.7 3.74 63.953 5.913 3.982 0.362 9.653 0.965 12.67 1.207 3.017 0.362 8.205 0.845 11.463 1.207 3.378 0.362 8.447 0.845 11.463 1.207 3.017 0.242 9.292 0.845 13.877 1.207 4.706 0.362 10.618 0.965 13.273 1.207 2.655 0.362 11.343 1.086 19.307 1.81s16.41 1.568 18.703 1.81c2.293 0.242 7.482 0.724 11.463 1.086 8.808 0.845 53.213 5.068 70.59 6.757 18.1 1.81 22.443 2.172 32.58 3.017 4.947 0.362 10.74 0.965 12.67 1.207 2.052 0.242 7.12 0.845 11.463 1.207s10.015 0.965 12.67 1.207c5.31 0.603 53.696 5.068 65.16 6.033 3.982 0.362 9.653 0.965 12.67 1.327 9.292 1.207 11.222 1.448 22.323 2.293 6.033 0.362 12.187 0.965 13.877 1.207s10.136 1.086 18.703 1.81c8.688 0.724 17.376 1.568 19.307 1.81 2.052 0.242 8.205 0.845 13.877 1.207s11.463 0.965 12.79 1.207c1.448 0.362 6.637 0.845 11.463 1.207 4.947 0.362 10.618 0.845 12.55 1.207 2.052 0.242 8.688 0.845 14.842 1.327 6.033 0.362 11.102 1.207 11.102 1.69 0 0.362-0.724 0.845-1.448 0.845-3.258 0.12-20.996 1.69-23.892 2.172-1.69 0.242-7.36 0.845-12.67 1.207s-11.583 0.965-13.877 1.207c-4.827 0.603-12.67 1.448-24.133 2.413-4.344 0.362-13.032 1.207-19.307 1.81s-14.963 1.448-19.307 1.81c-4.344 0.362-9.773 0.965-12.067 1.207s-10.98 1.086-19.307 1.81c-8.326 0.724-17.013 1.568-19.307 1.81s-7.482 0.724-11.463 1.086c-11.102 1.086-45.13 4.223-51.283 4.947-3.017 0.242-11.343 1.086-18.703 1.81-7.24 0.724-15.807 1.568-18.823 1.81-3.017 0.362-12.187 1.086-20.513 1.81-8.205 0.724-16.29 1.568-17.98 1.81s-7.843 0.845-13.877 1.327c-5.913 0.362-11.825 0.965-13.032 1.207s-6.395 0.724-11.463 1.086c-5.068 0.362-11.222 0.965-13.515 1.207-2.293 0.362-7.963 0.845-12.67 1.207-4.585 0.362-9.773 0.965-11.463 1.207s-7.36 0.845-12.67 1.207c-5.31 0.362-10.98 0.965-12.67 1.207s-7.12 0.845-12.067 1.207c-4.947 0.362-10.98 0.965-13.273 1.207s-10.74 1.086-18.703 1.81c-7.963 0.724-16.652 1.568-19.307 1.81-2.655 0.362-10.74 1.086-18.1 1.81-18.462 1.568-63.833 5.792-71.796 6.637-6.516 0.724-8.808 0.965-24.133 2.413-4.344 0.483-10.015 0.965-12.67 1.207s-8.567 0.845-13.273 1.207c-11.946 1.086-17.858 1.81-18.462 2.413-0.483 0.483-15.807 57.196-26.788 98.946-2.655 10.136-16.29 61.178-40.906 153.246-9.895 37.165-21.117 79.278-24.857 93.516-3.862 14.238-11.463 42.716-16.893 63.35s-10.257 38.613-10.618 40.061c-0.483 2.172 92.309-43.802 511.504-253.399 281.635-140.817 512.107-256.295 512.107-256.657s-230.592-115.839-512.347-256.777c-346.311-173.156-512.107-255.45-511.624-254.002z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "settings",
		paths: [
			"M357.465 2.455c-20.234 4.274-46.25 13.95-72.895 27.021-43.108 21.24-57.688 39.338-52.283 64.725 0.754 3.645 4.274 13.825 7.918 22.497 8.294 20.486 11.060 31.168 11.186 42.857 0.125 19.984-10.054 39.966-31.043 60.83-21.24 21.24-40.595 30.917-61.458 30.917-11.311 0-20.862-2.388-36.447-8.798-29.535-12.443-40.846-13.95-53.917-7.666-13.196 6.409-27.65 25.261-40.971 53.289-18.6 39.213-27.65 69.753-27.146 92.123 0.503 22.119 8.672 31.545 38.333 43.863 22.497 9.426 29.283 13.448 38.961 22.497 15.207 14.453 21.491 33.682 21.617 65.102 0 22.622-2.262 34.814-9.551 49.392-8.798 17.72-21.869 27.524-52.786 39.589-28.906 11.436-38.458 24.382-36.699 50.021 2.639 36.699 31.923 105.195 55.048 128.697 8.294 8.294 16.967 12.693 26.518 13.322 9.301 0.754 15.207-0.88 37.453-9.803 10.054-4.022 19.984-7.666 21.994-8.044 2.137-0.377 5.152-1.132 6.912-1.508 3.896-0.754 18.349-0.754 22.497 0.125 16.213 3.142 33.305 13.825 50.775 31.42 19.857 20.109 29.535 39.338 29.912 58.945 0.125 13.322-2.514 23.126-14.076 50.397-4.776 11.436-5.279 13.573-5.404 23.879-0.125 9.551 0.377 12.316 3.017 17.47 8.044 16.338 31.797 32.677 72.266 49.519 57.31 23.879 88.981 25.011 104.691 3.645 5.279-7.038 6.159-8.923 14.578-29.032 12.191-29.158 23.502-41.349 45.497-49.392 21.869-7.918 60.201-7.541 81.817 0.628 21.491 8.169 32.174 20.612 45.622 53.037 10.683 25.639 17.092 33.305 31.923 37.956 20.234 6.284 56.431-2.514 104.691-25.388 28.153-13.322 46.879-27.775 53.163-40.846 6.159-12.693 4.902-24.131-5.279-48.387-9.301-22.246-10.431-26.77-10.431-42.731 0.125-12.945 0.377-15.333 3.645-23.251 11.814-28.781 45.497-59.823 72.769-66.862 16.338-4.147 28.026-2.262 58.693 9.929 18.349 7.289 20.109 7.792 30.163 7.792 8.923 0.125 11.688-0.377 16.967-3.017 13.448-6.661 27.021-24.382 40.218-52.032 17.72-36.951 27.021-66.485 27.775-87.725 0.628-17.47-3.519-28.278-13.825-36.447-6.536-5.152-8.044-6.032-30.917-15.835-28.781-12.316-37.453-20.36-49.141-45.622-2.639-5.907-5.152-24.508-5.152-38.836-0.125-42.103 12.443-65.982 41.978-80.184 4.399-2.137 13.573-6.159 20.486-9.049 27.524-11.563 35.19-20.486 36.699-41.978 1.382-20.989-11.060-61.96-30.038-99.287-17.344-33.934-33.054-49.519-51.529-50.775-9.174-0.754-15.333 0.88-34.939 8.798-20.612 8.421-31.043 11.060-42.731 11.060-20.862 0-39.966-9.929-62.087-32.174-14.453-14.453-23.376-28.53-27.65-43.235-2.137-7.289-2.89-21.994-1.382-28.278 2.010-8.546 5.781-19.48 10.431-30.792 7.416-17.47 9.426-25.513 8.798-34.437-0.628-9.803-4.524-17.847-12.82-26.393-10.054-10.306-18.6-15.835-42.857-27.65-44.113-21.617-81.064-31.42-101.801-27.146-17.847 3.645-24.508 11.311-37.704 43.36-5.279 12.82-10.18 21.994-15.585 28.655-13.573 17.092-36.699 26.016-67.993 26.268-39.464 0.252-63.343-10.558-77.797-35.19-2.765-4.65-7.918-15.458-11.436-24.131-3.645-8.672-8.546-18.727-10.934-22.371-11.060-16.464-28.278-21.24-56.305-15.333zM558.553 265.63c40.595 7.666 78.675 25.136 111.227 51.026 12.065 9.678 33.054 30.792 41.6 42.103 27.146 35.567 44.365 76.917 50.649 121.91 2.262 16.087 1.76 56.053-0.88 71.135-9.803 55.425-33.809 101.926-72.141 139.63-40.218 39.715-87.599 62.715-145.538 70.758-11.94 1.634-53.163 1.76-60.955 0.252-1.76-0.377-7.416-1.382-12.568-2.137-29.912-4.776-61.96-16.967-90.49-34.687-9.551-5.907-26.77-18.349-30.917-22.371-0.754-0.754-4.147-4.022-7.541-7.164-20.234-18.727-40.218-45.497-52.534-69.878-18.224-36.699-26.896-72.643-26.896-112.861 0.125-56.681 17.972-109.594 52.409-154.587 8.044-10.683 29.158-32.174 40.343-41.223 35.819-28.906 80.31-48.010 126.309-54.168 21.617-2.89 55.928-1.885 77.922 2.262z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Sport-channel",
		paths: [
			"M481.625 0.193c-0.12 0.12-5.546 0.723-11.816 1.086-6.27 0.483-12.54 1.086-13.866 1.326s-5.064 0.844-8.44 1.206c-7.957 0.844-12.901 1.688-31.348 4.703-1.326 0.12-3.737 0.723-5.426 1.086s-8.199 1.929-14.469 3.256c-22.306 4.943-60.165 16.76-75.357 23.511-1.929 0.964-7.114 3.134-11.454 4.823-11.574 4.823-42.080 20.136-55.343 27.973-38.583 22.667-71.86 48.349-103.691 79.938-54.137 53.896-95.493 119.124-121.535 191.708-9.043 25.44-18.568 62.094-22.064 85.364-3.014 19.171-3.497 23.029-4.22 30.987-0.483 4.581-1.086 10.007-1.447 12.057-1.086 6.873-1.326 67.64-0.361 79.577 1.206 13.866 3.617 36.291 4.34 39.788 0.361 1.326 1.688 8.681 3.014 16.277 11.334 64.988 37.86 130.94 75.718 188.694 4.34 6.631 8.32 12.54 8.923 13.263 0.483 0.603 4.703 6.39 9.404 12.66 28.696 38.341 62.456 72.101 100.557 100.918 30.384 22.788 48.951 34.363 82.711 51.243 45.334 22.547 104.174 40.994 151.197 47.264 2.653 0.361 8.681 1.206 13.263 1.809 23.029 3.134 79.818 4.34 103.088 2.17 56.307-5.184 103.811-16.518 152.523-36.291 24.958-10.249 56.789-26.406 76.563-39.066 19.653-12.54 41.717-28.214 51.966-36.894 2.411-2.050 6.993-5.908 10.249-8.56s9.646-8.32 14.348-12.66c80.783-75.237 133.834-169.161 155.295-274.902 3.859-18.568 6.631-36.291 7.596-48.228 0.361-4.943 0.964-10.369 1.326-12.057 1.086-5.426 1.326-67.761 0.241-79.577-1.326-16.397-3.497-34.604-4.703-41.597-0.603-3.376-1.688-9.526-2.411-13.866-9.887-55.945-33.519-119.245-62.817-167.835-7.114-11.696-19.774-31.469-21.944-34.121-0.483-0.723-4.943-6.631-10.007-13.263-61.853-82.711-149.025-145.408-248.256-178.445-32.916-10.972-74.995-20.014-106.705-23.029-4.34-0.361-9.404-0.964-11.454-1.326-3.979-0.603-72.463-1.567-73.187-0.964zM778.472 183.944c15.916 5.064 32.313 19.171 39.909 34.243 7.596 14.83 9.526 31.107 5.667 47.264-3.014 12.901-8.56 22.547-18.447 32.674-30.504 30.987-82.23 26.043-105.861-10.128-8.56-13.143-11.454-23.15-11.454-39.427 0-12.057 3.737-25.923 9.646-34.966 10.249-16.036 26.767-27.731 44.973-31.831 8.079-1.809 26.887-0.603 35.568 2.17zM552.884 207.214c7.234 3.376 173.381 168.92 177.119 176.517 1.447 2.773 2.773 6.511 3.134 8.44 0.241 1.929 0.603 27.731 0.603 57.391l0.12 54.016h134.678l7.476 3.737c15.674 7.837 23.15 26.043 17.121 41.959-4.1 10.972-12.298 18.689-23.27 21.944-2.411 0.723-37.016 1.206-90.187 1.206-84.761 0-86.45 0-93.081-2.532-7.957-2.894-15.433-10.369-19.291-19.050-2.291-5.306-2.411-7.957-2.532-47.626 0-23.029-0.361-41.838-0.723-41.838s-17.966 17.241-39.066 38.341l-38.221 38.221 70.414 70.414c49.676 49.676 71.257 71.981 73.187 75.96 2.291 4.461 2.894 7.476 2.894 15.191 0 8.44-0.483 10.49-3.617 16.157-4.1 7.354-12.901 14.589-20.617 16.76-3.617 1.086-37.257 1.447-124.911 1.447-135.040 0-127.564 0.483-138.174-9.043-9.646-8.681-13.986-22.909-10.61-34.483 3.376-11.213 13.263-21.22 24.114-24.114 3.376-0.964 28.937-1.326 80.060-1.447 41.236 0 74.995-0.361 74.995-0.723s-27.611-28.334-61.25-61.974l-61.371-61.371-128.047 128.047c-141.791 141.791-133.231 134.075-149.147 133.954-24.114-0.12-40.271-23.873-31.71-46.661 2.532-6.873 9.887-14.348 206.177-210.758l203.524-203.524-27.611-27.731-27.731-27.611-47.746 47.626c-43.888 43.767-48.228 47.867-54.498 50.157-23.15 8.801-46.54-7.354-46.54-31.951 0-15.313-1.206-13.746 64.747-79.818 32.554-32.674 61.371-60.888 63.903-62.697 9.646-6.752 24.597-7.837 35.689-2.532z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Syncronise",
		paths: [
			"M486.349 0.366c-0.128 0.256-6.149 0.768-13.195 1.281-27.544 1.665-59.828 6.918-88.524 14.349-15.757 4.1-44.966 13.067-51.116 15.886-1.409 0.513-8.584 3.459-16.014 6.406-90.702 36.255-176.279 106.331-231.495 189.603-38.305 57.906-61.493 113.89-76.739 185.376l-0.513 2.946h198.314l0.897-3.843c2.946-13.195 19.473-48.938 31.771-68.539 24.597-39.074 58.674-74.047 96.339-98.901 39.201-25.75 82.247-42.404 127.47-49.066 5.252-0.768 11.017-1.794 12.811-2.178s15.63-0.768 30.746-1.025c21.779-0.384 31.387 0.128 46.12 2.049 67.258 8.968 124.907 35.871 175.767 81.991l9.865 8.968-129.904 129.904 162.059 0.384c116.196 0.256 164.238 0 169.746-1.025 23.7-4.484 43.685-23.444 49.963-47.528 1.538-5.765 1.922-33.436 1.922-171.284v-164.365l-58.931 59.058-59.058 59.058-13.708-12.811c-62.006-58.034-139.897-100.567-221.887-121.192-16.654-4.227-38.561-8.711-49.322-10.249-2.819-0.384-6.533-0.897-8.327-1.281-3.33-0.513-13.965-1.538-32.028-3.075-10.633-1.025-62.133-1.665-63.030-0.897z",
			"M80.88 610.171c-23.060 5.637-42.789 26.006-47.657 49.195-1.409 6.79-2.178 332.062-0.768 332.062 0.384 0 26.903-26.263 59.058-58.418l58.418-58.418 7.943 7.559c59.699 58.034 138.615 102.872 219.196 124.395 19.857 5.381 34.59 8.455 61.493 12.939 17.935 2.946 40.355 4.484 69.18 4.484 36.639 0.128 57.65-1.153 81.991-5.124 2.178-0.256 5.893-0.897 8.327-1.281 77.123-12.298 156.807-46.633 222.271-95.826 51.372-38.69 101.591-94.417 131.441-145.918 2.435-4.227 5.252-9.095 6.406-11.017 22.419-37.408 46.376-100.567 54.96-144.252 0.768-4.227 1.794-8.711 2.049-9.992 0.641-2.049-4.611-2.178-98.517-2.178h-99.285l-0.897 3.459c-2.049 8.2-10.376 28.825-16.911 41.892-16.398 32.796-34.974 58.418-61.236 84.68-31.259 31.387-61.236 51.501-105.691 70.845-17.167 7.559-49.707 16.27-74.304 19.985-17.808 2.819-61.749 3.716-79.556 1.665-39.201-4.356-74.817-14.86-110.175-32.54-27.287-13.579-49.195-28.697-72.51-49.835l-10.505-9.608 130.545-130.545-164.238 0.128c-126.829 0.128-165.903 0.513-171.027 1.665z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "task-list",
		paths: [
			"M500.793 0.474c-1.287 0.234-5.267 1.054-8.779 1.756-14.046 2.81-31.37 12.525-42.255 23.527-6.789 6.906-15.1 19.079-18.612 27.156l-2.224 5.267-72.455 0.702-6.789 4.682c-4.799 3.395-7.608 6.321-9.833 10.535l-2.926 5.736-0.702 124.776h351.388l-0.351-62.973-0.351-62.857-3.395-5.618c-1.756-3.043-5.033-6.906-7.257-8.545-7.374-5.736-12.174-6.321-48.108-6.321h-33.243l-2.224-5.384c-11.354-26.453-36.755-46.47-65.665-51.737-5.853-1.171-22.356-1.521-26.22-0.702zM523.735 60.873c11.236 4.799 18.143 16.622 17.089 29.029-2.341 27.507-37.34 36.52-53.024 13.695-10.651-15.451-3.395-36.988 14.631-43.778 5.033-1.872 15.451-1.287 21.304 1.054z",
			"M176.327 118.463c-15.333 3.746-31.955 16.738-38.158 29.965-7.257 15.217-6.672-18.026-6.672 422.556 0 438.123-0.469 406.754 6.554 421.268 4.213 8.545 16.622 20.953 25.166 25.166 14.397 7.023-10.066 6.554 346.941 6.554 231.176 0 329.968-0.351 334.767-1.287 21.538-3.862 39.797-21.304 45.65-43.309 2.575-9.481 2.575-808.474 0-817.955-4.097-15.685-16.622-31.487-29.848-37.925-13.695-6.554-15.1-6.672-82.17-6.672h-61.803v117.051h-409.68v-117.051l-62.272 0.117c-45.65 0-64.027 0.469-68.475 1.521zM801.381 355.608c3.277 3.746 3.98 7.959 1.872 11.822-0.702 1.405-5.502 7.257-10.651 13.11-9.715 11.12-10.184 11.705-20.835 24.23-3.512 4.213-6.672 7.843-7.023 8.194s-3.746 4.213-7.608 8.779c-3.862 4.448-7.257 8.428-7.608 8.779s-4.799 5.618-9.949 11.705c-15.451 18.26-21.655 24.346-25.283 25.166-7.608 1.756-9.248 0.469-31.135-24.932-11.471-13.227-21.771-25.4-22.825-27.038-4.097-5.969-2.341-11.354 5.853-18.026 4.916-3.98 6.087-4.448 10.651-3.98 4.682 0.469 6.087 1.639 18.26 13.695 7.257 7.257 13.461 13.227 13.695 13.344 0.351 0 5.033-3.862 10.418-8.662s12.407-11.12 15.685-14.046c3.161-2.81 9.013-8.077 12.876-11.705 21.655-19.899 35.232-31.72 38.627-33.828 3.98-2.341 11.354-0.702 14.982 3.395zM580.154 382.062c12.29 4.213 20.601 17.323 19.197 30.668-1.171 11.589-10.418 22.356-21.42 24.815-2.575 0.702-68.592 1.171-154.508 1.171-168.085 0-156.38 0.585-165.862-8.662-10.535-10.184-11.822-26.102-3.043-38.276 2.692-3.746 10.184-9.013 15.1-10.535 1.639-0.469 70.933-0.936 154.039-0.936 135.429-0.117 151.582 0.117 156.498 1.756zM801.381 501.923c6.672 7.492 7.023 6.906-30.668 50.449-11.939 13.812-27.976 32.423-35.701 41.437-16.271 18.845-16.387 18.963-21.538 20.015-6.438 1.287-10.184-1.405-22.825-16.271-6.554-7.843-15.919-18.612-20.835-24.112-14.163-15.919-14.631-18.26-5.853-27.39 5.502-5.736 6.087-6.087 11.705-6.087h5.969l13.695 13.695 13.812 13.695 5.853-5.502c3.277-3.043 7.492-6.789 9.364-8.428 3.043-2.575 28.092-25.166 31.72-28.678 10.651-9.949 27.507-24.464 30.317-26.22 3.98-2.341 11.354-0.702 14.982 3.395zM584.836 530.366c19.313 11.354 19.548 38.744 0.351 50.566l-5.736 3.512-152.635 0.351c-103.474 0.234-154.157-0.117-157.2-0.936-2.575-0.702-6.789-2.926-9.481-5.033-13.93-10.769-15.217-31.135-2.81-43.543 9.248-9.248-3.161-8.662 168.554-8.428l153.337 0.234 5.618 3.277zM579.92 674.573c7.023 2.458 12.174 6.789 15.919 13.227 2.81 4.682 3.277 6.789 3.277 14.28 0 7.608-0.469 9.598-3.395 14.397-1.756 3.043-5.033 6.906-7.023 8.428-8.895 6.789-0.585 6.438-164.457 6.438-169.841 0-157.668 0.702-167.033-9.013-14.982-15.333-9.013-40.734 11.12-47.874 3.395-1.171 35.466-1.521 155.327-1.639 132.385 0 151.816 0.234 156.264 1.756zM716.753 702.080v29.263h-58.526v-58.526h58.526v29.263zM585.187 823.229c19.079 11.822 18.963 39.212-0.351 50.566l-5.618 3.277-152.050 0.351c-171.48 0.351-160.477 0.82-169.725-8.428-11.589-11.589-11.705-29.146-0.234-40.968 9.248-9.364-3.395-8.779 168.788-8.545l153.454 0.234 5.736 3.512zM716.753 848.395v29.263h-58.526v-58.526h58.526v29.263z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "tick",
		paths: [
			"M914.93 70.689c-11.474 3.141-17.21 5.737-26.226 11.474-9.288 6.010-6.966 3.962-52.587 48.353-21.445 20.898-43.709 42.479-49.446 48.080-18.987 18.44-94.521 91.925-122.248 118.969-14.889 14.615-30.459 29.64-34.284 33.465-3.962 3.688-26.362 25.679-49.991 48.626-23.63 23.084-46.577 45.348-51.085 49.719s-19.942 19.396-34.284 33.329c-73.485 71.71-116.238 113.37-121.975 118.833-3.415 3.279-9.425 9.014-13.112 12.703l-6.966 6.556-11.063-12.567c-6.147-6.966-12.567-14.206-14.342-16.117-2.732-2.868-98.209-109.408-134.132-149.566-12.84-14.342-12.976-14.342-22.128-20.489-27.865-18.44-64.471-18.849-93.974-1.092-9.288 5.6-51.495 46.988-60.509 59.281-19.396 26.771-21.99 63.241-6.556 92.608 3.005 5.6 23.084 32.099 49.308 65.154 77.173 96.979 151.615 190.543 189.041 237.531 19.942 24.996 37.698 47.397 39.611 49.855 21.035 27.865 34.011 38.655 55.319 45.758 31.142 10.518 65.837 2.458 89.057-20.762 3.551-3.551 11.61-12.976 17.757-20.898s15.025-18.987 19.532-24.586c4.507-5.6 11.063-13.932 14.615-18.44 39.202-49.446 67.886-85.369 75.534-94.93 5.19-6.42 23.084-28.82 39.747-49.855 28.41-35.649 64.471-81.135 105.038-131.945 9.425-11.884 24.86-31.28 34.284-43.162s36.47-45.894 60.1-75.534c23.63-29.64 50.265-63.241 59.281-74.442 31.825-40.158 70.070-88.101 108.453-136.317 43.845-54.909 46.167-58.187 51.085-70.753 16.8-42.207-1.639-90.832-42.069-111.73-17.893-9.152-42.479-12.020-60.783-7.103z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "tick-circle",
		paths: [
			"M481.616 0.175c-0.12 0.12-5.546 0.723-11.816 1.086-6.27 0.483-12.54 1.086-13.866 1.326s-5.064 0.844-8.44 1.206c-7.957 0.844-12.901 1.688-31.348 4.703-1.326 0.12-3.737 0.723-5.426 1.086s-8.199 1.929-14.469 3.256c-22.306 4.943-60.165 16.76-75.357 23.511-1.929 0.964-7.114 3.134-11.454 4.823-11.574 4.823-42.080 20.136-55.343 27.973-38.583 22.667-71.86 48.349-103.691 79.938-54.137 53.896-95.493 119.124-121.535 191.708-9.043 25.44-18.568 62.094-22.064 85.364-3.014 19.171-3.497 23.029-4.22 30.987-0.483 4.581-1.086 10.007-1.447 12.057-1.086 6.873-1.326 67.64-0.361 79.577 1.206 13.866 3.617 36.291 4.34 39.788 0.361 1.326 1.688 8.681 3.014 16.277 11.334 64.988 37.86 130.94 75.718 188.694 4.34 6.631 8.32 12.54 8.923 13.263 0.483 0.603 4.703 6.39 9.404 12.66 28.696 38.341 62.456 72.101 100.557 100.918 30.384 22.788 48.951 34.363 82.711 51.243 45.334 22.547 104.174 40.994 151.197 47.264 2.653 0.361 8.681 1.206 13.263 1.809 23.029 3.134 79.818 4.34 103.088 2.17 56.307-5.184 103.811-16.518 152.523-36.291 24.958-10.249 56.789-26.406 76.563-39.066 19.653-12.54 41.717-28.214 51.966-36.894 2.411-2.050 6.993-5.908 10.249-8.56s9.646-8.32 14.348-12.66c80.783-75.237 133.834-169.161 155.295-274.902 3.859-18.568 6.631-36.291 7.596-48.228 0.361-4.943 0.964-10.369 1.326-12.057 1.086-5.426 1.326-67.761 0.241-79.577-1.326-16.397-3.497-34.604-4.703-41.597-0.603-3.376-1.688-9.526-2.411-13.866-9.887-55.945-33.519-119.245-62.817-167.835-7.114-11.696-19.774-31.469-21.944-34.121-0.483-0.723-4.943-6.631-10.007-13.263-61.853-82.711-149.025-145.408-248.256-178.445-32.916-10.972-74.995-20.014-106.705-23.029-4.34-0.361-9.404-0.964-11.454-1.326-3.979-0.603-72.463-1.567-73.187-0.964zM762.185 245.418c18.327 8.56 29.057 26.767 27.731 47.264-1.086 15.674-1.809 16.639-85.003 120.451-3.497 4.34-9.646 12.057-82.591 103.691-23.873 30.023-55.343 69.57-69.931 87.897s-35.086 44.129-45.697 57.391c-10.49 13.263-20.738 26.284-22.909 28.817-16.76 21.22-22.306 25.923-34.846 29.781-17.121 5.306-35.207 0.603-47.746-12.54-3.256-3.497-19.050-22.788-35.086-43.044s-30.023-37.86-31.107-39.186c-1.086-1.326-6.149-7.596-11.093-13.866s-9.646-12.298-10.49-13.263c-1.447-1.688-38.944-48.951-62.697-78.733-11.937-15.191-16.036-23.631-16.639-35.568-0.844-17.363 4.461-27.851 24.356-47.506 11.454-11.334 16.036-14.951 22.788-18.086 7.596-3.617 9.284-3.979 19.774-3.979 10.249 0 12.298 0.361 19.291 3.737 8.681 4.1 11.093 6.27 23.511 20.256 4.703 5.184 9.284 10.369 10.249 11.454 1.086 1.086 6.27 6.752 11.454 12.78 5.306 5.908 10.61 11.937 11.937 13.263 1.206 1.326 12.54 13.986 25.2 28.093l23.029 25.681 10.851-10.851c6.029-5.908 14.589-14.227 18.93-18.327 4.34-4.22 23.27-22.667 41.959-40.874 18.809-18.206 39.909-38.824 46.903-45.576 7.114-6.873 29.42-28.696 49.676-48.349 20.256-19.774 40.633-39.668 45.456-44.25 4.703-4.581 23.029-22.426 40.753-39.668 40.030-38.944 44.973-42.080 64.747-41.114 7.234 0.361 11.213 1.326 17.241 4.22z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "trash",
		paths: [
			"M406.899 1.871c-21.081 5.782-38.065 22.888-43.607 44.089-1.205 4.336-1.807 12.89-1.807 25.417v19.033h-79.505c-86.974 0-89.503 0.12-106.126 7.108-24.936 10.48-44.571 32.766-52.401 59.749-1.687 6.023-2.168 13.853-2.529 45.414l-0.602 38.307h783.363l-0.12-35.295c-0.12-29.874-0.482-36.621-2.409-44.812-6.384-27.345-23.49-49.028-48.305-61.074-18.31-9.035-13.853-8.673-106.729-9.035l-83.48-0.482v-18.913c0-12.528-0.602-21.081-1.807-25.417-5.662-21.442-22.647-38.428-44.089-44.089-9.276-2.529-201.051-2.409-209.845 0zM602.409 75.353v15.058h-180.693v-30.115h180.693v15.058z",
			"M180.792 647.547v376.443h662.54v-752.886h-662.54v376.443zM345.343 365.184c6.625 3.373 13.010 10.962 14.938 17.708 0.843 3.012 1.205 89.142 1.205 264.775 0 229.841-0.241 261.041-1.807 265.618-2.529 7.228-6.745 12.287-13.492 16.262-4.938 3.012-6.987 3.494-14.817 3.494-7.71 0-9.878-0.482-14.697-3.373-3.132-1.807-7.108-5.060-8.673-7.228-7.228-9.396-6.745 9.396-6.745-274.773 0-292.481-0.843-267.425 9.035-277.182 9.276-9.276 23.249-11.444 35.054-5.301zM522.302 363.498c7.589 2.529 15.299 10.239 17.828 17.828 1.927 5.421 2.048 26.984 2.048 266.34 0 284.17 0.482 265.377-6.745 274.773-1.566 2.168-5.541 5.421-8.673 7.228-4.698 2.77-6.987 3.373-14.697 3.373-10.359 0-14.455-1.687-21.683-9.155-9.155-9.517-8.432 14.094-8.191-278.869l0.361-262.727 3.614-5.782c7.95-12.768 21.924-17.828 36.139-13.010zM707.693 365.546c6.264 3.614 11.083 9.517 13.492 16.021 1.325 3.734 1.566 50.714 1.687 265.498 0 291.517 0.722 267.786-8.552 277.062-7.108 7.108-11.203 8.793-21.563 8.793-7.83 0.12-9.878-0.361-14.817-3.253-6.745-3.975-11.926-10.722-13.973-17.949-1.085-3.855-1.325-69.146-1.085-266.582l0.361-261.522 3.012-5.782c3.373-6.625 9.517-12.166 16.382-14.697 6.987-2.65 18.43-1.566 25.056 2.409z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "vehicle",
		paths: [
			"M213.514 172.634c-7.965 2.162-17.296 7.169-23.327 12.517-5.917 5.234-180.015 237.138-184.111 245.216-6.372 12.745-6.258 9.785-5.917 128.241 0.341 108.782 0.341 109.010 2.845 115.041 7.737 18.889 23.668 32.658 42.215 36.526 3.3 0.682 13.655 1.251 22.986 1.251h17.068l0.113 5.348c0 3.073 0.228 6.258 0.341 7.169 0.228 0.91 0.797 4.779 1.251 8.534 4.324 36.526 29.13 75.783 60.991 96.721 25.489 16.727 48.929 23.782 79.539 23.896 30.382 0 54.278-7.169 79.88-24.009 17.296-11.379 38.688-36.071 47.792-55.188 8.875-18.434 14.451-40.851 14.565-58.26v-4.21h256.026l0.113 3.641c0.113 11.379 3.073 28.334 6.827 39.94 7.169 22.076 18.093 39.598 35.161 56.554 28.903 28.903 61.902 42.215 103.207 41.533 28.903-0.456 52.115-7.737 76.808-24.009 10.582-6.941 30.61-27.082 37.551-37.437 11.151-16.955 19.685-37.664 22.417-54.619 0.682-4.438 1.479-9.216 1.707-10.81 0.341-1.593 0.569-5.576 0.569-8.875l0.113-5.917h31.633c34.25 0 39.257-0.682 51.433-6.486 8.875-4.324 20.369-16.158 24.693-25.375 6.258-13.541 6.258-12.176 5.803-113.789l-0.341-93.876-2.731-6.827c-5.917-14.793-15.589-25.375-28.903-31.748-8.193-3.869-20.823-6.714-78.174-17.182-8.421-1.593-17.637-3.414-20.482-3.983-2.845-0.682-16.158-3.3-29.585-5.803s-24.693-5.007-25.034-5.576c-0.341-0.456-4.665-5.234-9.672-10.469s-16.499-17.41-25.603-27.082c-9.103-9.672-20.369-21.733-25.261-26.741-4.779-5.007-9.785-10.354-11.151-11.948s-6.372-6.941-11.151-11.948c-4.893-5.121-12.858-13.541-17.865-18.889-15.362-16.158-40.851-43.24-43.809-46.54-1.593-1.593-10.013-10.582-18.775-19.913s-19.8-21.051-24.465-26.058c-19.572-20.823-26.285-25.603-40.623-28.561-11.038-2.389-388.25-2.276-396.669 0zM383.401 315.44v83.066h-135.409c-74.532 0-135.409-0.228-135.409-0.569 0-0.228 6.258-8.875 13.996-19.116 7.624-10.241 35.388-47.45 61.674-82.497l47.678-63.95h147.471v83.066zM601.308 238.291c2.958 3.3 12.289 13.199 20.482 21.961 8.306 8.762 16.386 17.41 18.093 19.344 1.707 1.82 6.827 7.283 11.266 11.948 8.875 9.331 36.071 38.233 47.109 50.067 12.972 13.883 15.703 16.727 31.179 33.112 8.534 8.99 16.841 18.093 18.547 20.026l3.186 3.755h-282.426v-166.133h126.989l5.576 5.917z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Warning important",
		paths: [
			"M493.967 46.154c-26.092 4.098-54.098 20.356-70.082 40.71-5.328 6.695-22.95 35.383-34.562 56.284-1.776 3.415-3.825 6.695-4.372 7.514-0.547 0.683-6.695 11.202-13.661 23.224-15.027 25.956-19.126 32.923-28.688 49.18-3.825 6.695-8.333 14.48-9.836 17.076-2.459 4.098-18.033 31.011-36.612 62.841-2.868 4.917-8.88 15.163-13.525 22.95-4.508 7.65-9.563 16.257-11.065 19.126-1.502 2.732-3.415 6.011-4.098 7.104-1.23 1.776-18.716 31.83-25.956 44.399-1.23 2.185-18.443 31.694-38.251 65.574-19.809 33.743-40.3 69.125-45.765 78.552-12.705 21.858-77.869 133.743-93.579 160.519-23.634 40.3-50.273 86.201-53.142 91.803-6.011 12.022-9.972 28.962-10.519 45.491-0.273 8.606 0.136 18.716 0.819 22.541 2.185 11.202 7.923 27.322 13.114 36.476 4.372 7.787 17.076 24.317 21.448 27.732 15.984 13.114 26.23 19.262 39.344 23.907 19.945 6.967-2.185 6.695 435.108 6.695 441.256 0.136 420.764 0.41 439.343-6.831 19.673-7.514 36.749-19.809 48.907-34.972 26.639-33.060 33.060-76.093 17.35-115.163-1.776-4.234-20.901-38.115-42.623-75.272-21.584-37.159-41.257-70.902-43.716-75-8.744-15.027-29.781-51.365-67.623-116.12-21.311-36.476-46.312-79.508-55.737-95.628-22.541-38.661-23.771-40.984-37.842-64.891-6.557-11.339-13.797-23.907-16.12-28.005-2.185-4.098-4.781-8.47-5.738-9.563-0.819-1.093-3.142-4.781-5.055-8.197-3.279-5.874-29.781-51.639-44.808-77.186-3.962-6.831-8.333-14.344-9.699-16.803-1.502-2.323-3.689-6.421-5.191-8.88-1.366-2.323-5.601-9.563-9.289-15.984-11.748-19.945-40.164-68.715-43.033-73.77-21.175-36.749-28.552-47.814-38.115-56.83-13.935-12.978-27.049-20.628-45.629-26.775-9.972-3.279-15.301-4.098-28.005-4.508-8.606-0.273-19.262 0-23.497 0.683zM524.569 206.126c24.454 5.055 44.263 24.864 50.273 50.137 1.502 6.557 1.23 29.508-0.683 48.771-0.273 3.006-0.957 12.842-1.366 21.858s-1.093 20.082-1.366 24.59c-0.41 4.508-0.957 14.344-1.366 21.858s-1.093 17.35-1.366 21.858c-0.273 4.508-0.957 14.344-1.366 21.858-1.64 27.049-2.049 34.289-2.732 45.082-0.957 15.846-1.913 31.147-2.732 45.082-0.957 18.443-2.049 34.426-2.732 45.082-0.41 5.191-0.957 15.027-1.366 21.858-0.41 6.695-0.957 16.529-1.366 21.858-0.41 5.191-0.957 15.71-1.502 23.224-0.957 17.623-2.732 23.36-9.016 29.508-15.71 15.163-57.103 14.208-70.902-1.776-4.781-5.464-6.421-11.476-7.24-27.049-0.957-15.027-1.776-28.825-2.868-44.399-0.41-6.011-0.957-17.076-1.366-24.59s-0.957-16.393-1.23-19.809c-0.41-3.415-0.957-13.525-1.366-22.541-0.547-9.016-1.23-20.082-1.502-24.59-0.41-4.508-0.957-14.344-1.366-21.858s-1.093-18.306-1.366-23.907c-1.23-18.443-1.913-30.464-2.596-43.033-1.093-17.076-2.323-37.295-2.868-43.033-0.273-2.596-0.819-14.071-1.366-25.273-0.547-11.339-1.23-20.765-1.366-21.311-1.366-2.049-1.776-44.946-0.683-50.137 7.923-34.017 42.623-56.42 76.776-49.316zM526.891 725.797c28.825 7.65 49.316 33.743 49.316 62.841-0.136 44.125-44.672 75.683-86.201 61.066-19.262-6.695-31.83-19.535-40.71-41.803-2.596-6.284-3.415-22.677-1.502-31.557 7.24-36.066 44.399-59.836 79.099-50.546z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Warning-important",
		paths: [
			"M481.949 1.485c-0.36 0.241-6.010 0.842-12.622 1.322-6.611 0.36-13.342 0.961-15.026 1.202s-5.65 0.842-9.015 1.322c-10.337 1.322-28.609 4.207-33.658 5.409-2.645 0.601-8.896 2.044-13.824 3.125-67.916 15.026-141.602 49.645-196.537 92.439-43.515 33.898-79.095 71.041-109.507 114.797-33.658 48.202-59.983 105.18-74.888 162.278-4.568 17.671-10.337 46.761-12.021 60.704-0.721 5.891-1.562 12.982-1.923 15.627-3.125 25.484-3.125 82.1 0 107.224 5.409 43.995 11.539 71.642 23.921 109.147 10.337 31.013 27.166 68.517 41.591 92.678 2.645 4.568 5.29 9.015 5.77 9.736 3.726 6.371 14.184 22.238 21.036 31.855 61.665 86.548 150.739 153.263 250.389 187.401 26.085 8.896 67.797 19.113 91.237 22.238 3.366 0.481 7.093 0.961 8.414 1.202 1.202 0.241 5.891 0.842 10.218 1.202 4.327 0.481 9.497 1.082 11.42 1.322 9.135 1.322 77.893 1.202 91.958-0.241 32.336-3.246 47.362-5.77 76.331-12.862 129.582-31.614 242.696-114.076 313.256-228.151 43.515-70.32 69.96-152.301 75.248-233.801 1.562-24.522 0.842-74.408-1.443-88.592-0.241-1.443-1.322-9.857-2.404-18.391-9.857-76.691-42.072-157.951-88.592-223.824-6.731-9.616-9.616-13.342-21.757-28.609-15.507-19.353-42.313-46.88-63.589-65.152-66.233-56.857-146.17-95.804-232.358-113.234-6.611-1.322-14.184-2.765-16.709-3.125s-5.77-0.842-7.212-1.202c-1.443-0.241-5.169-0.842-8.534-1.202-3.246-0.36-8.174-0.961-10.819-1.322s-6.972-0.842-9.616-1.202c-6.492-0.721-78.014-1.923-78.735-1.322zM533.156 179.030c14.305 4.689 27.166 14.425 34.619 26.326 7.332 11.66 12.502 31.855 12.021 47.601-0.12 7.933-1.683 34.86-2.284 41.471-0.12 2.284-0.721 9.015-1.082 15.026-0.842 11.3-1.562 21.517-2.524 33.658-0.36 3.967-0.842 11.3-1.202 16.228-1.443 20.916-1.923 26.085-2.404 31.254-0.241 3.005-0.842 9.497-1.202 14.425-1.202 16.228-1.683 22.118-2.885 36.062-0.721 7.573-1.562 18.151-1.923 23.44s-0.842 12.021-1.202 15.026c-0.241 3.005-0.842 8.655-1.202 12.622s-0.842 9.616-1.202 12.622c-0.241 3.005-0.842 9.736-1.202 15.026s-0.961 11.78-1.202 14.425c-0.36 2.645-0.842 8.054-1.202 12.021-1.562 17.069-2.404 25.725-4.207 40.87-0.721 5.891-1.562 13.463-1.923 16.829-1.202 10.938-2.885 16.588-6.492 21.396-6.852 9.376-16.108 13.583-30.653 13.943-15.987 0.36-26.445-4.327-33.538-14.906-3.366-4.928-4.327-7.933-5.409-16.829-0.842-6.010-1.683-12.14-1.923-13.824s-1.082-9.497-1.803-17.43c-1.202-13.704-1.923-20.795-3.005-28.849-0.241-2.044-0.842-7.933-1.202-13.223s-0.961-11.78-1.202-14.425c-0.961-8.775-1.683-17.911-2.404-27.647-0.36-5.29-0.961-11.3-1.202-13.223-0.241-2.044-0.842-9.015-1.202-15.627-0.481-6.611-1.082-13.342-1.202-15.026-0.241-1.683-0.721-7.933-1.202-13.824-0.36-6.010-0.961-12.502-1.202-14.425-0.241-2.044-0.842-8.534-1.202-14.425-0.36-6.010-0.961-13.223-1.202-16.228-0.481-5.049-1.202-14.665-2.404-30.051-0.241-3.606-0.842-10.938-1.202-16.228-0.842-11.179-1.562-20.795-2.404-31.855-0.241-4.327-0.842-11.901-1.202-16.829-0.241-4.928-0.842-13.583-1.322-19.233-3.005-38.346 2.284-61.546 17.911-78.494 17.189-18.512 44.837-25.604 68.878-17.671zM533.757 720.798c22.479 7.694 40.269 27.407 44.837 49.645 2.645 13.103 1.082 29.691-3.726 41.471-6.852 16.348-23.44 30.772-41.831 36.302-10.819 3.246-32.215 2.885-42.673-0.721-14.544-5.049-28.489-15.507-35.461-26.565-11.179-17.671-12.622-46.399-3.366-65.632 8.896-18.391 26.565-32.215 46.64-36.543 7.933-1.803 28.008-0.601 35.58 2.044z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Map",
		paths: [
			"M0.399 472.587c0.256 388.085 0.384 409.075 2.56 416.115 9.727 31.872 30.975 54.526 61.694 66.046 14.463 5.376-2.047 5.247 491.633 5.247h467.699l-0.127-405.492c-0.127-384.372-0.256-405.875-2.304-415.604-7.807-34.559-33.152-60.926-68.605-71.55l-8.96-2.687-943.972-0.64 0.384 408.564zM453.762 120.342l24.319 24.319-45.439 45.439-46.975-47.102-47.102-46.975h90.877l24.319 24.319zM370.308 433.676l-337.654 337.526-0.384-67.454-0.256-67.582 539.504-539.888 136.316-0.256-337.526 337.654zM183.433 439.308l-22.783 22.783-128.636-128.636v-90.877l174.075 174.075-22.656 22.656zM991.986 288.017v31.999h-146.556l-95.997 95.997 242.553 242.553v90.877l-287.991-287.991-197.114 197.114 2.432 9.6c3.072 11.52 2.816 31.359-0.512 42.111l-2.176 6.912 210.81 210.81h-90.877l-165.371-165.371-7.552 2.304c-10.496 3.2-33.023 3.2-43.262 0.127l-7.552-2.432-165.371 165.371h-90.877l210.81-210.81-2.432-7.552c-3.072-10.24-3.072-32.767 0.127-43.262l2.304-7.552-83.454-83.454 22.656-22.783 22.783-22.656 83.454 83.454 6.912-2.047c12.287-3.712 28.415-4.096 40.831-0.896l10.88 2.687 197.114-197.114-112.637-112.637 22.783-22.656 22.656-22.783 112.637 112.637 114.557-114.557h173.435v31.999z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Expand-screen",
		paths: [
			"M141.327 2.74c-52.29 9.284-97.891 42.733-121.919 89.426-8.601 16.519-12.014 26.623-17.475 51.198-0.683 2.595-1.365 201.788-1.501 442.76l-0.409 437.845h432.247c383.508 0 433.886-0.273 446.582-2.184 60.619-8.874 111.134-49.697 134.207-108.404 1.639-4.096 4.505-13.517 6.553-21.026l3.687-13.789 0.409-439.347 0.273-439.211-434.432 0.136c-410.54 0.136-435.388 0.273-448.221 2.595zM921.584 481.271c0 276.060-0.409 380.64-1.501 385.965-5.597 25.804-27.032 47.375-52.837 52.837-5.188 1.092-111.953 1.501-385.965 1.501h-378.865v-377.909c0-265.547 0.409-380.366 1.501-386.101 4.505-24.439 24.848-46.284 49.969-53.11 5.325-1.501 76.046-1.775 387.193-1.912l380.504-0.136v378.865z",
			"M699.317 323.99l153.321 153.321 0.409-127.79c0.136-85.739-0.136-129.838-1.092-134.48-3.14-14.745-13.653-29.354-26.487-36.863-12.97-7.645-10.786-7.509-150.59-7.509h-128.883l153.321 153.321z",
			"M170.68 675.414c0 83.009 0.547 130.248 1.501 134.207 4.642 20.615 21.571 37.409 42.324 42.188 3.823 0.956 52.837 1.501 134.616 1.501h128.61l-152.911-152.911c-84.101-84.101-153.185-152.911-153.458-152.911-0.409 0-0.683 57.615-0.683 127.927z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "Tag",
		paths: [
			"M0 61.44v430.080l496.64 496.64c22.306 22.078 53 35.719 86.88 35.719s64.574-13.64 86.89-35.729l-0.010 0.010 317.76-316.16c22.078-22.306 35.719-53 35.719-86.88s-13.64-64.574-35.729-86.89l0.010 0.010-496.64-498.24h-430.080c-33.932 0-61.44 27.508-61.44 61.44v0zM210.88 150.72c0 33.402-27.078 60.479-60.48 60.479s-60.48-27.078-60.48-60.48c0-33.402 27.078-60.48 60.48-60.48 0.113 0 0.225 0 0.337 0.001h-0.017c0 0 0.001 0 0.001 0 33.225 0 60.16 26.935 60.16 60.16 0 0.113 0 0.225-0.001 0.337v-0.017z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "advertising",
		paths: [
			"M280.827 251.645c-153.122 153.246-253.755 254.748-257.23 259.711-16.255 22.832-23.7 46.409-23.576 73.459 0.124 25.934 8.81 51.372 24.445 72.342 9.183 12.285 338.134 340.243 346.943 345.951 15.387 9.927 33.006 17 48.642 19.482 11.044 1.738 29.037 1.738 39.956 0 19.854-3.102 42.933-13.526 57.7-25.934 3.723-3.102 119.246-118.005 256.485-255.368l249.784-249.661v-218.143c0-239.858 0.372-226.208-7.569-241.098-4.84-9.183-15.634-19.854-24.817-24.817-14.642-7.817-2.979-7.445-241.595-7.445h-217.522l-251.646 251.522zM898.774 96.662c22.087 10.671 34.496 30.153 34.62 54.226 0 16.008-6.204 30.649-17.869 42.189-22.212 22.212-55.962 23.825-80.532 3.723-26.43-21.467-28.912-61.299-5.584-86.86 12.16-13.277 27.547-19.482 47.029-18.861 10.919 0.497 12.657 0.869 22.335 5.584zM558.532 249.412l27.671 27.671 12.037-3.226c6.576-1.738 24.445-6.453 39.831-10.547 15.262-4.095 28.043-7.197 28.416-6.948 0.497 0.62 17.124 61.422 20.102 73.955l1.489 5.584 10.050 2.73c5.46 1.489 21.467 5.832 35.488 9.555s27.547 7.445 30.153 8.066c3.599 0.992 4.591 1.861 4.095 3.474-0.248 1.117-3.971 14.89-8.189 30.649-4.095 15.634-8.314 31.27-9.306 34.744-3.971 13.773-6.453 9.678 26.182 42.189l29.409 29.409-59.064 59.064 3.846 14.021c2.11 7.817 6.453 23.576 9.43 35.241 3.102 11.54 6.204 23.079 6.948 25.438 0.62 2.358 0.744 4.715 0.248 5.087-0.497 0.497-7.569 2.73-15.759 4.84-19.482 5.212-50.627 13.526-57.7 15.387-6.453 1.738-4.591-2.979-18.116 47.897-4.591 17.372-8.81 32.139-9.306 32.634-0.744 0.992-11.416-1.613-60.058-14.767l-19.854-5.335-29.409 29.409-29.532 29.409-58.941-58.692-6.204 1.613c-3.351 0.744-21.095 5.46-39.211 10.424-18.116 4.84-33.503 8.81-34.124 8.81s-2.979-7.073-5.335-15.883c-16.628-62.54-17.248-64.773-19.11-64.773-0.869 0-11.54-2.73-23.825-6.081-12.285-3.226-29.409-7.942-38.095-10.175-8.81-2.358-15.883-4.715-15.883-5.335 0-1.117 11.788-45.788 17.496-66.509l3.599-13.029-58.941-58.941 29.409-29.532 29.532-29.409-1.861-6.204c-1.117-3.351-2.11-7.322-2.482-8.686-0.248-1.364-4.219-16.38-8.81-33.38-6.081-22.707-7.942-31.021-6.825-31.642 0.869-0.62 9.43-3.102 19.11-5.707 47.401-12.657 58.569-15.759 59.313-16.503 0.497-0.497 5.335-18.241 10.919-39.335 5.707-21.218 10.547-38.839 11.044-39.335s5.087 0.248 10.175 1.613c5.087 1.364 22.956 6.081 39.584 10.547l30.277 8.189 14.767-14.767c8.066-8.066 21.218-21.218 29.16-29.16 12.285-12.409 14.767-14.393 16.38-13.029 1.117 0.744 14.393 14.021 29.781 29.284z"
		],
		height: 1024,
		width: 1024
	},
	{
		name: "buzz",
		paths: [
			"M789.717 74.755c-41.204 40.948-77.93 77.545-81.769 81-37.237 34.423-87.655 63.982-137.048 80.489-21.754 7.294-52.209 14.076-74.602 16.891-4.223 0.512-8.83 1.023-10.237 1.28-1.407 0.127-3.327 0.384-4.095 0.384-1.28 0.127-1.663 39.669-1.663 193.224v193.224l6.142 0.767c44.020 5.375 79.081 14.46 115.423 30.071 14.332 6.142 36.213 17.275 46.067 23.546 39.412 24.825 49.393 33.783 137.688 121.948l78.697 78.697 20.73-0.512c19.834-0.384 20.986-0.512 26.616-3.839 7.165-4.223 12.413-10.877 14.716-18.682 1.536-4.735 1.792-34.166 1.792-167.248v-161.361l11.9-1.536c10.749-1.407 24.057-5.246 31.735-9.214 6.654-3.455 19.962-13.564 25.209-19.067 31.351-32.887 35.83-83.303 10.749-120.029-16.763-24.44-42.611-39.669-71.915-42.228-3.839-0.384-7.165-0.767-7.294-0.896-0.256-0.256-0.384-73.451-0.384-162.897 0-145.111-0.256-163.153-2.047-167.504-3.072-7.294-7.934-13.052-14.46-16.891-5.631-3.327-6.782-3.455-26.489-3.839l-20.73-0.512-74.731 74.731z",
			"M173.192 257.102c-43.124 6.271-74.346 19.322-102.37 42.74-8.83 7.294-20.474 18.427-20.474 19.707 0 0.384 29.175 0.64 65.005 0.64 62.062 0 65.005 0.127 68.973 2.559 7.805 4.735 10.11 13.82 5.502 21.37-4.606 7.678-1.536 7.422-86.248 8.061l-78.057 0.64-5.375 11.004c-2.943 6.015-6.911 15.228-8.701 20.474-3.072 9.085-8.445 28.664-8.445 30.839 0 0.512 32.631 1.023 72.683 1.023 55.408 0 73.323 0.384 75.754 1.663 4.351 2.176 8.957 9.47 8.957 14.203 0 2.176-1.152 5.758-2.559 8.061-4.991 8.318-2.432 8.061-83.943 8.061h-73.835l0.896 12.029c0.896 13.564 3.199 26.489 7.294 41.715l2.687 10.237h84.712c65.134 0 85.352 0.384 87.782 1.663 1.663 0.896 4.479 3.583 6.142 6.015 5.246 7.805 2.303 18.042-6.398 22.521-2.815 1.536-17.019 1.792-80.361 1.792h-76.905l4.735 7.294c32.374 51.185 87.782 83.816 149.589 88.167 6.398 0.512 11.773 1.023 12.029 1.28 0.256 0.127 20.73 81.64 45.554 180.811 24.825 99.299 45.811 182.347 46.706 184.394 2.432 6.015 13.052 14.843 19.707 16.508 3.966 0.896 27.512 1.407 73.962 1.407h68.204l7.038-3.583c5.246-2.687 8.318-5.375 11.773-10.493 9.085-13.309 11.773 0.512-36.726-193.224-23.546-94.693-43.251-173.134-43.635-174.413-0.64-2.047 1.407-2.176 31.351-2.176h32.118v-383.889l-135.897 0.127c-74.858 0.127-137.433 0.512-139.223 0.767z"
		],
		height: 1024,
		width: 1024
	}
];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  transform: ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledSvg = styled('svg')(_templateObject(), function (props) {
  var transform = [];

  if (props.rotate) {
    transform.push("rotate(".concat(props.rotate, "deg)"));
  }

  if (props.scaleX) {
    transform.push("scaleX(".concat(props.scaleX, ")"));
  }

  if (props.scaleY) {
    transform.push("scaleX(".concat(props.scaleY, ")"));
  }

  return transform.join(' ');
});
var IconPath = styled('path')(_templateObject2(), function (props) {
  switch (props.color) {
    case 'black':
      return black;

    case 'white':
      return white;

    case 'orange':
      return orange1;

    case 'blue':
      return functionalBlue;

    case 'grey':
      return grey2;

    case 'red':
      return functionalRed;

    case 'yellow':
      return functionalYellow;

    case 'green':
      return functionalGreen;

    default:
      return props.color;
  }
});

var Icon = function Icon(props) {
  var icon = props.icon,
      color = props.color,
      colors = props.colors,
      rotate = props.rotate,
      width = props.width,
      height = props.height,
      scaleX = props.scaleX,
      scaleY = props.scaleY,
      title = props.title,
      rest = _objectWithoutProperties(props, ["icon", "color", "colors", "rotate", "width", "height", "scaleX", "scaleY", "title"]);

  var iconObj = icons.find(function (obj) {
    return obj.name === icon;
  });

  if (iconObj === undefined) {
    return null;
  }

  var svgHeight = iconObj.height;
  var svgWidth = iconObj.width;
  var hasSeveralColor = colors && colors.length === iconObj.paths.length;
  return React.createElement(StyledSvg, _extends({}, rest, {
    width: width,
    height: height,
    viewBox: "0 0 ".concat(svgWidth, " ").concat(svgHeight),
    rotate: rotate,
    scaleX: scaleX,
    scaleY: scaleY
  }), title ? React.createElement("title", null, title) : undefined, iconObj.paths.map(function (p, key) {
    var theColor = hasSeveralColor ? colors[key] : color; // eslint-disable-next-line react/no-array-index-key

    return React.createElement(IconPath, {
      key: key,
      color: theColor,
      d: p
    });
  }));
};

Icon.allowedColors = ['white', 'black', 'grey', 'orange', 'blue', 'green', 'red', 'yellow'];
Icon.defaultProps = {
  height: 16,
  color: undefined,
  colors: undefined,
  rotate: 0,
  width: 16,
  scaleX: 1,
  scaleY: 1,
  title: undefined
};
Icon.propTypes = {
  /** Number, height of the icon */
  height: PropTypes.number,

  /** Number, width of the icon */
  width: PropTypes.number,

  /** String, color of the icon */
  color: PropTypes.oneOf(Icon.allowedColors),

  /** Array of String, the colors to apply for each paths */
  colors: PropTypes.arrayOf(PropTypes.string),

  /** Number, rotation in degree */
  rotate: PropTypes.number,

  /** String, icon name */
  icon: PropTypes.string.isRequired,

  /** Number, vertical axial symmetry */
  scaleX: PropTypes.number,

  /** Number, horizontal axial symmetry */
  scaleY: PropTypes.number,

  /** String, Icon title */
  title: PropTypes.string
};

var fontSizeBase = 16;
var mobilePaddingTop = 8 / fontSizeBase;
var mobilePaddingBottom = 10 / fontSizeBase;
var paddingTop = 19 / fontSizeBase;
var paddingBottom = 21 / fontSizeBase;
var paddingLeft = 15 / fontSizeBase;
var paddingRight = 15 / fontSizeBase;
var mobileIconSize = 20 / fontSizeBase;
var iconSize = 32 / fontSizeBase;
var marginRightIcon = 15 / fontSizeBase;
var maxWidthContent = 600 / fontSizeBase;
var maxWidthWrapper = maxWidthContent + paddingLeft + paddingRight + iconSize;
var mobileMaxWidthWrapper = maxWidthContent + paddingLeft + paddingRight + mobileIconSize;

function _templateObject4() {
  var data = _taggedTemplateLiteral$1(["\n  display: block;\n  background-color: white;\n  max-width: ", "rem;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral$1(["\n  max-width: ", "rem;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteral$1(["\n  width: ", "rem;\n  flex-shrink: 0;\n  margin-right: ", "rem;\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral$1(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-top: ", "rem;\n  padding-bottom: ", "rem;\n  padding-left: ", "rem;\n  padding-right: ", "rem;\n  background-color: ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$1(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var RootContainer = styled.div(_templateObject$1(), function (props) {
  return props.size === 's' ? mobilePaddingTop : paddingTop;
}, function (props) {
  return props.size === 's' ? mobilePaddingBottom : paddingBottom;
}, paddingLeft, paddingRight, function (props) {
  var color;

  switch (props.type) {
    case 'error':
      color = seeThroughRed;
      break;

    case 'info':
      color = seeThroughBlue;
      break;

    case 'success':
      color = seeThroughGreen;
      break;

    case 'warning':
    default:
      color = seeThroughYellow;
      break;
  }

  return color;
});
var MyIcon = styled(Icon)(_templateObject2$1(), function (props) {
  return props.size === 's' ? mobileIconSize : iconSize;
}, marginRightIcon);
var ContentContainer = styled.div(_templateObject3(), maxWidthContent);
var Wrapper = styled.div(_templateObject4(), function (props) {
  return props.size === 's' ? mobileMaxWidthWrapper : maxWidthWrapper;
});

var getColorFromType = function getColorFromType(type) {
  switch (type) {
    case 'error':
      return 'red';

    case 'info':
      return 'blue';

    case 'success':
      return 'green';

    case 'warning':
    default:
      return 'yellow';
  }
};

var getIconFromType = function getIconFromType(type) {
  switch (type) {
    case 'error':
      return 'error-severe';

    case 'info':
      return 'info';

    case 'success':
      return 'tick-circle';

    case 'warning':
    default:
      return 'Warning important';
  }
};

var Toast = function Toast(props) {
  var children = props.children,
      size = props.size,
      type = props.type;
  var iconHeight = size === 's' ? 20 : 32;
  var iconWidth = size === 's' ? 20 : 32;
  return React.createElement(Wrapper, {
    size: size
  }, React.createElement(RootContainer, {
    type: type,
    size: size
  }, React.createElement(MyIcon, {
    icon: getIconFromType(type),
    height: iconHeight,
    width: iconWidth,
    color: getColorFromType(type)
  }), React.createElement(ContentContainer, null, children)));
};

Toast.propTypes = {
  /** String, the type of the toast to display */
  type: PropTypes.oneOf(['error', 'warning', 'info', 'success']).isRequired,

  /** String, the size of the panel */
  size: PropTypes.oneOf(['s', 'm']).isRequired,

  /** Node, the contents of the toast */
  children: PropTypes.node.isRequired
};

var quot = /"/g;

// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
// https://tc39.github.io/ecma262/#sec-createhtml
var createHtml = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
var stringHtmlForced = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};

// `String.prototype.bold` method
// https://tc39.github.io/ecma262/#sec-string.prototype.bold
_export({ target: 'String', proto: true, forced: stringHtmlForced('bold') }, {
  bold: function bold() {
    return createHtml(this, 'b', '', '');
  }
});

var fontSizeBase$1 = 16;
var headlineXXS = 20 / fontSizeBase$1;
var headlineXS = 24 / fontSizeBase$1;
var headlineS = 30 / fontSizeBase$1;
var headlineM = 34 / fontSizeBase$1;
var headlineL = 40 / fontSizeBase$1;
var headlineXL = 50 / fontSizeBase$1;
var headlineXXL = 60 / fontSizeBase$1;
var headlineLetterSpacing = -0.85 / fontSizeBase$1;
var textS = 14 / fontSizeBase$1;
var textM = 16 / fontSizeBase$1;
var textL = 18 / fontSizeBase$1;

function _templateObject$2() {
  var data = _taggedTemplateLiteral$2(["\n  font-size: ", ";\n  line-height: 125%;\n  font-weight: ", ";\n  color: ", ";\n  margin: 0;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$2(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Text = styled('p')(_templateObject$2(), function (props) {
  switch (props.size) {
    case 's':
      return "".concat(textS, "rem");

    case 'm':
      return "".concat(textM, "rem");

    case 'l':
      return "".concat(textL, "rem");

    default:
      return "".concat(textM, "rem");
  }
}, function (props) {
  return props.bold ? 'bold' : 'normal';
}, function (props) {
  switch (props.color) {
    case 'black':
      return black;

    case 'white':
      return white;

    case 'orange':
      return orange2;

    case 'darkOrange':
      return orange1;

    case 'grey':
      return grey2;

    case 'darkGrey':
      return grey3;

    case 'red':
      return functionalRed;

    default:
      return black;
  }
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ToastService =
/*#__PURE__*/
function () {
  function ToastService() {
    var defaultToastTimeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;

    _classCallCheck(this, ToastService);

    this.toastQueue = []; // Controls how much time (ms) there is between the moment when toast n disappears and toast n+1 appears on screen

    this.defaultToastTimeout = defaultToastTimeout;
    this.enqueueToastComponent = this.enqueueToastComponent.bind(this);
    this.enqueueToastSimple = this.enqueueToastSimple.bind(this);
    this.dequeueAndDisplay = this.dequeueAndDisplay.bind(this);
  }

  _createClass(ToastService, [{
    key: "enqueueToastComponent",
    value: function enqueueToastComponent(component, timeToDisplay, callback) {
      // Save the insertion index
      var toastIndex = this.toastQueue.length;
      this.toastQueue.push({
        component: component,
        timeToDisplay: timeToDisplay,
        callback: callback
      }); // If this is the only element in the queue, process it now

      if (this.toastQueue.length === 1) {
        this.dequeueAndDisplay();
      }

      return toastIndex;
    }
  }, {
    key: "enqueueToastSimple",
    value: function enqueueToastSimple(text) {
      var timeToDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        size: 's',
        type: 'success'
      };
      var callback = arguments.length > 3 ? arguments[3] : undefined;
      var size = options.size,
          type = options.type;
      this.enqueueToastComponent(React.createElement(Toast, {
        size: size || 's',
        type: type || 'success'
      }, React.createElement(Text, {
        bold: true
      }, text)), timeToDisplay, callback);
    }
  }, {
    key: "dequeueAndDisplay",
    value: function dequeueAndDisplay() {
      var _this = this;

      var nextToast = this.toastQueue[0];
      ToastService.displayToast(nextToast);
      setTimeout(function () {
        ToastService.hideToast();

        if (typeof nextToast.callback === 'function') {
          nextToast.callback();
        }

        _this.toastQueue.shift();
      }, nextToast.timeToDisplay); // Register the timeout for the next dequeue if there is at least one toast in the queue

      setTimeout(function () {
        if (_this.toastQueue.length > 0) {
          _this.dequeueAndDisplay();
        }
      }, nextToast.timeToDisplay + this.defaultToastTimeout);
    }
  }], [{
    key: "displayToast",
    value: function displayToast(toast) {
      var toastContainer = document.getElementById('toast-container');

      if (!toastContainer) {
        var container = ToastService.getContainerElement();
        document.body.appendChild(container);
      }

      toastContainer = document.getElementById('toast-container');
      ReactDOM.render(toast.component, toastContainer, function () {
        setTimeout(function () {
          toastContainer.style.top = '90%';
        }, 0);
      });
    }
  }, {
    key: "hideToast",
    value: function hideToast() {
      var toastContainer = document.getElementById('toast-container');

      if (!toastContainer) {
        return;
      }

      toastContainer.style.top = '100%';
    }
  }, {
    key: "getContainerElement",
    value: function getContainerElement() {
      var el = document.createElement('div');
      el.setAttribute('id', 'toast-container');
      el.style.position = 'fixed';
      el.style.width = '100%';
      el.style.top = '100%';
      el.style.display = 'flex';
      el.style.flexDirection = 'row';
      el.style.justifyContent = 'center';
      el.style.fontFamily = 'o-HelveticaNeue, Arial, sans-serif';
      el.style.transition = 'top 0.5s ease-in';
      return el;
    }
  }]);

  return ToastService;
}();

var ToastService$1 = new ToastService();

var defineProperty$5 = objectDefineProperty.f;


var NativeSymbol = global_1.Symbol;

if (descriptors && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty$5(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  _export({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');

var correctPrototypeGetter = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$1 = sharedKey('IE_PROTO');
var ObjectPrototype$1 = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO$1)) return O[IE_PROTO$1];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype$1 : null;
};

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if ( !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;

var createIteratorConstructor = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  return IteratorConstructor;
};

var aPossiblePrototype = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis$1 = function () { return this; };

var defineIterator = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype$2 !== Object.prototype && CurrentIteratorPrototype.next) {
      if ( objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$1] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR$1, returnThis$1);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ( IterablePrototype[ITERATOR$1] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR$1, defaultIterator);
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = internalState.set;
var getInternalState$1 = internalState.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
_export({ target: 'Object', stat: true, sham: !descriptors }, {
  create: objectCreate
});

var FAILS_ON_PRIMITIVES$2 = fails(function () { objectGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
_export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$2, sham: !correctPrototypeGetter }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return objectGetPrototypeOf(toObject(it));
  }
});

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
_export({ target: 'Object', stat: true }, {
  setPrototypeOf: objectSetPrototypeOf
});

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
var objectToString = toStringTagSupport ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!toStringTagSupport) {
  redefine(Object.prototype, 'toString', objectToString, { unsafe: true });
}

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$2 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$2(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$2(true)
};

var charAt = stringMultibyte.charAt;



var STRING_ITERATOR = 'String Iterator';
var setInternalState$2 = internalState.set;
var getInternalState$2 = internalState.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState$2(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$2(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var ITERATOR$2 = wellKnownSymbol('iterator');
var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
var ArrayValues = es_array_iterator.values;

for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$2] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$3]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$3, COLLECTION_NAME);
    }
    if (domIterables[COLLECTION_NAME]) for (var METHOD_NAME in es_array_iterator) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, es_array_iterator[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = es_array_iterator[METHOD_NAME];
      }
    }
  }
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral$3(["\n  font-size: ", ";\n  font-weight: bold;\n  color: ", ";\n  margin: 0;\n  line-height: 100%;\n  letter-spacing: ", "rem;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$3(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Headline = styled('p')(_templateObject$3(), function (props) {
  switch (props.size) {
    case 'xxs':
      return "".concat(headlineXXS, "rem");

    case 'xs':
      return "".concat(headlineXS, "rem");

    case 's':
      return "".concat(headlineS, "rem");

    case 'm':
      return "".concat(headlineM, "rem");

    case 'l':
      return "".concat(headlineL, "rem");

    case 'xl':
      return "".concat(headlineXL, "rem");

    case 'xxl':
      return "".concat(headlineXXL, "rem");

    default:
      return "".concat(headlineS, "rem");
  }
}, function (props) {
  switch (props.color) {
    case 'black':
      return black;

    case 'white':
      return white;

    case 'orange':
      return orange2;

    case 'darkOrange':
      return orange1;

    case 'grey':
      return grey2;

    case 'darkGrey':
      return grey3;

    default:
      return black;
  }
}, headlineLetterSpacing);

var fontSizeBase$2 = 16;
var paddingTopHeader = 10 / fontSizeBase$2;
var paddingSideHeader = 20 / fontSizeBase$2;
var marginIcons = 10 / fontSizeBase$2;
var borderArrowSize = 7 / fontSizeBase$2;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject6() {
  var data = _taggedTemplateLiteral$4(["\n  background-color: ", ";\n  border-top: 1px solid ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral$4(["\n  flex: 1 1 0rem;\n  margin-left: ", ";\n  margin-right: ", "rem;\n\n  ", " & {\n    color: ", ";\n  }\n\n  ", ":hover & {\n    color: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteral$4(["\n  border-left: ", "rem solid transparent;\n  border-right: ", "rem solid transparent;\n  border-bottom: ", ";\n  transform: ", ";\n\n  ", ":hover & {\n    border-bottom-color: ", ";\n  }\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral$4(["\n  ", " & ", " {\n    fill: ", ";\n  }\n\n  ", ":hover & ", " {\n    fill: ", ";\n  }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral$4(["\n  display: flex;\n  align-items: center;\n  padding: ", "rem ", "rem;\n  background-color: ", ";\n  cursor: pointer;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral$4([""]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$4(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container = styled('div')(_templateObject$4());
var AccordionHeader = styled('div')(_templateObject2$2(), paddingTopHeader, paddingSideHeader, function (props) {
  return props.dark ? black : white;
});
var AccordionIcon = styled(Icon)(_templateObject3$1(), AccordionHeader, IconPath, function (props) {
  return props.dark ? white : black;
}, AccordionHeader, IconPath, function (props) {
  return props.dark ? orange1 : orange2;
});
var AccordionArrow = styled('div')(_templateObject4$1(), borderArrowSize, borderArrowSize, function (props) {
  return props.dark ? "".concat(borderArrowSize, "rem solid ").concat(white) : "".concat(borderArrowSize, "rem solid ").concat(black);
}, function (props) {
  return props.isClosed ? 'rotate(180deg)' : undefined;
}, AccordionHeader, function (props) {
  return props.dark ? orange1 : orange2;
});
var AccordionTitle = styled(Text)(_templateObject5(), function (props) {
  return props.hasLeftMargin ? "".concat(marginIcons, "rem") : undefined;
}, marginIcons, AccordionHeader, function (props) {
  return props.dark ? white : black;
}, AccordionHeader, function (props) {
  return props.dark ? orange1 : orange2;
});
var Content = styled('div')(_templateObject6(), function (props) {
  return props.dark ? black : white;
}, grey4);

var Accordion =
/*#__PURE__*/
function (_Component) {
  _inherits(Accordion, _Component);

  function Accordion(props) {
    var _this;

    _classCallCheck$1(this, Accordion);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Accordion).call(this, props));
    _this.handleTriggerClick = _this.handleTriggerClick.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_assertThisInitialized(_this));
    _this.continueOpenCollapsible = _this.continueOpenCollapsible.bind(_assertThisInitialized(_this));

    if (props.closed) {
      _this.state = {
        isClosed: true,
        shouldSwitchAutoOnNextCycle: false,
        height: 0,
        transition: "height ".concat(props.transitionTime, "ms ").concat(props.easing),
        overflow: 'hidden',
        inTransition: false
      };
    } else {
      _this.state = {
        isClosed: false,
        shouldSwitchAutoOnNextCycle: false,
        height: 'auto',
        transition: 'none',
        overflow: undefined,
        inTransition: false
      };
    }

    _this.contentElement = React.createRef();
    return _this;
  }

  _createClass$1(Accordion, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var closed = this.props.closed;
      var _this$state = this.state,
          shouldOpenOnNextCycle = _this$state.shouldOpenOnNextCycle,
          shouldSwitchAutoOnNextCycle = _this$state.shouldSwitchAutoOnNextCycle;

      if (shouldOpenOnNextCycle) {
        this.continueOpenCollapsible();
      }

      if (prevState.height === 'auto' && shouldSwitchAutoOnNextCycle === true) {
        window.setTimeout(function () {
          // Set small timeout to ensure a true re-render
          _this2.setState({
            height: 0,
            overflow: 'hidden',
            isClosed: true,
            shouldSwitchAutoOnNextCycle: false
          });
        }, 50);
      }

      if (prevProps.closed !== closed) {
        if (closed === true) {
          this.closeCollapsible();
        } else {
          this.openCollapsible();
        }
      }
    }
  }, {
    key: "openCollapsible",
    value: function openCollapsible() {
      this.setState({
        inTransition: true,
        shouldOpenOnNextCycle: true
      });
    }
  }, {
    key: "closeCollapsible",
    value: function closeCollapsible() {
      var _this$props = this.props,
          transitionTime = _this$props.transitionTime,
          easing = _this$props.easing;
      this.setState({
        shouldSwitchAutoOnNextCycle: true,
        height: this.contentElement.current.offsetHeight,
        transition: "height ".concat(transitionTime, "ms ").concat(easing),
        inTransition: true
      });
    }
  }, {
    key: "continueOpenCollapsible",
    value: function continueOpenCollapsible() {
      var _this$props2 = this.props,
          transitionTime = _this$props2.transitionTime,
          easing = _this$props2.easing;
      this.setState({
        height: this.contentElement.current.offsetHeight,
        transition: "height ".concat(transitionTime, "ms ").concat(easing),
        isClosed: false,
        inTransition: true,
        shouldOpenOnNextCycle: false
      });
    }
  }, {
    key: "handleTriggerClick",
    value: function handleTriggerClick(event) {
      var _this$props3 = this.props,
          onOpen = _this$props3.onOpen,
          onClose = _this$props3.onClose;
      var _this$state2 = this.state,
          inTransition = _this$state2.inTransition,
          isClosed = _this$state2.isClosed;
      event.preventDefault();

      if (inTransition) {
        return;
      }

      if (isClosed === true) {
        this.openCollapsible();

        if (onOpen !== undefined) {
          onOpen();
        }
      } else {
        this.closeCollapsible();

        if (onClose !== undefined) {
          onClose();
        }
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      e.stopPropagation();

      if (e.which === 13 || e.which === 32) {
        this.handleTriggerClick(e);
      }
    }
  }, {
    key: "handleTransitionEnd",
    value: function handleTransitionEnd() {
      var _this$props4 = this.props,
          onOpened = _this$props4.onOpened,
          onClosed = _this$props4.onClosed;
      var isClosed = this.state.isClosed;

      if (!isClosed) {
        this.setState({
          height: 'auto',
          overflow: undefined,
          inTransition: false
        });

        if (onOpened !== undefined) {
          onOpened();
        }
      } else {
        this.setState({
          inTransition: false
        });

        if (onClosed !== undefined) {
          onClosed();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          darkHeader = _this$props5.darkHeader,
          darkContent = _this$props5.darkContent,
          icon = _this$props5.icon,
          iconSize = _this$props5.iconSize,
          iconRotate = _this$props5.iconRotate,
          title = _this$props5.title,
          children = _this$props5.children,
          rest = _objectWithoutProperties$1(_this$props5, ["darkHeader", "darkContent", "icon", "iconSize", "iconRotate", "title", "children"]);

      var _this$state3 = this.state,
          height = _this$state3.height,
          transition = _this$state3.transition,
          overflow = _this$state3.overflow,
          isClosed = _this$state3.isClosed;
      var contentStyle = {
        height: height,
        WebkitTransition: transition,
        msTransition: transition,
        transition: transition,
        overflow: overflow
      };
      return React.createElement(Container, rest, React.createElement(AccordionHeader, {
        onClick: this.handleTriggerClick,
        onKeyDown: this.handleKeyDown,
        dark: darkHeader,
        role: "button",
        tabIndex: 0,
        "aria-expanded": !isClosed
      }, icon ? React.createElement(AccordionIcon, {
        dark: darkHeader,
        icon: icon,
        height: iconSize,
        width: iconSize,
        rotate: iconRotate
      }) : undefined, React.createElement(AccordionTitle, {
        bold: true,
        hasLeftMargin: icon !== undefined,
        dark: darkHeader
      }, title), React.createElement(AccordionArrow, {
        dark: darkHeader,
        isClosed: isClosed
      })), React.createElement("div", {
        style: contentStyle,
        onTransitionEnd: this.handleTransitionEnd,
        "aria-hidden": isClosed
      }, React.createElement(Content, {
        dark: darkContent,
        ref: this.contentElement
      }, children)));
    }
  }]);

  return Accordion;
}(Component);

Accordion.defaultProps = {
  darkHeader: false,
  darkContent: false,
  closed: false,
  transitionTime: 200,
  easing: 'linear',
  iconRotate: 0,
  icon: undefined,
  iconSize: 32,
  children: undefined,
  onOpen: undefined,
  onClose: undefined,
  onOpened: undefined,
  onClosed: undefined
};
Accordion.propTypes = {
  /** Boolean indicating if the accordion header is in dark theme */
  darkHeader: PropTypes.bool,

  /** Boolean indicating if the accordion content is in dark theme */
  darkContent: PropTypes.bool,

  /** Boolean indicating when the accordion should be closed */
  closed: PropTypes.bool,

  /** Number indicating the transition time for the closing effect */
  transitionTime: PropTypes.number,

  /** String indicating the transition type for the closing effect */
  easing: PropTypes.oneOf(['linear', 'ease', 'ease-in', 'ease-in-out', 'ease-out', 'step-start', 'step-end']),

  /** Number indicating the rotation in degree for the icon */
  iconRotate: PropTypes.number,

  /** String indicating the title of the accordion */
  title: PropTypes.string.isRequired,

  /** String indicating the name of the icon to apply */
  icon: PropTypes.string,

  /** Size of the icon */
  iconSize: PropTypes.number,

  /** Node inside the accordion */
  children: PropTypes.node,

  /** Function triggered when the accordion is opening */
  onOpen: PropTypes.func,

  /** Function triggered when the accordion is closing */
  onClose: PropTypes.func,

  /** Function triggered when the accordion is opened */
  onOpened: PropTypes.func,

  /** Function triggered when the accordion is closed */
  onClosed: PropTypes.func
};

var fontSizeBase$3 = 16;
var textS$1 = 14 / fontSizeBase$3;
var textM$1 = 16 / fontSizeBase$3;
var border = 2 / fontSizeBase$3;
var heightS = 30 / fontSizeBase$3;
var heightM = 40 / fontSizeBase$3;
var heightL = 50 / fontSizeBase$3;
var paddingS = 10 / fontSizeBase$3;
var paddingM = 20 / fontSizeBase$3;
var paddingL = 30 / fontSizeBase$3;
var marginIcon = 8 / fontSizeBase$3;
var heightIconS = 15;
var heightIconM = 25;
var heightIconL = 35;

function _templateObject$5() {
  var data = _taggedTemplateLiteral$5(["\n  font-family: o-HelveticaNeue, Arial, sans-serif;\n  font-weight: bold;\n  font-size: ", ";\n  border-style: solid;\n  border-width: ", "rem;\n  height: ", ";\n  min-width: ", ";\n  padding: ", ";\n  cursor: pointer;\n  outline: 0;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  & > div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: ", ";\n\n    & > span {\n      margin-right: ", ";\n\n      margin-left: ", ";\n    }\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$5(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Button = styled('button')(_templateObject$5(), function (props) {
  switch (props.size) {
    case 's':
      return "".concat(textS$1, "rem");

    case 'm':
    case 'l':
      return "".concat(textM$1, "rem");

    default:
      return "".concat(textS$1, "rem");
  }
}, border, function (props) {
  switch (props.size) {
    case 's':
      return "".concat(heightS, "rem");

    case 'm':
      return "".concat(heightM, "rem");

    case 'l':
      return "".concat(heightL, "rem");

    default:
      return "".concat(heightS, "rem");
  }
}, function (props) {
  switch (props.size) {
    case 's':
      return "".concat(heightS, "rem");

    case 'm':
      return "".concat(heightM, "rem");

    case 'l':
      return "".concat(heightL, "rem");

    default:
      return "".concat(heightS, "rem");
  }
}, function (props) {
  switch (props.paddingSize) {
    case 's':
      return "0 ".concat(paddingS, "rem");

    case 'l':
      return "0 ".concat(paddingL, "rem");

    case 'none':
      return '0';

    case 'm':
    default:
      return "0 ".concat(paddingM, "rem");
  }
}, function (props) {
  return props.iconPosition === 'right' ? 'row-reverse' : 'row';
}, function (props) {
  if (props.children.props.children[0] === undefined || props.iconPosition === 'left') {
    return undefined;
  }

  return "".concat(marginIcon, "rem");
}, function (props) {
  if (props.children.props.children[0] === undefined || props.iconPosition !== 'left') {
    return undefined;
  }

  return "".concat(marginIcon, "rem");
});

function _templateObject$6() {
  var data = _taggedTemplateLiteral$6(["\n  border-color: ", ";\n  background-color: transparent;\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active:enabled,\n  &.active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: transparent;\n    color: ", ";\n  }\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$6(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StandardOutlineButton = styled(Button)(_templateObject$6(), black, black, black, black, white, orange2, orange2, white, grey4, grey4);

function _templateObject$7() {
  var data = _taggedTemplateLiteral$7(["\n  border-color: ", ";\n  background-color: transparent;\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active:enabled,\n  &.active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: transparent;\n    color: ", ";\n  }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$7(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DarkStandardOutlineButton = styled(Button)(_templateObject$7(), white, white, white, black, orange2, orange2, white, grey2, grey2);

function _templateObject$8() {
  var data = _taggedTemplateLiteral$8(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    background-color: transparent;\n    color: ", ";\n  }\n\n  &:active:enabled,\n  &.active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$8(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StandardFillButton = styled(Button)(_templateObject$8(), black, black, white, black, orange2, orange2, white, grey4, grey4, white);

function _templateObject$9() {
  var data = _taggedTemplateLiteral$9(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    background-color: transparent;\n    color: ", ";\n  }\n\n  &:active:enabled,\n  &.active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$9(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DarkStandardFillButton = styled(Button)(_templateObject$9(), white, white, black, white, orange2, orange2, white, grey2, grey2, black);

function _templateObject$a() {
  var data = _taggedTemplateLiteral$a(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active:enabled,\n  &.active:enabled {\n    border-color: ", ";\n    background-color: transparent;\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$a(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ImportantButton = styled(Button)(_templateObject$a(), orange2, orange2, white, black, black, white, black, black, grey4, grey4, white);

function _templateObject$b() {
  var data = _taggedTemplateLiteral$b(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active:enabled,\n  &.active:enabled {\n    border-color: ", ";\n    background-color: transparent;\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$b(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DarkImportantButton = styled(Button)(_templateObject$b(), orange2, orange2, white, white, white, black, white, white, grey2, grey2, black);

function _templateObject$c() {
  var data = _taggedTemplateLiteral$c(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active:enabled,\n  &.active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$c(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var PositiveButton = styled(Button)(_templateObject$c(), functionalGreen, functionalGreen, black, black, black, white, orange2, orange2, white, grey4, grey4, white);

function _templateObject$d() {
  var data = _taggedTemplateLiteral$d(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: ", ";\n  }\n\n  &:active:enabled,\n  &.active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$d(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DarkPositiveButton = styled(Button)(_templateObject$d(), functionalGreen, functionalGreen, black, white, white, orange2, orange2, white, grey2, grey2, black);

function _templateObject$e() {
  var data = _taggedTemplateLiteral$e(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active:enabled,\n  &.active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$e(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var NegativeButton = styled(Button)(_templateObject$e(), functionalRed, functionalRed, white, black, black, white, orange2, orange2, white, grey4, grey4, white);

function _templateObject$f() {
  var data = _taggedTemplateLiteral$f(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active:enabled,\n  &.active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$f(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DarkNegativeButton = styled(Button)(_templateObject$f(), functionalRed, functionalRed, white, white, white, black, orange2, orange2, white, grey2, grey2, black);

function _templateObject$g() {
  var data = _taggedTemplateLiteral$g(["\n  border-color: transparent;\n  background-color: transparent;\n  padding: 0;\n\n  &:hover:enabled,\n  &:active:enabled,\n  &.active:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: transparent;\n  }\n\n  &:disabled {\n    background-color: transparent;\n    border-color: transparent;\n  }\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$g(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var IconButton = styled(Button)(_templateObject$g(), grey4);

function _templateObject$h() {
  var data = _taggedTemplateLiteral$h(["\n  border-color: transparent;\n  background-color: transparent;\n  padding: 0;\n\n  &:hover:enabled,\n  &:active:enabled,\n  &.active:enabled\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: transparent;\n  }\n\n  &:disabled {\n    background-color: transparent;\n    border-color: transparent;\n  }\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$h(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DarkIconButton = styled(Button)(_templateObject$h(), grey2);

function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (call && (_typeof$1(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$1(self); }

function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf$1(o) { _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$1(o); }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$1(subClass, superClass); }

function _setPrototypeOf$1(o, p) { _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$1(o, p); }

function _templateObject2$3() {
  var data = _taggedTemplateLiteral$i(["\n  display:flex;\n  align-items: center;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$i() {
  var data = _taggedTemplateLiteral$i(["\n  ", " & ", ",\n  ", " & ", ",\n  ", " & ", " {\n    fill: ", "\n  }\n\n  ", " & ", ",\n  ", " & ", ",\n  ", " & ", " {\n    fill: ", "\n  }\n\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":active:enabled & ", ",\n  ", ".active:enabled & ", ",\n  ", ":active:enabled & ", ",\n  ", ".active:enabled & ", ",\n  ", ":active:enabled & ", ",\n  ", ".active:enabled & ", ",\n  ", ":active:enabled & ", ",\n  ", ".active:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":active:enabled & ", ",\n  ", ".active:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":active:enabled & ", ",\n  ", ".active:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":disabled & ", ",\n  ", ":disabled & ", "  {\n    fill: ", "\n  }\n\n  ", ":disabled & ", ",\n  ", ":disabled & ", ",\n  ", ":disabled & ", ",\n  ", ":disabled & ", " {\n    fill: ", "\n  }\n\n\n  ", " & ", ",\n  ", " & ", ",\n  ", " & ", ",\n  ", " & ", " {\n    fill: ", "\n  }\n\n  ", " & ", ",\n  ", " & ", " {\n    fill: ", "\n  }\n\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":active:enabled & ", ",\n  ", ".active:enabled & ", ",\n  ", ":active:enabled & ", ",\n  ", ".active:enabled & ", ",\n  ", ":active:enabled & ", ",\n  ", ".active:enabled & ", ",\n  ", ":active:enabled & ", ",\n  ", ".active:enabled & ", ",\n  ", ":active:enabled & ", ",\n  ", ".active:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":active:enabled & ", ",\n  ", ".active:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":disabled & ", ",\n  ", ":disabled & ", " {\n    fill: ", "\n  }\n\n  ", ":disabled & ", ",\n  ", ":disabled & ", ",\n  ", ":disabled & ", ",\n  ", ":disabled & ", " {\n    fill: ", "\n  }\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$i(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ButtonIcon = styled(Icon)(_templateObject$i(), StandardOutlineButton, IconPath, PositiveButton, IconPath, IconButton, IconPath, black, StandardFillButton, IconPath, ImportantButton, IconPath, NegativeButton, IconPath, white, StandardOutlineButton, IconPath, StandardOutlineButton, IconPath, ImportantButton, IconPath, ImportantButton, IconPath, PositiveButton, IconPath, PositiveButton, IconPath, NegativeButton, IconPath, NegativeButton, IconPath, white, StandardFillButton, IconPath, StandardFillButton, IconPath, IconButton, IconPath, IconButton, IconPath, black, StandardOutlineButton, IconPath, StandardOutlineButton, IconPath, StandardFillButton, IconPath, StandardFillButton, IconPath, PositiveButton, IconPath, PositiveButton, IconPath, NegativeButton, IconPath, NegativeButton, IconPath, white, ImportantButton, IconPath, ImportantButton, IconPath, black, IconButton, IconPath, IconButton, IconPath, orange2, StandardOutlineButton, IconPath, IconButton, IconPath, grey4, StandardFillButton, IconPath, ImportantButton, IconPath, PositiveButton, IconPath, NegativeButton, IconPath, white, DarkStandardOutlineButton, IconPath, DarkImportantButton, IconPath, DarkNegativeButton, IconPath, DarkIconButton, IconPath, white, DarkStandardFillButton, IconPath, DarkPositiveButton, IconPath, black, DarkStandardOutlineButton, IconPath, DarkStandardOutlineButton, IconPath, DarkImportantButton, IconPath, DarkImportantButton, IconPath, DarkPositiveButton, IconPath, DarkPositiveButton, IconPath, DarkNegativeButton, IconPath, DarkNegativeButton, IconPath, black, DarkStandardFillButton, IconPath, DarkStandardFillButton, IconPath, DarkIconButton, IconPath, DarkIconButton, IconPath, white, DarkStandardOutlineButton, IconPath, DarkStandardOutlineButton, IconPath, DarkStandardFillButton, IconPath, DarkStandardFillButton, IconPath, DarkImportantButton, IconPath, DarkImportantButton, IconPath, DarkPositiveButton, IconPath, DarkPositiveButton, IconPath, DarkNegativeButton, IconPath, DarkNegativeButton, IconPath, white, DarkIconButton, IconPath, DarkIconButton, IconPath, orange2, DarkStandardOutlineButton, IconPath, DarkIconButton, IconPath, grey2, DarkStandardFillButton, IconPath, DarkImportantButton, IconPath, DarkPositiveButton, IconPath, DarkNegativeButton, IconPath, black);
var ButtonText = styled('span')(_templateObject2$3());

var Button$1 =
/*#__PURE__*/
function (_Component) {
  _inherits$1(Button, _Component);

  _createClass$2(Button, null, [{
    key: "getIconSize",
    value: function getIconSize(size) {
      switch (size) {
        case 's':
          return heightIconS;

        case 'm':
          return heightIconM;

        case 'l':
          return heightIconL;

        default:
          return heightIconM;
      }
    }
  }]);

  function Button(props) {
    var _this;

    _classCallCheck$2(this, Button);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(Button).call(this, props));
    _this.ref = React.createRef();
    return _this;
  }

  _createClass$2(Button, [{
    key: "focusButton",
    value: function focusButton() {
      this.ref.current.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          htmlType = _this$props.htmlType,
          type = _this$props.type,
          size = _this$props.size,
          paddingSize = _this$props.paddingSize,
          iconPosition = _this$props.iconPosition,
          iconSize = _this$props.iconSize,
          disabled = _this$props.disabled,
          children = _this$props.children,
          icon = _this$props.icon,
          iconRotate = _this$props.iconRotate,
          onClick = _this$props.onClick,
          rest = _objectWithoutProperties$2(_this$props, ["htmlType", "type", "size", "paddingSize", "iconPosition", "iconSize", "disabled", "children", "icon", "iconRotate", "onClick"]);

      var text = children ? React.createElement(ButtonText, null, children) : undefined;
      var localIcon = icon ? React.createElement(ButtonIcon, {
        icon: icon,
        width: iconSize === undefined ? Button.getIconSize(size) : iconSize,
        height: iconSize === undefined ? Button.getIconSize(size) : iconSize,
        rotate: iconRotate
      }) : undefined;
      var ButtonType;

      switch (type) {
        case 'standardDark':
          ButtonType = DarkStandardOutlineButton;
          break;

        case 'fill':
          ButtonType = StandardFillButton;
          break;

        case 'fillDark':
          ButtonType = DarkStandardFillButton;
          break;

        case 'important':
          ButtonType = ImportantButton;
          break;

        case 'importantDark':
          ButtonType = DarkImportantButton;
          break;

        case 'positive':
          ButtonType = PositiveButton;
          break;

        case 'positiveDark':
          ButtonType = DarkPositiveButton;
          break;

        case 'negative':
          ButtonType = NegativeButton;
          break;

        case 'negativeDark':
          ButtonType = DarkNegativeButton;
          break;

        case 'icon':
          ButtonType = IconButton;
          break;

        case 'iconDark':
          ButtonType = DarkIconButton;
          break;

        default:
          ButtonType = StandardOutlineButton;
      }

      return React.createElement(ButtonType, _extends$1({}, rest, {
        ref: this.ref,
        size: size,
        paddingSize: paddingSize,
        iconPosition: iconPosition,
        disabled: disabled,
        onClick: onClick,
        type: htmlType
      }), React.createElement("div", null, localIcon, text));
    }
  }]);

  return Button;
}(Component);

Button$1.allowedTypes = ['standard', 'fill', 'important', 'positive', 'negative', 'icon', 'standardDark', 'fillDark', 'importantDark', 'positiveDark', 'negativeDark', 'iconDark'];
Button$1.defaultProps = {
  children: undefined,
  type: 'standard',
  htmlType: 'button',
  size: 'm',
  paddingSize: 'm',
  icon: undefined,
  iconPosition: 'left',
  iconRotate: 0,
  iconSize: undefined,
  disabled: false,
  onClick: undefined
};
Button$1.propTypes = {
  /** Node inside the button */
  children: PropTypes.node,

  /** String indicating the type of button */
  type: PropTypes.oneOf(Button$1.allowedTypes),

  /** String indicating the html type of button */
  htmlType: PropTypes.oneOf(['button', 'submit', 'reset']),

  /** String indicating the size of button */
  size: PropTypes.oneOf(['s', 'm', 'l']),

  /** String indicating the padding size of button */
  paddingSize: PropTypes.oneOf(['s', 'm', 'l', 'none']),

  /** String indicating the name of the icon to apply */
  icon: PropTypes.string,

  /** String indicating the position of the icon */
  iconPosition: PropTypes.oneOf(['left', 'right']),

  /** Number indicating the rotation in degree for the icon */
  iconRotate: PropTypes.number,

  /** Number to customize the size of the icon */
  iconSize: PropTypes.number,

  /** Boolean indicating if the button should be disabled */
  disabled: PropTypes.bool,

  /** onClick handler */
  onClick: PropTypes.func
};

function _templateObject$j() {
  var data = _taggedTemplateLiteral$j(["\n  box-sizing: border-box;\n  text-decoration: none;\n  font-weight: bold;\n  font-size: ", ";\n  border-style: solid;\n  border-width: ", "rem;\n  height: ", ";\n  min-width: ", ";\n  padding: ", ";\n  cursor: pointer;\n  outline: 0;\n\n  &:disabled {\n    cursor: initial;\n  }\n\n  & > div {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: ", ";\n\n    & > span {\n      margin-right: ", ";\n\n      margin-left: ", ";\n    }\n  }\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$j(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Button$2 = styled(Link)(_templateObject$j(), function (props) {
  switch (props.size) {
    case 's':
      return "".concat(textS$1, "rem");

    case 'm':
    case 'l':
      return "".concat(textM$1, "rem");

    default:
      return "".concat(textS$1, "rem");
  }
}, border, function (props) {
  switch (props.size) {
    case 's':
      return "".concat(heightS, "rem");

    case 'm':
      return "".concat(heightM, "rem");

    case 'l':
      return "".concat(heightL, "rem");

    default:
      return "".concat(heightS, "rem");
  }
}, function (props) {
  switch (props.size) {
    case 's':
      return "".concat(heightS, "rem");

    case 'm':
      return "".concat(heightM, "rem");

    case 'l':
      return "".concat(heightL, "rem");

    default:
      return "".concat(heightS, "rem");
  }
}, function (props) {
  switch (props.paddingSize) {
    case 's':
      return "0 ".concat(paddingS, "rem");

    case 'm':
      return "0 ".concat(paddingM, "rem");

    case 'l':
      return "0 ".concat(paddingL, "rem");

    default:
      return "0 ".concat(paddingM, "rem");
  }
}, function (props) {
  return props.iconPosition === 'right' ? 'row-reverse' : 'row';
}, function (props) {
  if (props.children.props.children[0] === undefined || props.iconPosition === 'left') {
    return undefined;
  }

  return "".concat(marginIcon, "rem");
}, function (props) {
  if (props.children.props.children[0] === undefined || props.iconPosition !== 'left') {
    return undefined;
  }

  return "".concat(marginIcon, "rem");
});

function _templateObject$k() {
  var data = _taggedTemplateLiteral$k(["\n  border-color: ", ";\n  background-color: transparent;\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: transparent;\n    color: ", ";\n  }\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$k(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StandardOutlineButton$1 = styled(Button$2)(_templateObject$k(), black, black, black, black, white, orange2, orange2, white, grey4, grey4);

function _templateObject$l() {
  var data = _taggedTemplateLiteral$l(["\n  border-color: ", ";\n  background-color: transparent;\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: transparent;\n    color: ", ";\n  }\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$l(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DarkStandardOutlineButton$1 = styled(Button$2)(_templateObject$l(), white, white, white, black, orange2, orange2, white, grey2, grey2);

function _templateObject$m() {
  var data = _taggedTemplateLiteral$m(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    background-color: transparent;\n    color: ", ";\n  }\n\n  &:active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$m(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StandardFillButton$1 = styled(Button$2)(_templateObject$m(), black, black, white, black, orange2, orange2, white, grey4, grey4, white);

function _templateObject$n() {
  var data = _taggedTemplateLiteral$n(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    background-color: transparent;\n    color: ", ";\n  }\n\n  &:active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$n(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DarkStandardFillButton$1 = styled(Button$2)(_templateObject$n(), white, white, black, white, orange2, orange2, white, grey2, grey2, black);

function _templateObject$o() {
  var data = _taggedTemplateLiteral$o(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active:enabled {\n    border-color: ", ";\n    background-color: transparent;\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$o(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ImportantButton$1 = styled(Button$2)(_templateObject$o(), orange2, orange2, white, black, black, white, black, black, grey4, grey4, white);

function _templateObject$p() {
  var data = _taggedTemplateLiteral$p(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active:enabled {\n    border-color: ", ";\n    background-color: transparent;\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$p(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DarkImportantButton$1 = styled(Button$2)(_templateObject$p(), orange2, orange2, white, white, white, black, white, white, grey2, grey2, black);

function _templateObject$q() {
  var data = _taggedTemplateLiteral$q(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$q(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var PositiveButton$1 = styled(Button$2)(_templateObject$q(), functionalGreen, functionalGreen, black, black, black, white, orange2, orange2, white, grey4, grey4, white);

function _templateObject$r() {
  var data = _taggedTemplateLiteral$r(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: ", ";\n  }\n\n  &:active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$r(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DarkPositiveButton$1 = styled(Button$2)(_templateObject$r(), functionalGreen, functionalGreen, black, white, white, orange2, orange2, white, grey2, grey2, black);

function _templateObject$s() {
  var data = _taggedTemplateLiteral$s(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$s(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var NegativeButton$1 = styled(Button$2)(_templateObject$s(), functionalRed, functionalRed, white, black, black, white, orange2, orange2, white, grey4, grey4, white);

function _templateObject$t() {
  var data = _taggedTemplateLiteral$t(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active:enabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$t(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DarkNegativeButton$1 = styled(Button$2)(_templateObject$t(), functionalRed, functionalRed, white, white, white, black, orange2, orange2, white, grey2, grey2, black);

function _templateObject$u() {
  var data = _taggedTemplateLiteral$u(["\n  border-color: transparent;\n  background-color: transparent;\n  padding: 0;\n\n  &:hover:enabled,\n  &:active:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: transparent;\n  }\n\n  &:disabled {\n    background-color: transparent;\n    border-color: transparent;\n  }\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$u(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var IconButton$1 = styled(Button$2)(_templateObject$u(), grey4);

function _templateObject$v() {
  var data = _taggedTemplateLiteral$v(["\n  border-color: transparent;\n  background-color: transparent;\n  padding: 0;\n\n  &:hover:enabled,\n  &:active:enabled,\n  &:focus:enabled {\n    border-color: ", ";\n    background-color: transparent;\n  }\n\n  &:disabled {\n    background-color: transparent;\n    border-color: transparent;\n  }\n"]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$v(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DarkIconButton$1 = styled(Button$2)(_templateObject$v(), grey2);

function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function _objectWithoutProperties$3(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$3(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$2(self, call) { if (call && (_typeof$2(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$2(self); }

function _assertThisInitialized$2(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf$2(o) { _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$2(o); }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$2(subClass, superClass); }

function _setPrototypeOf$2(o, p) { _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$2(o, p); }

function _templateObject$w() {
  var data = _taggedTemplateLiteral$w(["\n  ", " & ", ",\n  ", " & ", ",\n  ", " & ", " {\n    fill: ", "\n  }\n\n  ", " & ", ",\n  ", " & ", ",\n  ", " & ", " {\n    fill: ", "\n  }\n\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":active:enabled & ", ",\n  ", ":active:enabled & ", ",\n  ", ":active:enabled & ", ",\n  ", ":active:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":active:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":active:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":disabled & ", ",\n  ", ":disabled & ", "  {\n    fill: ", "\n  }\n\n  ", ":disabled & ", ",\n  ", ":disabled & ", ",\n  ", ":disabled & ", ",\n  ", ":disabled & ", " {\n    fill: ", "\n  }\n\n\n  ", " & ", ",\n  ", " & ", ",\n  ", " & ", ",\n  ", " & ", " {\n    fill: ", "\n  }\n\n  ", " & ", ",\n  ", " & ", " {\n    fill: ", "\n  }\n\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", ",\n  ", ":hover:enabled & ", ",\n  ", ":focus:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":active:enabled & ", ",\n  ", ":active:enabled & ", ",\n  ", ":active:enabled & ", ",\n  ", ":active:enabled & ", ",\n  ", ":active:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":active:enabled & ", " {\n    fill: ", "\n  }\n\n  ", ":disabled & ", ",\n  ", ":disabled & ", " {\n    fill: ", "\n  }\n\n  ", ":disabled & ", ",\n  ", ":disabled & ", ",\n  ", ":disabled & ", ",\n  ", ":disabled & ", " {\n    fill: ", "\n  }\n"]);

  _templateObject$w = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$w(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ButtonIcon$1 = styled(Icon)(_templateObject$w(), StandardOutlineButton$1, IconPath, PositiveButton$1, IconPath, IconButton$1, IconPath, black, StandardFillButton$1, IconPath, ImportantButton$1, IconPath, NegativeButton$1, IconPath, white, StandardOutlineButton$1, IconPath, StandardOutlineButton$1, IconPath, ImportantButton$1, IconPath, ImportantButton$1, IconPath, PositiveButton$1, IconPath, PositiveButton$1, IconPath, NegativeButton$1, IconPath, NegativeButton$1, IconPath, white, StandardFillButton$1, IconPath, StandardFillButton$1, IconPath, IconButton$1, IconPath, IconButton$1, IconPath, black, StandardOutlineButton$1, IconPath, StandardFillButton$1, IconPath, PositiveButton$1, IconPath, NegativeButton$1, IconPath, white, ImportantButton$1, IconPath, black, IconButton$1, IconPath, orange2, StandardOutlineButton$1, IconPath, IconButton$1, IconPath, grey4, StandardFillButton$1, IconPath, ImportantButton$1, IconPath, PositiveButton$1, IconPath, NegativeButton$1, IconPath, white, DarkStandardOutlineButton$1, IconPath, DarkImportantButton$1, IconPath, DarkNegativeButton$1, IconPath, DarkIconButton$1, IconPath, white, DarkStandardFillButton$1, IconPath, DarkPositiveButton$1, IconPath, black, DarkStandardOutlineButton$1, IconPath, DarkStandardOutlineButton$1, IconPath, DarkImportantButton$1, IconPath, DarkImportantButton$1, IconPath, DarkPositiveButton$1, IconPath, DarkPositiveButton$1, IconPath, DarkNegativeButton$1, IconPath, DarkNegativeButton$1, IconPath, black, DarkStandardFillButton$1, IconPath, DarkStandardFillButton$1, IconPath, DarkIconButton$1, IconPath, DarkIconButton$1, IconPath, white, DarkStandardOutlineButton$1, IconPath, DarkStandardFillButton$1, IconPath, DarkImportantButton$1, IconPath, DarkPositiveButton$1, IconPath, DarkNegativeButton$1, IconPath, white, DarkIconButton$1, IconPath, orange2, DarkStandardOutlineButton$1, IconPath, DarkIconButton$1, IconPath, grey2, DarkStandardFillButton$1, IconPath, DarkImportantButton$1, IconPath, DarkPositiveButton$1, IconPath, DarkNegativeButton$1, IconPath, black);

var Button$3 =
/*#__PURE__*/
function (_Component) {
  _inherits$2(Button, _Component);

  function Button() {
    _classCallCheck$3(this, Button);

    return _possibleConstructorReturn$2(this, _getPrototypeOf$2(Button).apply(this, arguments));
  }

  _createClass$3(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          size = _this$props.size,
          paddingSize = _this$props.paddingSize,
          iconPosition = _this$props.iconPosition,
          iconSize = _this$props.iconSize,
          disabled = _this$props.disabled,
          children = _this$props.children,
          icon = _this$props.icon,
          iconRotate = _this$props.iconRotate,
          rest = _objectWithoutProperties$3(_this$props, ["type", "size", "paddingSize", "iconPosition", "iconSize", "disabled", "children", "icon", "iconRotate"]);

      var text = children ? React.createElement("span", null, children) : undefined;
      var localIcon = icon ? React.createElement(ButtonIcon$1, {
        icon: icon,
        width: iconSize === undefined ? Button.getIconSize(size) : iconSize,
        height: iconSize === undefined ? Button.getIconSize(size) : iconSize,
        rotate: iconRotate
      }) : undefined;
      var ButtonType;

      switch (type) {
        case 'standardDark':
          ButtonType = DarkStandardOutlineButton$1;
          break;

        case 'fill':
          ButtonType = StandardFillButton$1;
          break;

        case 'fillDark':
          ButtonType = DarkStandardFillButton$1;
          break;

        case 'important':
          ButtonType = ImportantButton$1;
          break;

        case 'importantDark':
          ButtonType = DarkImportantButton$1;
          break;

        case 'positive':
          ButtonType = PositiveButton$1;
          break;

        case 'positiveDark':
          ButtonType = DarkPositiveButton$1;
          break;

        case 'negative':
          ButtonType = NegativeButton$1;
          break;

        case 'negativeDark':
          ButtonType = DarkNegativeButton$1;
          break;

        case 'icon':
          ButtonType = IconButton$1;
          break;

        case 'iconDark':
          ButtonType = DarkIconButton$1;
          break;

        default:
          ButtonType = StandardOutlineButton$1;
      }

      return React.createElement(ButtonType, _extends$2({}, rest, {
        size: size,
        paddingSize: paddingSize,
        iconPosition: iconPosition,
        disabled: disabled
      }), React.createElement("div", null, localIcon, text));
    }
  }], [{
    key: "getIconSize",
    value: function getIconSize(size) {
      switch (size) {
        case 's':
          return heightIconS;

        case 'm':
          return heightIconM;

        case 'l':
          return heightIconL;

        default:
          return heightIconM;
      }
    }
  }]);

  return Button;
}(Component);

Button$3.defaultProps = {
  children: undefined,
  type: 'standard',
  size: 'm',
  paddingSize: 'm',
  icon: undefined,
  iconPosition: 'left',
  iconRotate: 0,
  iconSize: undefined,
  disabled: false
};
Button$3.propTypes = {
  /** Node inside the button */
  children: PropTypes.node,

  /** String indicating the type of button */
  type: PropTypes.oneOf(['standard', 'fill', 'important', 'positive', 'negative', 'icon', 'standardDark', 'fillDark', 'importantDark', 'positiveDark', 'negativeDark', 'iconDark']),

  /** String indicating the size of button */
  size: PropTypes.oneOf(['s', 'm', 'l']),

  /** String indicating the padding size of button */
  paddingSize: PropTypes.oneOf(['s', 'm', 'l']),

  /** String indicating the name of the icon to apply */
  icon: PropTypes.string,

  /** String indicating the position of the icon */
  iconPosition: PropTypes.oneOf(['left', 'right']),

  /** Number indicating the rotation in degree for the icon */
  iconRotate: PropTypes.number,

  /** Number to customize the size of the icon */
  iconSize: PropTypes.number,

  /** Boolean indicating if the button should be disabled */
  disabled: PropTypes.bool
};

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var nativeDateToString = DatePrototype[TO_STRING];
var getTime = DatePrototype.getTime;

// `Date.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-date.prototype.tostring
if (new Date(NaN) + '' != INVALID_DATE) {
  redefine(DatePrototype, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? nativeDateToString.call(this) : INVALID_DATE;
  });
}

var $filter = arrayIteration.filter;



var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH$4 = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 || !USES_TO_LENGTH$4 }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var fontSizeBase$4 = 16;
var paddingBottom$1 = 20 / fontSizeBase$4;
var paddingSide = 20 / fontSizeBase$4;
var weekNumberSize = 10 / fontSizeBase$4;
var small = {
  heightMonthLine: 44 / fontSizeBase$4,
  heightWeekLine: 28 / fontSizeBase$4,
  heightDay: 24 / fontSizeBase$4,
  widthDay: 24 / fontSizeBase$4,
  marginDay: 2 / fontSizeBase$4,
  busyDaysIndicatorHeight: 3 / fontSizeBase$4,
  busyDaysIndicatorWidth: 3 / fontSizeBase$4,
  busyDaysIndicatorBottom: 1 / fontSizeBase$4
};
var medium = {
  heightMonthLine: 70 / fontSizeBase$4,
  heightWeekLine: 36 / fontSizeBase$4,
  heightDay: 30 / fontSizeBase$4,
  widthDay: 30 / fontSizeBase$4,
  marginDay: 3 / fontSizeBase$4,
  busyDaysIndicatorHeight: 4 / fontSizeBase$4,
  busyDaysIndicatorWidth: 4 / fontSizeBase$4,
  busyDaysIndicatorBottom: 1 / fontSizeBase$4
};

function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$3(self, call) { if (call && (_typeof$3(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$3(self); }

function _getPrototypeOf$3(o) { _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$3(o); }

function _assertThisInitialized$3(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); return Constructor; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$3(subClass, superClass); }

function _setPrototypeOf$3(o, p) { _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$3(o, p); }

function _templateObject2$4() {
  var data = _taggedTemplateLiteral$x(["\n  width: ", "};\n  height: ", "};\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  background-color: ", ";\n  cursor: ", ";\n  opacity: ", ";\n\n  &:hover {\n    background-color: ", ";\n\n    ", " {\n      color: ", ";\n    }\n\n    ", " {\n      background: ", ";\n    }\n  }\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$x() {
  var data = _taggedTemplateLiteral$x(["\n  height: ", ";\n  width: ", ";\n  background: ", ";\n  position: absolute;\n  bottom: ", ";\n  left: 50%;\n  transform: translateX(-50%);\n  border-radius: 50%;\n"]);

  _templateObject$x = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$x(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
moment.locale('fr');
var BusyIndicator = styled('div')(_templateObject$x(), function (props) {
  return props.size === 's' ? "".concat(small.busyDaysIndicatorHeight, "rem") : "".concat(medium.busyDaysIndicatorHeight, "rem");
}, function (props) {
  return props.size === 's' ? "".concat(small.busyDaysIndicatorWidth, "rem") : "".concat(medium.busyDaysIndicatorWidth, "rem");
}, function (props) {
  return props.color || black;
}, function (props) {
  return props.size === 's' ? "".concat(small.busyDaysIndicatorBottom, "rem") : "".concat(medium.busyDaysIndicatorBottom, "rem");
});
var StyledWeekDay = styled('div')(_templateObject2$4(), function (props) {
  if (props.size === 's') {
    return "".concat(small.widthDay, "rem");
  }

  return "".concat(medium.widthDay, "rem");
}, function (props) {
  if (props.size === 's') {
    return "".concat(small.heightDay, "rem");
  }

  return "".concat(medium.heightDay, "rem");
}, function (props) {
  if (props.isActiveDay) {
    return grey6;
  }

  if (props.isCurrentDay) {
    return orange2;
  }

  return undefined;
}, function (props) {
  return !props.isDisabled ? 'pointer' : undefined;
}, function (props) {
  return props.isDisabled ? '0.2' : undefined;
}, function (props) {
  return !props.isDisabled ? black : undefined;
}, Text, function (props) {
  return !props.isDisabled ? white : undefined;
}, BusyIndicator, function (props) {
  return !props.isDisabled ? white : undefined;
});

var WeekDay =
/*#__PURE__*/
function (_Component) {
  _inherits$3(WeekDay, _Component);

  _createClass$4(WeekDay, null, [{
    key: "isCurrentDay",
    value: function isCurrentDay(date) {
      return moment().isSame(date, 'day');
    }
  }, {
    key: "isActiveDay",
    value: function isActiveDay(date, activeDay) {
      return activeDay && activeDay.isSame(date, 'day');
    }
  }, {
    key: "isInMonth",
    value: function isInMonth(date, month) {
      return date.isSame(month, 'month');
    }
  }, {
    key: "isBeforeMin",
    value: function isBeforeMin(date, min) {
      return min && date.clone().startOf('day').isBefore(min.clone().startOf('day'));
    }
  }, {
    key: "isAfterMax",
    value: function isAfterMax(date, max) {
      return max && date.clone().startOf('day').isAfter(max.clone().startOf('day'));
    }
  }, {
    key: "getTextColor",
    value: function getTextColor(date, month, isActiveDay) {
      if (isActiveDay) {
        return 'black';
      }

      if (WeekDay.isCurrentDay(date)) {
        return 'white';
      }

      if (!WeekDay.isInMonth(date, month)) {
        return 'grey';
      }

      return 'black';
    }
  }]);

  function WeekDay(props) {
    var _this;

    _classCallCheck$4(this, WeekDay);

    _this = _possibleConstructorReturn$3(this, _getPrototypeOf$3(WeekDay).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized$3(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  _createClass$4(WeekDay, [{
    key: "handleClick",
    value: function handleClick(date, isDisabled) {
      var handleClick = this.props.handleClick;

      if (!isDisabled) {
        if (handleClick) {
          handleClick(date);
        }
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e, date, isDisabled) {
      if (e.which === 13 || e.which === 32) {
        this.handleClick(date, isDisabled);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          size = _this$props.size,
          date = _this$props.date,
          month = _this$props.month,
          activeDate = _this$props.activeDate,
          min = _this$props.min,
          max = _this$props.max,
          busyDays = _this$props.busyDays;
      var isCurrentDay = WeekDay.isCurrentDay(date);
      var isActiveDay = WeekDay.isActiveDay(date, activeDate);
      var isBefore = WeekDay.isBeforeMin(date, min);
      var isAfter = WeekDay.isAfterMax(date, max);
      var isDisabled = isBefore || isAfter;
      var color = WeekDay.getTextColor(date, month, isActiveDay);
      var isBusy = busyDays.filter(function (day) {
        return date.isSame(day, 'day');
      }).length;
      return React.createElement(StyledWeekDay, {
        size: size,
        isCurrentDay: isCurrentDay,
        isActiveDay: isActiveDay,
        isDisabled: isDisabled,
        onClick: function onClick() {
          return _this2.handleClick(date, isDisabled);
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.handleKeyDown(e, date, isDisabled);
        },
        tabIndex: isDisabled ? -1 : 0,
        role: "button",
        "aria-disabled": isDisabled,
        disabled: isDisabled
      }, React.createElement(Text, {
        size: "s",
        bold: isCurrentDay,
        color: color
      }, date.date()), !!isBusy && React.createElement(BusyIndicator, {
        size: size,
        color: color
      }));
    }
  }]);

  return WeekDay;
}(Component);

WeekDay.defaultProps = {
  date: moment(),
  activeDate: undefined,
  min: undefined,
  max: undefined,
  size: 'm',
  month: moment(),
  handleClick: function handleClick() {},
  busyDays: []
};
WeekDay.propTypes = {
  /** Date, day to show */
  date: PropTypes.instanceOf(moment),

  /** Date, active day */
  activeDate: PropTypes.instanceOf(moment),

  /** Date, minimum date selection */
  min: PropTypes.instanceOf(moment),

  /** Date, maximum date selection */
  max: PropTypes.instanceOf(moment),

  /** String indicating the size of calendar */
  size: PropTypes.oneOf(['s', 'm']),

  /** Date, month to show (day is in grey if not in this month) */
  month: PropTypes.instanceOf(moment),

  /** Function, called when a day is clicked */
  handleClick: PropTypes.instanceOf(Function),

  /** Array containing a list of Date which represent busy days/days with event(s) */
  busyDays: PropTypes.arrayOf(PropTypes.instanceOf(moment))
};

function _templateObject2$5() {
  var data = _taggedTemplateLiteral$y(["\n  width: ", "};\n  height: ", "};\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & > ", " {\n    font-size: ", "rem;\n  }\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$y() {
  var data = _taggedTemplateLiteral$y(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: ", ";\n\n  background-color: ", ";\n"]);

  _templateObject$y = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$y(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
moment.locale('fr');
var StyledWeekLine = styled('div')(_templateObject$y(), function (props) {
  if (props.size === 's') {
    return "".concat(small.heightWeekLine, "rem");
  }

  return "".concat(medium.heightWeekLine, "rem");
}, function (props) {
  return props.isActive ? grey6 : undefined;
});
var StyledWeekNumber = styled('div')(_templateObject2$5(), function (props) {
  if (props.size === 's') {
    return "".concat(small.widthDay, "rem");
  }

  return "".concat(medium.widthDay, "rem");
}, function (props) {
  if (props.size === 's') {
    return "".concat(small.heightDay, "rem");
  }

  return "".concat(medium.heightDay, "rem");
}, Text, weekNumberSize);

var WeekLine = function WeekLine(props) {
  var size = props.size,
      date = props.date,
      month = props.month,
      showWeekNumber = props.showWeekNumber,
      activeWeek = props.activeWeek,
      activeDate = props.activeDate,
      handleDayClick = props.handleDayClick,
      min = props.min,
      max = props.max,
      busyDays = props.busyDays;
  var firstDay = date.clone().startOf('week');
  var days = [];

  for (var i = 0; i < 7; i += 1) {
    days.push(firstDay.clone().add(i, 'day'));
  }

  return React.createElement(StyledWeekLine, {
    size: size,
    isActive: date.week() === activeWeek
  }, showWeekNumber ? React.createElement(StyledWeekNumber, {
    size: size
  }, React.createElement(Text, {
    size: "s",
    color: "grey"
  }, date.week())) : undefined, days.map(function (d) {
    return React.createElement(WeekDay, {
      key: d.valueOf(),
      size: size,
      month: month,
      date: d,
      activeDate: activeDate,
      handleClick: handleDayClick,
      min: min,
      max: max,
      busyDays: busyDays
    });
  }));
};

WeekLine.defaultProps = {
  date: moment(),
  activeDate: undefined,
  activeWeek: undefined,
  min: undefined,
  max: undefined,
  showWeekNumber: false,
  size: 'm',
  month: moment(),
  handleDayClick: function handleDayClick() {},
  busyDays: []
};
WeekLine.propTypes = {
  /** Date, week to show */
  date: PropTypes.instanceOf(moment),

  /** Date, active date */
  activeDate: PropTypes.instanceOf(moment),

  /** Number, active week number */
  activeWeek: PropTypes.number,

  /** Date, minimum date selection */
  min: PropTypes.instanceOf(moment),

  /** Date, maximum date selection */
  max: PropTypes.instanceOf(moment),

  /** Boolean indicating if weeks numbers are displayed */
  showWeekNumber: PropTypes.bool,

  /** String indicating the size of calendar */
  size: PropTypes.oneOf(['s', 'm']),

  /** Date, month to show */
  month: PropTypes.instanceOf(moment),

  /** Function, called when a day is clicked */
  handleDayClick: PropTypes.instanceOf(Function),

  /** Array containing a list of Date which represent busy days/days with event(s) */
  busyDays: PropTypes.arrayOf(PropTypes.instanceOf(moment))
};

function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function _objectWithoutProperties$4(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$4(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$4(self, call) { if (call && (_typeof$4(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$4(self); }

function _getPrototypeOf$4(o) { _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$4(o); }

function _assertThisInitialized$4(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); return Constructor; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$4(subClass, superClass); }

function _setPrototypeOf$4(o, p) { _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$4(o, p); }

function _templateObject5$1() {
  var data = _taggedTemplateLiteral$z(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ", "};\n  height: ", "};\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteral$z(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: ", "};\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral$z(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-left: auto;\n\n  & > :first-child {\n    margin-right: ", "};\n  }\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral$z(["\n  height: ", "};\n  display: flex;\n  align-items: center;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$z() {
  var data = _taggedTemplateLiteral$z(["\n  background-color: #fff;\n  width: ", "};\n  padding: 0 ", "rem ", "rem;\n"]);

  _templateObject$z = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$z(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
moment.locale('fr');
var Container$1 = styled('div')(_templateObject$z(), function (props) {
  var nbDays = 7;

  if (props.showWeekNumber) {
    nbDays += 1;
  }

  if (props.size === 's') {
    return "".concat(small.widthDay * nbDays + small.marginDay * (nbDays * 2 - 2), "rem");
  }

  return "".concat(medium.widthDay * nbDays + medium.marginDay * (nbDays * 2 - 2), "rem");
}, paddingSide, paddingBottom$1);
var MonthLine = styled('div')(_templateObject2$6(), function (props) {
  if (props.size === 's') {
    return "".concat(small.heightMonthLine, "rem");
  }

  return "".concat(medium.heightMonthLine, "rem");
});
var MonthControls = styled('div')(_templateObject3$2(), function (props) {
  if (props.size === 's') {
    return "".concat(small.marginDay * 2, "rem");
  }

  return "".concat(medium.marginDay * 2, "rem");
});
var HeaderWeekLine = styled('div')(_templateObject4$2(), function (props) {
  if (props.size === 's') {
    return "".concat(small.heightWeekLine, "rem");
  }

  return "".concat(medium.heightWeekLine, "rem");
});
var HeaderWeekDay = styled('div')(_templateObject5$1(), function (props) {
  if (props.size === 's') {
    return "".concat(small.widthDay, "rem");
  }

  return "".concat(medium.widthDay, "rem");
}, function (props) {
  if (props.size === 's') {
    return "".concat(small.heightDay, "rem");
  }

  return "".concat(medium.heightDay, "rem");
});
var weekdays = moment.weekdays().map(function (day, index) {
  return {
    key: index,
    day: day.charAt(0).toUpperCase()
  };
});
var last = weekdays.shift();
weekdays.push(last);

var Calendar =
/*#__PURE__*/
function (_Component) {
  _inherits$4(Calendar, _Component);

  _createClass$5(Calendar, null, [{
    key: "getStateValues",
    value: function getStateValues(props) {
      var min = props.min ? moment(props.min) : undefined;
      var max = props.max ? moment(props.max) : undefined;
      var date = moment(props.date);
      var activeDate = props.activeDate ? moment(props.activeDate) : undefined;
      var busyDays = props.busyDays.map(function (dt) {
        return moment(dt);
      });

      if (min && date.isBefore(min)) {
        date = min;
      }

      if (activeDate && min && activeDate.isBefore(min)) {
        activeDate = min;
      }

      if (max && date.isAfter(max)) {
        date = max;
      }

      if (activeDate && max && activeDate.isAfter(max)) {
        activeDate = max;
      }

      return {
        activeDate: activeDate,
        date: date,
        min: min,
        max: max,
        busyDays: busyDays
      };
    }
  }]);

  function Calendar(props) {
    var _this;

    _classCallCheck$5(this, Calendar);

    _this = _possibleConstructorReturn$4(this, _getPrototypeOf$4(Calendar).call(this, props));

    var _Calendar$getStateVal = Calendar.getStateValues(props),
        activeDate = _Calendar$getStateVal.activeDate,
        date = _Calendar$getStateVal.date,
        min = _Calendar$getStateVal.min,
        max = _Calendar$getStateVal.max,
        busyDays = _Calendar$getStateVal.busyDays;

    _this.state = {
      date: date,
      activeDate: activeDate,
      min: min,
      max: max,
      busyDays: busyDays
    };
    _this.handlePrevMonth = _this.handlePrevMonth.bind(_assertThisInitialized$4(_this));
    _this.handleNextMonth = _this.handleNextMonth.bind(_assertThisInitialized$4(_this));
    _this.handleDayClick = _this.handleDayClick.bind(_assertThisInitialized$4(_this));
    return _this;
  }

  _createClass$5(Calendar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps !== this.props) {
        var _Calendar$getStateVal2 = Calendar.getStateValues(this.props),
            activeDate = _Calendar$getStateVal2.activeDate,
            date = _Calendar$getStateVal2.date,
            min = _Calendar$getStateVal2.min,
            max = _Calendar$getStateVal2.max,
            busyDays = _Calendar$getStateVal2.busyDays;

        this.setState({
          date: date,
          activeDate: activeDate,
          min: min,
          max: max,
          busyDays: busyDays
        });
      }
    }
  }, {
    key: "handlePrevMonth",
    value: function handlePrevMonth(event) {
      var handlePrevMonth = this.props.handlePrevMonth;
      var date = this.state.date;
      event.preventDefault();
      this.setState({
        date: date.clone().subtract(1, 'month')
      }, function () {
        if (handlePrevMonth) {
          handlePrevMonth(date);
        }
      });
    }
  }, {
    key: "handleNextMonth",
    value: function handleNextMonth(event) {
      var handleNextMonth = this.props.handleNextMonth;
      var date = this.state.date;
      event.preventDefault();
      this.setState({
        date: date.clone().add(1, 'month')
      }, function () {
        if (handleNextMonth) {
          handleNextMonth(date);
        }
      });
    }
  }, {
    key: "handleDayClick",
    value: function handleDayClick(day) {
      var selectDay = this.props.selectDay;
      this.setState({
        date: day,
        activeDate: day
      });

      if (selectDay) {
        selectDay(day.toDate(), false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          date = _this$state.date,
          busyDays = _this$state.busyDays,
          activeDate = _this$state.activeDate,
          min = _this$state.min,
          max = _this$state.max;
      var dt = date;

      var _this$props = this.props,
          size = _this$props.size,
          showWeekNumber = _this$props.showWeekNumber,
          activeWeek = _this$props.activeWeek,
          rest = _objectWithoutProperties$4(_this$props, ["size", "showWeekNumber", "activeWeek"]);

      var firstWeek = dt.clone().startOf('month');
      var weeks = [];

      for (var i = 0; i < 6; i += 1) {
        weeks.push(firstWeek.clone().add(i, 'week'));
      }

      return React.createElement(Container$1, _extends$3({}, rest, {
        size: size,
        showWeekNumber: showWeekNumber
      }), React.createElement(MonthLine, {
        size: size
      }, React.createElement(Text, {
        bold: true,
        size: "s"
      }, dt.format('MMMM YYYY')), React.createElement(MonthControls, {
        size: size
      }, React.createElement(Button$1, {
        size: "s",
        type: "icon",
        icon: "arrow-previous",
        onClick: this.handlePrevMonth,
        disabled: !this.canGoToPreviousMonth
      }), React.createElement(Button$1, {
        size: "s",
        type: "icon",
        icon: "arrow-next",
        onClick: this.handleNextMonth,
        disabled: !this.canGoToNextMonth
      }))), React.createElement(HeaderWeekLine, {
        size: size
      }, showWeekNumber ? React.createElement(HeaderWeekDay, {
        key: -1,
        size: size
      }) : undefined, weekdays.map(function (d) {
        return React.createElement(HeaderWeekDay, {
          key: d.key,
          size: size
        }, React.createElement(Text, {
          size: "s"
        }, d.day));
      })), weeks.map(function (w) {
        return React.createElement(WeekLine, {
          key: w.valueOf(),
          size: size,
          date: w,
          busyDays: busyDays,
          activeDate: activeDate,
          activeWeek: activeWeek,
          min: min,
          max: max,
          month: firstWeek,
          showWeekNumber: showWeekNumber,
          handleDayClick: _this2.handleDayClick
        });
      }));
    }
  }, {
    key: "canGoToNextMonth",
    get: function get() {
      var _this$state2 = this.state,
          max = _this$state2.max,
          date = _this$state2.date;

      if (max && max.clone().endOf('day').isSameOrBefore(date.clone().endOf('month'))) {
        return false;
      }

      return true;
    }
  }, {
    key: "canGoToPreviousMonth",
    get: function get() {
      var _this$state3 = this.state,
          min = _this$state3.min,
          date = _this$state3.date;

      if (min && min.clone().startOf('day').isSameOrAfter(date.clone().startOf('month'))) {
        return false;
      }

      return true;
    }
  }]);

  return Calendar;
}(Component);

Calendar.defaultProps = {
  date: new Date(),
  activeDate: undefined,
  activeWeek: undefined,
  min: undefined,
  max: undefined,
  showWeekNumber: false,
  size: 'm',
  selectDay: function selectDay() {},
  handlePrevMonth: function handlePrevMonth() {},
  handleNextMonth: function handleNextMonth() {},
  busyDays: []
};
Calendar.propTypes = {
  /** Date, month to show */
  date: PropTypes.instanceOf(Date),

  /** Date, active day */
  activeDate: PropTypes.instanceOf(Date),

  /**  Number, active week number */
  activeWeek: PropTypes.number,

  /** Date, minimum date selection */
  min: PropTypes.instanceOf(Date),

  /** Date, maximum date selection */
  max: PropTypes.instanceOf(Date),

  /** Boolean indicating if weeks numbers are displayed */
  showWeekNumber: PropTypes.bool,

  /** String indicating the size of calendar */
  size: PropTypes.oneOf(['s', 'm']),

  /** Function, called when a day is selected */
  selectDay: PropTypes.instanceOf(Function),

  /** Function, called when click on previous month */
  handlePrevMonth: PropTypes.instanceOf(Function),

  /** Function, called when click on next month */
  handleNextMonth: PropTypes.instanceOf(Function),

  /** Array containing a list of Date which represent busy days/days with event(s) */
  busyDays: PropTypes.arrayOf(PropTypes.instanceOf(Date))
};

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$3 = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod$3(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod$3(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod$3(3)
};

var trim = stringTrim.trim;


var $parseInt = global_1.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED$1 = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$1 ? function parseInt(string, radix) {
  var S = trim(String(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
_export({ global: true, forced: parseInt != numberParseInt }, {
  parseInt: numberParseInt
});

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

var UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

var BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
	UNSUPPORTED_Y: UNSUPPORTED_Y,
	BROKEN_CARET: BROKEN_CARET
};

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = regexpStickyHelpers.UNSUPPORTED_Y || regexpStickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec = patchedExec;

_export({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
  exec: regexpExec
});

// eslint-disable-next-line import/prefer-default-export
function hexToHSL(hex) {
  var result = /^#?([a-f\d]{1,2})([a-f\d]{1,2})([a-f\d]{1,2})$/i.exec(hex);
  var r = parseInt(result[1].length === 1 ? "".concat(result[1]).concat(result[1]) : result[1], 16);
  var g = parseInt(result[2].length === 1 ? "".concat(result[2]).concat(result[2]) : result[2], 16);
  var b = parseInt(result[3].length === 1 ? "".concat(result[3]).concat(result[3]) : result[3], 16);
  r /= 255;
  g /= 255;
  b /= 255;
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var h;
  var s;
  var l = (max + min) / 2;

  if (max === min) {
    // achromatic
    h = 0;
    s = 0;
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;

      case g:
        h = (b - r) / d + 2;
        break;

      case b:
        h = (r - g) / d + 4;
        break;

      default:
        h = 0;
    }

    h /= 6;
  }

  return {
    h: h,
    s: s,
    l: l
  };
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteral$A(["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  flex: 0 1 auto;\n  max-width: 100%;\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$A() {
  var data = _taggedTemplateLiteral$A(["\n  max-width: 17rem;\n  max-height: 5rem;\n  background-color: ", ";\n  border-radius: 0.25rem;\n  padding: 0.5rem;\n  display: inline-flex;\n  align-items: flex-start;\n  flex-direction: column;\n"]);

  _templateObject$A = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$A(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container$2 = styled('div')(_templateObject$A(), function (props) {
  return props.color;
});
var CalendarBaseText = styled(Text)(_templateObject2$7());

var CalendarCard = function CalendarCard(_ref) {
  var calendar = _ref.calendar;
  var textColor = hexToHSL(calendar.color).l < 0.5 ? 'white' : 'black';
  return React.createElement(Container$2, {
    color: calendar.color
  }, React.createElement(CalendarBaseText, {
    size: "m",
    bold: true,
    color: textColor
  }, calendar.title), calendar.comments ? React.createElement(CalendarBaseText, {
    size: "s",
    color: textColor
  }, calendar.comments) : null, calendar.from ? React.createElement(CalendarBaseText, {
    size: "s",
    color: textColor
  }, calendar.from) : null);
};

CalendarCard.propTypes = {
  calendar: PropTypes.shape({
    title: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    comments: PropTypes.string,
    from: PropTypes.string
  }).isRequired
};

function _templateObject$B() {
  var data = _taggedTemplateLiteral$B(["\n  background-color: #fff;\n  max-width: 30rem;\n"]);

  _templateObject$B = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$B(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var CardContainer = styled('div')(_templateObject$B());

function _templateObject$C() {
  var data = _taggedTemplateLiteral$C(["\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: ", ";\n  height: 15rem;\n"]);

  _templateObject$C = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$C(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var CardMedia = styled('div')(_templateObject$C(), function (props) {
  if (props.image) {
    return "url(".concat(props.image, ")");
  }

  return undefined;
});

function _templateObject$D() {
  var data = _taggedTemplateLiteral$D(["\n  padding: 2rem;\n\n  ", " {\n    margin: 1rem 0;\n  }\n"]);

  _templateObject$D = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$D(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var CardContent = styled('div')(_templateObject$D(), Headline);

function _templateObject$E() {
  var data = _taggedTemplateLiteral$E(["\n  padding: 0.5rem 2rem 3rem;\n"]);

  _templateObject$E = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$E(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var CardActions = styled('div')(_templateObject$E());

var index = {
  CardContainer: CardContainer,
  CardMedia: CardMedia,
  CardContent: CardContent,
  CardActions: CardActions
};

var fontSizeBase$5 = 16;
var minWidth = 160 / fontSizeBase$5;
var sizeIconS = 12;
var sizeIconM = 15;
var sizeIconL = 15;

function _typeof$5(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$5(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$5(self, call) { if (call && (_typeof$5(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$5(self); }

function _getPrototypeOf$5(o) { _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$5(o); }

function _assertThisInitialized$5(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$6(Constructor.prototype, protoProps); if (staticProps) _defineProperties$6(Constructor, staticProps); return Constructor; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$5(subClass, superClass); }

function _setPrototypeOf$5(o, p) { _setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$5(o, p); }

function _templateObject5$2() {
  var data = _taggedTemplateLiteral$F(["\n  background: none;\n  border: 0;\n  width: 100%;\n  height: ", "rem;\n  padding: 0 ", "rem;\n  text-align: left;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  &:hover, &:focus {\n    background-color: ", ";\n\n    ", " {\n      color: ", ";\n    }\n\n    path {\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteral$F(["\n  white-space: nowrap;\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteral$F(["\n  margin-right: 5px;\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral$F(["\n  display: ", ";\n  list-style: none;\n  background-color: ", ";\n  border-style: solid;\n  border-width: ", "rem;\n  border-color: ", ";\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  top: ", ";\n  bottom: ", ";\n  left: ", ";\n  right: ", ";\n  min-width: ", "rem;\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$F() {
  var data = _taggedTemplateLiteral$F(["\n  position: relative;\n  display: inline-block;\n"]);

  _templateObject$F = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$F(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container$3 = styled('div')(_templateObject$F());
var List = styled('ul')(_templateObject2$8(), function (props) {
  return props.opened ? 'block' : 'none';
}, white, border, black, function (props) {
  return props.position === 'bottom' ? '100%' : undefined;
}, function (props) {
  return props.position === 'top' ? '100%' : undefined;
}, function (props) {
  return props.horizontalPosition === 'right' ? 0 : undefined;
}, function (props) {
  return props.horizontalPosition === 'left' ? 0 : undefined;
}, minWidth);
var ItemIcon = styled(Icon)(_templateObject3$3());
var ItemText = styled(Text)(_templateObject4$3());
var ButtonItem = styled('button')(_templateObject5$2(), heightM, paddingM, black, Text, white, white);

var Dropdown =
/*#__PURE__*/
function (_Component) {
  _inherits$5(Dropdown, _Component);

  _createClass$6(Dropdown, null, [{
    key: "getIconSize",
    value: function getIconSize(size) {
      switch (size) {
        case 's':
          return sizeIconS;

        case 'm':
          return sizeIconM;

        case 'l':
          return sizeIconL;

        default:
          return sizeIconM;
      }
    }
  }]);

  function Dropdown(props) {
    var _this;

    _classCallCheck$6(this, Dropdown);

    _this = _possibleConstructorReturn$5(this, _getPrototypeOf$5(Dropdown).call(this, props));
    _this.state = {
      opened: false
    };
    _this.onClickDropdownButton = _this.onClickDropdownButton.bind(_assertThisInitialized$5(_this));
    _this.onWindowClick = _this.onWindowClick.bind(_assertThisInitialized$5(_this));
    _this.onSelectItem = _this.onSelectItem.bind(_assertThisInitialized$5(_this));
    _this.node = React.createRef();
    return _this;
  }

  _createClass$6(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this.onWindowClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.onWindowClick);
    }
  }, {
    key: "onClickDropdownButton",
    value: function onClickDropdownButton() {
      var disabled = this.props.disabled;
      var opened = this.state.opened;

      if (disabled) {
        return;
      }

      this.setState({
        opened: !opened
      });
    }
  }, {
    key: "onWindowClick",
    value: function onWindowClick(event) {
      var opened = this.state.opened;
      var dropdownElement = this.node.current;

      if (dropdownElement && event.target !== dropdownElement && !dropdownElement.contains(event.target) && opened) {
        this.setState({
          opened: false
        });
      }
    }
  }, {
    key: "onSelectItem",
    value: function onSelectItem(item) {
      var onChange = this.props.onChange;

      if (onChange) {
        onChange(item);
      }

      this.setState({
        opened: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          type = _this$props.type,
          size = _this$props.size,
          paddingSize = _this$props.paddingSize,
          children = _this$props.children,
          disabled = _this$props.disabled,
          items = _this$props.items,
          displayArrow = _this$props.displayArrow,
          position = _this$props.position,
          horizontalPosition = _this$props.horizontalPosition,
          icon = _this$props.icon,
          iconColor = _this$props.iconColor,
          iconRotate = _this$props.iconRotate,
          iconSize = _this$props.iconSize,
          rest = _objectWithoutProperties$5(_this$props, ["className", "type", "size", "paddingSize", "children", "disabled", "items", "displayArrow", "position", "horizontalPosition", "icon", "iconColor", "iconRotate", "iconSize"]);

      var opened = this.state.opened;
      var arrowIconButton = displayArrow ? {
        iconPosition: 'right',
        icon: 'arrow-down',
        iconSize: Dropdown.getIconSize(size)
      } : null;
      return React.createElement(Container$3, _extends$4({}, rest, {
        className: className,
        ref: this.node
      }), React.createElement(Button$1, _extends$4({
        type: type,
        size: size,
        paddingSize: paddingSize,
        disabled: disabled,
        onClick: this.onClickDropdownButton,
        className: opened ? 'active' : undefined
      }, arrowIconButton), icon ? React.createElement(Icon, {
        icon: icon,
        width: iconSize,
        height: iconSize,
        color: iconColor,
        rotate: iconRotate
      }) : null, children), React.createElement(List, {
        opened: opened,
        size: size,
        position: position,
        horizontalPosition: horizontalPosition
      }, items.map(function (item) {
        var itemIconSize = item.iconSize || Dropdown.defaultItemIconSize;
        return React.createElement("li", {
          key: item.value
        }, React.createElement(ButtonItem, {
          onClick: function onClick() {
            _this2.onSelectItem(item);
          },
          "data-selector": item.dataSelector
        }, item.icon ? React.createElement(ItemIcon, {
          icon: item.icon,
          width: itemIconSize,
          height: itemIconSize
        }) : null, React.createElement(ItemText, {
          bold: true
        }, item.text)));
      })));
    }
  }]);

  return Dropdown;
}(Component);

Dropdown.allowedPositions = ['top', 'bottom'];
Dropdown.allowedHorizontalPositions = ['right', 'left'];
Dropdown.defaultItemIconSize = 20;
Dropdown.defaultProps = {
  children: undefined,
  type: 'standard',
  size: 'm',
  paddingSize: 'm',
  items: [],
  onChange: function onChange() {},
  disabled: false,
  displayArrow: true,
  position: 'bottom',
  horizontalPosition: 'right',
  className: undefined,
  icon: undefined,
  iconColor: 'black',
  iconRotate: 0,
  iconSize: 16
};
Dropdown.propTypes = {
  /** Label of the field */
  children: PropTypes.node,

  /** String indicating the type of dropdown */
  type: PropTypes.oneOf(Button$1.allowedTypes),

  /** String indicating the size of button */
  size: PropTypes.oneOf(['s', 'm', 'l']),

  /** String indicating the padding size of button */
  paddingSize: PropTypes.oneOf(['s', 'm', 'l', 'none']),

  /** List of option items */
  items: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,

    /** String indicating the name of the icon to apply */
    icon: PropTypes.string,

    /** Number indicating the size of the icon to apply */
    iconSize: PropTypes.number,
    dataSelector: PropTypes.string
  })),

  /** Function called where new option is selected */
  onChange: PropTypes.func,

  /** Boolean indicating if the input is disabled */
  disabled: PropTypes.bool,

  /** Boolean indicating if the dropdown arrow should be displayed */
  displayArrow: PropTypes.bool,

  /** String indicating the position of the dropdown when it's opened */
  position: PropTypes.oneOf(Dropdown.allowedPositions),

  /** String indicating the horizontal position of the dropdown when it's opened */
  horizontalPosition: PropTypes.oneOf(Dropdown.allowedHorizontalPositions),

  /** String, internal to Styled Component function */
  className: PropTypes.string,

  /** String indicating the name of the icon to apply */
  icon: PropTypes.string,

  /** String indicating the color of the icon to apply */
  iconColor: PropTypes.oneOf(Icon.allowedColors),

  /** Number indicating the rotation in degree for the icon */
  iconRotate: PropTypes.number,

  /** Number indicating the size for the icon */
  iconSize: PropTypes.number
};

// `String.prototype.anchor` method
// https://tc39.github.io/ecma262/#sec-string.prototype.anchor
_export({ target: 'String', proto: true, forced: stringHtmlForced('anchor') }, {
  anchor: function anchor(name) {
    return createHtml(this, 'a', 'name', name);
  }
});

function _typeof$6(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$6 = function _typeof(obj) { return typeof obj; }; } else { _typeof$6 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$6(obj); }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$6(self, call) { if (call && (_typeof$6(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$6(self); }

function _getPrototypeOf$6(o) { _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$6(o); }

function _assertThisInitialized$6(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties$7(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$7(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$7(Constructor.prototype, protoProps); if (staticProps) _defineProperties$7(Constructor, staticProps); return Constructor; }

function _inherits$6(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$6(subClass, superClass); }

function _setPrototypeOf$6(o, p) { _setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$6(o, p); }

function _templateObject2$9() {
  var data = _taggedTemplateLiteral$G(["\n  display: ", ";\n  list-style: none;\n  background-color: ", ";\n  margin: 0;\n  padding: 0;\n  left: 0;\n  position: absolute;\n  z-index: 1;\n  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$G() {
  var data = _taggedTemplateLiteral$G(["\n  position: relative;\n  display: inline-block;\n"]);

  _templateObject$G = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$G(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container$4 = styled('div')(_templateObject$G());
var List$1 = styled('ul')(_templateObject2$9(), function (props) {
  return props.opened ? 'block' : 'none';
}, white);

var DropdownMenu =
/*#__PURE__*/
function (_Component) {
  _inherits$6(DropdownMenu, _Component);

  _createClass$7(DropdownMenu, null, [{
    key: "findAnchorByCss",
    value: function findAnchorByCss(cssSelector) {
      return document.querySelector(cssSelector);
    }
  }]);

  function DropdownMenu(props) {
    var _this;

    _classCallCheck$7(this, DropdownMenu);

    _this = _possibleConstructorReturn$6(this, _getPrototypeOf$6(DropdownMenu).call(this, props));
    _this.listComponentRef = React.createRef();
    _this.node = React.createRef();
    _this.anchorElement = null;
    _this.state = {
      opened: false
    };
    _this.onClickDropdownButton = _this.onClickDropdownButton.bind(_assertThisInitialized$6(_this));
    _this.onWindowClick = _this.onWindowClick.bind(_assertThisInitialized$6(_this));
    _this.getListComponent = _this.getListComponent.bind(_assertThisInitialized$6(_this));
    _this.updateAnchorRef = _this.updateAnchorRef.bind(_assertThisInitialized$6(_this));
    _this.getDropdownPosition = _this.getDropdownPosition.bind(_assertThisInitialized$6(_this));
    _this.renderAsChildren = _this.renderAsChildren.bind(_assertThisInitialized$6(_this));
    _this.renderAsPortal = _this.renderAsPortal.bind(_assertThisInitialized$6(_this));
    return _this;
  }

  _createClass$7(DropdownMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this.onWindowClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.onWindowClick);
    }
  }, {
    key: "onClickDropdownButton",
    value: function onClickDropdownButton(event) {
      var _this$props = this.props,
          onOpen = _this$props.onOpen,
          onClose = _this$props.onClose;
      var opened = this.state.opened;

      if (opened && onClose) {
        onClose(event);
      }

      if (!opened && onOpen) {
        onOpen(event);
      }

      this.setState({
        opened: !opened
      });
    }
  }, {
    key: "onWindowClick",
    value: function onWindowClick(event) {
      var onClose = this.props.onClose;
      var opened = this.state.opened;
      var dropdownElement = this.node.current;

      if (event.target !== dropdownElement && !dropdownElement.contains(event.target) && opened) {
        if (onClose) {
          onClose(event);
        }

        this.setState({
          opened: false
        });
      }
    }
  }, {
    key: "getListComponent",
    value: function getListComponent() {
      var children = this.props.children;
      var opened = this.state.opened;
      return React.createElement(List$1, {
        opened: opened,
        ref: this.listComponentRef
      }, React.Children.map(children, function (child, i) {
        return (
          /* eslint-disable-next-line react/no-array-index-key */
          React.createElement("li", {
            key: i
          }, child)
        );
      }));
    }
  }, {
    key: "getDropdownPosition",
    value: function getDropdownPosition() {
      if (!this.node) {
        return null;
      }

      var _this$node$current$ge = this.node.current.getBoundingClientRect(),
          bottom = _this$node$current$ge.bottom,
          left = _this$node$current$ge.left;

      return {
        x: left,
        y: bottom
      };
    }
  }, {
    key: "updateAnchorRef",
    value: function updateAnchorRef() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      // Performance Optimization. Do not recompute the ref more than once
      if (!force && this.anchorElement) {
        return;
      }

      var anchor = this.props.anchor;
      this.anchorElement = DropdownMenu.findAnchorByCss(anchor);
    }
  }, {
    key: "renderAsPortal",
    value: function renderAsPortal() {
      this.updateAnchorRef();

      if (this.anchorElement) {
        return ReactDOM.createPortal(this.getListComponent(), this.anchorElement);
      }

      return null;
    }
  }, {
    key: "renderAsChildren",
    value: function renderAsChildren() {
      return this.getListComponent();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          size = _this$props2.size,
          anchor = _this$props2.anchor;
      return React.createElement(Container$4, {
        ref: this.node
      }, React.createElement(Button$1, {
        icon: "More-dots",
        rotate: 90,
        size: size,
        type: "icon",
        onClick: this.onClickDropdownButton
      }), anchor ? this.renderAsPortal() : this.renderAsChildren());
    }
  }]);

  return DropdownMenu;
}(Component);

DropdownMenu.defaultProps = {
  children: null,
  size: 'm',
  anchor: null,
  onOpen: null,
  onClose: null
};
DropdownMenu.propTypes = {
  /** Node inside the button */
  children: PropTypes.node,

  /** String indicating the size of button */
  size: PropTypes.oneOf(['s', 'm', 'l']),

  /** String, CSS selector to specify to which DOM Element should the dropdown menu be anchored */
  anchor: PropTypes.string,

  /** onOpen, optional callback when the dropdown opens */
  onOpen: PropTypes.func,

  /** onClose, optional callback when the dropdown opens */
  onClose: PropTypes.func
};

function _templateObject$H() {
  var data = _taggedTemplateLiteral$H(["\n  border: 0;\n  width: 100%;\n  height: ", "rem;\n  padding: 0 ", "rem;\n  text-align: left;\n  cursor: pointer;\n  \n  &:hover:enabled,\n  &:active:enabled,\n  &.active:enabled,\n  &:focus:enabled {\n    background-color: #e4e4e4;\n  }\n"]);

  _templateObject$H = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$H(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var MenuButton = styled(Button$1)(_templateObject$H(), heightM, paddingM);

var DropdownMenuButton = function DropdownMenuButton(props) {
  return React.createElement(MenuButton, props);
};

DropdownMenuButton.defaultProps = {
  children: null,
  icon: null
};
DropdownMenuButton.propTypes = {
  /** String indicating the name of the icon to apply */
  icon: PropTypes.string,

  /** Node inside the button */
  children: PropTypes.node
};

function _templateObject$I() {
  var data = _taggedTemplateLiteral$I(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  flex-flow: ", ";\n  flex: ", ";\n"]);

  _templateObject$I = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$I(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Flex = styled('div')(_templateObject$I(), function (props) {
  return props.flexDirection;
}, function (props) {
  return props.alignItems;
}, function (props) {
  return props.justifyContent;
}, function (props) {
  return props.flexFlow;
}, function (props) {
  return props.flex;
});

var fontSizeBase$6 = 16;
var tooltipFontSize = 14 / fontSizeBase$6;
var tooltipPadding = 11 / fontSizeBase$6;
var tooltipArrowHeight = 10 / fontSizeBase$6;

function _typeof$7(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$7 = function _typeof(obj) { return typeof obj; }; } else { _typeof$7 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$7(obj); }

function _objectWithoutProperties$6(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$6(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$6(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$8(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$8(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$8(Constructor.prototype, protoProps); if (staticProps) _defineProperties$8(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$7(self, call) { if (call && (_typeof$7(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$7(self); }

function _assertThisInitialized$7(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf$7(o) { _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$7(o); }

function _inherits$7(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$7(subClass, superClass); }

function _setPrototypeOf$7(o, p) { _setPrototypeOf$7 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$7(o, p); }

function _templateObject4$4() {
  var data = _taggedTemplateLiteral$J(["\n  display: ", ";\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteral$J(["\n  position:relative;\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteral$J(["\n  height: ", "rem;\n  width: ", "rem;\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  background-color: ", ";\n  transform: rotate(45deg);\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$J() {
  var data = _taggedTemplateLiteral$J(["\n  background-color: ", ";\n  font-weight: bold;\n  font-size: ", "rem;\n  color: ", ";\n  width: 270px;\n  height: 140px;\n  padding: ", "rem;\n  position: absolute;\n\n  top: ", ";\n\n  left: ", ";\n"]);

  _templateObject$J = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$J(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TooltipDiv = styled('div')(_templateObject$J(), grey5, tooltipFontSize, black, tooltipPadding, function (props) {
  switch (props.position) {
    case 'right':
      return '-10px';

    case 'bottom':
      return '40px';

    case 'top':
      return '-170px';

    default:
      return '0';
  }
}, function (props) {
  switch (props.position) {
    case 'right':
      return '50px';

    case 'bottom':
      {
        if (props.isReverse) {
          return '-270px';
        }

        return '-5px';
      }

    case 'top':
      return '-5px';

    default:
      return '5px';
  }
});
var TooltipArrow = styled.div(_templateObject2$a(), tooltipArrowHeight, tooltipArrowHeight, function (props) {
  switch (props.position) {
    case 'right':
      return '7px';

    case 'left':
      return '0';

    case 'bottom':
      return '35px';

    case 'top':
      return '-14px';

    default:
      return '5px';
  }
}, function (props) {
  switch (props.position) {
    case 'right':
      return '45px';

    case 'left':
      return '0';

    case 'bottom':
      return '3px';

    case 'top':
      return '3px';

    default:
      return '5px';
  }
}, grey5);
var Container$5 = styled.div(_templateObject3$4());
var TooltipContainer = styled.div(_templateObject4$4(), function (props) {
  return props.display ? 'block' : 'none';
});

var Tooltip =
/*#__PURE__*/
function (_Component) {
  _inherits$7(Tooltip, _Component);

  function Tooltip(props) {
    var _this;

    _classCallCheck$8(this, Tooltip);

    _this = _possibleConstructorReturn$7(this, _getPrototypeOf$7(Tooltip).call(this, props));

    _this.setWrapperRef = function (node) {
      _this.wrapperRef = node;
    };

    _this.handleClick = function () {
      _this.setState(function (prevState) {
        return {
          displayTooltip: !prevState.displayTooltip
        };
      });
    };

    _this.handleClickOutside = function (event) {
      if (_this.wrapperRef && !_this.wrapperRef.contains(event.target)) {
        _this.setState({
          displayTooltip: false
        });
      }
    };

    _this.state = {
      displayTooltip: false
    };
    return _this;
  }

  _createClass$8(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickOutside, true);
    }
  }, {
    key: "render",
    value: function render() {
      var displayTooltip = this.state.displayTooltip;

      var _this$props = this.props,
          icon = _this$props.icon,
          iconColor = _this$props.iconColor,
          iconHeight = _this$props.iconHeight,
          position = _this$props.position,
          children = _this$props.children,
          isReverse = _this$props.isReverse,
          rest = _objectWithoutProperties$6(_this$props, ["icon", "iconColor", "iconHeight", "position", "children", "isReverse"]);

      return React.createElement(Container$5, rest, React.createElement("div", {
        ref: this.setWrapperRef
      }, React.createElement(Icon, {
        icon: icon,
        color: iconColor,
        height: iconHeight,
        onClick: this.handleClick
      }), React.createElement(TooltipContainer, {
        display: displayTooltip
      }, React.createElement(TooltipDiv, {
        position: position,
        isReverse: isReverse
      }, children), React.createElement(TooltipArrow, {
        position: position
      }))));
    }
  }]);

  return Tooltip;
}(Component);

Tooltip.defaultProps = {
  icon: 'assistance',
  iconColor: 'blue',
  iconHeight: 25,
  position: 'right',
  children: undefined,
  isReverse: false
};
Tooltip.propTypes = {
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  iconHeight: PropTypes.number,
  position: PropTypes.oneOf(['right', 'top', 'bottom']),
  children: PropTypes.node,
  isReverse: PropTypes.bool
};

var fontSizeBase$7 = 16;
var size = 16 / fontSizeBase$7;
var borderWidth = 2 / fontSizeBase$7;
var borderWidthSelected = 6 / fontSizeBase$7;
var marginText = 10 / fontSizeBase$7;
var paddingHorizontal = 5 / fontSizeBase$7;

function _objectWithoutProperties$7(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$7(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$7(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject4$5() {
  var data = _taggedTemplateLiteral$K(["\n  position: absolute;\n  left: -9999px;\n\n  &:focus {\n    & ~ ", " {\n      border-color: ", ";\n    }\n  }\n\n  &:checked {\n    & ~ ", " {\n      background-color: transparent;\n      border-width: ", "rem;\n      border-color: ", ";\n      height: ", "rem;\n      width: ", "rem;\n      min-width: ", "rem;\n      min-height: ", "rem;\n    }\n\n    &:disabled {\n      & ~ ", " {\n        border-color: ", ";\n      }\n    }\n  }\n\n  &:disabled {\n    & ~ ", " {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteral$K(["\n  ", " & {\n    padding-left: ", "rem;\n  }\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteral$K(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ", "rem;\n  min-width: ", "rem;\n  height: ", "rem;\n  min-height: ", "rem;\n  border-width: ", "rem;\n  border-style: solid;\n  border-color: ", ";\n  border-radius: ", "rem;\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$K() {
  var data = _taggedTemplateLiteral$K(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: ", "rem 0;\n"]);

  _templateObject$K = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$K(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container$6 = styled('label')(_templateObject$K(), paddingHorizontal);
var RadioContainer = styled('div')(_templateObject2$b(), size, size, size, size, borderWidth, grey4, size);
var Label = styled(Text.withComponent('div'))(_templateObject3$5(), Container$6, marginText);
var Input = styled('input')(_templateObject4$5(), RadioContainer, grey3, RadioContainer, borderWidthSelected, function (props) {
  return props.color;
}, size + borderWidth * 2 - borderWidthSelected * 2, size + borderWidth * 2 - borderWidthSelected * 2, size + borderWidth * 2 - borderWidthSelected * 2, size + borderWidth * 2 - borderWidthSelected * 2, RadioContainer, grey4, Label, grey4);

var Radio = function Radio(props) {
  var checked = props.checked,
      disabled = props.disabled,
      value = props.value,
      color = props.color,
      labelSize = props.labelSize,
      labelBold = props.labelBold,
      onChange = props.onChange,
      children = props.children,
      rest = _objectWithoutProperties$7(props, ["checked", "disabled", "value", "color", "labelSize", "labelBold", "onChange", "children"]);

  var label = children ? React.createElement(Label, {
    size: labelSize,
    bold: labelBold,
    onClick: function onClick() {
      onChange({
        value: value
      });
    }
  }, children) : undefined;
  return React.createElement(Container$6, rest, React.createElement(Input, {
    type: "radio",
    value: value,
    disabled: disabled,
    color: color,
    checked: checked
  }), React.createElement(RadioContainer, {
    role: "radio",
    "aria-checked": checked,
    onClick: function onClick() {
      onChange({
        value: value
      });
    }
  }), label);
};

Radio.defaultProps = {
  color: orange2,
  checked: false,
  labelBold: true,
  labelSize: 'm',
  disabled: false,
  onChange: function onChange() {},
  children: undefined
};
Radio.propTypes = {
  /** Label of the field */
  children: PropTypes.node,

  /** String indicating the value of the radio */
  value: PropTypes.string.isRequired,

  /** String indicating the color of the checkbox */
  color: PropTypes.string,

  /** Boolean indicating if the checkbox is checked */
  checked: PropTypes.bool,

  /** Boolean indicating if the label is bold */
  labelBold: PropTypes.bool,

  /** String indicating the size of the label */
  labelSize: PropTypes.oneOf(['s', 'm', 'l']),

  /** Boolean indicating if the checkbox is disabled */
  disabled: PropTypes.bool,

  /** Function excecuted on change */
  onChange: PropTypes.func
};

var fontSizeBase$8 = 16;
var fontFamily = 'inherit';
var height = 36 / fontSizeBase$8;
var heightL$1 = 46 / fontSizeBase$8;
var heightXL = 56 / fontSizeBase$8;
var fontSize = 16 / fontSizeBase$8;
var fontSizeL = 18 / fontSizeBase$8;
var fontSizeXL = 20 / fontSizeBase$8;
var iconSizeM = 20;
var iconSizeL = 25;
var iconSizeXL = 30;
var horizontalPadding = 7 / fontSizeBase$8;
var horizontalPaddingL = 12 / fontSizeBase$8;
var horizontalPaddingXL = 17 / fontSizeBase$8;
var borderInput = 2 / fontSizeBase$8;
var paddingTopLabel = 10 / fontSizeBase$8;
var paddingTopLabelL = 15 / fontSizeBase$8;
var paddingTopLabelXL = 20 / fontSizeBase$8;
var paddingRightLabel = 20 / fontSizeBase$8;
var horizontalMarginInput = 10 / fontSizeBase$8;

function _typeof$8(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$8 = function _typeof(obj) { return typeof obj; }; } else { _typeof$8 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$8(obj); }

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function _objectWithoutProperties$8(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$8(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$8(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$9(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$9(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$9(Constructor.prototype, protoProps); if (staticProps) _defineProperties$9(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$8(self, call) { if (call && (_typeof$8(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$8(self); }

function _assertThisInitialized$8(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf$8(o) { _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$8(o); }

function _inherits$8(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$8(subClass, superClass); }

function _setPrototypeOf$8(o, p) { _setPrototypeOf$8 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$8(o, p); }

function _templateObject9() {
  var data = _taggedTemplateLiteral$L(["\n  flex-shrink: 0;\n  margin-right: 0.3125rem;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral$L(["\n  position: absolute;\n  left: ", ";\n  top: 50%;\n  transform: translateY(-50%);\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral$L(["\n  margin-bottom: ", "rem;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteral$L(["\n  position: relative;\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteral$L(["\n  padding-right: ", "rem;\n  flex: 1 1 0rem;\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$6() {
  var data = _taggedTemplateLiteral$L(["\n  display: flex;\n  align-items: center;\n  margin-top: ", "rem;\n  text-align: ", "\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteral$L(["\n  display: flex;\n  width: ", ";\n  text-align: right;\n  padding: ", ";\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$c() {
  var data = _taggedTemplateLiteral$L(["\n  ", "\n  padding: ", "rem;\n  font-size: ", "rem;\n  font-family: ", ";\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$L() {
  var data = _taggedTemplateLiteral$L(["\n    height: ", ";\n    padding: ", ";\n    font-size: ", ";\n  padding-left: ", ";\n  font-family: ", ";\n  ", ";\n"]);

  _templateObject$L = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$L(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function getStyle(props) {
  var color = props.isValid ? grey4 : functionalRed;
  var borderColor = props.isValid ? black : functionalRed;
  return "\n    font-weight: bold;\n    color: ".concat(black, ";\n    border: ").concat(borderInput, "rem solid ").concat(color, ";\n    outline: none;\n\n    :focus {\n      border-color: ").concat(borderColor, "\n    }\n\n    :disabled {\n      background-color: ").concat(grey6, "\n    }\n  ");
}

var TextInputElement = styled('input')(_templateObject$L(), function (props) {
  var heightV;

  switch (props.size) {
    case 'l':
      heightV = heightL$1;
      break;

    case 'xl':
      heightV = heightXL;
      break;

    case 'm':
    default:
      heightV = height;
      break;
  }

  return "".concat(heightV, "rem");
}, function (props) {
  var paddingV;

  switch (props.size) {
    case 'l':
      paddingV = horizontalPaddingL;
      break;

    case 'xl':
      paddingV = horizontalPaddingXL;
      break;

    case 'm':
    default:
      paddingV = horizontalPadding;
      break;
  }

  return "0 ".concat(paddingV, "rem");
}, function (props) {
  var fontSizeV;

  switch (props.size) {
    case 'l':
      fontSizeV = fontSizeL;
      break;

    case 'xl':
      fontSizeV = fontSizeXL;
      break;

    case 'm':
    default:
      fontSizeV = fontSize;
      break;
  }

  return "".concat(fontSizeV, "rem");
}, function (props) {
  if (props.icon) {
    var paddingL;

    switch (props.size) {
      case 'l':
        paddingL = iconSizeL;
        break;

      case 'xl':
        paddingL = iconSizeXL;
        break;

      case 'm':
      default:
        paddingL = iconSizeM;
        break;
    }

    return "".concat((paddingL * 2 - 5) / fontSizeBase$8, "rem");
  }

  return undefined;
}, fontFamily, function (props) {
  return getStyle(props);
});
var TextAreaElement = styled('textarea')(_templateObject2$c(), function (props) {
  return getStyle(props);
}, horizontalPadding, fontSize, fontFamily);
var Span = Text.withComponent('span');
var LeftLabelContainer = styled('div')(_templateObject3$6(), function (props) {
  return props.width ? "".concat(props.width, "%") : undefined;
}, function (props) {
  var paddingV;

  switch (props.size) {
    case 'l':
      paddingV = paddingTopLabelL;
      break;

    case 'xl':
      paddingV = paddingTopLabelXL;
      break;

    case 'm':
    default:
      paddingV = paddingTopLabel;
      break;
  }

  return "".concat(paddingV, "rem 0");
});
var ErrorT = styled(Text)(_templateObject4$6(), horizontalMarginInput, function (props) {
  return props.position === 'top' ? undefined : 'right';
});
var LabelLeft = styled('label')(_templateObject5$3(), paddingRightLabel);
var FlexRelative = styled(Flex)(_templateObject6$1());
var LabelTop = styled('label')(_templateObject7(), horizontalMarginInput);
var InputIcon = styled(Icon)(_templateObject8(), function (props) {
  var left;

  switch (props.size) {
    case 'l':
      left = iconSizeL;
      break;

    case 'xl':
      left = iconSizeXL;
      break;

    case 'm':
    default:
      left = iconSizeM;
      break;
  }

  return "".concat(left / 2 / fontSizeBase$8, "rem");
});
var ErrorIcon = styled(Icon)(_templateObject9());

var TextInput =
/*#__PURE__*/
function (_Component) {
  _inherits$8(TextInput, _Component);

  function TextInput(props) {
    var _this;

    _classCallCheck$9(this, TextInput);

    _this = _possibleConstructorReturn$8(this, _getPrototypeOf$8(TextInput).call(this, props));

    _this.handleChange = function (event) {
      var onChange = _this.props.onChange;
      event.preventDefault();

      if (onChange) {
        onChange(event.target.value);
      }
    };

    _this.focusTextInput = function () {
      _this.ref.current.focus();
    };

    _this.ref = React.createRef();
    _this.element = props.type === 'textarea' ? TextAreaElement : TextInputElement;
    return _this;
  }

  _createClass$9(TextInput, [{
    key: "getIcon",
    value: function getIcon() {
      var _this$props = this.props,
          icon = _this$props.icon,
          type = _this$props.type,
          size = _this$props.size;

      if (icon === undefined || type === 'textarea') {
        return undefined;
      }

      var iconColor = this.props.iconColor;
      var iconSize;

      switch (size) {
        case 'l':
          iconSize = iconSizeL;
          break;

        case 'xl':
          iconSize = iconSizeXL;
          break;

        case 'm':
        default:
          iconSize = iconSizeM;
          break;
      }

      return React.createElement(InputIcon, {
        icon: icon,
        color: iconColor,
        width: iconSize,
        height: iconSize
      });
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      var _this$props2 = this.props,
          label = _this$props2.label,
          id = _this$props2.id,
          mandatory = _this$props2.mandatory,
          labelPosition = _this$props2.labelPosition,
          labelWidth = _this$props2.labelWidth,
          size = _this$props2.size;

      if (label === undefined || label === '') {
        return undefined;
      }

      var content;

      if (labelPosition === 'left') {
        content = React.createElement(LabelLeft, {
          htmlFor: id
        }, React.createElement(Span, {
          bold: true,
          id: "".concat(id, "-label")
        }, label, mandatory ? React.createElement(Span, {
          bold: true,
          color: "orange"
        }, "\xA0*") : undefined));
      } else {
        content = React.createElement(LabelTop, {
          htmlFor: id
        }, React.createElement(Span, {
          bold: true,
          id: "".concat(id, "-label")
        }, label, mandatory ? React.createElement(Span, {
          bold: true,
          color: "orange"
        }, "\xA0*") : undefined));
      }

      if (labelPosition === 'left') {
        return React.createElement(LeftLabelContainer, {
          width: labelWidth,
          size: size
        }, content);
      }

      return content;
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage() {
      var _this$props3 = this.props,
          errorMessage = _this$props3.errorMessage,
          errorWithIcon = _this$props3.errorWithIcon,
          valid = _this$props3.valid,
          id = _this$props3.id,
          labelPosition = _this$props3.labelPosition;

      if (errorMessage && !valid) {
        return React.createElement(ErrorT, {
          id: "".concat(id, "-error-message"),
          bold: true,
          size: "s",
          color: errorWithIcon ? 'black' : 'red',
          position: labelPosition
        }, errorWithIcon && React.createElement(ErrorIcon, {
          icon: "error-severe",
          color: "red",
          height: 15,
          width: 15
        }), errorMessage);
      }

      return undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          labelPosition = _this$props4.labelPosition,
          id = _this$props4.id,
          type = _this$props4.type,
          size = _this$props4.size,
          mandatory = _this$props4.mandatory,
          placeholder = _this$props4.placeholder,
          icon = _this$props4.icon,
          inputAppend = _this$props4.inputAppend,
          disabled = _this$props4.disabled,
          valid = _this$props4.valid,
          value = _this$props4.value,
          rest = _objectWithoutProperties$8(_this$props4, ["labelPosition", "id", "type", "size", "mandatory", "placeholder", "icon", "inputAppend", "disabled", "valid", "value"]);

      return React.createElement(Flex, {
        flexDirection: "column"
      }, React.createElement(Flex, {
        flexDirection: labelPosition === 'top' ? 'column' : undefined
      }, this.getLabel(), React.createElement(FlexRelative, {
        flexDirection: "column",
        flex: labelPosition === 'left' ? '1 1 0rem' : undefined
      }, this.getIcon(), React.createElement(this.element, _extends$5({}, rest, {
        ref: this.ref,
        id: id,
        type: type,
        size: size,
        required: mandatory,
        placeholder: placeholder,
        disabled: disabled,
        isValid: valid,
        onChange: this.handleChange,
        icon: icon,
        value: value,
        "aria-invalid": !valid,
        "aria-required": mandatory,
        "aria-describedby": "".concat(id, "-error-message")
      })), inputAppend || '', this.getErrorMessage())));
    }
  }]);

  return TextInput;
}(Component);

TextInput.defaultProps = {
  type: 'text',
  mandatory: false,
  size: 'm',
  placeholder: undefined,
  label: '',
  labelPosition: 'top',
  labelWidth: 30,
  valid: true,
  errorMessage: undefined,
  errorWithIcon: false,
  maxLength: undefined,
  disabled: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  icon: undefined,
  iconColor: 'black',
  value: '',
  inputAppend: undefined
};
TextInput.propTypes = {
  /** Node to append to the input */
  inputAppend: PropTypes.node,

  /** Id of the input */
  id: PropTypes.string.isRequired,

  /** String indicating the type of the input */
  type: PropTypes.oneOf(['text', 'password', 'textarea']),

  /** Boolean indicating if the field is mandatory */
  mandatory: PropTypes.bool,

  /** String indicating the size of the input */
  size: PropTypes.oneOf(['m', 'l', 'xl']),

  /** String indicating the placeholder of the label */
  placeholder: PropTypes.string,

  /** Srint input label */
  label: PropTypes.string,

  /** String indicating the position of the label */
  labelPosition: PropTypes.oneOf(['top', 'left']),

  /** Number indicating the width of label (percentage) */
  labelWidth: PropTypes.number,

  /** Boolean indicating if the input is valid */
  valid: PropTypes.bool,

  /** String indicating the error message */
  errorMessage: PropTypes.string,

  /** Boolean displaying icon error */
  errorWithIcon: PropTypes.bool,

  /** Boolean indicating if the input is disabled */
  disabled: PropTypes.bool,

  /** Number indicating max-length */
  maxLength: PropTypes.number,

  /** Function excecute on focus DOM event */
  onFocus: PropTypes.func,

  /** Function excecute on blur DOM event */
  onBlur: PropTypes.func,

  /** String indicating the name of the icon to apply */
  icon: PropTypes.string,

  /** String indicating the color of the icon to apply */
  iconColor: PropTypes.string,

  /** Function excecuted when input value changes */
  onChange: PropTypes.func,

  /** String corresponding to the input value */
  value: PropTypes.string
};

function _templateObject4$7() {
  var data = _taggedTemplateLiteral$M(["\n  display: none;\n  &:checked + ", ":before {\n    transform: translateX(2.9rem);\n  }\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$7() {
  var data = _taggedTemplateLiteral$M(["\n  padding-left:  ", ";\n  color:  ", ";\n  font-weight: bold;\n  z-index: 0;\n  line-height: 2rem;\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$d() {
  var data = _taggedTemplateLiteral$M(["\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ", ";\n  transition: .4s;\n  border-radius: 1rem;\n\n  &:before {\n    height: 1.9rem;\n    width: 1.9rem;\n    position: absolute;\n    content: \"\";\n    left: .1rem;\n    bottom: 1px;\n    background-color: white;\n    transition: .4s;\n    border-radius: 50%;\n    z-index: 1;\n  }\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$M() {
  var data = _taggedTemplateLiteral$M(["\n  position: relative;\n  display: inline-block;\n  min-width: 5rem;\n  height: 2rem;\n  outline: none;\n"]);

  _templateObject$M = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$M(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Check = styled('label')(_templateObject$M());
var Slider = styled('div')(_templateObject2$d(), function (props) {
  if (props.disabled) return grey4;
  return props.checked ? props.backgroundColor : props.unCheckedBackground;
});
var Text$1 = styled('span')(_templateObject3$7(), function (props) {
  return props.checked ? '.6rem' : '2.38rem';
}, function (props) {
  return props.checked ? black : white;
});
var Input$1 = styled('input')(_templateObject4$7(), Slider);

var SwitchComponent = function SwitchComponent(props) {
  var backgroundColor = props.backgroundColor,
      unCheckedBackground = props.unCheckedBackground,
      disabled = props.disabled,
      onChange = props.onChange,
      checked = props.checked,
      id = props.id;
  return React.createElement(Check, null, React.createElement(Input$1, {
    id: id,
    disabled: disabled,
    type: "checkbox",
    checked: checked,
    onChange: onChange
  }), React.createElement(Slider, {
    disabled: disabled,
    checked: checked,
    backgroundColor: backgroundColor,
    unCheckedBackground: unCheckedBackground
  }, React.createElement(Text$1, {
    checked: checked
  }, checked ? 'Oui' : 'Non')));
};

SwitchComponent.defaultProps = {
  disabled: false,
  checked: true,
  id: undefined
};
SwitchComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  unCheckedBackground: PropTypes.string.isRequired,
  id: PropTypes.string,
  disabled: PropTypes.bool,

  /** Boolean indicating if the checkbox is checked */
  checked: PropTypes.bool
};

var fontSizeBase$9 = 16;
var size$1 = 16 / fontSizeBase$9;
var borderWidth$1 = 2 / fontSizeBase$9;
var tickHeight = 18;
var marginText$1 = 10 / fontSizeBase$9;
var marginTextRight = 10 / fontSizeBase$9;
var marginTextLeft = 20 / fontSizeBase$9;
var paddingHorizontal$1 = 5 / fontSizeBase$9;

function _templateObject3$8() {
  var data = _taggedTemplateLiteral$N(["\n  position: absolute;\n  left: -9999px;\n\n  &:focus {\n    & ~ ", " {\n      border-color: ", ";\n    }\n  }\n\n  &:checked {\n    & ~ ", " {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    & ~ ", " > ", " {\n      display: block;\n    }\n\n    &:disabled {\n      & ~ ", " {\n        background-color: ", ";\n        border-color: ", ";\n      }\n    }\n  }\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$e() {
  var data = _taggedTemplateLiteral$N(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ", "rem;\n  height: ", "rem;\n  min-width: ", "rem;\n  min-height: ", "rem;\n  border-width: ", "rem;\n  border-style: solid;\n  border-color: ", ";\n\n  & > ", " {\n    display: none;\n  }\n"]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$N() {
  var data = _taggedTemplateLiteral$N([""]);

  _templateObject$N = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$N(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledIcon = styled(Icon)(_templateObject$N());
var CheckboxContainer = styled('div')(_templateObject2$e(), size$1, size$1, size$1, size$1, borderWidth$1, grey4, StyledIcon);
var Input$2 = styled('input')(_templateObject3$8(), CheckboxContainer, grey3, CheckboxContainer, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, CheckboxContainer, StyledIcon, CheckboxContainer, grey4, grey4);

var CheckboxTick = function CheckboxTick(props) {
  var checked = props.checked,
      disabled = props.disabled,
      color = props.color,
      tickColor = props.tickColor,
      onChange = props.onChange,
      id = props.id;
  return React.createElement("div", null, React.createElement(Input$2, {
    type: "checkbox",
    disabled: disabled,
    color: color,
    checked: checked,
    onChange: onChange
  }), React.createElement(CheckboxContainer, {
    id: "".concat(id, "-input"),
    role: "checkbox",
    "aria-checked": checked
  }, React.createElement(StyledIcon, {
    icon: "tick",
    color: tickColor,
    height: tickHeight
  })));
};

CheckboxTick.defaultProps = {
  color: orange2,
  checked: false,
  disabled: false,
  tickColor: 'white',
  id: undefined
};
CheckboxTick.propTypes = {
  /** Function for handling onChange */
  onChange: PropTypes.func.isRequired,

  /** String indicating the color of the checkbox */
  color: PropTypes.string,

  /** Boolean indicating if the checkbox is checked */
  checked: PropTypes.bool,

  /** Boolean indicating if the checkbox is disabled */
  disabled: PropTypes.bool,

  /** Color of the tick */
  tickColor: PropTypes.oneOf(['white', 'black', 'orange', 'blue', 'green']),

  /** String identifier */
  id: PropTypes.string
};

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function _typeof$9(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$9 = function _typeof(obj) { return typeof obj; }; } else { _typeof$9 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$9(obj); }

function _objectWithoutProperties$9(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$9(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$9(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$a(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$a(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$a(Constructor.prototype, protoProps); if (staticProps) _defineProperties$a(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$9(self, call) { if (call && (_typeof$9(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$9(self); }

function _getPrototypeOf$9(o) { _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$9(o); }

function _assertThisInitialized$9(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$9(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$9(subClass, superClass); }

function _setPrototypeOf$9(o, p) { _setPrototypeOf$9 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$9(o, p); }

function _templateObject2$f() {
  var data = _taggedTemplateLiteral$O(["\n  ", " & {\n    padding-left: ", ";\n    padding-right: ", ";\n    width: ", ";\n    text-align: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject2$f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$O() {
  var data = _taggedTemplateLiteral$O(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: ", "rem 0;\n"]);

  _templateObject$O = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$O(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container$7 = styled('label')(_templateObject$O(), paddingHorizontal$1);
var Label$1 = styled(Text)(_templateObject2$f(), Container$7, function (props) {
  return props.position === 'right' && "".concat(marginText$1, "rem");
}, function (props) {
  return props.position === 'left' && "".concat(marginText$1, "rem");
}, function (props) {
  return props.width && "calc(".concat(props.width, "% - ").concat(marginText$1, "rem)");
}, function (props) {
  return props.position === 'left' && 'right';
}, function (props) {
  return props.disabled ? grey4 : props.color;
});
var ChildrenContainer = Label$1.withComponent('div');

var CheckboxComponent =
/*#__PURE__*/
function (_Component) {
  _inherits$9(CheckboxComponent, _Component);

  function CheckboxComponent(props) {
    var _this;

    _classCallCheck$a(this, CheckboxComponent);

    _this = _possibleConstructorReturn$9(this, _getPrototypeOf$9(CheckboxComponent).call(this, props));
    _this.state = {
      checked: true
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized$9(_this));
    _this.createChildrenElement = _this.createChildrenElement.bind(_assertThisInitialized$9(_this));
    return _this;
  }

  _createClass$a(CheckboxComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var checked = this.props.checked;
      this.setState({
        checked: checked
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var checked = this.props.checked;

      if (prevProps.checked !== checked) {
        this.setState({
          checked: checked
        });
      }
    }
  }, {
    key: "createChildrenElement",
    value: function createChildrenElement() {
      var _this$props = this.props,
          children = _this$props.children,
          disabled = _this$props.disabled,
          labelSize = _this$props.labelSize,
          labelBold = _this$props.labelBold,
          labelPosition = _this$props.labelPosition,
          labelWidth = _this$props.labelWidth,
          wrapperType = _this$props.wrapperType,
          id = _this$props.id;

      if (!children) {
        return null;
      }

      var props = {
        size: labelSize,
        bold: labelBold,
        position: labelPosition,
        width: labelWidth,
        disabled: disabled,
        id: "".concat(id, "-label")
      };

      switch (wrapperType) {
        case 'text':
          return React.createElement(Label$1, props, children);

        case 'div':
          return React.createElement(ChildrenContainer, props, children);

        default:
          return null;
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var onChange = this.props.onChange;
      event.stopPropagation();
      this.setState({
        checked: event.target.checked
      });

      if (onChange) {
        onChange({
          checked: event.target.checked
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          color = _this$props2.color,
          labelPosition = _this$props2.labelPosition,
          tickColor = _this$props2.tickColor,
          checkboxType = _this$props2.checkboxType,
          backgroundColor = _this$props2.backgroundColor,
          unCheckedBackground = _this$props2.unCheckedBackground,
          id = _this$props2.id,
          rest = _objectWithoutProperties$9(_this$props2, ["disabled", "color", "labelPosition", "tickColor", "checkboxType", "backgroundColor", "unCheckedBackground", "id"]);

      var checked = this.state.checked;
      var label = this.createChildrenElement();
      var element = checkboxType === 'checkbox' ? React.createElement(CheckboxTick, {
        id: id,
        onChange: this.handleChange,
        checked: checked,
        disabled: disabled,
        tickColor: tickColor,
        color: color
      }) : React.createElement(SwitchComponent, {
        id: id,
        onChange: this.handleChange,
        checked: checked,
        backgroundColor: backgroundColor,
        unCheckedBackground: unCheckedBackground,
        disabled: disabled
      });
      return React.createElement(Container$7, rest, labelPosition === 'left' && label, element, labelPosition === 'right' && label);
    }
  }]);

  return CheckboxComponent;
}(Component);

var Switch = function Switch(props) {
  return React.createElement(CheckboxComponent, _extends$6({
    checkboxType: "switch"
  }, props));
};

var Checkbox = function Checkbox(props) {
  return React.createElement(CheckboxComponent, props);
};

CheckboxComponent.defaultProps = {
  children: '',
  color: orange2,
  checked: true,
  labelBold: true,
  labelSize: 'm',
  labelPosition: 'right',
  labelWidth: undefined,
  disabled: false,
  tickColor: 'white',
  wrapperType: 'text',
  checkboxType: 'checkbox',
  backgroundColor: '#32c832',
  unCheckedBackground: '#E70002',
  id: undefined
};
CheckboxComponent.propTypes = {
  /** Label of the field */
  children: PropTypes.node,

  /** String indicating the color of the checkbox */
  color: PropTypes.string,

  /** Boolean indicating if the checkbox is checked */
  checked: PropTypes.bool,

  /** Boolean indicating if the label is bold */
  labelBold: PropTypes.bool,

  /** String indicating the size of the label */
  labelSize: PropTypes.oneOf(['s', 'm', 'l']),

  /** String indicating the size of the label */
  labelPosition: PropTypes.oneOf(['left', 'right']),

  /** String indicating the width of the label (%) */
  labelWidth: PropTypes.number,

  /** Boolean indicating if the checkbox is disabled */
  disabled: PropTypes.bool,

  /** Color of the tick */
  tickColor: PropTypes.oneOf(['white', 'black', 'orange', 'blue', 'green']),

  /** The id of the field */
  id: PropTypes.string,

  /** The label of the field */
  checkboxType: PropTypes.string,

  /** String background color when check */
  backgroundColor: PropTypes.string,

  /** String background color */
  unCheckedBackground: PropTypes.string,

  /** Function callback on change */
  onChange: PropTypes.func.isRequired,

  /** The element used to wrap the children elements */
  wrapperType: PropTypes.oneOf(['text', 'div'])
};
Switch.propTypes = CheckboxComponent.propTypes;
Checkbox.propTypes = CheckboxComponent.propTypes;

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function _objectWithoutProperties$a(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$a(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$a(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Textarea = function Textarea(props) {
  var children = props.children,
      rest = _objectWithoutProperties$a(props, ["children"]);

  return React.createElement(TextInput, _extends$7({
    type: "textarea"
  }, rest), children);
};

Textarea.defaultProps = {
  children: '',
  mandatory: false,
  placeholder: undefined,
  labelPosition: 'top',
  labelWidth: 30,
  valid: true,
  errorMessage: undefined,
  maxLength: undefined,
  disabled: false
};
Textarea.propTypes = {
  /** Id of the input */
  id: PropTypes.string.isRequired,

  /** Label of the textarea */
  children: PropTypes.node,

  /** String indicating the placeholder of the label */
  placeholder: PropTypes.string,

  /** String indicating the position of the label */
  labelPosition: PropTypes.oneOf(['top', 'left']),

  /** Number indicating the width of label (percentage) */
  labelWidth: PropTypes.number,

  /** Boolean indicating if the input is valid */
  valid: PropTypes.bool,

  /** String indicating the error message */
  errorMessage: PropTypes.string,

  /** Boolean indicating if the input is disabled */
  disabled: PropTypes.bool,

  /** Boolean indicating if the field is mandatory */
  mandatory: PropTypes.bool,

  /** Number indicating max-length */
  maxLength: PropTypes.number
};

var $forEach$1 = arrayIteration.forEach;



var STRICT_METHOD$2 = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH$5 = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
var arrayForEach = (!STRICT_METHOD$2 || !USES_TO_LENGTH$5) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
_export({ target: 'Array', proto: true, forced: [].forEach != arrayForEach }, {
  forEach: arrayForEach
});

// TODO: Remove from `core-js@4` since it's moved to entry points







var SPECIES$3 = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$3] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classofRaw(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};

var max$2 = Math.max;
var min$2 = Math.min;
var floor$1 = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegexpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regexpExecAbstract(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max$2(min$2(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor$1(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

for (var COLLECTION_NAME$1 in domIterables) {
  var Collection$1 = global_1[COLLECTION_NAME$1];
  var CollectionPrototype$1 = Collection$1 && Collection$1.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype$1 && CollectionPrototype$1.forEach !== arrayForEach) try {
    createNonEnumerableProperty(CollectionPrototype$1, 'forEach', arrayForEach);
  } catch (error) {
    CollectionPrototype$1.forEach = arrayForEach;
  }
}

var fontSizeBase$a = 16;
var borderSize = 2 / fontSizeBase$a;
var timeSelectorWidth = 40 / fontSizeBase$a;
/* Quantity Selector */

var selectorHeight = 30 / fontSizeBase$a;
var selectorHeightL = 38.4 / fontSizeBase$a;
var operatorFontSize = 22 / fontSizeBase$a;
var operatorFontSizeL = 30 / fontSizeBase$a;
var valueFontSize = 16 / fontSizeBase$a;
var valueFontSizeL = 20 / fontSizeBase$a;
var valuePadding = 5 / fontSizeBase$a;
var valuePaddingL = 10 / fontSizeBase$a;
var paddingRightLabel$1 = 20 / fontSizeBase$a;
var horizontalMarginInput$1 = 10 / fontSizeBase$a;
var paddingTopLabel$1 = 10 / fontSizeBase$a;
var paddingTopLabelL$1 = 15 / fontSizeBase$a;

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$b(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$b(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$b(Constructor.prototype, protoProps); if (staticProps) _defineProperties$b(Constructor, staticProps); return Constructor; }

var Formatter =
/*#__PURE__*/
function () {
  function Formatter() {
    _classCallCheck$b(this, Formatter);
  }

  _createClass$b(Formatter, null, [{
    key: "parseFormat",
    value: function parseFormat(format) {
      var previousChar = '';
      var split = '';
      var splits = [];

      for (var i = 0; i < format.length; i += 1) {
        var currentChar = format.charAt(i);

        if (previousChar === currentChar) {
          split += currentChar;
        } else {
          if (split.length > 0) {
            splits.push(split);
          }

          previousChar = currentChar;
          split = currentChar;
        }
      }

      if (split.length > 0) {
        splits.push(split);
      }

      return splits;
    }
  }, {
    key: "tokenBlockLength",
    value: function tokenBlockLength(token) {
      switch (token) {
        case 'DD':
          return 2;

        case 'MM':
          return 2;

        case 'YYYY':
          return 4;

        case '/':
          return 0;

        case '-':
          return 0;

        default:
          throw new Error("Unknonwn token ".concat(token));
      }
    }
  }, {
    key: "adjustTokenValue",
    value: function adjustTokenValue(token, value) {
      switch (token) {
        case '/':
          return '/';

        case '-':
          return '-';

        case 'DD':
          return value > 31 ? 31 : value;

        case 'MM':
          return value > 12 ? 12 : value;

        default:
          return value;
      }
    }
  }]);

  return Formatter;
}();

function _typeof$a(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$a = function _typeof(obj) { return typeof obj; }; } else { _typeof$a = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$a(obj); }

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function _objectWithoutProperties$b(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$b(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$b(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$c(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$c(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$c(Constructor.prototype, protoProps); if (staticProps) _defineProperties$c(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$a(self, call) { if (call && (_typeof$a(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$a(self); }

function _getPrototypeOf$a(o) { _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$a(o); }

function _assertThisInitialized$a(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$a(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$a(subClass, superClass); }

function _setPrototypeOf$a(o, p) { _setPrototypeOf$a = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$a(o, p); }

function _templateObject5$4() {
  var data = _taggedTemplateLiteral$P(["\n  border: ", "rem solid ", ";\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$8() {
  var data = _taggedTemplateLiteral$P(["\n  position:fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  display: ", "\n"]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$9() {
  var data = _taggedTemplateLiteral$P(["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 3;\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$g() {
  var data = _taggedTemplateLiteral$P(["\n  position: relative;\n  display: inline;\n"]);

  _templateObject2$g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$P() {
  var data = _taggedTemplateLiteral$P([""]);

  _templateObject$P = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$P(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
moment.locale('fr');
var Container$8 = styled('div')(_templateObject$P());
var DateDivWrapper = styled('div')(_templateObject2$g());
var DateCalendar = styled('div')(_templateObject3$9());
var BackgroundLayout = styled('div')(_templateObject4$8(), function (props) {
  return props.opened ? 'block' : 'none';
});
var MiniCalendar = styled(Calendar)(_templateObject5$4(), borderSize, grey4);

var DatePicker =
/*#__PURE__*/
function (_Component) {
  _inherits$a(DatePicker, _Component);

  function DatePicker(props) {
    var _this;

    _classCallCheck$c(this, DatePicker);

    _this = _possibleConstructorReturn$a(this, _getPrototypeOf$a(DatePicker).call(this, props));
    _this.format = props.format;
    _this.dateFormat = Formatter.parseFormat(_this.format);

    var date = _this.getValue(props.value);

    _this.state = {
      focused: false,
      date: date,
      value: date.format(_this.format),
      valid: true
    };
    _this.setFocus = _this.setFocus.bind(_assertThisInitialized$a(_this));
    _this.onDateSelection = _this.onDateSelection.bind(_assertThisInitialized$a(_this));
    _this.onInputKeyDown = _this.onInputKeyDown.bind(_assertThisInitialized$a(_this));
    _this.setDateToNextDay = _this.setDateToNextDay.bind(_assertThisInitialized$a(_this));
    _this.setDateToPreviousDay = _this.setDateToPreviousDay.bind(_assertThisInitialized$a(_this));
    _this.formatDate = _this.formatDate.bind(_assertThisInitialized$a(_this));
    return _this;
  }

  _createClass$c(DatePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          value = _this$props.value,
          format = _this$props.format;

      if (prevProps.value !== value) {
        this.updateDate(value);
      }

      if (prevProps.format !== format) {
        this.format = format;
        this.dateFormat = Formatter.parseFormat(format);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      var _this2 = this;

      var onChange = this.props.onChange;
      var newValue = this.formatDate(value);
      this.updateDate(newValue, function () {
        if (onChange) {
          onChange(_this2.state);
        }
      });
    }
  }, {
    key: "onInputKeyDown",
    value: function onInputKeyDown(keyboardEvent) {
      if (keyboardEvent.key === 'Tab' || keyboardEvent.keyCode === 9) {
        this.setFocus(false);
      } else if (keyboardEvent.key === 'ArrowUp' || keyboardEvent.keyCode === 38) {
        this.setDateToNextDay();
      } else if (keyboardEvent.key === 'ArrowDown' || keyboardEvent.keyCode === 40) {
        this.setDateToPreviousDay();
      } else if (keyboardEvent.key === 'Enter' || keyboardEvent.keyCode === 13) {
        // Prevents the bubbling from triggering the form submission
        keyboardEvent.stopPropagation();
        this.setFocus(false);
      }
    }
  }, {
    key: "onDateSelection",
    value: function onDateSelection(date, keepFocus) {
      var onChange = this.props.onChange;
      var newDate = moment(date);
      this.setState({
        date: newDate,
        value: newDate.format(this.format),
        focused: keepFocus,
        valid: true
      });

      if (onChange) {
        onChange({
          date: newDate,
          value: newDate.format(this.format),
          valid: true
        });
      }
    }
  }, {
    key: "getValue",
    value: function getValue(dateString, returnInvaliDDate) {
      var date = moment(dateString, this.format);

      if (!date.isValid() && !returnInvaliDDate) {
        return moment();
      }

      return date;
    }
  }, {
    key: "setFocus",
    value: function setFocus(value) {
      this.setState({
        focused: value
      });
    }
  }, {
    key: "setDateToNextDay",
    value: function setDateToNextDay() {
      var date = this.state.date;
      var newDate = date.clone().add(1, 'day');
      this.onDateSelection(newDate.toDate(), true);
    }
  }, {
    key: "setDateToPreviousDay",
    value: function setDateToPreviousDay() {
      var date = this.state.date;
      var newDate = date.clone().subtract(1, 'day');
      this.onDateSelection(newDate.toDate(), true);
    }
  }, {
    key: "updateDate",
    value: function updateDate(value, callback) {
      var date = this.getValue(value, true);
      var newValue = date.isValid() ? date.format(this.format) : value;
      var state = {
        valid: date.isValid(),
        value: newValue
      };

      if (date.isValid()) {
        state.date = date;
      }

      this.setState(state, callback);
    }
  }, {
    key: "formatDate",
    value: function formatDate(currentValue) {
      var result = '';
      var value = currentValue.replace(/[^\d]/g, '');
      this.dateFormat.forEach(function (token) {
        if (value.length > 0) {
          var tokenBlockLength = Formatter.tokenBlockLength(token);
          var blockString = value.slice(0, tokenBlockLength);
          var rest = value.slice(tokenBlockLength);
          result += Formatter.adjustTokenValue(token, blockString);
          value = rest;
        }
      });
      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          min = _this$props2.min,
          max = _this$props2.max,
          maxLength = _this$props2.maxLength,
          rest = _objectWithoutProperties$b(_this$props2, ["children", "min", "max", "maxLength"]);

      var _this$state = this.state,
          focused = _this$state.focused,
          date = _this$state.date,
          valid = _this$state.valid,
          value = _this$state.value;
      var inputAppend = focused ? React.createElement(DateCalendar, null, React.createElement(MiniCalendar, {
        size: "s",
        selectDay: this.onDateSelection,
        date: date.toDate(),
        activeDate: date.toDate(),
        min: min,
        max: max
      })) : undefined;
      return React.createElement(Container$8, rest, React.createElement(DateDivWrapper, null, React.createElement(TextInput, _extends$8({
        type: "text"
      }, rest, {
        onFocus: function onFocus() {
          return _this3.setFocus(true);
        },
        onChange: function onChange(data) {
          return _this3.onChange(data);
        },
        onKeyDown: this.onInputKeyDown,
        icon: "calendar-day",
        iconColor: this.iconColor,
        valid: valid,
        value: value || '',
        placeholder: "DD/MM/YYYY",
        maxLength: maxLength,
        inputAppend: inputAppend
      }), children)), React.createElement(BackgroundLayout, {
        opened: focused,
        onClick: function onClick() {
          return _this3.setFocus(false);
        }
      }));
    }
  }, {
    key: "iconColor",
    get: function get() {
      var focused = this.state.focused;
      return focused ? 'orange' : 'black';
    }
  }, {
    key: "isDateValid",
    get: function get() {
      var date = this.state.date;
      return date.isValid();
    }
  }]);

  return DatePicker;
}(Component);

DatePicker.defaultProps = {
  children: '',
  mandatory: false,
  placeholder: undefined,
  labelPosition: 'top',
  labelWidth: 30,
  errorMessage: undefined,
  disabled: false,
  size: 'm',
  maxLength: 10,
  format: 'DD/MM/YYYY',
  value: '',
  onChange: function onChange() {},
  min: undefined,
  max: undefined
};
DatePicker.propTypes = {
  /** Label of the input */
  children: PropTypes.node,

  /** Value of the input */
  value: PropTypes.string,

  /** Id of the input */
  id: PropTypes.string.isRequired,

  /** String indicating the position of the label */
  labelPosition: PropTypes.oneOf(['top', 'left']),

  /** Number indicating the width of label (percentage) */
  labelWidth: PropTypes.number,

  /** String indicating the error message */
  errorMessage: PropTypes.string,

  /** Boolean indicating if the input is disabled */
  disabled: PropTypes.bool,

  /** Boolean indicating if the field is mandatory */
  mandatory: PropTypes.bool,

  /** String indicating the placeholder of the label */
  placeholder: PropTypes.string,

  /** String indicating the size of the input */
  size: PropTypes.oneOf(['m', 'l', 'xl']),

  /** Number indicating max-length */
  maxLength: PropTypes.number,

  /** String indicating date format (Luxon) for validation */
  format: PropTypes.string,

  /** Function executed on datepicker change */
  onChange: PropTypes.func,

  /** Date, minimum date selection in the picker */
  min: PropTypes.instanceOf(Date),

  /** Date, maximum date selection in the picker */
  max: PropTypes.instanceOf(Date)
};

var $includes = arrayIncludes.includes;



var USES_TO_LENGTH$6 = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true, forced: !USES_TO_LENGTH$6 }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var MATCH$1 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
_export({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegexp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

function _typeof$b(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$b = function _typeof(obj) { return typeof obj; }; } else { _typeof$b = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$b(obj); }

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function _objectWithoutProperties$c(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$c(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$c(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$d(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$d(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$d(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$d(Constructor.prototype, protoProps); if (staticProps) _defineProperties$d(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$b(self, call) { if (call && (_typeof$b(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$b(self); }

function _getPrototypeOf$b(o) { _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$b(o); }

function _assertThisInitialized$b(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$b(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$b(subClass, superClass); }

function _setPrototypeOf$b(o, p) { _setPrototypeOf$b = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$b(o, p); }

function _templateObject8$1() {
  var data = _taggedTemplateLiteral$Q(["\n  padding: 0.5rem 0;\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteral$Q(["\n  display: flex;\n  flex: 1 1 0rem;\n  flex-direction: column;\n  justify-content: center;\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteral$Q(["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 3;\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$5() {
  var data = _taggedTemplateLiteral$Q(["\n  border: ", "rem solid ", ";\n  display: flex;\n  flex-direction: row;\n  background: ", ";\n  padding: 0.8rem 0.5rem;\n\n  ", ":nth-child(4) {\n    margin-left: 0.2rem;\n  }\n"]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$9() {
  var data = _taggedTemplateLiteral$Q(["\n  width: ", "rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject4$9 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$a() {
  var data = _taggedTemplateLiteral$Q(["\n  position:fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  display: ", "\n"]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$h() {
  var data = _taggedTemplateLiteral$Q(["\n  position: relative;\n  display: inline;\n"]);

  _templateObject2$h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$Q() {
  var data = _taggedTemplateLiteral$Q([""]);

  _templateObject$Q = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$Q(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
moment.locale('fr');
var Container$9 = styled('div')(_templateObject$Q());
var DateDivWrapper$1 = styled('div')(_templateObject2$h());
var BackgroundLayout$1 = styled('div')(_templateObject3$a(), function (props) {
  return props.opened ? 'block' : 'none';
});
var TimeSelector = styled('div')(_templateObject4$9(), timeSelectorWidth);
var TimePickerSelector = styled('div')(_templateObject5$5(), borderSize, grey4, white, TimeSelector);
var TimePickerWrapper = styled('div')(_templateObject6$2());
var Separator = styled('div')(_templateObject7$1());
var ValueText = styled(Text)(_templateObject8$1());

var TimePicker =
/*#__PURE__*/
function (_Component) {
  _inherits$b(TimePicker, _Component);

  function TimePicker(props) {
    var _this;

    _classCallCheck$d(this, TimePicker);

    _this = _possibleConstructorReturn$b(this, _getPrototypeOf$b(TimePicker).call(this, props));
    _this.format = props.Hour24Format ? 'HH:mm' : 'hh:mm a';
    _this.state = {
      focused: false,
      valid: true,
      minValue: moment(props.minTime, _this.format),
      maxValue: moment(props.maxTime, _this.format)
    };
    var date = props.value && props.value !== '' ? _this.getValue(props.value).clone().startOf('minute') : moment().clone().startOf('minute');
    _this.state.date = date;
    _this.state.value = date.format(_this.format);
    _this.setFocus = _this.setFocus.bind(_assertThisInitialized$b(_this));
    _this.modifyTime = _this.modifyTime.bind(_assertThisInitialized$b(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized$b(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized$b(_this));
    _this.rootNode = React.createRef();
    return _this;
  }

  _createClass$d(TimePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var _this$props = this.props,
          minTime = _this$props.minTime,
          maxTime = _this$props.maxTime,
          value = _this$props.value;

      if (prevProps.minTime !== minTime || prevProps.maxTime !== maxTime) {
        this.setState({
          minValue: moment(minTime, this.format),
          maxValue: moment(maxTime, this.format)
        }, function () {
          if (value) {
            _this2.onChange(value, false);
          }
        });
      }
    }
  }, {
    key: "onChange",
    value: function onChange(value, onChangeTrigger) {
      var onChange = this.props.onChange; // Really basic autoformat for now

      var formattedValue = value;

      if (formattedValue.length > 2 && !formattedValue.includes(':')) {
        formattedValue = formattedValue.replace(/[^\d]/g, '');
        var hours = formattedValue.slice(0, 2);
        var minutes = formattedValue.slice(2);
        formattedValue = "".concat(hours, ":").concat(minutes);
      }

      var date = this.getValue(formattedValue, true);
      var newValue = date.isValid() ? date.format(this.format) : formattedValue;
      var state = {
        valid: date.isValid(),
        value: newValue
      };

      if (date.isValid()) {
        state.date = date;
      }

      this.setState(state);

      if (onChange && onChangeTrigger !== false) {
        onChange(state);
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(focusEvent) {
      // Checks if the next element receiving focus is inside the rootNode
      if (!this.rootNode.current.contains(focusEvent.relatedTarget)) {
        this.setFocus(false);
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(keyboardEvent) {
      if (keyboardEvent.shiftKey && (keyboardEvent.key === 'Tab' || keyboardEvent.keyCode === 9)) {
        this.setFocus(false);
      }
    }
  }, {
    key: "getValue",
    value: function getValue(dateString, returnInvalidDate) {
      var _this$state = this.state,
          maxValue = _this$state.maxValue,
          minValue = _this$state.minValue;
      var date = moment(dateString, this.format);

      if (!date.isValid() && !returnInvalidDate) {
        return moment();
      }

      if (date.isValid()) {
        if (maxValue.isBefore(date)) {
          date = maxValue;
        }

        if (minValue.isAfter(date)) {
          date = minValue;
        }
      }

      return date;
    }
  }, {
    key: "setFocus",
    value: function setFocus(value) {
      this.setState({
        focused: value
      });
    }
  }, {
    key: "modifyTime",
    value: function modifyTime(type, operation) {
      var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var _this$state2 = this.state,
          date = _this$state2.date,
          maxValue = _this$state2.maxValue,
          minValue = _this$state2.minValue;
      var _this$props2 = this.props,
          loopback = _this$props2.loopback,
          onChange = _this$props2.onChange;
      var newTime = date.clone()[operation](value, type);
      var newTimeExceedRange = newTime.isAfter(maxValue) || newTime.isBefore(minValue);

      if (newTimeExceedRange && loopback === 'none') {
        return;
      }

      if (newTimeExceedRange && loopback === 'full') {
        if (type === 'hours' && operation === 'add' && date.hour() === 23) {
          newTime = date.clone().set({
            hour: 0
          });
        } else if (type === 'hours' && operation === 'subtract' && date.hour() === 0) {
          newTime = date.clone().set({
            hour: 23
          });
        } else if (type === 'minutes' && operation === 'add' && date.minute() === 59) {
          newTime = date.clone().set({
            minute: 0
          });
        } else if (type === 'minutes' && operation === 'subtract' && date.minute() === 0) {
          newTime = date.clone().set({
            minute: 59
          });
        }
      } else if (newTimeExceedRange && loopback === 'bounded') {
        if (operation === 'add') {
          newTime = minValue.set({});
        } else if (operation === 'subtract') {
          newTime = maxValue.set({});
        }
      }

      var isDateValid = !(newTime.isAfter(maxValue) || newTime.isBefore(minValue));
      var state = {
        date: newTime,
        value: newTime.format(this.format),
        valid: isDateValid
      };
      this.setState(state);

      if (onChange) {
        onChange(state);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          Hour24Format = _this$props3.Hour24Format,
          maxLength = _this$props3.maxLength,
          rest = _objectWithoutProperties$c(_this$props3, ["children", "Hour24Format", "maxLength"]);

      var _this$state3 = this.state,
          focused = _this$state3.focused,
          date = _this$state3.date,
          valid = _this$state3.valid,
          value = _this$state3.value,
          minValue = _this$state3.minValue,
          maxValue = _this$state3.maxValue;
      var inputAppend = focused ? React.createElement(TimePickerWrapper, {
        ref: this.rootNode
      }, React.createElement(TimePickerSelector, {
        "aria-hidden": focused,
        onBlur: this.onBlur
      }, React.createElement(TimeSelector, null, React.createElement(Button$1, {
        size: "s",
        type: "icon",
        icon: "arrow-up",
        onClick: function onClick() {
          return _this3.modifyTime('hours', 'add');
        },
        disabled: this.isIncrementHourDisabled
      }), React.createElement(ValueText, {
        bold: true
      }, Hour24Format ? date.format('HH') : date.format('hh')), React.createElement(Button$1, {
        size: "s",
        type: "icon",
        icon: "arrow-down",
        onClick: function onClick() {
          return _this3.modifyTime('hours', 'subtract');
        },
        disabled: this.isDecrementHourDisabled
      })), React.createElement(Separator, null, ":"), React.createElement(TimeSelector, null, React.createElement(Button$1, {
        size: "s",
        type: "icon",
        icon: "arrow-up",
        onClick: function onClick() {
          return _this3.modifyTime('minutes', 'add');
        },
        disabled: this.isIncrementMinuteDisabled
      }), React.createElement(ValueText, {
        bold: true
      }, date.format('mm')), React.createElement(Button$1, {
        size: "s",
        type: "icon",
        icon: "arrow-down",
        onClick: function onClick() {
          return _this3.modifyTime('minutes', 'subtract');
        },
        disabled: this.isDecrementMinuteDisabled
      })), !Hour24Format ? React.createElement(TimeSelector, null, React.createElement(Button$1, {
        size: "s",
        type: "icon",
        icon: "arrow-up",
        onClick: function onClick() {
          return _this3.modifyTime('hours', 'add', 12);
        },
        disabled: this.isIncrementPeriodDisabled
      }), React.createElement(ValueText, {
        bold: true
      }, date.format('A')), React.createElement(Button$1, {
        size: "s",
        type: "icon",
        icon: "arrow-down",
        onClick: function onClick() {
          return _this3.modifyTime('hours', 'subtract', 12);
        },
        disabled: this.isDecrementPeriodDisabled
      })) : '')) : undefined;
      return React.createElement(Container$9, rest, React.createElement(DateDivWrapper$1, null, React.createElement(TextInput, _extends$9({
        type: "text"
      }, rest, {
        onFocus: function onFocus() {
          return _this3.setFocus(true);
        },
        onChange: function onChange(data) {
          return _this3.onChange(data);
        },
        icon: "Clock-white",
        iconColor: this.iconColor,
        valid: valid,
        value: value || '',
        placeholder: Hour24Format ? 'HH:MM' : 'HH:MM PM',
        maxLength: maxLength,
        "aria-valuemin": minValue.format(this.format),
        "aria-valuemax": maxValue.format(this.format),
        "aria-valuenow": value,
        "aria-haspopup": focused,
        inputAppend: inputAppend,
        onKeyDown: this.onKeyDown
      }), children)), React.createElement(BackgroundLayout$1, {
        opened: focused,
        onClick: function onClick() {
          return _this3.setFocus(false);
        }
      }));
    }
  }, {
    key: "iconColor",
    get: function get() {
      var focused = this.state.focused;
      return focused ? 'orange' : 'black';
    }
  }, {
    key: "isIncrementHourDisabled",
    get: function get() {
      var loopback = this.props.loopback;
      var _this$state4 = this.state,
          date = _this$state4.date,
          maxValue = _this$state4.maxValue;

      if (loopback === 'full' || loopback === 'bounded') {
        return false;
      }

      return date.clone().add(1, 'hour').isAfter(maxValue);
    }
  }, {
    key: "isDecrementHourDisabled",
    get: function get() {
      var loopback = this.props.loopback;
      var _this$state5 = this.state,
          date = _this$state5.date,
          minValue = _this$state5.minValue;

      if (loopback === 'full' || loopback === 'bounded') {
        return false;
      }

      return date.clone().subtract(1, 'hour').isBefore(minValue);
    }
  }, {
    key: "isIncrementMinuteDisabled",
    get: function get() {
      var loopback = this.props.loopback;
      var _this$state6 = this.state,
          date = _this$state6.date,
          maxValue = _this$state6.maxValue;

      if (loopback === 'full' || loopback === 'bounded') {
        return false;
      }

      return date.clone().add(1, 'minute').isAfter(maxValue);
    }
  }, {
    key: "isDecrementMinuteDisabled",
    get: function get() {
      var loopback = this.props.loopback;
      var _this$state7 = this.state,
          date = _this$state7.date,
          minValue = _this$state7.minValue;

      if (loopback === 'full' || loopback === 'bounded') {
        return false;
      }

      return date.clone().subtract(1, 'minute').isBefore(minValue);
    }
  }, {
    key: "isIncrementPeriodDisabled",
    get: function get() {
      var date = this.state.date;
      return date.format('A') === 'PM';
    }
  }, {
    key: "isDecrementPeriodDisabled",
    get: function get() {
      var date = this.state.date;
      return date.format('A') === 'AM';
    }
  }]);

  return TimePicker;
}(Component);

TimePicker.defaultProps = {
  children: '',
  mandatory: false,
  placeholder: undefined,
  labelPosition: 'top',
  labelWidth: 30,
  errorMessage: undefined,
  disabled: false,
  size: 'm',
  maxLength: 10,
  Hour24Format: true,
  maxTime: '23:59',
  minTime: '00:00',
  value: '',
  onChange: function onChange() {},
  loopback: 'none'
};
TimePicker.propTypes = {
  /** Label of the input */
  children: PropTypes.node,

  /** Value of the input */
  value: PropTypes.string,

  /** Id of the input */
  id: PropTypes.string.isRequired,

  /** String indicating the position of the label */
  labelPosition: PropTypes.oneOf(['top', 'left']),

  /** Number indicating the width of label (percentage) */
  labelWidth: PropTypes.number,

  /** String indicating the error message */
  errorMessage: PropTypes.string,

  /** Boolean indicating if the input is disabled */
  disabled: PropTypes.bool,

  /** Boolean indicating if the field is mandatory */
  mandatory: PropTypes.bool,

  /** String indicating the placeholder of the label */
  placeholder: PropTypes.string,

  /** String indicating the size of the input */
  size: PropTypes.oneOf(['m', 'l', 'xl']),

  /** Number indicating max-length */
  maxLength: PropTypes.number,

  /** Boolean indicating if the timepicker display 24-Hour format (if false, 12-Hour format) */
  Hour24Format: PropTypes.bool,

  /** String indicating the max time that can't be reached by the timepicker */
  maxTime: PropTypes.string,

  /** String indicating min time that can't be reached by the timepicker */
  minTime: PropTypes.string,

  /** Function called on timepicker change */
  onChange: PropTypes.func,

  /** String indicating how the picker should behave */
  loopback: PropTypes.oneOf(['none', 'full', 'bounded'])
};

function _typeof$c(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$c = function _typeof(obj) { return typeof obj; }; } else { _typeof$c = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$c(obj); }

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function _objectWithoutProperties$d(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$d(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$d(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$e(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$e(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$e(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$e(Constructor.prototype, protoProps); if (staticProps) _defineProperties$e(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$c(self, call) { if (call && (_typeof$c(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$c(self); }

function _getPrototypeOf$c(o) { _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$c(o); }

function _assertThisInitialized$c(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$c(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$c(subClass, superClass); }

function _setPrototypeOf$c(o, p) { _setPrototypeOf$c = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$c(o, p); }

function _templateObject6$3() {
  var data = _taggedTemplateLiteral$R(["\n  margin-bottom: ", "rem;\n"]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$6() {
  var data = _taggedTemplateLiteral$R(["\n  padding-right: ", "rem;\n  flex: 1 1 0rem;\n"]);

  _templateObject5$6 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$a() {
  var data = _taggedTemplateLiteral$R(["\n  display: flex;\n  width: ", ";\n  text-align: right;\n  padding: ", ";\n"]);

  _templateObject4$a = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$b() {
  var data = _taggedTemplateLiteral$R(["\n  height:  ", ";\n"]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$i() {
  var data = _taggedTemplateLiteral$R(["\n  border-top: ", "rem solid ", ";\n  border-bottom: ", "rem solid ", ";\n  padding: ", ";\n  background: ", ";\n\n  ", " {\n    font-size: ", ";\n  }\n"]);

  _templateObject2$i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$R() {
  var data = _taggedTemplateLiteral$R(["\n  height: ", ";\n  width: ", ";\n  cursor: ", ";\n  border-left: ", ";\n  border-top: ", "rem solid ", ";\n  border-bottom: ", "rem solid ", ";\n  border-right: ", ";\n\n  font-size: ", ";\n  color: ", ";\n\n  &:focus, &:hover, &:active {\n      color: ", ";\n  }\n  background: ", ";\n\n  ", "\n"]);

  _templateObject$R = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$R(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Operator = styled(Button$1)(_templateObject$R(), function (props) {
  return props.size && props.size === 'l' ? "".concat(selectorHeightL + borderSize * 2, "rem") : "".concat(selectorHeight + borderSize * 2, "rem");
}, function (props) {
  return props.size && props.size === 'l' ? "".concat(selectorHeightL - borderSize, "rem") : "".concat(selectorHeight - borderSize, "rem");
}, function (props) {
  return props.disabled ? undefined : 'pointer';
}, function (props) {
  var color = props.position === 'left' ? grey4 : undefined;
  return color ? "".concat(borderSize, "rem solid ").concat(color) : 0;
}, borderSize, grey4, borderSize, grey4, function (props) {
  var color = props.position === 'left' ? undefined : grey4;
  return color ? "".concat(borderSize, "rem solid ").concat(color) : 0;
}, function (props) {
  return props.size && props.size === 'l' ? "".concat(operatorFontSizeL, "rem") : "".concat(operatorFontSize, "rem");
}, function (props) {
  return props.disabled ? grey4 : black;
}, function (props) {
  return props.disabled ? grey4 : white;
}, function (props) {
  return props.disabled ? grey6 : white;
}, function (props) {
  return !props.disabled && "\n    &:focus, &:hover {\n      background: ".concat(black, ";\n      border-color: ").concat(black, ";\n      p {\n        color: ").concat(white, ";\n      }\n    }\n\n    &:active {\n      background: ").concat(orange1, ";\n      border-color: ").concat(orange1, ";\n      p {\n        color: ").concat(white, ";\n      }\n    }\n  ");
});
var ValueDiv = styled(Flex)(_templateObject2$i(), borderSize, grey4, borderSize, grey4, function (props) {
  return props.size && props.size === 'l' ? "0 ".concat(valuePaddingL, "rem") : "0 ".concat(valuePadding, "rem");
}, function (props) {
  return props.disabled ? grey6 : white;
}, Text, function (props) {
  return props.size && props.size === 'l' ? "".concat(valueFontSizeL, "rem") : "".concat(valueFontSize, "rem");
});
var Container$a = styled(Flex)(_templateObject3$b(), function (props) {
  return props.size && props.size === 'l' ? "".concat(selectorHeightL + borderSize * 2, "rem") : "".concat(selectorHeight + borderSize * 2, "rem");
});
var Span$1 = Text.withComponent('span');
var LeftLabelContainer$1 = styled('div')(_templateObject4$a(), function (props) {
  return props.width ? "".concat(props.width, "%") : undefined;
}, function (props) {
  var paddingV;

  switch (props.size) {
    case 'l':
      paddingV = paddingTopLabelL$1;
      break;

    case 'm':
    default:
      paddingV = paddingTopLabel$1;
      break;
  }

  return "".concat(paddingV, "rem 0");
});
var LabelLeft$1 = styled('label')(_templateObject5$6(), paddingRightLabel$1);
var LabelTop$1 = styled('label')(_templateObject6$3(), horizontalMarginInput$1);

var QuantitySelector =
/*#__PURE__*/
function (_Component) {
  _inherits$c(QuantitySelector, _Component);

  function QuantitySelector(props) {
    var _this;

    _classCallCheck$e(this, QuantitySelector);

    _this = _possibleConstructorReturn$c(this, _getPrototypeOf$c(QuantitySelector).call(this, props));
    _this.state = {
      value: _this.getValue(props.defaultValue)
    };
    _this.actions = {
      increment: _this.incrementAction.bind(_assertThisInitialized$c(_this)),
      decrement: _this.decrementAction.bind(_assertThisInitialized$c(_this))
    };
    return _this;
  }

  _createClass$e(QuantitySelector, [{
    key: "getValue",
    value: function getValue(value) {
      var _this$props = this.props,
          max = _this$props.max,
          min = _this$props.min;
      var val = value;

      if (max && value > max) {
        val = max;
      }

      if (min && value < min) {
        val = min;
      }

      return val;
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          labelPosition = _this$props2.labelPosition,
          id = _this$props2.id,
          mandatory = _this$props2.mandatory,
          labelWidth = _this$props2.labelWidth,
          size = _this$props2.size;

      if (children === undefined || children === '') {
        return undefined;
      }

      var content;

      if (labelPosition === 'left') {
        content = React.createElement(LabelLeft$1, {
          htmlFor: id
        }, React.createElement(Span$1, {
          bold: true
        }, children, mandatory ? React.createElement(Span$1, {
          bold: true,
          color: "orange"
        }, "\xA0*") : undefined));
      } else {
        content = React.createElement(LabelTop$1, {
          htmlFor: id
        }, React.createElement(Span$1, {
          bold: true
        }, children, mandatory ? React.createElement(Span$1, {
          bold: true,
          color: "orange"
        }, "\xA0*") : undefined));
      }

      if (labelPosition === 'left') {
        return React.createElement(LeftLabelContainer$1, {
          width: labelWidth,
          size: size
        }, content);
      }

      return content;
    }
  }, {
    key: "triggerChange",
    value: function triggerChange() {
      var onChange = this.props.onChange;
      var value = this.state.value;

      if (onChange) {
        onChange({
          value: value
        });
      }
    }
  }, {
    key: "incrementAction",
    value: function incrementAction() {
      var _this$props3 = this.props,
          step = _this$props3.step,
          disabled = _this$props3.disabled;
      var value = this.state.value;

      if (this.isIncrementDisabled || disabled) {
        return;
      }

      this.setState({
        value: value + step
      }, this.triggerChange);
    }
  }, {
    key: "decrementAction",
    value: function decrementAction() {
      var step = this.props.step;
      var value = this.state.value;

      if (this.isDecrementDisabled) {
        return;
      }

      this.setState({
        value: value - step
      }, this.triggerChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          labelPosition = _this$props4.labelPosition,
          size = _this$props4.size,
          disabled = _this$props4.disabled,
          rest = _objectWithoutProperties$d(_this$props4, ["labelPosition", "size", "disabled"]);

      var value = this.state.value;
      return React.createElement(Flex, _extends$a({}, rest, {
        flexDirection: labelPosition === 'top' ? 'column' : undefined
      }), this.getLabel(), React.createElement(Flex, {
        flexDirection: "column",
        justifyContent: "space-around"
      }, React.createElement(Container$a, {
        size: size
      }, React.createElement(Operator, {
        alignItems: "center",
        justifyContent: "center",
        position: "left",
        onClick: this.actions.decrement,
        size: size,
        disabled: this.isDecrementDisabled
      }, React.createElement(Text, {
        bold: true,
        size: size
      }, "-")), React.createElement(ValueDiv, {
        alignItems: "center",
        justifyContent: "center",
        size: size,
        disabled: disabled
      }, React.createElement(Text, {
        bold: true
      }, value)), React.createElement(Operator, {
        alignItems: "center",
        justifyContent: "center",
        position: "right",
        onClick: this.actions.increment,
        size: size,
        disabled: this.isIncrementDisabled
      }, React.createElement(Text, {
        bold: true,
        size: size
      }, "+")))));
    }
  }, {
    key: "isIncrementDisabled",
    get: function get() {
      var _this$props5 = this.props,
          max = _this$props5.max,
          step = _this$props5.step,
          disabled = _this$props5.disabled;
      var value = this.state.value;
      return max !== null && max < value + step || disabled;
    }
  }, {
    key: "isDecrementDisabled",
    get: function get() {
      var _this$props6 = this.props,
          min = _this$props6.min,
          step = _this$props6.step,
          disabled = _this$props6.disabled;
      var value = this.state.value;
      return min !== null && min > value - step || disabled;
    }
  }]);

  return QuantitySelector;
}(Component);

QuantitySelector.defaultProps = {
  children: undefined,
  onChange: function onChange() {},
  defaultValue: 0,
  labelPosition: 'top',
  labelWidth: 30,
  disabled: false,
  mandatory: false,
  size: 'm',
  max: undefined,
  min: undefined,
  step: 1
};
QuantitySelector.propTypes = {
  /** Label of the field */
  children: PropTypes.node,

  /** Id of the input */
  id: PropTypes.string.isRequired,

  /** Function called on selector changes */
  onChange: PropTypes.func,

  /** Value of the selector */
  defaultValue: PropTypes.number,

  /** String indicating the position of the label */
  labelPosition: PropTypes.oneOf(['top', 'left']),

  /** Number indicating the width of label (percentage) */
  labelWidth: PropTypes.number,

  /** Boolean indicating if the selector is disabled */
  disabled: PropTypes.bool,

  /** Boolean indicating if the field is mandatory */
  mandatory: PropTypes.bool,

  /** String indicating the size of the selector */
  size: PropTypes.oneOf(['m', 'l']),

  /** Number indicating maximum value */
  max: PropTypes.number,

  /** Number indicating minimum value */
  min: PropTypes.number,

  /** Number indicating step value */
  step: PropTypes.number
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$2 = _root.Symbol;

var _Symbol = Symbol$2;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString$1;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1 = Array.isArray;

var isArray_1 = isArray$1;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray_1(value) && isObjectLike_1(value) && _baseGetTag(value) == stringTag);
}

var isString_1 = isString;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

var _baseFor = baseFor;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$2.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$2 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}

var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag$1 = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag$1] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$4.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$1(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys$1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && _baseFor(object, iteratee, keys_1);
}

var _baseForOwn = baseForOwn;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity_1;
}

var _castFunction = castFunction;

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && _baseForOwn(object, _castFunction(iteratee));
}

var forOwn_1 = forOwn;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/** `Object#toString` result references. */
var objectTag$1 = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$6 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag$1) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$5.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$7 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$2.call(hasOwnProperty$6).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');

var _Map = Map;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$8.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

var _setCacheAdd = setCacheAdd;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

var _SetCache = SetCache;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays;

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$1:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq_1(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$1:
    case stringTag$2:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$1:
      var convert = _mapToArray;

    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$9.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise = _getNative(_root, 'Promise');

var _Promise = Promise;

/* Built-in method references that are verified to be native. */
var Set = _getNative(_root, 'Set');

var _Set = Set;

/* Built-in method references that are verified to be native. */
var WeakMap$2 = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap$2;

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]',
    objectTag$2 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$2 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2) ||
    (_Map && getTag(new _Map) != mapTag$2) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag$2) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$2 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$2;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$2;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_1(object),
      othIsArr = isArray_1(other),
      objTag = objIsArr ? arrayTag$1 : _getTag(object),
      othTag = othIsArr ? arrayTag$1 : _getTag(other);

  objTag = objTag == argsTag$2 ? objectTag$3 : objTag;
  othTag = othTag == argsTag$2 ? objectTag$3 : othTag;

  var objIsObj = objTag == objectTag$3,
      othIsObj = othTag == objectTag$3,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer_1(object)) {
    if (!isBuffer_1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || isTypedArray_1(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$a.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$a.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

var _baseIsEqual = baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject_1(value);
}

var _isStrictComparable = isStrictComparable;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys_1(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, _isStrictComparable(value)];
  }
  return result;
}

var _getMatchData = getMatchData;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = _getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || _baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag$1);
}

var isSymbol_1 = isSymbol$1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

var memoize_1 = memoize;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString$2;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength_1(length) && _isIndex(key, length) &&
    (isArray_1(object) || isArguments_1(object));
}

var _hasPath = hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

var hasIn_1 = hasIn;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (_isKey(path) && _isStrictComparable(srcValue)) {
    return _matchesStrictComparable(_toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get_1(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn_1(object, path)
      : _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
  };
}

var _baseMatchesProperty = baseMatchesProperty;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return _baseGet(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
}

var property_1 = property;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity_1;
  }
  if (typeof value == 'object') {
    return isArray_1(value)
      ? _baseMatchesProperty(value[0], value[1])
      : _baseMatches(value);
  }
  return property_1(value);
}

var _baseIteratee = baseIteratee;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike_1(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = _createBaseEach(_baseForOwn);

var _baseEach = baseEach;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike_1(collection) ? Array(collection.length) : [];

  _baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap;

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray_1(collection) ? _arrayMap : _baseMap;
  return func(collection, _baseIteratee(iteratee));
}

var map_1 = map;

var flattenNames_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenNames = undefined;



var _isString3 = _interopRequireDefault(isString_1);



var _forOwn3 = _interopRequireDefault(forOwn_1);



var _isPlainObject3 = _interopRequireDefault(isPlainObject_1);



var _map3 = _interopRequireDefault(map_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNames = exports.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var names = [];

  (0, _map3.default)(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3.default)(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names.push(thing);
    }
  });

  return names;
};

exports.default = flattenNames;
});

unwrapExports(flattenNames_1);
var flattenNames_2 = flattenNames_1.flattenNames;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach;

var defineProperty$6 = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty$6;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$d.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$b.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}

var _baseAssign = baseAssign;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$c.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$1(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn$1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}

var _baseAssignIn = baseAssignIn;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

var _copySymbols = copySymbols;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$d.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp;

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    mapTag$3 = '[object Map]',
    numberTag$2 = '[object Number]',
    regexpTag$2 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$2:
      return _cloneArrayBuffer(object);

    case boolTag$2:
    case dateTag$2:
      return new Ctor(+object);

    case dataViewTag$3:
      return _cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);

    case mapTag$3:
      return new Ctor;

    case numberTag$2:
    case stringTag$3:
      return new Ctor(object);

    case regexpTag$2:
      return _cloneRegExp(object);

    case setTag$3:
      return new Ctor;

    case symbolTag$2:
      return _cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag;

/** Built-in value references. */
var objectCreate$1 = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate$1) {
      return objectCreate$1(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$4;
}

var _baseIsMap = baseIsMap;

/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

var isMap_1 = isMap;

/** `Object#toString` result references. */
var setTag$4 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$4;
}

var _baseIsSet = baseIsSet;

/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

var isSet_1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$5 = '[object Map]',
    numberTag$3 = '[object Number]',
    objectTag$4 = '[object Object]',
    regexpTag$3 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$4 = '[object String]',
    symbolTag$3 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$3] = cloneableTags[arrayTag$2] =
cloneableTags[arrayBufferTag$3] = cloneableTags[dataViewTag$4] =
cloneableTags[boolTag$3] = cloneableTags[dateTag$3] =
cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] =
cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] =
cloneableTags[int32Tag$2] = cloneableTags[mapTag$5] =
cloneableTags[numberTag$3] = cloneableTags[objectTag$4] =
cloneableTags[regexpTag$3] = cloneableTags[setTag$5] =
cloneableTags[stringTag$4] = cloneableTags[symbolTag$3] =
cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] =
cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$2] = cloneableTags[funcTag$2] =
cloneableTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject_1(value)) {
    return value;
  }
  var isArr = isArray_1(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$4 || tag == argsTag$3 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet_1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_1(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn : keys_1);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return _baseClone(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}

var cloneDeep_1 = cloneDeep;

var mergeClasses_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeClasses = undefined;



var _forOwn3 = _interopRequireDefault(forOwn_1);



var _cloneDeep3 = _interopRequireDefault(cloneDeep_1);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];
    if (toMerge) {
      (0, _forOwn3.default)(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

exports.default = mergeClasses;
});

unwrapExports(mergeClasses_1);
var mergeClasses_2 = mergeClasses_1.mergeClasses;

var autoprefix_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoprefix = undefined;



var _forOwn3 = _interopRequireDefault(forOwn_1);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },

  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },

  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },

  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      'extend': name
    };
  }
};

var autoprefix = exports.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles, function (value, key) {
      var transform = transforms[key];
      if (transform) {
        expanded = _extends({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

exports.default = autoprefix;
});

unwrapExports(autoprefix_1);
var autoprefix_2 = autoprefix_1.autoprefix;

var hover_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hover = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hover = exports.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function () {
        return _this.setState({ hover: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Hover;
  }(_react2.default.Component);
};

exports.default = hover;
});

unwrapExports(hover_1);
var hover_2 = hover_1.hover;

var active_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.active = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var active = exports.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function () {
        return _this.setState({ active: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Active;
  }(_react2.default.Component);
};

exports.default = active;
});

unwrapExports(active_1);
var active_2 = active_1.active;

var loop = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var loopable = function loopable(i, length) {
  var props = {};
  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);

  return props;
};

exports.default = loopable;
});

unwrapExports(loop);

var lib = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;



var _flattenNames2 = _interopRequireDefault(flattenNames_1);



var _mergeClasses2 = _interopRequireDefault(mergeClasses_1);



var _autoprefix2 = _interopRequireDefault(autoprefix_1);



var _hover3 = _interopRequireDefault(hover_1);



var _active2 = _interopRequireDefault(active_1);



var _loop3 = _interopRequireDefault(loop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes, activeNames);
  return (0, _autoprefix2.default)(merged);
};

exports.default = ReactCSS;
});

unwrapExports(lib);
var lib_1 = lib.ReactCSS;
var lib_2 = lib.loop;
var lib_3 = lib.handleActive;
var lib_4 = lib.handleHover;
var lib_5 = lib.hover;

var alpha = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var a = void 0;
    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (hsl.a !== a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;
    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (initialA !== _a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }
  return null;
};
});

unwrapExports(alpha);
var alpha_1 = alpha.calculateChange;

var checkboard = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var checkboardCache = {};

var render = exports.render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  } // If no context can be found, return early.
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};

var get = exports.get = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }

  var checkboard = render(c1, c2, size, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};
});

unwrapExports(checkboard);
var checkboard_1 = checkboard.render;
var checkboard_2 = checkboard.get;

var Checkboard_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkboard = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



var checkboard$1 = _interopRequireWildcard(checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkboard = exports.Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow;

  var styles = (0, _reactcss2.default)({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + checkboard$1.get(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.grid });
};

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

exports.default = Checkboard;
});

unwrapExports(Checkboard_1);
var Checkboard_2 = Checkboard_1.Checkboard;

var Alpha_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alpha = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



var alpha$1 = _interopRequireWildcard(alpha);



var _Checkboard2 = _interopRequireDefault(Checkboard_1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alpha = exports.Alpha = function (_ref) {
  _inherits(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = alpha$1.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = (0, _reactcss2.default)({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden',
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': _extends({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });

      return _react2.default.createElement(
        'div',
        { style: styles.alpha },
        _react2.default.createElement(
          'div',
          { style: styles.checkboard },
          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
        ),
        _react2.default.createElement('div', { style: styles.gradient }),
        _react2.default.createElement(
          'div',
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Alpha;
}(React.PureComponent || React.Component);

exports.default = Alpha;
});

unwrapExports(Alpha_1);
var Alpha_2 = Alpha_1.Alpha;

var EditableInput_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_ARROW_OFFSET = 1;

var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
var isValidKeyCode = function isValidKeyCode(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};

var getFormattedPercentage = function getFormattedPercentage(number) {
  return number + '%';
};
var getNumberValue = function getNumberValue(value) {
  return Number(String(value).replace(/%/g, ''));
};
var getIsPercentage = function getIsPercentage(value) {
  return String(value).indexOf('%') > -1;
};

var EditableInput = exports.EditableInput = function (_ref) {
  _inherits(EditableInput, _ref);

  function EditableInput(props) {
    _classCallCheck(this, EditableInput);

    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };

    _this.handleChange = function (e) {
      _this.setUpdatedValue(e.target.value, e);
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var value = getNumberValue(e.target.value);
      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
        var offset = _this.getArrowOffset();
        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;

        _this.setUpdatedValue(updatedValue, e);
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };
    return _this;
  }

  _createClass(EditableInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({ blurValue: String(this.props.value).toUpperCase() });
        } else {
          this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'getValueObjectWithLabel',
    value: function getValueObjectWithLabel(value) {
      return _defineProperty({}, this.props.label, value);
    }
  }, {
    key: 'getArrowOffset',
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: 'setUpdatedValue',
    value: function setUpdatedValue(value, e) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
      this.props.onChange && this.props.onChange(onChangeValue, e);

      var isPercentage = getIsPercentage(e.target.value);
      this.setState({
        value: isPercentage ? getFormattedPercentage(value) : value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);

      return _react2.default.createElement(
        'div',
        { style: styles.wrap },
        _react2.default.createElement('input', {
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }),
        this.props.label && !this.props.hideLabel ? _react2.default.createElement(
          'span',
          { style: styles.label, onMouseDown: this.handleMouseDown },
          this.props.label
        ) : null
      );
    }
  }]);

  return EditableInput;
}(React.PureComponent || React.Component);

exports.default = EditableInput;
});

unwrapExports(EditableInput_1);
var EditableInput_2 = EditableInput_1.EditableInput;

var hue = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, direction, hsl, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var h = void 0;
    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (hsl.h !== h) {
      return {
        h: h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'rgb'
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }

    if (hsl.h !== _h) {
      return {
        h: _h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'rgb'
      };
    }
  }
  return null;
};
});

unwrapExports(hue);
var hue_1 = hue.calculateChange;

var Hue_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hue = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



var hue$1 = _interopRequireWildcard(hue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hue = exports.Hue = function (_ref) {
  _inherits(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = hue$1.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;


      var styles = (0, _reactcss2.default)({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%',
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, { vertical: direction === 'vertical' });

      return _react2.default.createElement(
        'div',
        { style: styles.hue },
        _react2.default.createElement(
          'div',
          {
            className: 'hue-' + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'style',
            null,
            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
          ),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Hue;
}(React.PureComponent || React.Component);

exports.default = Hue;
});

unwrapExports(Hue_1);
var Hue_2 = Hue_1.Hue;

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq_1(object[key], value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike_1(value) && isArrayLike_1(value);
}

var isArrayLikeObject_1 = isArrayLikeObject;

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return _copyObject(value, keysIn_1(value));
}

var toPlainObject_1 = toPlainObject;

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray_1(srcValue),
        isBuff = !isArr && isBuffer_1(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray_1(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray_1(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject_1(objValue)) {
        newValue = _copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = _cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject_1(srcValue) || isArguments_1(srcValue)) {
      newValue = objValue;
      if (isArguments_1(objValue)) {
        newValue = toPlainObject_1(objValue);
      }
      else if (!isObject_1(objValue) || isFunction_1(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  _assignMergeValue(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep;

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  _baseFor(source, function(srcValue, key) {
    stack || (stack = new _Stack);
    if (isObject_1(srcValue)) {
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(_safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      _assignMergeValue(object, key, newValue);
    }
  }, keysIn_1);
}

var _baseMerge = baseMerge;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty ? identity_1 : function(func, string) {
  return _defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return _baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner;

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = _createAssigner(function(object, source, srcIndex) {
  _baseMerge(object, source, srcIndex);
});

var merge_1 = merge;

var Raised_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Raised = undefined;



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _reactcss2 = _interopRequireDefault(lib);



var _merge2 = _interopRequireDefault(merge_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Raised = exports.Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },

    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, passedStyles), { 'zDepth-1': zDepth === 1 });

  return _react2.default.createElement(
    'div',
    { style: styles.wrap },
    _react2.default.createElement('div', { style: styles.bg }),
    _react2.default.createElement(
      'div',
      { style: styles.content },
      children
    )
  );
};

Raised.propTypes = {
  background: _propTypes2.default.string,
  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
  radius: _propTypes2.default.number,
  styles: _propTypes2.default.object
};

Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2,
  styles: {}
};

exports.default = Raised;
});

unwrapExports(Raised_1);
var Raised_2 = Raised_1.Raised;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root.Date.now();
};

var now_1 = now;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber_1(wait) || 0;
  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now_1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  if (isObject_1(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce_1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var throttle_1 = throttle;

var saturation = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, hsl, container) {
  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  }

  if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left / containerWidth;
  var bright = 1 - top / containerHeight;

  return {
    h: hsl.h,
    s: saturation,
    v: bright,
    a: hsl.a,
    source: 'rgb'
  };
};
});

unwrapExports(saturation);
var saturation_1 = saturation.calculateChange;

var Saturation_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Saturation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



var _throttle2 = _interopRequireDefault(throttle_1);



var saturation$1 = _interopRequireWildcard(saturation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Saturation = exports.Saturation = function (_ref) {
  _inherits(Saturation, _ref);

  function Saturation(props) {
    _classCallCheck(this, Saturation);

    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e) {
      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, saturation$1.calculateChange(e, _this.props.hsl, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  _createClass(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = (0, _reactcss2.default)({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, { 'custom': !!this.props.style });

      return _react2.default.createElement(
        'div',
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        _react2.default.createElement(
          'style',
          null,
          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
        ),
        _react2.default.createElement(
          'div',
          { style: styles.white, className: 'saturation-white' },
          _react2.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
          )
        )
      );
    }
  }]);

  return Saturation;
}(React.PureComponent || React.Component);

exports.default = Saturation;
});

unwrapExports(Saturation_1);
var Saturation_2 = Saturation_1.Saturation;

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray_1(collection) ? _arrayEach : _baseEach;
  return func(collection, _castFunction(iteratee));
}

var forEach_1 = forEach;

var each = forEach_1;

var tinycolor = createCommonjsModule(function (module) {
// TinyColor v1.4.1
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if ( module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else {
    window.tinycolor = tinycolor;
}

})(Math);
});

var color = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.red = exports.getContrastingColor = exports.isValidHex = exports.toState = exports.simpleCheckForValidColor = undefined;



var _each2 = _interopRequireDefault(each);



var _tinycolor2 = _interopRequireDefault(tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var simpleCheckForValidColor = exports.simpleCheckForValidColor = function simpleCheckForValidColor(data) {
  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
  var checked = 0;
  var passed = 0;
  (0, _each2.default)(keysToCheck, function (letter) {
    if (data[letter]) {
      checked += 1;
      if (!isNaN(data[letter])) {
        passed += 1;
      }
      if (letter === 's' || letter === 'l') {
        var percentPatt = /^\d+%$/;
        if (percentPatt.test(data[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data : false;
};

var toState = exports.toState = function toState(data, oldHue) {
  var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
  var hsl = color.toHsl();
  var hsv = color.toHsv();
  var rgb = color.toRgb();
  var hex = color.toHex();
  if (hsl.s === 0) {
    hsl.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }
  var transparent = hex === '000000' && rgb.a === 0;

  return {
    hsl: hsl,
    hex: transparent ? 'transparent' : '#' + hex,
    rgb: rgb,
    hsv: hsv,
    oldHue: data.h || oldHue || hsl.h,
    source: data.source
  };
};

var isValidHex = exports.isValidHex = function isValidHex(hex) {
  // disable hex4 and hex8
  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
  return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2.default)(hex).isValid();
};

var getContrastingColor = exports.getContrastingColor = function getContrastingColor(data) {
  if (!data) {
    return '#fff';
  }
  var col = toState(data);
  if (col.hex === 'transparent') {
    return 'rgba(0,0,0,0.4)';
  }
  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
  return yiq >= 128 ? '#000' : '#fff';
};

var red = exports.red = {
  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
  hex: '#ff0000',
  rgb: { r: 255, g: 0, b: 0, a: 1 },
  hsv: { h: 0, s: 1, v: 1, a: 1 }
};

exports.default = exports;
});

unwrapExports(color);
var color_1 = color.red;
var color_2 = color.getContrastingColor;
var color_3 = color.isValidHex;
var color_4 = color.toState;
var color_5 = color.simpleCheckForValidColor;

var ColorWrap_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorWrap = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _debounce2 = _interopRequireDefault(debounce_1);



var _color2 = _interopRequireDefault(color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    _inherits(ColorPicker, _ref);

    function ColorPicker(props) {
      _classCallCheck(this, ColorPicker);

      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = _color2.default.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = _color2.default.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = _extends({}, _color2.default.toState(props.color, 0));

      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    _createClass(ColorPicker, [{
      key: 'render',
      value: function render() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, state) {
        return _extends({}, _color2.default.toState(nextProps.color, state.oldHue));
      }
    }]);

    return ColorPicker;
  }(React.PureComponent || React.Component);

  ColorPicker.propTypes = _extends({}, Picker.propTypes);

  ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });

  return ColorPicker;
};

exports.default = ColorWrap;
});

unwrapExports(ColorWrap_1);
var ColorWrap_2 = ColorWrap_1.ColorWrap;

var interaction = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFocus = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */


var handleFocus = exports.handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function () {
        return _this.setState({ focus: false });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Focus, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          Span,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          _react2.default.createElement(Component, _extends({}, this.props, this.state))
        );
      }
    }]);

    return Focus;
  }(_react2.default.Component);
};
});

unwrapExports(interaction);
var interaction_1 = interaction.handleFocus;

var Swatch_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swatch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);





var _Checkboard2 = _interopRequireDefault(Checkboard_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTER = 13;

var Swatch = exports.Swatch = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;

  var transparent = color === 'transparent';
  var styles = (0, _reactcss2.default)({
    default: {
      swatch: _extends({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return _react2.default.createElement(
    'div',
    _extends({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && _react2.default.createElement(_Checkboard2.default, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    })
  );
};

exports.default = (0, interaction.handleFocus)(Swatch);
});

unwrapExports(Swatch_1);
var Swatch_2 = Swatch_1.Swatch;

var common = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



Object.defineProperty(exports, 'Alpha', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Alpha_1).default;
  }
});



Object.defineProperty(exports, 'Checkboard', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Checkboard_1).default;
  }
});



Object.defineProperty(exports, 'EditableInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(EditableInput_1).default;
  }
});



Object.defineProperty(exports, 'Hue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Hue_1).default;
  }
});



Object.defineProperty(exports, 'Raised', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Raised_1).default;
  }
});



Object.defineProperty(exports, 'Saturation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Saturation_1).default;
  }
});



Object.defineProperty(exports, 'ColorWrap', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(ColorWrap_1).default;
  }
});



Object.defineProperty(exports, 'Swatch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Swatch_1).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
});

unwrapExports(common);

var AlphaPointer_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaPointer = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlphaPointer = exports.AlphaPointer = function AlphaPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = AlphaPointer;
});

unwrapExports(AlphaPointer_1);
var AlphaPointer_2 = AlphaPointer_1.AlphaPointer;

var Alpha = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaPicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);





var _AlphaPointer2 = _interopRequireDefault(AlphaPointer_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlphaPicker = exports.AlphaPicker = function AlphaPicker(_ref) {
  var rgb = _ref.rgb,
      hsl = _ref.hsl,
      width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      direction = _ref.direction,
      style = _ref.style,
      renderers = _ref.renderers,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      alpha: {
        radius: '2px',
        style: style
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'alpha-picker ' + className },
    _react2.default.createElement(common.Alpha, _extends({}, styles.alpha, {
      rgb: rgb,
      hsl: hsl,
      pointer: pointer,
      renderers: renderers,
      onChange: onChange,
      direction: direction
    }))
  );
};

AlphaPicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: _AlphaPointer2.default
};

exports.default = (0, common.ColorWrap)(AlphaPicker);
});

unwrapExports(Alpha);
var Alpha_1$1 = Alpha.AlphaPicker;

var BlockSwatches_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockSwatches = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



var _map2 = _interopRequireDefault(map_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlockSwatches = exports.BlockSwatches = function BlockSwatches(_ref) {
  var colors = _ref.colors,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        marginRight: '-10px'
      },
      swatch: {
        width: '22px',
        height: '22px',
        float: 'left',
        marginRight: '10px',
        marginBottom: '10px',
        borderRadius: '4px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.swatches },
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(common.Swatch, {
        key: c,
        color: c,
        style: styles.swatch,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: '0 0 4px ' + c
        }
      });
    }),
    _react2.default.createElement('div', { style: styles.clear })
  );
};

exports.default = BlockSwatches;
});

unwrapExports(BlockSwatches_1);
var BlockSwatches_2 = BlockSwatches_1.BlockSwatches;

var Block_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Block = undefined;



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _reactcss2 = _interopRequireDefault(lib);



var _merge2 = _interopRequireDefault(merge_1);



var _color2 = _interopRequireDefault(color);





var _BlockSwatches2 = _interopRequireDefault(BlockSwatches_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Block = exports.Block = function Block(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var transparent = hex === 'transparent';
  var handleChange = function handleChange(hexCode, e) {
    _color2.default.isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        boxShadow: '0 1px rgba(0,0,0,.1)',
        borderRadius: '6px',
        position: 'relative'
      },
      head: {
        height: '110px',
        background: hex,
        borderRadius: '6px 6px 0 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      },
      body: {
        padding: '10px'
      },
      label: {
        fontSize: '18px',
        color: _color2.default.getContrastingColor(hex),
        position: 'relative'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: 'transparent transparent ' + hex + ' transparent',
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: '-10px'
      },
      input: {
        width: '100%',
        fontSize: '12px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '22px',
        boxShadow: 'inset 0 0 0 1px #ddd',
        borderRadius: '4px',
        padding: '0 7px',
        boxSizing: 'border-box'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      }
    }
  }, passedStyles), { 'hide-triangle': triangle === 'hide' });

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'block-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangle }),
    _react2.default.createElement(
      'div',
      { style: styles.head },
      transparent && _react2.default.createElement(common.Checkboard, { borderRadius: '6px 6px 0 0' }),
      _react2.default.createElement(
        'div',
        { style: styles.label },
        hex
      )
    ),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      _react2.default.createElement(_BlockSwatches2.default, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
      _react2.default.createElement(common.EditableInput, {
        style: { input: styles.input },
        value: hex,
        onChange: handleChange
      })
    )
  );
};

Block.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  triangle: _propTypes2.default.oneOf(['top', 'hide']),
  styles: _propTypes2.default.object
};

Block.defaultProps = {
  width: 170,
  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
  triangle: 'top',
  styles: {}
};

exports.default = (0, common.ColorWrap)(Block);
});

unwrapExports(Block_1);
var Block_2 = Block_1.Block;

var red = {"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"};
var pink = {"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"};
var purple = {"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"};
var deepPurple = {"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"};
var indigo = {"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"};
var blue = {"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"};
var lightBlue = {"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"};
var cyan = {"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"};
var teal = {"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"};
var green = {"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"};
var lightGreen = {"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"};
var lime = {"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"};
var yellow = {"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"};
var amber = {"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"};
var orange = {"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"};
var deepOrange = {"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"};
var brown = {"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"};
var grey = {"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"};
var blueGrey = {"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"};
var darkText = {"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"};
var lightText = {"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"};
var darkIcons = {"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"};
var lightIcons = {"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"};
var white$1 = "#ffffff";
var black$1 = "#000000";

var colors_es2015 = {
  red: red,
  pink: pink,
  purple: purple,
  deepPurple: deepPurple,
  indigo: indigo,
  blue: blue,
  lightBlue: lightBlue,
  cyan: cyan,
  teal: teal,
  green: green,
  lightGreen: lightGreen,
  lime: lime,
  yellow: yellow,
  amber: amber,
  orange: orange,
  deepOrange: deepOrange,
  brown: brown,
  grey: grey,
  blueGrey: blueGrey,
  darkText: darkText,
  lightText: lightText,
  darkIcons: darkIcons,
  lightIcons: lightIcons,
  white: white$1,
  black: black$1
};

var colors_es2015$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	red: red,
	pink: pink,
	purple: purple,
	deepPurple: deepPurple,
	indigo: indigo,
	blue: blue,
	lightBlue: lightBlue,
	cyan: cyan,
	teal: teal,
	green: green,
	lightGreen: lightGreen,
	lime: lime,
	yellow: yellow,
	amber: amber,
	orange: orange,
	deepOrange: deepOrange,
	brown: brown,
	grey: grey,
	blueGrey: blueGrey,
	darkText: darkText,
	lightText: lightText,
	darkIcons: darkIcons,
	lightIcons: lightIcons,
	white: white$1,
	black: black$1,
	'default': colors_es2015
});

var CircleSwatch_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleSwatch = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleSwatch = exports.CircleSwatch = function CircleSwatch(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      hover = _ref.hover,
      active = _ref.active,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: 'scale(1)',
        transition: '100ms transform ease'
      },
      Swatch: {
        borderRadius: '50%',
        background: 'transparent',
        boxShadow: 'inset 0 0 0 ' + circleSize / 2 + 'px ' + color,
        transition: '100ms box-shadow ease'
      }
    },
    'hover': {
      swatch: {
        transform: 'scale(1.2)'
      }
    },
    'active': {
      Swatch: {
        boxShadow: 'inset 0 0 0 3px ' + color
      }
    }
  }, { hover: hover, active: active });

  return _react2.default.createElement(
    'div',
    { style: styles.swatch },
    _react2.default.createElement(common.Swatch, {
      style: styles.Swatch,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
    })
  );
};

CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};

exports.default = (0, lib.handleHover)(CircleSwatch);
});

unwrapExports(CircleSwatch_1);
var CircleSwatch_2 = CircleSwatch_1.CircleSwatch;

var _materialColors = getCjsExportFromNamespace(colors_es2015$1);

var Circle_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Circle = undefined;



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _reactcss2 = _interopRequireDefault(lib);



var _map2 = _interopRequireDefault(map_1);



var _merge2 = _interopRequireDefault(merge_1);



var material = _interopRequireWildcard(_materialColors);





var _CircleSwatch2 = _interopRequireDefault(CircleSwatch_1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Circle = exports.Circle = function Circle(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      circleSize = _ref.circleSize,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      circleSpacing = _ref.circleSpacing,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      card: {
        width: width,
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(hexCode, e) {
    return onChange({ hex: hexCode, source: 'hex' }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'circle-picker ' + className },
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_CircleSwatch2.default, {
        key: c,
        color: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover,
        active: hex === c.toLowerCase(),
        circleSize: circleSize,
        circleSpacing: circleSpacing
      });
    })
  );
};

Circle.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  circleSize: _propTypes2.default.number,
  circleSpacing: _propTypes2.default.number,
  styles: _propTypes2.default.object
};

Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500']],
  styles: {}
};

exports.default = (0, common.ColorWrap)(Circle);
});

unwrapExports(Circle_1);
var Circle_2 = Circle_1.Circle;

var UnfoldMoreHorizontalIcon = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

exports.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2.default.createElement(
    'svg',
    _extends({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2.default.createElement('path', { d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' })
  );
};
});

unwrapExports(UnfoldMoreHorizontalIcon);

var ChromeFields_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromeFields = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



var _color2 = _interopRequireDefault(color);





var _UnfoldMoreHorizontalIcon2 = _interopRequireDefault(UnfoldMoreHorizontalIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */

var ChromeFields = exports.ChromeFields = function (_React$Component) {
  _inherits(ChromeFields, _React$Component);

  function ChromeFields(props) {
    _classCallCheck(this, ChromeFields);

    var _this = _possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));

    _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({ view: 'rgb' });
      } else if (_this.state.view === 'rgb') {
        _this.setState({ view: 'hsl' });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: 'hex' });
        } else {
          _this.setState({ view: 'rgb' });
        }
      }
    };

    _this.handleChange = function (data, e) {
      if (data.hex) {
        _color2.default.isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        // Remove any occurances of '%'.
        if (typeof data.s === 'string' && data.s.includes('%')) {
          data.s = data.s.replace('%', '');
        }
        if (typeof data.l === 'string' && data.l.includes('%')) {
          data.l = data.l.replace('%', '');
        }

        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: Number(data.s && data.s || _this.props.hsl.s),
          l: Number(data.l && data.l || _this.props.hsl.l),
          source: 'hsl'
        }, e);
      }
    };

    _this.showHighlight = function (e) {
      e.currentTarget.style.background = '#eee';
    };

    _this.hideHighlight = function (e) {
      e.currentTarget.style.background = 'transparent';
    };

    if (props.hsl.a !== 1 && props.view === "hex") {
      _this.state = {
        view: "rgb"
      };
    } else {
      _this.state = {
        view: props.view
      };
    }
    return _this;
  }

  _createClass(ChromeFields, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            fill: '#333',
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);

      var fields = void 0;
      if (this.state.view === 'hex') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'hex', value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'rgb') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'r',
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'g',
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'b',
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'hsl') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'h',
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 's',
              value: Math.round(this.props.hsl.s * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'l',
              value: Math.round(this.props.hsl.l * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { style: styles.wrap, className: 'flexbox-fix' },
        fields,
        _react2.default.createElement(
          'div',
          { style: styles.toggle },
          _react2.default.createElement(
            'div',
            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
                return _this2.icon = icon;
              } },
            _react2.default.createElement(_UnfoldMoreHorizontalIcon2.default, {
              style: styles.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.hsl.a !== 1 && state.view === 'hex') {
        return { view: 'rgb' };
      }
      return null;
    }
  }]);

  return ChromeFields;
}(_react2.default.Component);

ChromeFields.defaultProps = {
  view: "hex"
};

exports.default = ChromeFields;
});

unwrapExports(ChromeFields_1);
var ChromeFields_2 = ChromeFields_1.ChromeFields;

var ChromePointer_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointer = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointer = exports.ChromePointer = function ChromePointer() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = ChromePointer;
});

unwrapExports(ChromePointer_1);
var ChromePointer_2 = ChromePointer_1.ChromePointer;

var ChromePointerCircle_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointerCircle = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = ChromePointerCircle;
});

unwrapExports(ChromePointerCircle_1);
var ChromePointerCircle_2 = ChromePointerCircle_1.ChromePointerCircle;

var Chrome_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chrome = undefined;



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _reactcss2 = _interopRequireDefault(lib);



var _merge2 = _interopRequireDefault(merge_1);





var _ChromeFields2 = _interopRequireDefault(ChromeFields_1);



var _ChromePointer2 = _interopRequireDefault(ChromePointer_1);



var _ChromePointerCircle2 = _interopRequireDefault(ChromePointerCircle_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Chrome = exports.Chrome = function Chrome(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      defaultView = _ref.defaultView;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'chrome-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2.default.createElement(common.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: _ChromePointerCircle2.default,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      _react2.default.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        _react2.default.createElement(
          'div',
          { style: styles.color },
          _react2.default.createElement(
            'div',
            { style: styles.swatch },
            _react2.default.createElement('div', { style: styles.active }),
            _react2.default.createElement(common.Checkboard, { renderers: renderers })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: styles.toggles },
          _react2.default.createElement(
            'div',
            { style: styles.hue },
            _react2.default.createElement(common.Hue, {
              style: styles.Hue,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              onChange: onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(common.Alpha, {
              style: styles.Alpha,
              rgb: rgb,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              renderers: renderers,
              onChange: onChange
            })
          )
        )
      ),
      _react2.default.createElement(_ChromeFields2.default, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
      })
    )
  );
};

Chrome.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  disableAlpha: _propTypes2.default.bool,
  styles: _propTypes2.default.object,
  defaultView: _propTypes2.default.oneOf(["hex", "rgb", "hsl"])
};

Chrome.defaultProps = {
  width: 225,
  disableAlpha: false,
  styles: {}
};

exports.default = (0, common.ColorWrap)(Chrome);
});

unwrapExports(Chrome_1);
var Chrome_2 = Chrome_1.Chrome;

var CompactColor_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactColor = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



var _color2 = _interopRequireDefault(color);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactColor = exports.CompactColor = function CompactColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      color: {
        background: color,
        width: '15px',
        height: '15px',
        float: 'left',
        marginRight: '5px',
        marginBottom: '5px',
        position: 'relative',
        cursor: 'pointer'
      },
      dot: {
        absolute: '5px 5px 5px 5px',
        background: _color2.default.getContrastingColor(color),
        borderRadius: '50%',
        opacity: '0'
      }
    },
    'active': {
      dot: {
        opacity: '1'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      dot: {
        background: '#000'
      }
    },
    'transparent': {
      dot: {
        background: '#000'
      }
    }
  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });

  return _react2.default.createElement(
    common.Swatch,
    {
      style: styles.color,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    _react2.default.createElement('div', { style: styles.dot })
  );
};

exports.default = CompactColor;
});

unwrapExports(CompactColor_1);
var CompactColor_2 = CompactColor_1.CompactColor;

var CompactFields_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactFields = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactFields = exports.CompactFields = function CompactFields(_ref) {
  var hex = _ref.hex,
      rgb = _ref.rgb,
      onChange = _ref.onChange;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        display: 'flex',
        paddingBottom: '6px',
        paddingRight: '5px',
        position: 'relative'
      },
      active: {
        position: 'absolute',
        top: '6px',
        left: '5px',
        height: '9px',
        width: '9px',
        background: hex
      },
      HEXwrap: {
        flex: '6',
        position: 'relative'
      },
      HEXinput: {
        width: '80%',
        padding: '0px',
        paddingLeft: '20%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      HEXlabel: {
        display: 'none'
      },
      RGBwrap: {
        flex: '3',
        position: 'relative'
      },
      RGBinput: {
        width: '70%',
        padding: '0px',
        paddingLeft: '30%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '3px',
        left: '0px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        fontSize: '12px',
        color: '#999'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else {
      onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    _react2.default.createElement('div', { style: styles.active }),
    _react2.default.createElement(common.EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: 'hex',
      value: hex,
      onChange: handleChange
    }),
    _react2.default.createElement(common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    _react2.default.createElement(common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    _react2.default.createElement(common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    })
  );
};

exports.default = CompactFields;
});

unwrapExports(CompactFields_1);
var CompactFields_2 = CompactFields_1.CompactFields;

var Compact_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Compact = undefined;



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _reactcss2 = _interopRequireDefault(lib);



var _map2 = _interopRequireDefault(map_1);



var _merge2 = _interopRequireDefault(merge_1);



var _color2 = _interopRequireDefault(color);





var _CompactColor2 = _interopRequireDefault(CompactColor_1);



var _CompactFields2 = _interopRequireDefault(CompactFields_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Compact = exports.Compact = function Compact(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      Compact: {
        background: '#f6f6f6',
        radius: '4px'
      },
      compact: {
        paddingTop: '5px',
        paddingLeft: '5px',
        boxSizing: 'initial',
        width: '240px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else {
      onChange(data, e);
    }
  };

  return _react2.default.createElement(
    common.Raised,
    { style: styles.Compact, styles: passedStyles },
    _react2.default.createElement(
      'div',
      { style: styles.compact, className: 'compact-picker ' + className },
      _react2.default.createElement(
        'div',
        null,
        (0, _map2.default)(colors, function (c) {
          return _react2.default.createElement(_CompactColor2.default, {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
          });
        }),
        _react2.default.createElement('div', { style: styles.clear })
      ),
      _react2.default.createElement(_CompactFields2.default, { hex: hex, rgb: rgb, onChange: handleChange })
    )
  );
};

Compact.propTypes = {
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  styles: _propTypes2.default.object
};

Compact.defaultProps = {
  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],
  styles: {}
};

exports.default = (0, common.ColorWrap)(Compact);
});

unwrapExports(Compact_1);
var Compact_2 = Compact_1.Compact;

var GithubSwatch_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GithubSwatch = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GithubSwatch = exports.GithubSwatch = function GithubSwatch(_ref) {
  var hover = _ref.hover,
      color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var hoverSwatch = {
    position: 'relative',
    zIndex: '2',
    outline: '2px solid #fff',
    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
  };

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        width: '25px',
        height: '25px',
        fontSize: '0'
      }
    },
    'hover': {
      swatch: hoverSwatch
    }
  }, { hover: hover });

  return _react2.default.createElement(
    'div',
    { style: styles.swatch },
    _react2.default.createElement(common.Swatch, {
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: hoverSwatch
    })
  );
};

exports.default = (0, lib.handleHover)(GithubSwatch);
});

unwrapExports(GithubSwatch_1);
var GithubSwatch_2 = GithubSwatch_1.GithubSwatch;

var Github_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Github = undefined;



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _reactcss2 = _interopRequireDefault(lib);



var _map2 = _interopRequireDefault(map_1);



var _merge2 = _interopRequireDefault(merge_1);





var _GithubSwatch2 = _interopRequireDefault(GithubSwatch_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Github = exports.Github = function Github(_ref) {
  var width = _ref.width,
      colors = _ref.colors,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.2)',
        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
        borderRadius: '4px',
        position: 'relative',
        padding: '5px',
        display: 'flex',
        flexWrap: 'wrap'
      },
      triangle: {
        position: 'absolute',
        border: '7px solid transparent',
        borderBottomColor: '#fff'
      },
      triangleShadow: {
        position: 'absolute',
        border: '8px solid transparent',
        borderBottomColor: 'rgba(0,0,0,0.15)'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-14px',
        left: '10px'
      },
      triangleShadow: {
        top: '-16px',
        left: '9px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-14px',
        right: '10px'
      },
      triangleShadow: {
        top: '-16px',
        right: '9px'
      }
    },
    'bottom-left-triangle': {
      triangle: {
        top: '35px',
        left: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        left: '9px',
        transform: 'rotate(180deg)'
      }
    },
    'bottom-right-triangle': {
      triangle: {
        top: '35px',
        right: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        right: '9px',
        transform: 'rotate(180deg)'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right',
    'bottom-left-triangle': triangle === 'bottom-left',
    'bottom-right-triangle': triangle === 'bottom-right'
  });

  var handleChange = function handleChange(hex, e) {
    return onChange({ hex: hex, source: 'hex' }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'github-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangleShadow }),
    _react2.default.createElement('div', { style: styles.triangle }),
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_GithubSwatch2.default, {
        color: c,
        key: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

Github.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
  styles: _propTypes2.default.object
};

Github.defaultProps = {
  width: 200,
  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
  triangle: 'top-left',
  styles: {}
};

exports.default = (0, common.ColorWrap)(Github);
});

unwrapExports(Github_1);
var Github_2 = Github_1.Github;

var HuePointer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderPointer = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderPointer = exports.SliderPointer = function SliderPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = SliderPointer;
});

unwrapExports(HuePointer);
var HuePointer_1 = HuePointer.SliderPointer;

var Hue = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HuePicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _reactcss2 = _interopRequireDefault(lib);



var _merge2 = _interopRequireDefault(merge_1);





var _HuePointer2 = _interopRequireDefault(HuePointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HuePicker = exports.HuePicker = function HuePicker(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      hsl = _ref.hsl,
      direction = _ref.direction,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  // Overwrite to provide pure hue color
  var handleChange = function handleChange(data) {
    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
  };

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'hue-picker ' + className },
    _react2.default.createElement(common.Hue, _extends({}, styles.hue, {
      hsl: hsl,
      pointer: pointer,
      onChange: handleChange,
      direction: direction
    }))
  );
};

HuePicker.propTypes = {
  styles: _propTypes2.default.object
};
HuePicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: _HuePointer2.default,
  styles: {}
};

exports.default = (0, common.ColorWrap)(HuePicker);
});

unwrapExports(Hue);
var Hue_1$1 = Hue.HuePicker;

var Material_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Material = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



var _merge2 = _interopRequireDefault(merge_1);



var _color2 = _interopRequireDefault(color);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Material = exports.Material = function Material(_ref) {
  var onChange = _ref.onChange,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      material: {
        width: '98px',
        height: '98px',
        padding: '16px',
        fontFamily: 'Roboto'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '2px solid ' + hex,
        outline: 'none',
        height: '30px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '1px solid #eee',
        outline: 'none',
        height: '30px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      split: {
        display: 'flex',
        marginRight: '-10px',
        paddingTop: '11px'
      },
      third: {
        flex: '1',
        paddingRight: '10px'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    }
  };

  return _react2.default.createElement(
    common.Raised,
    { styles: passedStyles },
    _react2.default.createElement(
      'div',
      { style: styles.material, className: 'material-picker ' + className },
      _react2.default.createElement(common.EditableInput, {
        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
        label: 'hex',
        value: hex,
        onChange: handleChange
      }),
      _react2.default.createElement(
        'div',
        { style: styles.split, className: 'flexbox-fix' },
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'r', value: rgb.r,
            onChange: handleChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'g',
            value: rgb.g,
            onChange: handleChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'b',
            value: rgb.b,
            onChange: handleChange
          })
        )
      )
    )
  );
};

exports.default = (0, common.ColorWrap)(Material);
});

unwrapExports(Material_1);
var Material_2 = Material_1.Material;

var PhotoshopFields = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPicker = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



var _color2 = _interopRequireDefault(color);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPicker = exports.PhotoshopPicker = function PhotoshopPicker(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsv = _ref.hsv,
      hex = _ref.hex;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        paddingTop: '5px',
        paddingBottom: '9px',
        width: '80px',
        position: 'relative'
      },
      divider: {
        height: '5px'
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        marginLeft: '40%',
        width: '40%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '5px',
        fontSize: '13px',
        paddingLeft: '3px',
        marginRight: '10px'
      },
      RGBlabel: {
        left: '0px',
        width: '34px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px',
        position: 'absolute'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        marginLeft: '20%',
        width: '80%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '6px',
        fontSize: '13px',
        paddingLeft: '3px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '14px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px'
      },
      fieldSymbols: {
        position: 'absolute',
        top: '5px',
        right: '-7px',
        fontSize: '13px'
      },
      symbol: {
        height: '20px',
        lineHeight: '22px',
        paddingBottom: '7px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data['#']) {
      _color2.default.isValidHex(data['#']) && onChange({
        hex: data['#'],
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else if (data.h || data.s || data.v) {
      onChange({
        h: data.h || hsv.h,
        s: data.s || hsv.s,
        v: data.v || hsv.v,
        source: 'hsv'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields },
    _react2.default.createElement(common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'h',
      value: Math.round(hsv.h),
      onChange: handleChange
    }),
    _react2.default.createElement(common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 's',
      value: Math.round(hsv.s * 100),
      onChange: handleChange
    }),
    _react2.default.createElement(common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'v',
      value: Math.round(hsv.v * 100),
      onChange: handleChange
    }),
    _react2.default.createElement('div', { style: styles.divider }),
    _react2.default.createElement(common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    _react2.default.createElement(common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    _react2.default.createElement(common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    }),
    _react2.default.createElement('div', { style: styles.divider }),
    _react2.default.createElement(common.EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: '#',
      value: hex.replace('#', ''),
      onChange: handleChange
    }),
    _react2.default.createElement(
      'div',
      { style: styles.fieldSymbols },
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '\xB0'
      ),
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      ),
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      )
    )
  );
};

exports.default = PhotoshopPicker;
});

unwrapExports(PhotoshopFields);
var PhotoshopFields_1 = PhotoshopFields.PhotoshopPicker;

var PhotoshopPointerCircle_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPointerCircle = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
  var hsl = _ref.hsl;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    },
    'black-outline': {
      picker: {
        boxShadow: 'inset 0 0 0 1px #000'
      }
    }
  }, { 'black-outline': hsl.l > 0.5 });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = PhotoshopPointerCircle;
});

unwrapExports(PhotoshopPointerCircle_1);
var PhotoshopPointerCircle_2 = PhotoshopPointerCircle_1.PhotoshopPointerCircle;

var PhotoshopPointer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPointerCircle = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
  var styles = (0, _reactcss2.default)({
    'default': {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '4px 0 4px 6px',
        borderColor: 'transparent transparent transparent #fff',
        position: 'absolute',
        top: '1px',
        left: '1px'
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 8px',
        borderColor: 'transparent transparent transparent #555'
      },

      left: {
        Extend: 'triangleBorder',
        transform: 'translate(-13px, -4px)'
      },
      leftInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      },

      right: {
        Extend: 'triangleBorder',
        transform: 'translate(20px, -14px) rotate(180deg)'
      },
      rightInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.pointer },
    _react2.default.createElement(
      'div',
      { style: styles.left },
      _react2.default.createElement('div', { style: styles.leftInside })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.right },
      _react2.default.createElement('div', { style: styles.rightInside })
    )
  );
};

exports.default = PhotoshopPointerCircle;
});

unwrapExports(PhotoshopPointer);
var PhotoshopPointer_1 = PhotoshopPointer.PhotoshopPointerCircle;

var PhotoshopButton_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopButton = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopButton = exports.PhotoshopButton = function PhotoshopButton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      children = _ref.children,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      button: {
        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
        border: '1px solid #878787',
        borderRadius: '2px',
        height: '20px',
        boxShadow: '0 1px 0 0 #EAEAEA',
        fontSize: '14px',
        color: '#000',
        lineHeight: '20px',
        textAlign: 'center',
        marginBottom: '10px',
        cursor: 'pointer'
      }
    },
    'active': {
      button: {
        boxShadow: '0 0 0 1px #878787'
      }
    }
  }, { active: active });

  return _react2.default.createElement(
    'div',
    { style: styles.button, onClick: onClick },
    label || children
  );
};

exports.default = PhotoshopButton;
});

unwrapExports(PhotoshopButton_1);
var PhotoshopButton_2 = PhotoshopButton_1.PhotoshopButton;

var PhotoshopPreviews_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPreviews = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPreviews = exports.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
  var rgb = _ref.rgb,
      currentColor = _ref.currentColor;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        border: '1px solid #B3B3B3',
        borderBottom: '1px solid #F0F0F0',
        marginBottom: '2px',
        marginTop: '1px'
      },
      new: {
        height: '34px',
        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
      },
      current: {
        height: '34px',
        background: currentColor,
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
      },
      label: {
        fontSize: '14px',
        color: '#000',
        textAlign: 'center'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: styles.label },
      'new'
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatches },
      _react2.default.createElement('div', { style: styles.new }),
      _react2.default.createElement('div', { style: styles.current })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.label },
      'current'
    )
  );
};

exports.default = PhotoshopPreviews;
});

unwrapExports(PhotoshopPreviews_1);
var PhotoshopPreviews_2 = PhotoshopPreviews_1.PhotoshopPreviews;

var Photoshop_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Photoshop = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _reactcss2 = _interopRequireDefault(lib);



var _merge2 = _interopRequireDefault(merge_1);





var _PhotoshopFields2 = _interopRequireDefault(PhotoshopFields);



var _PhotoshopPointerCircle2 = _interopRequireDefault(PhotoshopPointerCircle_1);



var _PhotoshopPointer2 = _interopRequireDefault(PhotoshopPointer);



var _PhotoshopButton2 = _interopRequireDefault(PhotoshopButton_1);



var _PhotoshopPreviews2 = _interopRequireDefault(PhotoshopPreviews_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Photoshop = exports.Photoshop = function (_React$Component) {
  _inherits(Photoshop, _React$Component);

  function Photoshop(props) {
    _classCallCheck(this, Photoshop);

    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }

  _createClass(Photoshop, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$styles = _props.styles,
          passedStyles = _props$styles === undefined ? {} : _props$styles,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className;

      var styles = (0, _reactcss2.default)((0, _merge2.default)({
        'default': {
          picker: {
            background: '#DCDCDC',
            borderRadius: '4px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
            boxSizing: 'initial',
            width: '513px'
          },
          head: {
            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
            borderBottom: '1px solid #B1B1B1',
            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
            height: '23px',
            lineHeight: '24px',
            borderRadius: '4px 4px 0 0',
            fontSize: '13px',
            color: '#4D4D4D',
            textAlign: 'center'
          },
          body: {
            padding: '15px 15px 0',
            display: 'flex'
          },
          saturation: {
            width: '256px',
            height: '256px',
            position: 'relative',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0',
            overflow: 'hidden'
          },
          hue: {
            position: 'relative',
            height: '256px',
            width: '19px',
            marginLeft: '10px',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0'
          },
          controls: {
            width: '180px',
            marginLeft: '10px'
          },
          top: {
            display: 'flex'
          },
          previews: {
            width: '60px'
          },
          actions: {
            flex: '1',
            marginLeft: '20px'
          }
        }
      }, passedStyles));

      return _react2.default.createElement(
        'div',
        { style: styles.picker, className: 'photoshop-picker ' + className },
        _react2.default.createElement(
          'div',
          { style: styles.head },
          this.props.header
        ),
        _react2.default.createElement(
          'div',
          { style: styles.body, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.saturation },
            _react2.default.createElement(common.Saturation, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: _PhotoshopPointerCircle2.default,
              onChange: this.props.onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.hue },
            _react2.default.createElement(common.Hue, {
              direction: 'vertical',
              hsl: this.props.hsl,
              pointer: _PhotoshopPointer2.default,
              onChange: this.props.onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.controls },
            _react2.default.createElement(
              'div',
              { style: styles.top, className: 'flexbox-fix' },
              _react2.default.createElement(
                'div',
                { style: styles.previews },
                _react2.default.createElement(_PhotoshopPreviews2.default, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              _react2.default.createElement(
                'div',
                { style: styles.actions },
                _react2.default.createElement(_PhotoshopButton2.default, { label: 'OK', onClick: this.props.onAccept, active: true }),
                _react2.default.createElement(_PhotoshopButton2.default, { label: 'Cancel', onClick: this.props.onCancel }),
                _react2.default.createElement(_PhotoshopFields2.default, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Photoshop;
}(_react2.default.Component);

Photoshop.propTypes = {
  header: _propTypes2.default.string,
  styles: _propTypes2.default.object
};

Photoshop.defaultProps = {
  header: 'Color Picker',
  styles: {}
};

exports.default = (0, common.ColorWrap)(Photoshop);
});

unwrapExports(Photoshop_1);
var Photoshop_2 = Photoshop_1.Photoshop;

var SketchFields_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SketchFields = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



var _color2 = _interopRequireDefault(color);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */

var SketchFields = exports.SketchFields = function SketchFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      disableAlpha = _ref.disableAlpha;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        display: 'flex',
        paddingTop: '4px'
      },
      single: {
        flex: '1',
        paddingLeft: '6px'
      },
      alpha: {
        flex: '1',
        paddingLeft: '6px'
      },
      double: {
        flex: '2'
      },
      input: {
        width: '80%',
        padding: '4px 10% 3px',
        border: 'none',
        boxShadow: 'inset 0 0 0 1px #ccc',
        fontSize: '11px'
      },
      label: {
        display: 'block',
        textAlign: 'center',
        fontSize: '11px',
        color: '#222',
        paddingTop: '3px',
        paddingBottom: '4px',
        textTransform: 'capitalize'
      }
    },
    'disableAlpha': {
      alpha: {
        display: 'none'
      }
    }
  }, { disableAlpha: disableAlpha });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        a: rgb.a,
        source: 'rgb'
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 100) {
        data.a = 100;
      }

      data.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data.a,
        source: 'rgb'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    _react2.default.createElement(
      'div',
      { style: styles.double },
      _react2.default.createElement(common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.alpha },
      _react2.default.createElement(common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
      })
    )
  );
};

exports.default = SketchFields;
});

unwrapExports(SketchFields_1);
var SketchFields_2 = SketchFields_1.SketchFields;

var SketchPresetColors_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SketchPresetColors = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _reactcss2 = _interopRequireDefault(lib);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SketchPresetColors = exports.SketchPresetColors = function SketchPresetColors(_ref) {
  var colors = _ref.colors,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0, _reactcss2.default)({
    'default': {
      colors: {
        margin: '0 -10px',
        padding: '10px 0 0 10px',
        borderTop: '1px solid #eee',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative'
      },
      swatchWrap: {
        width: '16px',
        height: '16px',
        margin: '0 10px 10px 0'
      },
      swatch: {
        borderRadius: '3px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
      }
    },
    'no-presets': {
      colors: {
        display: 'none'
      }
    }
  }, {
    'no-presets': !colors || !colors.length
  });

  var handleClick = function handleClick(hex, e) {
    onClick({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.colors, className: 'flexbox-fix' },
    colors.map(function (colorObjOrString) {
      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
      var key = '' + c.color + (c.title || '');
      return _react2.default.createElement(
        'div',
        { key: key, style: styles.swatchWrap },
        _react2.default.createElement(common.Swatch, _extends({}, c, {
          style: styles.swatch,
          onClick: handleClick,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
          }
        }))
      );
    })
  );
};

SketchPresetColors.propTypes = {
  colors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    color: _propTypes2.default.string,
    title: _propTypes2.default.string
  })])).isRequired
};

exports.default = SketchPresetColors;
});

unwrapExports(SketchPresetColors_1);
var SketchPresetColors_2 = SketchPresetColors_1.SketchPresetColors;

var Sketch_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sketch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _reactcss2 = _interopRequireDefault(lib);



var _merge2 = _interopRequireDefault(merge_1);





var _SketchFields2 = _interopRequireDefault(SketchFields_1);



var _SketchPresetColors2 = _interopRequireDefault(SketchPresetColors_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sketch = exports.Sketch = function Sketch(_ref) {
  var width = _ref.width,
      rgb = _ref.rgb,
      hex = _ref.hex,
      hsv = _ref.hsv,
      hsl = _ref.hsl,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      disableAlpha = _ref.disableAlpha,
      presetColors = _ref.presetColors,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': _extends({
      picker: {
        width: width,
        padding: '10px 10px 0',
        boxSizing: 'initial',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
      },
      saturation: {
        width: '100%',
        paddingBottom: '75%',
        position: 'relative',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '3px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      controls: {
        display: 'flex'
      },
      sliders: {
        padding: '4px 0',
        flex: '1'
      },
      color: {
        width: '24px',
        height: '24px',
        position: 'relative',
        marginTop: '4px',
        marginLeft: '4px',
        borderRadius: '3px'
      },
      activeColor: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '2px',
        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      hue: {
        position: 'relative',
        height: '10px',
        overflow: 'hidden'
      },
      Hue: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },

      alpha: {
        position: 'relative',
        height: '10px',
        marginTop: '4px',
        overflow: 'hidden'
      },
      Alpha: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      }
    }, passedStyles),
    'disableAlpha': {
      color: {
        height: '10px'
      },
      hue: {
        height: '10px'
      },
      alpha: {
        display: 'none'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'sketch-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2.default.createElement(common.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.controls, className: 'flexbox-fix' },
      _react2.default.createElement(
        'div',
        { style: styles.sliders },
        _react2.default.createElement(
          'div',
          { style: styles.hue },
          _react2.default.createElement(common.Hue, {
            style: styles.Hue,
            hsl: hsl,
            onChange: onChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.alpha },
          _react2.default.createElement(common.Alpha, {
            style: styles.Alpha,
            rgb: rgb,
            hsl: hsl,
            renderers: renderers,
            onChange: onChange
          })
        )
      ),
      _react2.default.createElement(
        'div',
        { style: styles.color },
        _react2.default.createElement(common.Checkboard, null),
        _react2.default.createElement('div', { style: styles.activeColor })
      )
    ),
    _react2.default.createElement(_SketchFields2.default, {
      rgb: rgb,
      hsl: hsl,
      hex: hex,
      onChange: onChange,
      disableAlpha: disableAlpha
    }),
    _react2.default.createElement(_SketchPresetColors2.default, {
      colors: presetColors,
      onClick: onChange,
      onSwatchHover: onSwatchHover
    })
  );
};

Sketch.propTypes = {
  disableAlpha: _propTypes2.default.bool,
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  styles: _propTypes2.default.object
};

Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  styles: {},
  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
};

exports.default = (0, common.ColorWrap)(Sketch);
});

unwrapExports(Sketch_1);
var Sketch_2 = Sketch_1.Sketch;

var SliderSwatch_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSwatch = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwatch = exports.SliderSwatch = function SliderSwatch(_ref) {
  var hsl = _ref.hsl,
      offset = _ref.offset,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      active = _ref.active,
      first = _ref.first,
      last = _ref.last;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        height: '12px',
        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
        cursor: 'pointer'
      }
    },
    'first': {
      swatch: {
        borderRadius: '2px 0 0 2px'
      }
    },
    'last': {
      swatch: {
        borderRadius: '0 2px 2px 0'
      }
    },
    'active': {
      swatch: {
        transform: 'scaleY(1.8)',
        borderRadius: '3.6px/2px'
      }
    }
  }, { active: active, first: first, last: last });

  var handleClick = function handleClick(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: 'hsl'
    }, e);
  };

  return _react2.default.createElement('div', { style: styles.swatch, onClick: handleClick });
};

exports.default = SliderSwatch;
});

unwrapExports(SliderSwatch_1);
var SliderSwatch_2 = SliderSwatch_1.SliderSwatch;

var SliderSwatches_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSwatches = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



var _SliderSwatch2 = _interopRequireDefault(SliderSwatch_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
  var onClick = _ref.onClick,
      hsl = _ref.hsl;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        marginTop: '20px'
      },
      swatch: {
        boxSizing: 'border-box',
        width: '20%',
        paddingRight: '1px',
        float: 'left'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  // Acceptible difference in floating point equality
  var epsilon = 0.1;

  return _react2.default.createElement(
    'div',
    { style: styles.swatches },
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
      })
    ),
    _react2.default.createElement('div', { style: styles.clear })
  );
};

exports.default = SliderSwatches;
});

unwrapExports(SliderSwatches_1);
var SliderSwatches_2 = SliderSwatches_1.SliderSwatches;

var SliderPointer_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderPointer = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderPointer = exports.SliderPointer = function SliderPointer() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '14px',
        height: '14px',
        borderRadius: '6px',
        transform: 'translate(-7px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = SliderPointer;
});

unwrapExports(SliderPointer_1);
var SliderPointer_2 = SliderPointer_1.SliderPointer;

var Slider_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = undefined;



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _reactcss2 = _interopRequireDefault(lib);



var _merge2 = _interopRequireDefault(merge_1);





var _SliderSwatches2 = _interopRequireDefault(SliderSwatches_1);



var _SliderPointer2 = _interopRequireDefault(SliderPointer_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slider = exports.Slider = function Slider(_ref) {
  var hsl = _ref.hsl,
      onChange = _ref.onChange,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      hue: {
        height: '12px',
        position: 'relative'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  return _react2.default.createElement(
    'div',
    { style: styles.wrap || {}, className: 'slider-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.hue },
      _react2.default.createElement(common.Hue, {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatches },
      _react2.default.createElement(_SliderSwatches2.default, { hsl: hsl, onClick: onChange })
    )
  );
};

Slider.propTypes = {
  styles: _propTypes2.default.object
};
Slider.defaultProps = {
  pointer: _SliderPointer2.default,
  styles: {}
};

exports.default = (0, common.ColorWrap)(Slider);
});

unwrapExports(Slider_1);
var Slider_2 = Slider_1.Slider;

var CheckIcon = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

exports.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2.default.createElement(
    'svg',
    _extends({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
  );
};
});

unwrapExports(CheckIcon);

var SwatchesColor_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwatchesColor = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



var _color2 = _interopRequireDefault(color);





var _CheckIcon2 = _interopRequireDefault(CheckIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwatchesColor = exports.SwatchesColor = function SwatchesColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      first = _ref.first,
      last = _ref.last,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      color: {
        width: '40px',
        height: '24px',
        cursor: 'pointer',
        background: color,
        marginBottom: '1px'
      },
      check: {
        color: _color2.default.getContrastingColor(color),
        marginLeft: '8px',
        display: 'none'
      }
    },
    'first': {
      color: {
        overflow: 'hidden',
        borderRadius: '2px 2px 0 0'
      }
    },
    'last': {
      color: {
        overflow: 'hidden',
        borderRadius: '0 0 2px 2px'
      }
    },
    'active': {
      check: {
        display: 'block'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      check: {
        color: '#333'
      }
    },
    'transparent': {
      check: {
        color: '#333'
      }
    }
  }, {
    first: first,
    last: last,
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });

  return _react2.default.createElement(
    common.Swatch,
    {
      color: color,
      style: styles.color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    _react2.default.createElement(
      'div',
      { style: styles.check },
      _react2.default.createElement(_CheckIcon2.default, null)
    )
  );
};

exports.default = SwatchesColor;
});

unwrapExports(SwatchesColor_1);
var SwatchesColor_2 = SwatchesColor_1.SwatchesColor;

var SwatchesGroup_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwatchesGroup = undefined;



var _react2 = _interopRequireDefault(React);



var _reactcss2 = _interopRequireDefault(lib);



var _map2 = _interopRequireDefault(map_1);



var _SwatchesColor2 = _interopRequireDefault(SwatchesColor_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwatchesGroup = exports.SwatchesGroup = function SwatchesGroup(_ref) {
  var onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      group = _ref.group,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      group: {
        paddingBottom: '10px',
        width: '40px',
        float: 'left',
        marginRight: '10px'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.group },
    (0, _map2.default)(group, function (color, i) {
      return _react2.default.createElement(_SwatchesColor2.default, {
        key: color,
        color: color,
        active: color.toLowerCase() === active,
        first: i === 0,
        last: i === group.length - 1,
        onClick: onClick,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

exports.default = SwatchesGroup;
});

unwrapExports(SwatchesGroup_1);
var SwatchesGroup_2 = SwatchesGroup_1.SwatchesGroup;

var Swatches_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swatches = undefined;



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _reactcss2 = _interopRequireDefault(lib);



var _map2 = _interopRequireDefault(map_1);



var _merge2 = _interopRequireDefault(merge_1);



var _color2 = _interopRequireDefault(color);



var material = _interopRequireWildcard(_materialColors);





var _SwatchesGroup2 = _interopRequireDefault(SwatchesGroup_1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Swatches = exports.Swatches = function Swatches(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      picker: {
        width: width,
        height: height
      },
      overflow: {
        height: height,
        overflowY: 'scroll'
      },
      body: {
        padding: '16px 0 6px 16px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    _color2.default.isValidHex(data) && onChange({
      hex: data,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'swatches-picker ' + className },
    _react2.default.createElement(
      common.Raised,
      null,
      _react2.default.createElement(
        'div',
        { style: styles.overflow },
        _react2.default.createElement(
          'div',
          { style: styles.body },
          (0, _map2.default)(colors, function (group) {
            return _react2.default.createElement(_SwatchesGroup2.default, {
              key: group.toString(),
              group: group,
              active: hex,
              onClick: handleChange,
              onSwatchHover: onSwatchHover
            });
          }),
          _react2.default.createElement('div', { style: styles.clear })
        )
      )
    )
  );
};

Swatches.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string)),
  styles: _propTypes2.default.object

  /* eslint-disable max-len */
};Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']],
  styles: {}
};

exports.default = (0, common.ColorWrap)(Swatches);
});

unwrapExports(Swatches_1);
var Swatches_2 = Swatches_1.Swatches;

var Twitter_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitter = undefined;



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _reactcss2 = _interopRequireDefault(lib);



var _map2 = _interopRequireDefault(map_1);



var _merge2 = _interopRequireDefault(merge_1);



var _color2 = _interopRequireDefault(color);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Twitter = exports.Twitter = function Twitter(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '0 solid rgba(0,0,0,0.25)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
        borderRadius: '4px',
        position: 'relative'
      },
      body: {
        padding: '15px 9px 9px 15px'
      },
      label: {
        fontSize: '18px',
        color: '#fff'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent #fff transparent',
        position: 'absolute'
      },
      triangleShadow: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
        position: 'absolute'
      },
      hash: {
        background: '#F0F0F0',
        height: '30px',
        width: '30px',
        borderRadius: '4px 0 0 4px',
        float: 'left',
        color: '#98A1A4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      input: {
        width: '100px',
        fontSize: '14px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '28px',
        boxShadow: 'inset 0 0 0 1px #F0F0F0',
        boxSizing: 'content-box',
        borderRadius: '0 4px 4px 0',
        float: 'left',
        paddingLeft: '8px'
      },
      swatch: {
        width: '30px',
        height: '30px',
        float: 'left',
        borderRadius: '4px',
        margin: '0 6px 6px 0'
      },
      clear: {
        clear: 'both'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-10px',
        left: '12px'
      },
      triangleShadow: {
        top: '-11px',
        left: '12px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-10px',
        right: '12px'
      },
      triangleShadow: {
        top: '-11px',
        right: '12px'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right'
  });

  var handleChange = function handleChange(hexcode, e) {
    _color2.default.isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'twitter-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangleShadow }),
    _react2.default.createElement('div', { style: styles.triangle }),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      (0, _map2.default)(colors, function (c, i) {
        return _react2.default.createElement(common.Swatch, {
          key: i,
          color: c,
          hex: c,
          style: styles.swatch,
          onClick: handleChange,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: '0 0 4px ' + c
          }
        });
      }),
      _react2.default.createElement(
        'div',
        { style: styles.hash },
        '#'
      ),
      _react2.default.createElement(common.EditableInput, {
        label: null,
        style: { input: styles.input },
        value: hex.replace('#', ''),
        onChange: handleChange
      }),
      _react2.default.createElement('div', { style: styles.clear })
    )
  );
};

Twitter.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right']),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  styles: _propTypes2.default.object
};

Twitter.defaultProps = {
  width: 276,
  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
  triangle: 'top-left',
  styles: {}
};

exports.default = (0, common.ColorWrap)(Twitter);
});

unwrapExports(Twitter_1);
var Twitter_2 = Twitter_1.Twitter;

var lib$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomPicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;



Object.defineProperty(exports, 'AlphaPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Alpha).default;
  }
});



Object.defineProperty(exports, 'BlockPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Block_1).default;
  }
});



Object.defineProperty(exports, 'CirclePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Circle_1).default;
  }
});



Object.defineProperty(exports, 'ChromePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Chrome_1).default;
  }
});



Object.defineProperty(exports, 'CompactPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Compact_1).default;
  }
});



Object.defineProperty(exports, 'GithubPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Github_1).default;
  }
});



Object.defineProperty(exports, 'HuePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Hue).default;
  }
});



Object.defineProperty(exports, 'MaterialPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Material_1).default;
  }
});



Object.defineProperty(exports, 'PhotoshopPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Photoshop_1).default;
  }
});



Object.defineProperty(exports, 'SketchPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Sketch_1).default;
  }
});



Object.defineProperty(exports, 'SliderPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Slider_1).default;
  }
});



Object.defineProperty(exports, 'SwatchesPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Swatches_1).default;
  }
});



Object.defineProperty(exports, 'TwitterPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(Twitter_1).default;
  }
});



Object.defineProperty(exports, 'CustomPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(ColorWrap_1).default;
  }
});

var _Chrome2 = _interopRequireDefault(Chrome_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Chrome2.default;
});

unwrapExports(lib$1);
var lib_1$1 = lib$1.CustomPicker;
var lib_2$1 = lib$1.TwitterPicker;
var lib_3$1 = lib$1.SwatchesPicker;
var lib_4$1 = lib$1.SliderPicker;
var lib_5$1 = lib$1.SketchPicker;
var lib_6 = lib$1.PhotoshopPicker;
var lib_7 = lib$1.MaterialPicker;
var lib_8 = lib$1.HuePicker;
var lib_9 = lib$1.GithubPicker;
var lib_10 = lib$1.CompactPicker;
var lib_11 = lib$1.ChromePicker;
var lib_12 = lib$1.CirclePicker;
var lib_13 = lib$1.BlockPicker;
var lib_14 = lib$1.AlphaPicker;

function _typeof$d(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$d = function _typeof(obj) { return typeof obj; }; } else { _typeof$d = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$d(obj); }

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function _objectWithoutProperties$e(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$e(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$e(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$f(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$d(self, call) { if (call && (_typeof$d(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$d(self); }

function _getPrototypeOf$d(o) { _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$d(o); }

function _assertThisInitialized$d(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties$f(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$f(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$f(Constructor.prototype, protoProps); if (staticProps) _defineProperties$f(Constructor, staticProps); return Constructor; }

function _inherits$d(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$d(subClass, superClass); }

function _setPrototypeOf$d(o, p) { _setPrototypeOf$d = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$d(o, p); }

function _templateObject9$1() {
  var data = _taggedTemplateLiteral$S(["\n  margin-bottom: ", "rem;\n"]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$2() {
  var data = _taggedTemplateLiteral$S(["\n  padding-right: ", "rem;\n  flex: 1 1 0rem;\n"]);

  _templateObject8$2 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$2() {
  var data = _taggedTemplateLiteral$S(["\n  margin-top: ", "rem;\n  text-align: ", "\n"]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$4() {
  var data = _taggedTemplateLiteral$S(["\n  display: flex;\n  width: ", ";\n  text-align: right;\n  padding: ", ";\n"]);

  _templateObject6$4 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$7() {
  var data = _taggedTemplateLiteral$S(["\n  position: fixed;\n  top: 0rem;\n  right: 0rem;\n  bottom: 0rem;\n  left: 0rem;\n"]);

  _templateObject5$7 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$b() {
  var data = _taggedTemplateLiteral$S(["\n  position: absolute;\n  top: ", ";\n  z-index: 2;\n"]);

  _templateObject4$b = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$c() {
  var data = _taggedTemplateLiteral$S(["\n  width: ", ";\n  height: ", ";\n  border-radius: 0.1rem;\n  background: ", ";\n"]);

  _templateObject3$c = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$j() {
  var data = _taggedTemplateLiteral$S(["\n  height: ", ";\n  width: ", ";\n  padding: 0.3rem;\n  background: #fff;\n  border-radius: 0.1rem;\n  box-shadow: 0 0 0 1px rgba(0,0,0,.1);\n  display: inline-block;\n  cursor: pointer;\n  background-color: ", "\n"]);

  _templateObject2$j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$S() {
  var data = _taggedTemplateLiteral$S(["\n  position: relative;\n"]);

  _templateObject$S = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$S(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var FlexRelative$1 = styled(Flex)(_templateObject$S());
var MyButton = styled('div')(_templateObject2$j(), function (props) {
  var heightV;

  switch (props.size) {
    case 'l':
      heightV = heightL$1;
      break;

    case 'xl':
      heightV = heightXL;
      break;

    case 'm':
    default:
      heightV = height;
      break;
  }

  return "".concat(heightV, "rem");
}, function (props) {
  var heightV;

  switch (props.size) {
    case 'l':
      heightV = heightL$1;
      break;

    case 'xl':
      heightV = heightXL;
      break;

    case 'm':
    default:
      heightV = height;
      break;
  }

  return "".concat(heightV, "rem");
}, function (props) {
  return props.disabled ? grey6 : undefined;
});
var Color = styled('div')(_templateObject3$c(), function (props) {
  var heightV;

  switch (props.size) {
    case 'xl':
      heightV = heightXL;
      break;

    case 'l':
      heightV = heightL$1;
      break;

    case 'm':
    default:
      heightV = height;
      break;
  }

  return "".concat(heightV, "rem");
}, function (props) {
  var heightV;

  switch (props.size) {
    case 'xl':
      heightV = heightXL;
      break;

    case 'l':
      heightV = heightL$1;
      break;

    case 'm':
    default:
      heightV = height;
      break;
  }

  return "".concat(heightV, "rem");
}, function (props) {
  return props.color;
});
var PopOver = styled('div')(_templateObject4$b(), function (props) {
  var heightV;

  switch (props.size) {
    case 'xl':
      heightV = heightXL * 1.3;
      break;

    case 'l':
      heightV = heightL$1 * 1.4;
      break;

    case 'm':
    default:
      heightV = height * 1.5;
      break;
  }

  return "".concat(heightV, "rem");
});
var Cover = styled('div')(_templateObject5$7());
var Span$2 = Text.withComponent('span');
var LeftLabelContainer$2 = styled('div')(_templateObject6$4(), function (props) {
  return props.width ? "".concat(props.width, "%") : undefined;
}, function (props) {
  var paddingV;

  switch (props.size) {
    case 'l':
      paddingV = paddingTopLabelL;
      break;

    case 'xl':
      paddingV = paddingTopLabelXL;
      break;

    case 'm':
    default:
      paddingV = paddingTopLabel;
      break;
  }

  return "".concat(paddingV, "rem 0");
});
var ErrorT$1 = styled(Text)(_templateObject7$2(), horizontalMarginInput, function (props) {
  return props.position === 'top' ? undefined : 'right';
});
var LabelLeft$2 = styled('label')(_templateObject8$2(), paddingRightLabel);
var LabelTop$2 = styled('label')(_templateObject9$1(), horizontalMarginInput);

var ColorPicker =
/*#__PURE__*/
function (_Component) {
  _inherits$d(ColorPicker, _Component);

  _createClass$f(ColorPicker, null, [{
    key: "checkColorFormat",
    value: function checkColorFormat(color) {
      if (typeof color === 'string') {
        return /^#([A-F0-9]{6}|[A-F0-9]{3})$/.exec(color.toUpperCase());
      }

      return false;
    }
  }]);

  function ColorPicker(props) {
    var _this;

    _classCallCheck$f(this, ColorPicker);

    _this = _possibleConstructorReturn$d(this, _getPrototypeOf$d(ColorPicker).call(this, props));
    _this.state = {
      displayColorPicker: false,
      value: ColorPicker.checkColorFormat(props.value) ? props.value : props.defaultColor,
      disabled: props.disabled !== undefined ? props.disabled : false
    };
    _this.colors = props.colors;
    _this.handleButtonClick = _this.handleButtonClick.bind(_assertThisInitialized$d(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized$d(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized$d(_this));
    return _this;
  }

  _createClass$f(ColorPicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          value = _this$props.value,
          disabled = _this$props.disabled;

      if (prevProps.value !== value) {
        if (value && ColorPicker.checkColorFormat(value)) {
          this.setState({
            value: value,
            disabled: disabled
          });
        }
      }
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          labelPosition = _this$props2.labelPosition,
          id = _this$props2.id,
          mandatory = _this$props2.mandatory,
          labelWidth = _this$props2.labelWidth,
          size = _this$props2.size;

      if (children === undefined || children === '') {
        return undefined;
      }

      var content;

      if (labelPosition === 'left') {
        content = React.createElement(LabelLeft$2, {
          htmlFor: id
        }, React.createElement(Span$2, {
          bold: true
        }, children, mandatory ? React.createElement(Span$2, {
          bold: true,
          color: "orange"
        }, "\xA0*") : undefined));
      } else {
        content = React.createElement(LabelTop$2, {
          htmlFor: id
        }, React.createElement(Span$2, {
          bold: true
        }, children, mandatory ? React.createElement(Span$2, {
          bold: true,
          color: "orange"
        }, "\xA0*") : undefined));
      }

      if (labelPosition === 'left') {
        return React.createElement(LeftLabelContainer$2, {
          width: labelWidth,
          size: size
        }, content);
      }

      return content;
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage() {
      var _this$props3 = this.props,
          errorMessage = _this$props3.errorMessage,
          labelPosition = _this$props3.labelPosition;
      var valid = this.state.valid;

      if (errorMessage === undefined || valid) {
        return undefined;
      }

      return React.createElement(ErrorT$1, {
        bold: true,
        size: "s",
        color: "red",
        position: labelPosition
      }, errorMessage);
    }
  }, {
    key: "handleButtonClick",
    value: function handleButtonClick() {
      var _this$state = this.state,
          disabled = _this$state.disabled,
          displayColorPicker = _this$state.displayColorPicker;

      if (!disabled) {
        this.setState({
          displayColorPicker: !displayColorPicker
        });
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        displayColorPicker: false
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(color) {
      var onChange = this.props.onChange;
      var value = this.state.value;
      this.setState({
        value: color.hex
      }, function () {
        if (onChange) {
          onChange(value);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          labelPosition = _this$props4.labelPosition,
          size = _this$props4.size,
          rest = _objectWithoutProperties$e(_this$props4, ["labelPosition", "size"]);

      var _this$state2 = this.state,
          disabled = _this$state2.disabled,
          value = _this$state2.value,
          displayColorPicker = _this$state2.displayColorPicker;
      return React.createElement(Flex, _extends$b({}, rest, {
        flexDirection: "column"
      }), React.createElement(Flex, {
        flexDirection: labelPosition === 'top' ? 'column' : undefined
      }, this.getLabel(), React.createElement(FlexRelative$1, {
        flexDirection: "column",
        flex: labelPosition === 'left' ? '1 1 0rem' : undefined
      }, React.createElement(MyButton, {
        onClick: this.handleButtonClick,
        size: size,
        disabled: disabled
      }, React.createElement(Color, {
        color: value,
        size: size
      })), displayColorPicker ? React.createElement(PopOver, {
        size: size
      }, React.createElement(Cover, {
        onClick: this.handleClose
      }), React.createElement(lib_2$1, {
        color: value,
        onChange: this.handleChange,
        colors: this.colors
      })) : null)), this.getErrorMessage());
    }
  }]);

  return ColorPicker;
}(Component);

ColorPicker.defaultProps = {
  children: '',
  labelPosition: 'top',
  labelWidth: 30,
  errorMessage: undefined,
  disabled: false,
  mandatory: false,
  size: 'm',
  onChange: function onChange() {},
  value: orange2,
  colors: [functionalRed, orange2, supportingGold, functionalYellow, supportingDarkerGold, supportingLighterGold, supportingLighterEmerald, supportingLighterBlue, supportingLavender, supportingLighterLavender, supportingLighterCandy, supportingCandy, supportingDarkerCandy, supportingDarkerLavender, supportingDarkerBlue, functionalBlue, supportingBlue, supportingEmerald, functionalGreen, supportingDarkerEmerald, grey3],
  defaultColor: orange2
};
ColorPicker.propTypes = {
  /** Label of the input */
  children: PropTypes.node,

  /** Id of the input */
  id: PropTypes.string.isRequired,

  /** String indicating the position of the label */
  labelPosition: PropTypes.oneOf(['top', 'left']),

  /** Number indicating the width of label (percentage) */
  labelWidth: PropTypes.number,

  /** String indicating the error message */
  errorMessage: PropTypes.string,

  /** Boolean indicating if the input is disabled */
  disabled: PropTypes.bool,

  /** Boolean indicating if the field is mandatory */
  mandatory: PropTypes.bool,

  /** String indicating the size of the input */
  size: PropTypes.oneOf(['m', 'l', 'xl']),

  /** Function excecuted when input value changes */
  onChange: PropTypes.func,

  /** String corresponding to the input value */
  value: PropTypes.string,

  /** Array of string color */
  colors: PropTypes.arrayOf(PropTypes.string),

  /** String, default color */
  defaultColor: PropTypes.string
};

var fontSizeBase$b = 16;
var height$1 = 36 / fontSizeBase$b;
var minWidth$1 = 150 / fontSizeBase$b;
var marginRightOption = 15 / fontSizeBase$b;
var horizontalPadding$1 = 10 / fontSizeBase$b;
var borderSize$1 = 2 / fontSizeBase$b;
var borderArrowSize$1 = 7 / fontSizeBase$b;
var entryHeight = 40 / fontSizeBase$b;
var colorHeight = 20 / fontSizeBase$b;
var colorWidth = 20 / fontSizeBase$b;

function _typeof$e(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$e = function _typeof(obj) { return typeof obj; }; } else { _typeof$e = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$e(obj); }

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

function _objectWithoutProperties$f(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$f(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$f(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$g(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$g(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$g(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$g(Constructor.prototype, protoProps); if (staticProps) _defineProperties$g(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$e(self, call) { if (call && (_typeof$e(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$e(self); }

function _getPrototypeOf$e(o) { _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$e(o); }

function _assertThisInitialized$e(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$e(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$e(subClass, superClass); }

function _setPrototypeOf$e(o, p) { _setPrototypeOf$e = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$e(o, p); }

function _templateObject11() {
  var data = _taggedTemplateLiteral$T(["\n  margin-bottom: ", "rem;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral$T(["\n  padding-right: ", "rem;\n  flex: 1 1 0rem;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$2() {
  var data = _taggedTemplateLiteral$T(["\n  display: flex;\n  width: ", ";\n  text-align: right;\n  padding: ", "rem 0;\n"]);

  _templateObject9$2 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$3() {
  var data = _taggedTemplateLiteral$T(["\n  position: relative;\n  justify-content: center;\n  max-width: ", ";\n"]);

  _templateObject8$3 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$3() {
  var data = _taggedTemplateLiteral$T(["\n  position:fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 998;\n  display: ", "\n"]);

  _templateObject7$3 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$5() {
  var data = _taggedTemplateLiteral$T(["\n  border-left: ", "rem solid transparent;\n  border-right: ", "rem solid transparent;\n  border-top: ", "rem solid ", ";\n"]);

  _templateObject6$5 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$8() {
  var data = _taggedTemplateLiteral$T(["\n  display: ", ";\n  position: absolute;\n  top: ", "rem;\n  left: -", "rem;\n  right: -", "rem;\n  background: white;\n  margin: ", "rem 0 0 0;\n  border: ", "rem solid ", ";\n  border-top: 0;\n  list-style:none;\n  padding: 0;\n  max-height: ", ";\n  overflow-y: auto;\n"]);

  _templateObject5$8 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$c() {
  var data = _taggedTemplateLiteral$T(["\n  cursor: pointer;\n  height: ", "rem;\n  display: flex;\n  align-items: center;\n  padding: 0 ", "rem;\n\n  &:hover, &:focus {\n    background-color: ", ";\n\n    ", " {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject4$c = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$d() {
  var data = _taggedTemplateLiteral$T(["\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]);

  _templateObject3$d = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$k() {
  var data = _taggedTemplateLiteral$T(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: ", "rem;\n  min-width: ", "rem;\n  padding: 0 ", "rem;\n  background: ", ";\n  border: ", "rem solid ", ";\n  position: relative;\n  z-index: ", ";\n"]);

  _templateObject2$k = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$T() {
  var data = _taggedTemplateLiteral$T(["\n  cursor: ", ";\n"]);

  _templateObject$T = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$T(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container$b = styled('div')(_templateObject$T(), function (props) {
  return props.disabled ? 'not-allowed' : 'auto';
});
var SelectDiv = styled('div')(_templateObject2$k(), height$1, minWidth$1, horizontalPadding$1, function (props) {
  return props.disabled ? grey6 : white;
}, borderSize$1, grey4, function (props) {
  return props.opened ? 999 : undefined;
});
var LocalText = styled(Text)(_templateObject3$d());
var OptionListEntry = styled('li')(_templateObject4$c(), entryHeight, horizontalPadding$1, black, LocalText, white);
var OptionList = styled('ul')(_templateObject5$8(), function (props) {
  return props.opened ? 'block' : 'none';
}, height$1, borderSize$1, borderSize$1, borderSize$1, borderSize$1, grey4, function (props) {
  return "".concat(entryHeight * props.scrollItems, "rem");
});
var SelectArrow = styled('div')(_templateObject6$5(), borderArrowSize$1, borderArrowSize$1, borderArrowSize$1, black);
var BackgroundLayout$2 = styled('div')(_templateObject7$3(), function (props) {
  return props.opened ? 'block' : 'none';
});
var FlexRelative$2 = styled(Flex)(_templateObject8$3(), function (props) {
  if (props.labelPosition === 'top') {
    return undefined;
  }

  return props.width ? "".concat(100 - props.width, "%") : '100%';
});
var LeftLabelContainer$3 = styled('div')(_templateObject9$2(), function (props) {
  return props.width ? "".concat(props.width, "%") : undefined;
}, paddingTopLabel);
var LabelLeft$3 = styled('label')(_templateObject10(), paddingRightLabel);
var LabelTop$3 = styled('label')(_templateObject11(), horizontalMarginInput);
var Span$3 = Text.withComponent('span');

var Select =
/*#__PURE__*/
function (_Component) {
  _inherits$e(Select, _Component);

  function Select(props) {
    var _this;

    _classCallCheck$g(this, Select);

    _this = _possibleConstructorReturn$e(this, _getPrototypeOf$e(Select).call(this, props));

    _this.setSelectedItem(props.items);

    _this.state = {
      opened: false
    };
    _this.onSelectDivClick = _this.onSelectDivClick.bind(_assertThisInitialized$e(_this));
    _this.onSelectItem = _this.onSelectItem.bind(_assertThisInitialized$e(_this));
    return _this;
  }

  _createClass$g(Select, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var items = this.props.items;

      if (prevProps.items !== items) {
        this.setSelectedItem(items);
      }
    }
  }, {
    key: "onSelectDivClick",
    value: function onSelectDivClick() {
      var disabled = this.props.disabled;
      var opened = this.state.opened;

      if (disabled) {
        return;
      }

      this.setState({
        opened: !opened
      });
    }
  }, {
    key: "onSelectItem",
    value: function onSelectItem(item) {
      var onChange = this.props.onChange;
      this.selectedItem = item;

      if (onChange) {
        onChange(item);
      }
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      var _this$props = this.props,
          children = _this$props.children,
          labelPosition = _this$props.labelPosition,
          id = _this$props.id,
          mandatory = _this$props.mandatory,
          labelWidth = _this$props.labelWidth;

      if (children === undefined || children === '') {
        return undefined;
      }

      var content;

      if (labelPosition === 'left') {
        content = React.createElement(LabelLeft$3, {
          htmlFor: id
        }, React.createElement(Span$3, {
          bold: true
        }, children, mandatory ? React.createElement(Span$3, {
          bold: true,
          color: "orange"
        }, "\xA0*") : undefined));
      } else {
        content = React.createElement(LabelTop$3, {
          htmlFor: id
        }, React.createElement(Span$3, {
          bold: true
        }, children, mandatory ? React.createElement(Span$3, {
          bold: true,
          color: "orange"
        }, "\xA0*") : undefined));
      }

      if (labelPosition === 'left') {
        return React.createElement(LeftLabelContainer$3, {
          width: labelWidth
        }, content);
      }

      return content;
    }
  }, {
    key: "setSelectedItem",
    value: function setSelectedItem(items) {
      var filteredItem = items.filter(function (item) {
        return item.selected === true;
      });
      var defaultItem = items.length ? items[0] : {};
      this.selectedItem = filteredItem.length ? filteredItem[0] : defaultItem;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          items = _this$props2.items,
          labelWidth = _this$props2.labelWidth,
          labelPosition = _this$props2.labelPosition,
          disabled = _this$props2.disabled,
          scrollItems = _this$props2.scrollItems,
          rest = _objectWithoutProperties$f(_this$props2, ["items", "labelWidth", "labelPosition", "disabled", "scrollItems"]);

      var opened = this.state.opened;
      return React.createElement(Container$b, _extends$c({
        disabled: disabled
      }, rest), React.createElement(Flex, {
        flexDirection: labelPosition === 'top' ? 'column' : undefined
      }, this.getLabel(), React.createElement(FlexRelative$2, {
        flexDirection: "column",
        flex: labelPosition === 'left' ? '1 1 0rem' : undefined,
        width: labelWidth,
        labelPosition: labelPosition
      }, React.createElement(SelectDiv, {
        onClick: this.onSelectDivClick,
        disabled: disabled,
        opened: opened
      }, React.createElement(LocalText, {
        bold: true
      }, this.selectedItem.title), React.createElement(SelectArrow, null), React.createElement(OptionList, {
        opened: opened,
        scrollItems: scrollItems
      }, items.map(function (item) {
        return React.createElement(OptionListEntry, {
          key: item.value,
          value: item.value,
          onClick: function onClick() {
            _this2.onSelectItem(item);
          },
          tabIndex: 0
        }, React.createElement(LocalText, {
          bold: true
        }, item.title));
      }))))), React.createElement(BackgroundLayout$2, {
        onClick: this.onSelectDivClick,
        opened: opened
      }));
    }
  }]);

  return Select;
}(Component);

Select.defaultProps = {
  children: '',
  items: [],
  onChange: function onChange() {},
  labelPosition: 'top',
  labelWidth: 30,
  disabled: false,
  mandatory: false,
  scrollItems: 5
};
Select.propTypes = {
  /** Label of the field */
  children: PropTypes.node,

  /** Id of the input */
  id: PropTypes.string.isRequired,

  /** List of option items */
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    selected: PropTypes.bool
  })),

  /** Function called where new option is selected */
  onChange: PropTypes.func,

  /** String indicating the position of the label */
  labelPosition: PropTypes.oneOf(['top', 'left']),

  /** Number indicating the width of label (percentage) */
  labelWidth: PropTypes.number,

  /** Boolean indicating if the select is disabled */
  disabled: PropTypes.bool,

  /** Boolean indicating if the field is mandatory */
  mandatory: PropTypes.bool,

  /** Number indicating list items to be displayed before scrolling */
  scrollItems: PropTypes.number
};

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

function _objectWithoutProperties$g(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$g(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$g(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject$U() {
  var data = _taggedTemplateLiteral$U(["\n  z-index: ", ";\n  background-color: ", ";\n  opacity: ", ";\n  transition: ", ";\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: ", ";\n  height: 100%;\n"]);

  _templateObject$U = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$U(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var OverlayContainer = styled('div')(_templateObject$U(), function (props) {
  return props.zIndex;
}, function (props) {
  switch (props.color) {
    case 'white':
      return white;

    case 'grey':
      return grey3;

    case 'darkGrey':
      return grey2;

    case 'black':
    default:
      return black;
  }
}, function (props) {
  return props.isOpen ? props.opacity : 0;
}, function (props) {
  var transition = props.transition,
      isOpen = props.isOpen;
  return isOpen ? "opacity ".concat(transition.time, "s ").concat(transition.type) : "opacity ".concat(transition.time, "s ").concat(transition.type, ", width 0s ").concat(transition.time, "s ").concat(transition.type);
}, function (props) {
  return props.isOpen ? '100%' : 0;
});

var Overlay = function Overlay(props) {
  var onOverlayClick = props.onOverlayClick,
      rest = _objectWithoutProperties$g(props, ["onOverlayClick"]);

  return React.createElement(OverlayContainer, _extends$d({}, rest, {
    onClick: onOverlayClick
  }));
};

Overlay.defaultProps = {
  onOverlayClick: function onOverlayClick() {},
  isOpen: true,
  zIndex: 100,
  color: 'black',
  opacity: 0.5,
  transition: {
    type: 'linear',
    time: 0.5
  }
};
Overlay.propTypes = {
  onOverlayClick: PropTypes.func,
  isOpen: PropTypes.bool,
  zIndex: PropTypes.number,
  color: PropTypes.oneOf(['black', 'white', 'grey', 'darkGrey']),
  opacity: PropTypes.number,
  transition: PropTypes.shape({
    type: PropTypes.oneOf(['linear', 'ease', 'ease-in', 'ease-in-out', 'ease-out', 'step-start', 'step-end']),
    time: PropTypes.number
  })
};

function _typeof$f(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$f = function _typeof(obj) { return typeof obj; }; } else { _typeof$f = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$f(obj); }

function _objectWithoutProperties$h(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$h(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$h(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$h(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$h(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$h(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$h(Constructor.prototype, protoProps); if (staticProps) _defineProperties$h(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$f(self, call) { if (call && (_typeof$f(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$f(self); }

function _getPrototypeOf$f(o) { _getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$f(o); }

function _assertThisInitialized$f(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$f(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$f(subClass, superClass); }

function _setPrototypeOf$f(o, p) { _setPrototypeOf$f = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$f(o, p); }

function _templateObject4$d() {
  var data = _taggedTemplateLiteral$V(["\n  padding: 2rem;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n"]);

  _templateObject4$d = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$e() {
  var data = _taggedTemplateLiteral$V(["\n  transition: transform .5s ease-out;\n  transform: ", ";\n  width: ", ";\n  height: ", ";\n  background-color: white;\n  z-index: 2;\n  top: ", ";\n  bottom: ", ";\n  left: ", ";\n  right: ", ";\n  position: fixed;\n"]);

  _templateObject3$e = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$l() {
  var data = _taggedTemplateLiteral$V(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  z-index: ", ";\n"]);

  _templateObject2$l = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$V() {
  var data = _taggedTemplateLiteral$V([""]);

  _templateObject$V = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$V(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container$c = styled('div')(_templateObject$V());
var ModalContainer = styled('div')(_templateObject2$l(), function (props) {
  return props.zIndex;
});
var ContentContainer$1 = styled('div')(_templateObject3$e(), function (props) {
  if (props.isOpen) {
    return props.transform;
  }

  switch (props.slide) {
    case 'left':
      return 'translate(calc(-100vh), 0)';

    case 'right':
      return 'translate(calc(100vh), 0)';

    case 'bottom':
      return 'translate(0, calc(100vh))';

    case 'top':
    default:
      return 'translate(0, calc(-100vh))';
  }
}, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.top;
}, function (props) {
  return props.bottom;
}, function (props) {
  return props.left;
}, function (props) {
  return props.right;
});
var ModalContent = styled('div')(_templateObject4$d());

var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits$f(Modal, _Component);

  function Modal(props) {
    var _this;

    _classCallCheck$h(this, Modal);

    _this = _possibleConstructorReturn$f(this, _getPrototypeOf$f(Modal).call(this, props));
    _this.state = {
      display: props.isOpen,
      localOpen: props.isOpen,
      autoClosing: props.autoClosingTimer
    };
    _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_assertThisInitialized$f(_this));
    _this.handleCloseEvent = _this.handleCloseEvent.bind(_assertThisInitialized$f(_this));
    return _this;
  }

  _createClass$h(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var autoClosing = this.state.autoClosing;

      if (autoClosing) {
        setTimeout(function () {
          _this2.setState({
            localOpen: false
          });
        }, autoClosing);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this3 = this;

      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          onClose = _this$props.onClose,
          onOpen = _this$props.onOpen;
      var display = this.state.display;

      if (prevProps.isOpen !== isOpen) {
        if (isOpen === false) {
          this.setState({
            localOpen: false
          });

          if (onClose !== undefined) {
            onClose();
          }
        } else {
          if (onOpen !== undefined) {
            onOpen();
          }

          this.setState({
            display: true
          });
        }
      }

      if (display !== prevState.display && display === true) {
        window.setTimeout(function () {
          _this3.setState({
            localOpen: true
          });
        }, 50);
      }
    }
  }, {
    key: "handleTransitionEnd",
    value: function handleTransitionEnd() {
      var _this$props2 = this.props,
          onOpened = _this$props2.onOpened,
          onClosed = _this$props2.onClosed;
      var localOpen = this.state.localOpen;

      if (localOpen) {
        if (onOpened !== undefined) {
          onOpened();
        }
      } else {
        this.setState({
          display: false
        });

        if (onClosed !== undefined) {
          onClosed();
        }
      }
    }
  }, {
    key: "handleCloseEvent",
    value: function handleCloseEvent() {
      var _this$props3 = this.props,
          overlay = _this$props3.overlay,
          onClose = _this$props3.onClose;

      if (overlay.shouldCloseOnClick === false) {
        return;
      }

      this.setState({
        localOpen: false
      });

      if (onClose !== undefined) {
        onClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          overlay = _this$props4.overlay,
          slide = _this$props4.slide,
          top = _this$props4.top,
          bottom = _this$props4.bottom,
          left = _this$props4.left,
          right = _this$props4.right,
          width = _this$props4.width,
          height = _this$props4.height,
          transform = _this$props4.transform,
          zIndex = _this$props4.zIndex,
          rest = _objectWithoutProperties$h(_this$props4, ["children", "overlay", "slide", "top", "bottom", "left", "right", "width", "height", "transform", "zIndex"]);

      var _this$state = this.state,
          display = _this$state.display,
          localOpen = _this$state.localOpen;
      return React.createElement(Container$c, rest, !display ? null : React.createElement(ModalContainer, {
        zIndex: zIndex
      }, !overlay.shouldDisplay ? null : React.createElement(Overlay, {
        isOpen: localOpen,
        zIndex: 1,
        transition: overlay.transition,
        onOverlayClick: this.handleCloseEvent
      }), React.createElement(ContentContainer$1, {
        isOpen: localOpen,
        slide: slide,
        onTransitionEnd: this.handleTransitionEnd,
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        width: width,
        height: height,
        transform: transform
      }, React.createElement(ModalContent, null, children))));
    }
  }]);

  return Modal;
}(Component);

Modal.defaultProps = {
  isOpen: true,
  children: undefined,
  overlay: {
    transition: {
      type: 'linear',
      time: 0.5
    },
    shouldCloseOnClick: true,
    shouldDisplay: true
  },
  slide: 'top',
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onOpened: function onOpened() {},
  onClosed: function onClosed() {},
  top: '50%',
  bottom: undefined,
  left: '50%',
  right: undefined,
  width: '50%',
  height: 'auto',
  transform: 'translate(-50%,-50%)',
  autoClosingTimer: 0,
  zIndex: 1
};
Modal.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node,
  overlay: PropTypes.shape({
    transition: PropTypes.shape({
      type: PropTypes.oneOf(['linear', 'ease', 'ease-in', 'ease-in-out', 'ease-out', 'step-start', 'step-end']),
      time: PropTypes.number
    }),
    shouldCloseOnClick: PropTypes.bool,
    shouldDisplay: PropTypes.bool
  }),
  slide: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onOpened: PropTypes.func,
  onClosed: PropTypes.func,
  top: PropTypes.string,
  bottom: PropTypes.string,
  left: PropTypes.string,
  right: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  transform: PropTypes.string,

  /** Number z-index of the modal container */
  zIndex: PropTypes.number,

  /** Number to auto close modal (in milliseconds) */
  autoClosingTimer: PropTypes.number
};

var nativeGetOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;


var FAILS_ON_PRIMITIVES$3 = fails(function () { nativeGetOwnPropertyDescriptor$2(1); });
var FORCED$2 = !descriptors || FAILS_ON_PRIMITIVES$3;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
_export({ target: 'Object', stat: true, forced: FORCED$2, sham: !descriptors }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor$2(toIndexedObject(it), key);
  }
});

// `Object.getOwnPropertyDescriptors` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
_export({ target: 'Object', stat: true, sham: !descriptors }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof$g(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$g = function _typeof(obj) { return typeof obj; }; } else { _typeof$g = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$g(obj); }

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

function _objectWithoutProperties$i(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$i(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$i(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$i(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$i(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$i(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$i(Constructor.prototype, protoProps); if (staticProps) _defineProperties$i(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$g(self, call) { if (call && (_typeof$g(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$g(self); }

function _getPrototypeOf$g(o) { _getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$g(o); }

function _assertThisInitialized$g(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$g(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$g(subClass, superClass); }

function _setPrototypeOf$g(o, p) { _setPrototypeOf$g = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$g(o, p); }

function _templateObject6$6() {
  var data = _taggedTemplateLiteral$W(["\n  margin-left: 1.25rem;\n"]);

  _templateObject6$6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$9() {
  var data = _taggedTemplateLiteral$W(["\n  float: right;\n"]);

  _templateObject5$9 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$e() {
  var data = _taggedTemplateLiteral$W(["\n  display: flex;\n  align-self: flex-end;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n"]);

  _templateObject4$e = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$f() {
  var data = _taggedTemplateLiteral$W(["\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1 1 auto;\n"]);

  _templateObject3$f = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$m() {
  var data = _taggedTemplateLiteral$W(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  line-height: 1.25;\n  margin-bottom: 1.5rem;\n"]);

  _templateObject2$m = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$W() {
  var data = _taggedTemplateLiteral$W(["\n  margin: 0;\n  line-height: 1.25;\n"]);

  _templateObject$W = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$W(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Title = styled(Headline.withComponent('h5'))(_templateObject$W());
var ModalHeader = styled('div')(_templateObject2$m());
var ModalBody = styled('div')(_templateObject3$f());
var ModalFooter = styled('div')(_templateObject4$e());
var CloseButton = styled(Button$1)(_templateObject5$9());
var ButtonOk = styled(Button$1)(_templateObject6$6());

var ButtonModal =
/*#__PURE__*/
function (_Component) {
  _inherits$g(ButtonModal, _Component);

  function ButtonModal(props) {
    var _this;

    _classCallCheck$i(this, ButtonModal);

    _this = _possibleConstructorReturn$g(this, _getPrototypeOf$g(ButtonModal).call(this, props));
    _this.state = {
      localOpen: props.isOpen
    };
    _this.handleCloseIconClick = _this.handleCloseIconClick.bind(_assertThisInitialized$g(_this));
    _this.handleCloseButtonClick = _this.handleCloseButtonClick.bind(_assertThisInitialized$g(_this));
    _this.handleSubmitButtonClick = _this.handleSubmitButtonClick.bind(_assertThisInitialized$g(_this));
    return _this;
  }

  _createClass$i(ButtonModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpen = this.props.isOpen;

      if (prevProps.isOpen !== isOpen) {
        this.setState({
          localOpen: isOpen
        });
      }
    }
  }, {
    key: "handleCloseIconClick",
    value: function handleCloseIconClick() {
      var onClickOnCloseIcon = this.props.onClickOnCloseIcon;
      this.setState({
        localOpen: false
      });

      if (onClickOnCloseIcon) {
        onClickOnCloseIcon();
      }
    }
  }, {
    key: "handleCloseButtonClick",
    value: function handleCloseButtonClick() {
      var onClickOnCloseButton = this.props.onClickOnCloseButton;
      this.setState({
        localOpen: false
      });

      if (onClickOnCloseButton) {
        onClickOnCloseButton();
      }
    }
  }, {
    key: "handleSubmitButtonClick",
    value: function handleSubmitButtonClick() {
      var onClickOnSubmitButton = this.props.onClickOnSubmitButton;
      this.setState({
        localOpen: false
      });

      if (onClickOnSubmitButton) {
        onClickOnSubmitButton();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          title = _this$props.title,
          button = _this$props.button,
          rest = _objectWithoutProperties$i(_this$props, ["children", "title", "button"]);

      var localOpen = this.state.localOpen;
      return React.createElement(Modal, _extends$e({}, rest, {
        isOpen: localOpen
      }), React.createElement(ModalHeader, null, React.createElement(Title, {
        size: "xxs"
      }, title), React.createElement(CloseButton, {
        size: "s",
        type: "icon",
        icon: "delete",
        onClick: this.handleCloseIconClick
      })), React.createElement(ModalBody, null, children), React.createElement(ModalFooter, null, React.createElement(Button$1, {
        onClick: this.handleCloseButtonClick
      }, button.close), React.createElement(ButtonOk, {
        type: "important",
        onClick: this.handleSubmitButtonClick
      }, button.ok)));
    }
  }]);

  return ButtonModal;
}(Component);

ButtonModal.defaultProps = _objectSpread({}, Modal.defaultProps, {
  title: 'toto',
  button: {
    ok: 'Ok',
    close: 'Fermer'
  },
  onClickOnCloseButton: function onClickOnCloseButton() {},
  onClickOnCloseIcon: function onClickOnCloseIcon() {},
  onClickOnSubmitButton: function onClickOnSubmitButton() {}
});
ButtonModal.propTypes = _objectSpread({}, Modal.propTypes, {
  title: PropTypes.string,
  button: PropTypes.shape({
    ok: PropTypes.string,
    close: PropTypes.string
  }),
  onClickOnCloseButton: PropTypes.func,
  onClickOnCloseIcon: PropTypes.func,
  onClickOnSubmitButton: PropTypes.func
});

var fontSizeBase$c = 16;
var height$2 = 52 / fontSizeBase$c;
var padding = 20 / fontSizeBase$c;
var marginIcon$1 = 10 / fontSizeBase$c;
var heightIcon = 32;

function _objectWithoutProperties$j(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$j(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$j(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2$n() {
  var data = _taggedTemplateLiteral$X(["\n  margin-right: ", "rem;\n\n  ", ":hover & ", ",\n  ", ":active & ", " {\n    fill: ", "\n  }\n"]);

  _templateObject2$n = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$X() {
  var data = _taggedTemplateLiteral$X(["\n  display: flex;\n  height: ", "rem;\n  padding: 0 ", "rem;\n  align-items: center;\n  text-decoration: none;\n\n  &:hover > ", ",\n  &:active > ", " {\n    color: ", "\n  }\n"]);

  _templateObject$X = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$X(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var LinkContainer = styled('a')(_templateObject$X(), height$2, padding, Text, Text, orange2);
var ItemIcon$1 = styled(Icon)(_templateObject2$n(), marginIcon$1, LinkContainer, IconPath, LinkContainer, IconPath, orange2);

var LinkListItem = function LinkListItem(props) {
  var children = props.children,
      icon = props.icon,
      iconSize = props.iconSize,
      iconRotate = props.iconRotate,
      rest = _objectWithoutProperties$j(props, ["children", "icon", "iconSize", "iconRotate"]);

  var iconElement = icon ? React.createElement(ItemIcon$1, {
    icon: icon,
    width: iconSize || heightIcon,
    height: iconSize || heightIcon,
    rotate: iconRotate
  }) : undefined;
  return React.createElement(LinkContainer, rest, iconElement, React.createElement(Text, {
    size: "m",
    bold: true
  }, children));
};

LinkListItem.defaultProps = {
  icon: undefined,
  iconSize: 32,
  iconRotate: 0
};
LinkListItem.propTypes = {
  /** Node, text next to the checkbox */
  children: PropTypes.node.isRequired,

  /** String indicating the name of the icon to apply */
  icon: PropTypes.string,

  /** Number indicating the size for the icon */
  iconSize: PropTypes.number,

  /** Number indicating the rotation in degree for the icon */
  iconRotate: PropTypes.number
};

function _objectWithoutProperties$k(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$k(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$k(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2$o() {
  var data = _taggedTemplateLiteral$Y(["\n  margin-right: ", "rem;\n\n  ", ":hover & ", ",\n  ", ":active & ", ",\n  ", ".active & ", " {\n    fill: ", "\n  }\n"]);

  _templateObject2$o = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$Y() {
  var data = _taggedTemplateLiteral$Y(["\n  display: flex;\n  height: ", "rem;\n  padding: 0 ", "rem;\n  align-items: center;\n  text-decoration: none;\n\n  &:hover > ", ",\n  &:active > ", ",\n  &.active > ", " {\n    color: ", "\n  }\n"]);

  _templateObject$Y = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$Y(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var LinkContainer$1 = styled(NavLink)(_templateObject$Y(), height$2, padding, Text, Text, Text, orange2);
var ItemIcon$2 = styled(Icon)(_templateObject2$o(), marginIcon$1, LinkContainer$1, IconPath, LinkContainer$1, IconPath, LinkContainer$1, IconPath, orange2);

var NavLinkListItem = function NavLinkListItem(props) {
  var children = props.children,
      icon = props.icon,
      iconSize = props.iconSize,
      iconRotate = props.iconRotate,
      rest = _objectWithoutProperties$k(props, ["children", "icon", "iconSize", "iconRotate"]);

  var iconElement = icon ? React.createElement(ItemIcon$2, {
    icon: icon,
    iconSize: iconSize,
    width: iconSize || heightIcon,
    height: iconSize || heightIcon,
    rotate: iconRotate
  }) : undefined;
  return React.createElement(LinkContainer$1, rest, iconElement, React.createElement(Text, {
    size: "m",
    bold: true
  }, children));
};

NavLinkListItem.defaultProps = {
  icon: undefined,
  iconSize: 32,
  iconRotate: 0
};
NavLinkListItem.propTypes = {
  /** Node, text next to the checkbox */
  children: PropTypes.node.isRequired,

  /** String indicating the name of the icon to apply */
  icon: PropTypes.string,

  /** Number indicating the size for the icon */
  iconSize: PropTypes.number,

  /** Number indicating the rotation in degree for the icon */
  iconRotate: PropTypes.number
};

function _typeof$h(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$h = function _typeof(obj) { return typeof obj; }; } else { _typeof$h = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$h(obj); }

function _classCallCheck$j(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$j(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$j(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$j(Constructor.prototype, protoProps); if (staticProps) _defineProperties$j(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$h(self, call) { if (call && (_typeof$h(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$h(self); }

function _assertThisInitialized$h(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf$h(o) { _getPrototypeOf$h = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$h(o); }

function _inherits$h(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$h(subClass, superClass); }

function _setPrototypeOf$h(o, p) { _setPrototypeOf$h = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$h(o, p); }

function _templateObject6$7() {
  var data = _taggedTemplateLiteral$Z(["\n  margin-top: ", "rem;\n  margin-left: ", ";\n"]);

  _templateObject6$7 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$a() {
  var data = _taggedTemplateLiteral$Z(["\n  position: relative;\n  top: ", "\n"]);

  _templateObject5$a = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$f() {
  var data = _taggedTemplateLiteral$Z(["\n  margin-bottom: ", "rem;\n"]);

  _templateObject4$f = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$g() {
  var data = _taggedTemplateLiteral$Z(["\n  padding-right: ", "rem;\n  flex: 1 1 0rem;\n"]);

  _templateObject3$g = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$p() {
  var data = _taggedTemplateLiteral$Z(["\n  display: flex;\n  width: ", ";\n  text-align: right;\n  padding: ", ";\n"]);

  _templateObject2$p = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$Z() {
  var data = _taggedTemplateLiteral$Z(["\n  position: relative;\n  width: ", ";\n"]);

  _templateObject$Z = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$Z(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var FlexRelative$3 = styled(Flex)(_templateObject$Z(), function (props) {
  return props.labelWidth ? "".concat(100 - props.labelWidth, "%") : undefined;
});
var LeftLabelContainer$4 = styled('div')(_templateObject2$p(), function (props) {
  return props.labelWidth ? "".concat(props.labelWidth, "%") : undefined;
}, function (props) {
  var paddingV;

  switch (props.size) {
    case 'l':
      paddingV = paddingTopLabelL;
      break;

    case 'xl':
      paddingV = paddingTopLabelXL;
      break;

    case 'm':
    default:
      paddingV = paddingTopLabel;
      break;
  }

  return "".concat(paddingV, "rem 0");
});
var LabelLeft$4 = styled('label')(_templateObject3$g(), paddingRightLabel);
var LabelTop$4 = styled('label')(_templateObject4$f(), horizontalMarginInput);
var Span$4 = styled(Text.withComponent('span'))(_templateObject5$a(), function (props) {
  return props.labelOffsetTop ? "".concat(props.labelOffsetTop / 16, "rem") : 0;
});
var ErrorText = styled(Text)(_templateObject6$7(), horizontalMarginInput, function (props) {
  return props.marginLeft ? "".concat(props.marginLeft, "%") : undefined;
});

var Label$2 =
/*#__PURE__*/
function (_Component) {
  _inherits$h(Label, _Component);

  function Label() {
    _classCallCheck$j(this, Label);

    return _possibleConstructorReturn$h(this, _getPrototypeOf$h(Label).apply(this, arguments));
  }

  _createClass$j(Label, [{
    key: "getLabel",
    value: function getLabel() {
      var _this$props = this.props,
          id = _this$props.id,
          label = _this$props.label,
          labelPosition = _this$props.labelPosition,
          labelWidth = _this$props.labelWidth,
          labelOffsetTop = _this$props.labelOffsetTop,
          size = _this$props.size,
          mandatory = _this$props.mandatory;

      if (label === undefined || label === '') {
        return undefined;
      }

      var content;

      if (labelPosition === 'left') {
        content = React.createElement(LabelLeft$4, {
          htmlFor: id
        }, React.createElement(Span$4, {
          labelOffsetTop: labelOffsetTop,
          bold: true
        }, label, mandatory ? React.createElement(Span$4, {
          bold: true,
          color: "orange"
        }, "\xA0*") : undefined));
      } else {
        content = React.createElement(LabelTop$4, {
          htmlFor: id
        }, React.createElement(Span$4, {
          bold: true
        }, label, mandatory ? React.createElement(Span$4, {
          bold: true,
          color: "orange"
        }, "\xA0*") : undefined));
      }

      if (labelPosition === 'left') {
        return React.createElement(LeftLabelContainer$4, {
          labelWidth: labelWidth,
          size: size
        }, content);
      }

      return content;
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage() {
      var _this$props2 = this.props,
          error = _this$props2.error,
          labelPosition = _this$props2.labelPosition,
          labelWidth = _this$props2.labelWidth;

      if (error === undefined) {
        return null;
      }

      return React.createElement(ErrorText, {
        bold: true,
        size: "s",
        color: "red",
        marginLeft: labelPosition === 'left' ? labelWidth : undefined
      }, error);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          labelPosition = _this$props3.labelPosition,
          labelWidth = _this$props3.labelWidth,
          children = _this$props3.children,
          className = _this$props3.className;
      return React.createElement(Flex, {
        flexDirection: "column",
        className: className
      }, React.createElement(Flex, {
        flexDirection: labelPosition === 'top' ? 'column' : undefined
      }, this.getLabel(), React.createElement(FlexRelative$3, {
        flex: labelPosition === 'left' ? '1 1 0rem' : undefined,
        labelWidth: labelPosition === 'left' ? labelWidth : undefined
      }, children)), this.getErrorMessage());
    }
  }]);

  return Label;
}(Component);

Label$2.defaultProps = {
  mandatory: false,
  size: 'm',
  label: undefined,
  labelPosition: 'top',
  labelWidth: 30,
  labelOffsetTop: null,
  error: undefined,
  className: undefined
};
Label$2.propTypes = {
  /** Node of field element */
  children: PropTypes.node.isRequired,

  /** Label of the field */
  label: PropTypes.node,

  /** Id of the input */
  id: PropTypes.string.isRequired,

  /** Boolean indicating if the field is mandatory */
  mandatory: PropTypes.bool,

  /** String indicating the size of the input */
  size: PropTypes.oneOf(['m', 'l', 'xl']),

  /** String indicating the position of the label */
  labelPosition: PropTypes.oneOf(['top', 'left']),

  /** Number indicating the width of label (percentage) */
  labelWidth: PropTypes.number,

  /** Number indicating the top offset to apply for the label */
  labelOffsetTop: PropTypes.number,

  /** String of the error */
  error: PropTypes.string,

  /** String, internal to Styled Component function */
  className: PropTypes.string
};

function _typeof$i(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$i = function _typeof(obj) { return typeof obj; }; } else { _typeof$i = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$i(obj); }

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

function _objectWithoutProperties$l(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$l(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$l(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$k(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$k(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$k(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$k(Constructor.prototype, protoProps); if (staticProps) _defineProperties$k(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$i(self, call) { if (call && (_typeof$i(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$i(self); }

function _getPrototypeOf$i(o) { _getPrototypeOf$i = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$i(o); }

function _assertThisInitialized$i(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$i(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$i(subClass, superClass); }

function _setPrototypeOf$i(o, p) { _setPrototypeOf$i = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$i(o, p); }

function _templateObject4$g() {
  var data = _taggedTemplateLiteral$_(["\n  position: absolute;\n  left: ", ";\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: ", ";\n"]);

  _templateObject4$g = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$h() {
  var data = _taggedTemplateLiteral$_(["\n    ", "\n    width: 100%;\n    padding: ", "rem;\n    font-size: ", "rem;\n    font-family: Arial;\n"]);

  _templateObject3$h = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$q() {
  var data = _taggedTemplateLiteral$_(["\n    width: 100%;\n    height: ", ";\n    padding: ", ";\n    font-size: ", ";\n  padding-left: ", ";\n    ", ";\n"]);

  _templateObject2$q = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$_() {
  var data = _taggedTemplateLiteral$_(["\n  display: flex;\n  flex: 1 1 0rem;\n"]);

  _templateObject$_ = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$_(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function getStyle$1(props) {
  var color = props.error ? functionalRed : grey4;
  var borderColor = props.error ? functionalRed : black;
  return "\n    font-weight: bold;\n    color: ".concat(black, ";\n    border: ").concat(borderInput, "rem solid ").concat(color, ";\n    outline: none;\n    cursor: auto;\n\n    :focus {\n      border-color: ").concat(borderColor, "\n    }\n\n    :disabled {\n      background-color: ").concat(grey6, "\n      cursor: not-allowed;\n    }\n  ");
}

var Container$d = styled('div')(_templateObject$_());
var InputElement = styled('input')(_templateObject2$q(), function (props) {
  var heightV;

  switch (props.size) {
    case 'l':
      heightV = heightL$1;
      break;

    case 'xl':
      heightV = heightXL;
      break;

    case 'm':
    default:
      heightV = height;
      break;
  }

  return "".concat(heightV, "rem");
}, function (props) {
  var paddingV;

  switch (props.size) {
    case 'l':
      paddingV = horizontalPaddingL;
      break;

    case 'xl':
      paddingV = horizontalPaddingXL;
      break;

    case 'm':
    default:
      paddingV = horizontalPadding;
      break;
  }

  return "0 ".concat(paddingV, "rem");
}, function (props) {
  var fontSizeV;

  switch (props.size) {
    case 'l':
      fontSizeV = fontSizeL;
      break;

    case 'xl':
      fontSizeV = fontSizeXL;
      break;

    case 'm':
    default:
      fontSizeV = fontSize;
      break;
  }

  return "".concat(fontSizeV, "rem");
}, function (props) {
  if (props.icon) {
    var paddingL;

    switch (props.size) {
      case 'l':
        paddingL = iconSizeL;
        break;

      case 'xl':
        paddingL = iconSizeXL;
        break;

      case 'm':
      default:
        paddingL = iconSizeM;
        break;
    }

    return "".concat((paddingL * 2 - 5) / fontSizeBase$8, "rem");
  }

  return undefined;
}, function (props) {
  return getStyle$1(props);
});
var TextAreaElement$1 = styled('textarea')(_templateObject3$h(), function (props) {
  return getStyle$1(props);
}, horizontalPadding, fontSize);
var InputIcon$1 = styled(Icon)(_templateObject4$g(), function (props) {
  var left;

  switch (props.size) {
    case 'l':
      left = iconSizeL;
      break;

    case 'xl':
      left = iconSizeXL;
      break;

    case 'm':
    default:
      left = iconSizeM;
      break;
  }

  return "".concat(left / 2 / fontSizeBase$8, "rem");
}, function (props) {
  return props.disabled ? 'not-allowed' : 'auto';
});

var Input$3 =
/*#__PURE__*/
function (_Component) {
  _inherits$i(Input, _Component);

  function Input(props) {
    var _this;

    _classCallCheck$k(this, Input);

    _this = _possibleConstructorReturn$i(this, _getPrototypeOf$i(Input).call(this, props));
    _this.element = props.type === 'textarea' ? TextAreaElement$1 : InputElement;
    _this.inputRef = React.createRef();
    _this.handleIconClick = _this.handleIconClick.bind(_assertThisInitialized$i(_this));
    return _this;
  }

  _createClass$k(Input, [{
    key: "getIcon",
    value: function getIcon() {
      var _this$props = this.props,
          type = _this$props.type,
          size = _this$props.size,
          icon = _this$props.icon,
          iconColor = _this$props.iconColor,
          disabled = _this$props.disabled;

      if (icon === undefined || type === 'textarea') {
        return undefined;
      }

      var iconSize;

      switch (size) {
        case 'l':
          iconSize = iconSizeL;
          break;

        case 'xl':
          iconSize = iconSizeXL;
          break;

        case 'm':
        default:
          iconSize = iconSizeM;
          break;
      }

      return React.createElement(InputIcon$1, {
        icon: icon,
        color: iconColor,
        width: iconSize,
        height: iconSize,
        onClick: this.handleIconClick,
        disabled: disabled
      });
    }
  }, {
    key: "handleIconClick",
    value: function handleIconClick() {
      if (this.inputRef) {
        this.inputRef.current.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          otherProps = _objectWithoutProperties$l(_this$props2, ["className"]);

      return React.createElement(Container$d, {
        className: className
      }, this.getIcon(), React.createElement(this.element, _extends$f({}, otherProps, {
        ref: this.inputRef
      })));
    }
  }]);

  return Input;
}(Component);

Input$3.defaultProps = {
  className: undefined,
  type: 'text',
  size: 'm',
  icon: undefined,
  iconColor: 'black',
  error: false,
  disabled: false
};
Input$3.propTypes = {
  /** String, internal to Styled Component function */
  className: PropTypes.string,

  /** String indicating the type of the input */
  type: PropTypes.oneOf(['text', 'number', 'password', 'textarea']),

  /** String indicating the size of the input */
  size: PropTypes.oneOf(['m', 'l', 'xl']),

  /** String indicating the name of the icon to apply */
  icon: PropTypes.string,

  /** String indicating the color of the icon to apply */
  iconColor: PropTypes.oneOf(['black', 'orange', 'blue', 'green']),

  /** Boolean indicating if the input is in error */
  error: PropTypes.bool,

  /** Boolean indicating if the input is disabled */
  disabled: PropTypes.bool
};

function _typeof$j(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$j = function _typeof(obj) { return typeof obj; }; } else { _typeof$j = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$j(obj); }

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

function _objectWithoutProperties$m(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$m(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$m(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$l(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$l(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$l(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$l(Constructor.prototype, protoProps); if (staticProps) _defineProperties$l(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$j(self, call) { if (call && (_typeof$j(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$j(self); }

function _assertThisInitialized$j(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf$j(o) { _getPrototypeOf$j = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$j(o); }

function _inherits$j(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$j(subClass, superClass); }

function _setPrototypeOf$j(o, p) { _setPrototypeOf$j = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$j(o, p); }

var Input$4 =
/*#__PURE__*/
function (_Component) {
  _inherits$j(Input, _Component);

  function Input() {
    _classCallCheck$l(this, Input);

    return _possibleConstructorReturn$j(this, _getPrototypeOf$j(Input).apply(this, arguments));
  }

  _createClass$l(Input, [{
    key: "getErrorMessage",
    value: function getErrorMessage() {
      var _this$props = this.props,
          form = _this$props.form,
          field = _this$props.field;
      var touched = form.touched,
          errors = form.errors;

      if (!(touched[field.name] && errors[field.name])) {
        return undefined;
      }

      return errors[field.name];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          form = _this$props2.form,
          field = _this$props2.field,
          id = _this$props2.id,
          type = _this$props2.type,
          size = _this$props2.size,
          mandatory = _this$props2.mandatory,
          icon = _this$props2.icon,
          iconColor = _this$props2.iconColor,
          label = _this$props2.label,
          labelPosition = _this$props2.labelPosition,
          labelWidth = _this$props2.labelWidth,
          labelOffsetTop = _this$props2.labelOffsetTop,
          otherProps = _objectWithoutProperties$m(_this$props2, ["form", "field", "id", "type", "size", "mandatory", "icon", "iconColor", "label", "labelPosition", "labelWidth", "labelOffsetTop"]);

      var error = this.getErrorMessage();
      return React.createElement(Label$2, {
        id: id,
        label: label,
        labelPosition: labelPosition,
        labelWidth: labelWidth,
        labelOffsetTop: labelOffsetTop,
        size: size,
        mandatory: mandatory,
        error: error
      }, React.createElement(Input$3, _extends$g({
        id: id,
        type: type,
        size: size,
        icon: icon,
        iconColor: iconColor,
        error: error !== undefined
      }, otherProps, field)));
    }
  }]);

  return Input;
}(Component);

Input$4.defaultProps = {
  mandatory: false,
  label: undefined,
  labelPosition: 'top',
  labelWidth: 30,
  labelOffsetTop: null,
  disabled: false,
  type: Input$3.defaultProps.type,
  size: Input$3.defaultProps.size,
  icon: Input$3.defaultProps.icon,
  iconColor: Input$3.defaultProps.iconColor
};
Input$4.propTypes = {
  /** Formik form prop */
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({})
  }).isRequired,

  /** Formik field prop */
  field: PropTypes.shape({
    name: PropTypes.string
  }).isRequired,

  /** Label of the field */
  label: PropTypes.string,

  /** Id of the input */
  id: PropTypes.string.isRequired,

  /** Boolean indicating if the field is mandatory */
  mandatory: PropTypes.bool,

  /** String indicating the position of the label */
  labelPosition: PropTypes.oneOf(['top', 'left']),

  /** Number indicating the width of label (percentage) */
  labelWidth: PropTypes.number,

  /* Number indicating the top offset to apply for the label */
  labelOffsetTop: PropTypes.number,

  /** Boolean indicating if the input is disabled */
  disabled: PropTypes.bool,
  type: Input$3.propTypes.type,
  // eslint-disable-line react/no-typos
  size: Input$3.propTypes.size,
  // eslint-disable-line react/no-typos
  icon: Input$3.propTypes.icon,
  // eslint-disable-line react/no-typos
  iconColor: Input$3.propTypes.iconColor // eslint-disable-line react/no-typos

};

function _templateObject5$b() {
  var data = _taggedTemplateLiteral$$(["\n  position: absolute;\n  left: -9999px;\n\n  &:focus {\n    & ~ ", " {\n      border-color: ", ";\n    }\n  }\n\n  &:checked {\n    & ~ ", " {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    & ~ ", " > ", " {\n      display: block;\n    }\n\n    &:disabled {\n      & ~ ", " {\n        background-color: ", ";\n        border-color: ", ";\n      }\n    }\n  }\n\n  &:disabled {\n    & ~ ", " {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject5$b = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$h() {
  var data = _taggedTemplateLiteral$$(["\n  ", " & {\n    padding-left: ", ";\n    padding-right: ", ";\n    width: ", ";\n    text-align: ", ";\n  }\n"]);

  _templateObject4$h = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$i() {
  var data = _taggedTemplateLiteral$$(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ", "rem;\n  height: ", "rem;\n  min-width: ", "rem;\n  min-height: ", "rem;\n  border-width: ", "rem;\n  border-style: solid;\n  border-color: ", ";\n  background-color: ", ";\n  cursor: ", ";\n\n  & > ", " {\n    display: none;\n  }\n"]);

  _templateObject3$i = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$r() {
  var data = _taggedTemplateLiteral$$(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: ", ";\n  padding: ", "rem 0;\n"]);

  _templateObject2$r = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$$() {
  var data = _taggedTemplateLiteral$$([""]);

  _templateObject$$ = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$$(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledIcon$1 = styled(Icon)(_templateObject$$());
var Container$e = styled('label')(_templateObject2$r(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, paddingHorizontal$1);
var CheckboxContainer$1 = styled('div')(_templateObject3$i(), size$1, size$1, size$1, size$1, borderWidth$1, grey4, function (props) {
  return props.disabled ? grey6 : white;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, StyledIcon$1);
var Label$3 = styled(Text)(_templateObject4$h(), Container$e, function (props) {
  return props.position === 'right' && "".concat(marginTextRight, "rem");
}, function (props) {
  return props.position === 'left' && "".concat(marginTextLeft, "rem");
}, function (props) {
  return props.width && "calc(".concat(props.width, "% - ").concat(props.position === 'right' ? marginTextRight : marginTextLeft, "rem)");
}, function (props) {
  return props.position === 'left' && 'right';
});
var Input$5 = styled('input')(_templateObject5$b(), CheckboxContainer$1, grey3, CheckboxContainer$1, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, CheckboxContainer$1, StyledIcon$1, CheckboxContainer$1, grey4, grey4, Label$3, grey4);

var Checkbox$1 = function Checkbox(props) {
  var field = props.field,
      label = props.label,
      disabled = props.disabled,
      color = props.color,
      labelSize = props.labelSize,
      labelBold = props.labelBold,
      labelPosition = props.labelPosition,
      labelWidth = props.labelWidth,
      tickColor = props.tickColor;
  var labelElement = label ? React.createElement(Label$3, {
    size: labelSize,
    bold: labelBold,
    position: labelPosition,
    width: labelWidth
  }, label) : null;
  return React.createElement(Container$e, {
    disabled: disabled
  }, labelPosition === 'left' && labelElement, React.createElement(Input$5, {
    name: field.name,
    type: "checkbox",
    disabled: disabled,
    color: color,
    onChange: field.onChange,
    onBlur: field.onBlur,
    checked: field.value
  }), React.createElement(CheckboxContainer$1, {
    role: "checkbox",
    "aria-checked": field.value,
    disabled: disabled
  }, React.createElement(StyledIcon$1, {
    icon: "tick",
    color: tickColor,
    height: tickHeight
  })), labelPosition === 'right' && labelElement);
};

Checkbox$1.defaultProps = {
  color: orange2,
  labelBold: true,
  labelSize: 'm',
  labelPosition: 'right',
  labelWidth: undefined,
  disabled: false,
  tickColor: 'white'
};
Checkbox$1.propTypes = {
  /** Formik field prop */
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.bool,
    onBlur: PropTypes.func,
    onChange: PropTypes.func
  }).isRequired,

  /** Label of the field */
  label: PropTypes.node.isRequired,

  /** String indicating the color of the checkbox */
  color: PropTypes.string,

  /** Boolean indicating if the label is bold */
  labelBold: PropTypes.bool,

  /** String indicating the size of the label */
  labelSize: PropTypes.oneOf(['s', 'm', 'l']),

  /** String indicating the size of the label */
  labelPosition: PropTypes.oneOf(['left', 'right']),

  /** String indicating the width of the label (%) */
  labelWidth: PropTypes.number,

  /** Boolean indicating if the checkbox is disabled */
  disabled: PropTypes.bool,

  /** Color of the tick */
  tickColor: PropTypes.oneOf(['white', 'black', 'orange', 'blue', 'green'])
};

function _templateObject5$c() {
  var data = _taggedTemplateLiteral$10(["\n  padding: ", "rem 0;\n"]);

  _templateObject5$c = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$i() {
  var data = _taggedTemplateLiteral$10(["\n  position: absolute;\n  left: -9999px;\n\n  &:focus {\n    & ~ ", " {\n      border-color: ", ";\n    }\n  }\n\n  &:checked {\n    & ~ ", " {\n      background-color: transparent;\n      border-width: ", "rem;\n      border-color: ", ";\n      height: ", "rem;\n      width: ", "rem;\n      min-width: ", "rem;\n      min-height: ", "rem;\n    }\n\n    &:disabled {\n      & ~ ", " {\n        border-color: ", ";\n      }\n    }\n  }\n\n  &:disabled {\n    & ~ ", " {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject4$i = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$j() {
  var data = _taggedTemplateLiteral$10(["\n  display: flex;\n  align-items: center;\n\n  ", " & {\n    padding-left: ", "rem;\n  }\n"]);

  _templateObject3$j = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$s() {
  var data = _taggedTemplateLiteral$10(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ", "rem;\n  min-width: ", "rem;\n  height: ", "rem;\n  min-height: ", "rem;\n  border-width: ", "rem;\n  border-style: solid;\n  border-color: ", ";\n  border-radius: ", "rem;\n"]);

  _templateObject2$s = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$10() {
  var data = _taggedTemplateLiteral$10(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: ", "rem 0;\n"]);

  _templateObject$10 = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$10(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container$f = styled('label')(_templateObject$10(), paddingHorizontal);
var RadioContainer$1 = styled('div')(_templateObject2$s(), size, size, size, size, borderWidth, grey4, size);
var OptionLabel = styled(Text.withComponent('div'))(_templateObject3$j(), Container$f, marginText);
var Input$6 = styled('input')(_templateObject4$i(), RadioContainer$1, grey3, RadioContainer$1, borderWidthSelected, function (props) {
  return props.color;
}, size + borderWidth * 2 - borderWidthSelected * 2, size + borderWidth * 2 - borderWidthSelected * 2, size + borderWidth * 2 - borderWidthSelected * 2, size + borderWidth * 2 - borderWidthSelected * 2, RadioContainer$1, grey4, OptionLabel, grey4);
var OptionsContainer = styled('div')(_templateObject5$c(), paddingTopLabel - paddingHorizontal);

var Radio$1 = function Radio(props) {
  var field = props.field,
      id = props.id,
      label = props.label,
      labelPosition = props.labelPosition,
      labelWidth = props.labelWidth,
      labelOffsetTop = props.labelOffsetTop,
      disabled = props.disabled,
      color = props.color,
      optionLabelSize = props.optionLabelSize,
      optionLabelBold = props.optionLabelBold,
      options = props.options;
  return React.createElement(Label$2, {
    id: id,
    label: label,
    labelPosition: labelPosition,
    labelWidth: labelWidth,
    labelOffsetTop: labelOffsetTop
  }, React.createElement(OptionsContainer, null, options.map(function (option) {
    return React.createElement(Container$f, {
      key: option.value,
      htmlFor: "".concat(field.name, "-id-").concat(option.value)
    }, React.createElement(Flex, {
      alignItems: "center"
    }, React.createElement(Input$6, {
      id: "".concat(field.name, "-id-").concat(option.value),
      name: field.name,
      type: "radio",
      disabled: disabled,
      color: color,
      value: option.value,
      onChange: field.onChange,
      onBlur: field.onBlur,
      checked: field.value === option.value
    }), React.createElement(RadioContainer$1, {
      role: "checkbox",
      "aria-checked": field.value
    }), React.createElement(OptionLabel, {
      size: optionLabelSize,
      bold: optionLabelBold
    }, option.label, option.subComponent)));
  })));
};

Radio$1.defaultProps = {
  color: orange2,
  optionLabelBold: true,
  optionLabelSize: 'm',
  label: undefined,
  labelPosition: 'top',
  labelWidth: 30,
  labelOffsetTop: null,
  disabled: false
};
Radio$1.propTypes = {
  /** Formik field prop */
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func
  }).isRequired,

  /** Id of the input */
  id: PropTypes.string.isRequired,

  /** Label of the field */
  label: PropTypes.node,

  /** String indicating the position of the label */
  labelPosition: PropTypes.oneOf(['top', 'left']),

  /** Number indicating the width of label (percentage) */
  labelWidth: PropTypes.number,

  /* Number indicating the top offset to apply for the label */
  labelOffsetTop: PropTypes.number,

  /** String indicating the color of the radio */
  color: PropTypes.string,

  /** Boolean indicating if the label is bold */
  optionLabelBold: PropTypes.bool,

  /** String indicating the size of the label */
  optionLabelSize: PropTypes.oneOf(['s', 'm', 'l']),

  /** Boolean indicating if the radio is disabled */
  disabled: PropTypes.bool,

  /** List of option items */
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
  })).isRequired
};

function _typeof$k(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$k = function _typeof(obj) { return typeof obj; }; } else { _typeof$k = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$k(obj); }

function _classCallCheck$m(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$m(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$m(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$m(Constructor.prototype, protoProps); if (staticProps) _defineProperties$m(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$k(self, call) { if (call && (_typeof$k(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$k(self); }

function _getPrototypeOf$k(o) { _getPrototypeOf$k = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$k(o); }

function _assertThisInitialized$k(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$k(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$k(subClass, superClass); }

function _setPrototypeOf$k(o, p) { _setPrototypeOf$k = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$k(o, p); }

function _templateObject7$4() {
  var data = _taggedTemplateLiteral$11(["\n  border-left: ", "rem solid transparent;\n  border-right: ", "rem solid transparent;\n  border-top: ", "rem solid ", ";\n"]);

  _templateObject7$4 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$8() {
  var data = _taggedTemplateLiteral$11(["\n  display: ", ";\n  position: absolute;\n  top: ", "rem;\n  left: -", "rem;\n  right: -", "rem;\n  background: white;\n  margin: ", "rem 0 0 0;\n  border: ", "rem solid ", ";\n  border-top: 0;\n  list-style:none;\n  padding: 0;\n  max-height: ", ";\n  overflow-y: auto;\n"]);

  _templateObject6$8 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$d() {
  var data = _taggedTemplateLiteral$11(["\n  cursor: pointer;\n  height: ", "rem;\n  display: flex;\n  align-items: center;\n  padding: 0 ", "rem;\n\n  &:hover, &:focus {\n    background-color: ", ";\n\n    ", " {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject5$d = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$j() {
  var data = _taggedTemplateLiteral$11(["\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-right: ", "rem;\n"]);

  _templateObject4$j = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$k() {
  var data = _taggedTemplateLiteral$11(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject3$k = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$t() {
  var data = _taggedTemplateLiteral$11(["\n  background-color: ", ";\n  width: ", "rem;\n  height: ", "rem;\n  margin-right: ", "rem;\n"]);

  _templateObject2$t = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$11() {
  var data = _taggedTemplateLiteral$11(["\n  flex: 1 1 0rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: ", "rem;\n  max-width: calc(100% - ", "rem);\n  padding: 0 ", "rem;\n  background: ", ";\n  border: ", "rem solid ", ";\n  cursor: ", ";\n  position: relative;\n  z-index: ", ";\n"]);

  _templateObject$11 = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$11(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var SelectDiv$1 = styled('div')(_templateObject$11(), height$1, horizontalPadding$1 * 2 + borderSize$1 * 2, horizontalPadding$1, function (props) {
  return props.disabled ? grey6 : white;
}, borderSize$1, grey4, function (props) {
  return props.disabled ? undefined : 'pointer';
}, function (props) {
  return props.opened ? 999 : undefined;
});
var Color$1 = styled('div')(_templateObject2$t(), function (props) {
  return props.color ? props.color : undefined;
}, colorWidth, colorHeight, horizontalPadding$1);
var LocalTextContainer = styled('div')(_templateObject3$k());
var LocalText$1 = styled(Text)(_templateObject4$j(), marginRightOption);
var OptionListEntry$1 = styled('li')(_templateObject5$d(), entryHeight, horizontalPadding$1, black, LocalText$1, white);
var OptionList$1 = styled('ul')(_templateObject6$8(), function (props) {
  return props.opened ? 'block' : 'none';
}, height$1, borderSize$1, borderSize$1, borderSize$1, borderSize$1, grey4, function (props) {
  return "".concat(entryHeight * props.scrollItems, "rem");
});
var SelectArrow$1 = styled('div')(_templateObject7$4(), borderArrowSize$1, borderArrowSize$1, borderArrowSize$1, black);

var Select$1 =
/*#__PURE__*/
function (_Component) {
  _inherits$k(Select, _Component);

  function Select(props) {
    var _this;

    _classCallCheck$m(this, Select);

    _this = _possibleConstructorReturn$k(this, _getPrototypeOf$k(Select).call(this, props));
    _this.state = {
      opened: false
    };
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized$k(_this));
    _this.onSelectDivClick = _this.onSelectDivClick.bind(_assertThisInitialized$k(_this));
    _this.onSelectItem = _this.onSelectItem.bind(_assertThisInitialized$k(_this));
    _this.getLocalText = _this.getLocalText.bind(_assertThisInitialized$k(_this));
    _this.selectRef = React.createRef();
    return _this;
  }

  _createClass$m(Select, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "onSelectDivClick",
    value: function onSelectDivClick() {
      var disabled = this.props.disabled;
      var opened = this.state.opened;

      if (disabled) {
        return;
      }

      if (!opened) {
        document.addEventListener('mousedown', this.handleClickOutside);
      } else {
        document.removeEventListener('mousedown', this.handleClickOutside);
      }

      this.setState({
        opened: !opened
      });
    }
  }, {
    key: "onSelectItem",
    value: function onSelectItem(option) {
      var _this$props = this.props,
          field = _this$props.field,
          form = _this$props.form;
      form.setFieldTouched(field.name, true);
      form.setFieldValue(field.name, option.value);
    }
  }, {
    key: "getSelectedOption",
    value: function getSelectedOption() {
      var _this$props2 = this.props,
          field = _this$props2.field,
          options = _this$props2.options;
      var selectedOption = options.find(function (option) {
        return option.value === field.value;
      });
      var defaultOption = options.length ? options[0] : {};
      return selectedOption || defaultOption;
    }
  }, {
    key: "getLocalText",
    value: function getLocalText(option) {
      var useColor = this.props.useColor;
      return React.createElement(LocalTextContainer, null, useColor ? React.createElement(Color$1, {
        color: option.color
      }) : null, React.createElement(LocalText$1, {
        bold: true
      }, option.label));
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (this.selectRef && this.selectRef.current && !this.selectRef.current.contains(event.target)) {
        this.closeSelect();
      }
    }
  }, {
    key: "closeSelect",
    value: function closeSelect() {
      document.removeEventListener('mousedown', this.handleClickOutside);
      this.setState({
        opened: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          options = _this$props3.options,
          disabled = _this$props3.disabled,
          mandatory = _this$props3.mandatory,
          label = _this$props3.label,
          labelPosition = _this$props3.labelPosition,
          labelWidth = _this$props3.labelWidth,
          labelOffsetTop = _this$props3.labelOffsetTop,
          scrollItems = _this$props3.scrollItems,
          className = _this$props3.className;
      var opened = this.state.opened;
      return React.createElement(Label$2, {
        id: id,
        label: label,
        labelPosition: labelPosition,
        labelWidth: labelWidth,
        labelOffsetTop: labelOffsetTop,
        mandatory: mandatory,
        className: className
      }, React.createElement(SelectDiv$1, {
        onClick: this.onSelectDivClick,
        disabled: disabled,
        opened: opened,
        ref: this.selectRef,
        id: "".concat(id, "-id-select")
      }, this.getLocalText(this.getSelectedOption()), React.createElement(SelectArrow$1, null), React.createElement(OptionList$1, {
        opened: opened,
        scrollItems: scrollItems
      }, options.map(function (option) {
        return React.createElement(OptionListEntry$1, {
          key: option.key || option.value,
          value: option.value,
          onClick: function onClick() {
            _this2.onSelectItem(option);
          },
          tabIndex: 0,
          id: "".concat(id, "-id-").concat(option.key || option.value)
        }, _this2.getLocalText(option));
      }))));
    }
  }]);

  return Select;
}(Component);

Select$1.defaultProps = {
  label: undefined,
  labelPosition: 'top',
  labelWidth: 30,
  labelOffsetTop: null,
  disabled: false,
  mandatory: false,
  scrollItems: 5,
  useColor: false,
  className: undefined
};
Select$1.propTypes = {
  /** Formik form prop */
  form: PropTypes.shape({
    setFieldTouched: PropTypes.func,
    setFieldValue: PropTypes.func
  }).isRequired,

  /** Formik field prop */
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string
  }).isRequired,

  /** Label of the field */
  label: PropTypes.string,

  /** Id of the input */
  id: PropTypes.string.isRequired,

  /** List of option items */
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.any,
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
  })).isRequired,

  /** String indicating the position of the label */
  labelPosition: PropTypes.oneOf(['top', 'left']),

  /** Number indicating the width of label (percentage) */
  labelWidth: PropTypes.number,

  /* Number indicating the top offset to apply for the label */
  labelOffsetTop: PropTypes.number,

  /** Boolean indicating if the input is disabled */
  disabled: PropTypes.bool,

  /** Boolean indicating if the field is mandatory */
  mandatory: PropTypes.bool,

  /** Number indicating list items to be displayed before scrolling */
  scrollItems: PropTypes.number,

  /** Boolean indicating if we render color block or not */
  useColor: PropTypes.bool,

  /** String, internal to Styled Component function */
  className: PropTypes.string
};

function _typeof$l(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$l = function _typeof(obj) { return typeof obj; }; } else { _typeof$l = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$l(obj); }

function _classCallCheck$n(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$n(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$n(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$n(Constructor.prototype, protoProps); if (staticProps) _defineProperties$n(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$l(self, call) { if (call && (_typeof$l(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$l(self); }

function _getPrototypeOf$l(o) { _getPrototypeOf$l = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$l(o); }

function _assertThisInitialized$l(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$l(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$l(subClass, superClass); }

function _setPrototypeOf$l(o, p) { _setPrototypeOf$l = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$l(o, p); }

function _templateObject12() {
  var data = _taggedTemplateLiteral$12(["\n  padding: 0.5rem 0;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$1() {
  var data = _taggedTemplateLiteral$12(["\n  display: flex;\n  flex: 1 1 0rem;\n  flex-direction: column;\n  justify-content: center;\n"]);

  _templateObject11$1 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$1() {
  var data = _taggedTemplateLiteral$12(["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 3;\n"]);

  _templateObject10$1 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$3() {
  var data = _taggedTemplateLiteral$12(["\n  border: ", "rem solid ", ";\n  display: flex;\n  flex-direction: row;\n  background: ", ";\n  padding: 0.8rem 0.5rem;\n\n  ", ":nth-child(4) {\n    margin-left: 0.2rem;\n  }\n"]);

  _templateObject9$3 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$4() {
  var data = _taggedTemplateLiteral$12(["\n  width: ", "rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject8$4 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$5() {
  var data = _taggedTemplateLiteral$12(["\n  border: ", "rem solid ", ";\n"]);

  _templateObject7$5 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$9() {
  var data = _taggedTemplateLiteral$12(["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 3;\n"]);

  _templateObject6$9 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$e() {
  var data = _taggedTemplateLiteral$12(["\n  position: relative;\n  margin-top: ", "rem;\n  width: 100%;\n\n  @media (min-width: 458px) {\n    margin-top: 0;\n    margin-left: ", "rem;\n    width: ", "rem;\n  }\n"]);

  _templateObject5$e = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$k() {
  var data = _taggedTemplateLiteral$12(["\n  position: relative;\n\n  width: 100%;\n\n  @media (min-width: 458px) {\n    width: ", "rem;\n  }\n"]);

  _templateObject4$k = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$l() {
  var data = _taggedTemplateLiteral$12(["\n  width: 100%;\n\n  @media (min-width: 458px) {\n    width: ", "rem;\n  }\n"]);

  _templateObject3$l = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$u() {
  var data = _taggedTemplateLiteral$12(["\n  width: 100%;\n\n  @media (min-width: 458px) {\n    width: ", "rem;\n  }\n"]);

  _templateObject2$u = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$12() {
  var data = _taggedTemplateLiteral$12(["\n  flex: 1 1 0rem;\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: 458px) {\n    flex-direction: row;\n  }\n"]);

  _templateObject$12 = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$12(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
moment.locale('fr');
var Container$g = styled('div')(_templateObject$12());
var DateInput = styled(Input$3)(_templateObject2$u(), 236 / fontSizeBase$8);
var TimeInput = styled(Input$3)(_templateObject3$l(), 104 / fontSizeBase$8);
var DateContainer = styled(Flex)(_templateObject4$k(), 236 / fontSizeBase$8);
var TimeContainer = styled(Flex)(_templateObject5$e(), 20 / fontSizeBase$8, 20 / fontSizeBase$8, 104 / fontSizeBase$8);
var DateCalendar$1 = styled('div')(_templateObject6$9());
var MiniCalendar$1 = styled(Calendar)(_templateObject7$5(), borderSize, grey4);
var TimeSelector$1 = styled('div')(_templateObject8$4(), timeSelectorWidth);
var TimePickerSelector$1 = styled('div')(_templateObject9$3(), borderSize, grey4, white, TimeSelector$1);
var TimePickerWrapper$1 = styled('div')(_templateObject10$1());
var Separator$1 = styled('div')(_templateObject11$1());
var ValueText$1 = styled(Text)(_templateObject12());

var DateTimePicker =
/*#__PURE__*/
function (_Component) {
  _inherits$l(DateTimePicker, _Component);

  function DateTimePicker(props) {
    var _this;

    _classCallCheck$n(this, DateTimePicker);

    _this = _possibleConstructorReturn$l(this, _getPrototypeOf$l(DateTimePicker).call(this, props));
    var field = _this.props.field;
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized$l(_this));
    _this.setFocusDate = _this.setFocusDate.bind(_assertThisInitialized$l(_this));
    _this.setFocusTime = _this.setFocusTime.bind(_assertThisInitialized$l(_this));
    _this.closePickers = _this.closePickers.bind(_assertThisInitialized$l(_this));
    _this.handleBlurDate = _this.handleBlurDate.bind(_assertThisInitialized$l(_this));
    _this.handleBlurTime = _this.handleBlurTime.bind(_assertThisInitialized$l(_this));
    _this.handleChangeDate = _this.handleChangeDate.bind(_assertThisInitialized$l(_this));
    _this.handleChangeTime = _this.handleChangeTime.bind(_assertThisInitialized$l(_this));
    _this.handleEditTime = _this.handleEditTime.bind(_assertThisInitialized$l(_this));
    _this.handleKeyPressDate = _this.handleKeyPressDate.bind(_assertThisInitialized$l(_this));
    _this.handleKeyDownDate = _this.handleKeyDownDate.bind(_assertThisInitialized$l(_this));
    _this.handleKeyPressTime = _this.handleKeyPressTime.bind(_assertThisInitialized$l(_this));
    _this.handleKeyDownTime = _this.handleKeyDownTime.bind(_assertThisInitialized$l(_this));
    _this.onDateSelection = _this.onDateSelection.bind(_assertThisInitialized$l(_this));
    var momentDate = field.value ? moment(field.value) : undefined;
    var dateStr = momentDate ? momentDate.format('D MMMM YYYY') : '';
    var timeStr = momentDate ? momentDate.format('HH:mm') : '';
    _this.state = {
      dateStr: dateStr,
      timeStr: timeStr
    };
    _this.lastValidDate = dateStr;
    _this.lastValidTime = timeStr;
    _this.dateInputRef = React.createRef();
    _this.timeInputRef = React.createRef();
    _this.calendarRef = React.createRef();
    _this.timerRef = React.createRef();
    _this.validDateFormats = ['D MMM', // 8 oct
    'D MMMM', // 8 octobre
    'D MMM YYYY', // 8 oct 2018
    'D MMMM YYYY', // 8 octobre 2018
    'DD/MM', // 08/10
    'DD/MM/YYYY' // 08/10/2018
    ];
    _this.validTimeFormats = ['HH:mm', // 09:34
    'H:mm' // 9:34
    ];
    return _this;
  }

  _createClass$n(DateTimePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var field = this.props.field;

      if (prevProps.field.value.getTime() !== field.value.getTime()) {
        var momentDate = moment(field.value);
        var dateString = momentDate.format('D MMMM YYYY');
        var timeString = momentDate.format('HH:mm');
        this.setState({
          dateStr: dateString,
          timeStr: timeString
        }, function () {
          _this2.lastValidDate = dateString;
          _this2.lastValidTime = timeString;
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "onDateSelection",
    value: function onDateSelection(date) {
      var field = this.props.field;
      var value = field.value;
      var dateObj = moment(date);
      var newValue = moment(value).set({
        year: dateObj.year(),
        month: dateObj.month(),
        date: dateObj.date()
      });
      this.updateValue(newValue);
      this.closePickers();
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage() {
      var _this$props = this.props,
          form = _this$props.form,
          field = _this$props.field;
      var touched = form.touched,
          errors = form.errors;

      if (!(touched[field.name] && errors[field.name])) {
        return undefined;
      }

      return errors[field.name];
    }
  }, {
    key: "setFocusDate",
    value: function setFocusDate() {
      document.addEventListener('mousedown', this.handleClickOutside);
      this.setState({
        dateFocused: true
      });
    }
  }, {
    key: "setFocusTime",
    value: function setFocusTime() {
      document.addEventListener('mousedown', this.handleClickOutside);
      this.setState({
        timeFocused: true
      });
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (this.calendarRef && this.calendarRef.current && !this.calendarRef.current.contains(event.target) && this.dateInputRef && this.dateInputRef.current && !this.dateInputRef.current.inputRef.current.contains(event.target)) {
        this.closePickers();
      } else if (this.timerRef && this.timerRef.current && !this.timerRef.current.contains(event.target) && this.timeInputRef && this.timeInputRef.current && !this.timeInputRef.current.inputRef.current.contains(event.target)) {
        this.closePickers();
      }
    }
  }, {
    key: "closePickers",
    value: function closePickers() {
      document.removeEventListener('mousedown', this.handleClickOutside);
      this.setState({
        dateFocused: false,
        timeFocused: false
      });
    }
  }, {
    key: "handleChangeDate",
    value: function handleChangeDate(event) {
      var value = event.target.value;
      var date = moment(value, this.validDateFormats, 'fr', true);

      if (date.isValid()) {
        this.lastValidDate = value;
      }

      this.setState({
        dateStr: value
      });
    }
  }, {
    key: "handleChangeTime",
    value: function handleChangeTime(event) {
      var value = event.target.value;
      var time = moment(value, this.validTimeFormats, 'fr', true);

      if (time.isValid()) {
        this.lastValidTime = value;
      }

      this.setState({
        timeStr: value
      });
    }
  }, {
    key: "updateValue",
    value: function updateValue(newValue) {
      var _this$props2 = this.props,
          form = _this$props2.form,
          field = _this$props2.field,
          linkedWith = _this$props2.linkedWith;
      var value = field.value,
          name = field.name;

      if (linkedWith !== undefined) {
        var momentValue = moment(value);
        var linkedValue = moment(form.values[linkedWith]);
        var duration = linkedValue.diff(momentValue, 'minutes');
        var newLinkedValue = newValue.clone().add({
          minutes: duration
        });
        form.setFieldTouched(linkedWith, true);
        form.setFieldValue(linkedWith, newLinkedValue.toDate());
      }

      form.setFieldTouched(name, true);
      form.setFieldValue(name, newValue.toDate());
    }
  }, {
    key: "handleEditTime",
    value: function handleEditTime(type, operation) {
      var _this$props3 = this.props,
          field = _this$props3.field,
          min = _this$props3.min,
          max = _this$props3.max,
          minutesAddPad = _this$props3.minutesAddPad,
          minutesSubtractPad = _this$props3.minutesSubtractPad,
          hoursAddPad = _this$props3.hoursAddPad,
          hoursSubtractPad = _this$props3.hoursSubtractPad;
      var value = field.value;
      var momentDate = moment(value);
      var newValue;

      if (type === 'hours' && operation === 'plus') {
        newValue = momentDate.add({
          hours: hoursAddPad
        });
      } else if (type === 'hours' && operation === 'minus') {
        newValue = momentDate.subtract({
          hours: hoursSubtractPad
        });
      } else if (type === 'minutes' && operation === 'plus') {
        newValue = momentDate.add({
          minutes: minutesAddPad
        });
      } else if (type === 'minutes' && operation === 'minus') {
        newValue = momentDate.subtract({
          minutes: minutesSubtractPad
        });
      }

      if (max !== undefined && newValue.isAfter(max) || min !== undefined && newValue.isBefore(min)) {
        return;
      }

      this.updateValue(newValue);
    }
  }, {
    key: "handleBlurDate",
    value: function handleBlurDate() {
      var dateStr = this.state.dateStr;
      var field = this.props.field;
      var value = field.value;
      var date = moment(dateStr, this.validDateFormats, 'fr', true);

      if (date.isValid()) {
        var newValue = moment(value).set({
          year: date.year(),
          month: date.month(),
          date: date.date()
        });
        this.updateValue(newValue);
      } else {
        this.setState({
          dateStr: this.lastValidDate
        });
      }
    }
  }, {
    key: "handleBlurTime",
    value: function handleBlurTime() {
      var timeStr = this.state.timeStr;
      var field = this.props.field;
      var value = field.value;
      var time = moment(timeStr, this.validTimeFormats, 'fr', true);

      if (time.isValid()) {
        var newValue = moment(value).set({
          hour: time.hour(),
          minute: time.minute()
        });
        this.updateValue(newValue);
      } else {
        this.setState({
          timeStr: this.lastValidTime
        });
      }
    }
  }, {
    key: "handleKeyDownDate",
    value: function handleKeyDownDate(event) {
      var _this$props4 = this.props,
          field = _this$props4.field,
          min = _this$props4.min,
          max = _this$props4.max;
      var value = field.value;
      var momentValue = moment(value);

      if (event.key === 'ArrowUp') {
        var newValue = momentValue.add({
          days: 1
        });

        if (max !== undefined && newValue.isAfter(max)) {
          return;
        }

        this.updateValue(newValue);
      } else if (event.key === 'ArrowDown') {
        var _newValue = momentValue.subtract({
          days: 1
        });

        if (min !== undefined && _newValue.isBefore(min)) {
          return;
        }

        this.updateValue(_newValue);
      } else if (event.key === 'Tab' || event.key === 'Escape') {
        this.closePickers();
      }
    }
  }, {
    key: "handleKeyDownTime",
    value: function handleKeyDownTime(event) {
      var _this$props5 = this.props,
          field = _this$props5.field,
          min = _this$props5.min,
          max = _this$props5.max;
      var value = field.value;
      var momentValue = moment(value);

      if (event.key === 'ArrowUp') {
        var newValue = momentValue.add({
          minutes: 15
        });

        if (max !== undefined && newValue.isAfter(max)) {
          return;
        }

        this.updateValue(newValue);
      } else if (event.key === 'ArrowDown') {
        var _newValue2 = momentValue.subtract({
          minutes: 15
        });

        if (min !== undefined && _newValue2.isBefore(min)) {
          return;
        }

        this.updateValue(_newValue2);
      } else if (event.key === 'Tab' || event.key === 'Escape') {
        this.closePickers();
      }
    }
  }, {
    key: "handleKeyPressDate",
    value: function handleKeyPressDate(event) {
      var dateFocused = this.state.dateFocused;

      if (event.key === 'Enter') {
        if (dateFocused) {
          event.preventDefault();
          this.closePickers();
        }

        this.handleBlurDate();
      }
    }
  }, {
    key: "handleKeyPressTime",
    value: function handleKeyPressTime(event) {
      var timeFocused = this.state.timeFocused;

      if (event.key === 'Enter') {
        if (timeFocused) {
          event.preventDefault();
          this.closePickers();
        }

        this.handleBlurTime();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props6 = this.props,
          form = _this$props6.form,
          field = _this$props6.field,
          id = _this$props6.id,
          disabled = _this$props6.disabled,
          size = _this$props6.size,
          mandatory = _this$props6.mandatory,
          label = _this$props6.label,
          labelPosition = _this$props6.labelPosition,
          labelWidth = _this$props6.labelWidth,
          labelOffsetTop = _this$props6.labelOffsetTop,
          withHours = _this$props6.withHours,
          min = _this$props6.min,
          max = _this$props6.max;
      var _this$state = this.state,
          dateStr = _this$state.dateStr,
          timeStr = _this$state.timeStr,
          dateFocused = _this$state.dateFocused,
          timeFocused = _this$state.timeFocused;
      var momentDate = moment(field.value);
      return React.createElement(Label$2, {
        id: id,
        label: label,
        labelPosition: labelPosition,
        labelWidth: labelWidth,
        labelOffsetTop: labelOffsetTop,
        size: size,
        mandatory: mandatory,
        error: this.getErrorMessage()
      }, React.createElement(Container$g, null, React.createElement(DateContainer, null, React.createElement(DateInput, {
        ref: this.dateInputRef,
        disabled: disabled,
        size: size,
        required: mandatory,
        icon: "calendar-day",
        error: form.touched[field.name] && form.errors[field.name],
        onFocus: this.setFocusDate,
        onClick: this.setFocusDate,
        onChange: this.handleChangeDate,
        onBlur: this.handleBlurDate,
        onKeyPress: this.handleKeyPressDate,
        onKeyDown: this.handleKeyDownDate,
        value: dateStr,
        id: "".concat(field.name, "-id-date")
      }), dateFocused ? React.createElement(DateCalendar$1, {
        ref: this.calendarRef
      }, React.createElement(MiniCalendar$1, {
        size: "s",
        selectDay: this.onDateSelection,
        date: field.value,
        activeDate: field.value,
        min: min,
        max: max
      })) : null), withHours ? React.createElement(TimeContainer, null, React.createElement(TimeInput, {
        ref: this.timeInputRef,
        type: "text",
        disabled: disabled,
        size: size,
        required: mandatory,
        icon: "Clock-white",
        error: form.touched[field.name] && form.errors[field.name],
        onFocus: this.setFocusTime,
        onClick: this.setFocusTime,
        onChange: this.handleChangeTime,
        onBlur: this.handleBlurTime,
        onKeyPress: this.handleKeyPressTime,
        onKeyDown: this.handleKeyDownTime,
        value: timeStr,
        id: "".concat(field.name, "-id-time")
      }), timeFocused ? React.createElement(TimePickerWrapper$1, {
        ref: this.timerRef
      }, React.createElement(TimePickerSelector$1, {
        "aria-hidden": timeFocused
      }, React.createElement(TimeSelector$1, null, React.createElement(Button$1, {
        size: "s",
        type: "icon",
        icon: "arrow-up",
        onClick: function onClick() {
          return _this3.handleEditTime('hours', 'plus');
        }
      }), React.createElement(ValueText$1, {
        bold: true
      }, momentDate.format('HH')), React.createElement(Button$1, {
        size: "s",
        type: "icon",
        icon: "arrow-down",
        onClick: function onClick() {
          return _this3.handleEditTime('hours', 'minus');
        },
        disabled: this.isDecrementHourDisabled
      })), React.createElement(Separator$1, null, ":"), React.createElement(TimeSelector$1, null, React.createElement(Button$1, {
        size: "s",
        type: "icon",
        icon: "arrow-up",
        onClick: function onClick() {
          return _this3.handleEditTime('minutes', 'plus');
        }
      }), React.createElement(ValueText$1, {
        bold: true
      }, momentDate.format('mm')), React.createElement(Button$1, {
        size: "s",
        type: "icon",
        icon: "arrow-down",
        disabled: this.isDecrementMinuteDisabled,
        onClick: function onClick() {
          return _this3.handleEditTime('minutes', 'minus');
        }
      })))) : null) : null));
    }
  }, {
    key: "isDecrementHourDisabled",
    get: function get() {
      var _this$props7 = this.props,
          field = _this$props7.field,
          min = _this$props7.min;
      var value = field.value;

      if (min === undefined) {
        return false;
      }

      return moment(value).subtract(1, 'hours').valueOf() < min.valueOf();
    }
  }, {
    key: "isDecrementMinuteDisabled",
    get: function get() {
      var _this$props8 = this.props,
          field = _this$props8.field,
          min = _this$props8.min;
      var value = field.value;

      if (min === undefined) {
        return false;
      }

      return moment(value).subtract(1, 'minutes').valueOf() < min.valueOf();
    }
  }]);

  return DateTimePicker;
}(Component);

DateTimePicker.defaultProps = {
  mandatory: false,
  size: 'm',
  label: undefined,
  labelPosition: 'top',
  labelWidth: 30,
  labelOffsetTop: null,
  withHours: false,
  linkedWith: undefined,
  disabled: false,
  min: undefined,
  max: undefined,
  minutesAddPad: 15,
  minutesSubtractPad: 15,
  hoursAddPad: 1,
  hoursSubtractPad: 1
};
DateTimePicker.propTypes = {
  /** Formik form prop */
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    values: PropTypes.shape({}),
    setFieldTouched: PropTypes.func,
    setFieldValue: PropTypes.func
  }).isRequired,

  /** Formik field prop */
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.instanceOf(Date)
  }).isRequired,

  /** Id of the input */
  id: PropTypes.string.isRequired,

  /** Label of the field */
  label: PropTypes.node,

  /** Boolean indicating if we can select hours */
  withHours: PropTypes.bool,

  /** Name of the string linked to this input */
  linkedWith: PropTypes.string,

  /** Boolean indicating if the field is mandatory */
  mandatory: PropTypes.bool,

  /** String indicating the size of the input */
  size: PropTypes.oneOf(['m', 'l', 'xl']),

  /** String indicating the position of the label */
  labelPosition: PropTypes.oneOf(['top', 'left']),

  /** Number indicating the width of label (percentage) */
  labelWidth: PropTypes.number,

  /* Number indicating the top offset to apply for the label */
  labelOffsetTop: PropTypes.number,

  /** Boolean indicating if the input is disabled */
  disabled: PropTypes.bool,

  /** Date, minimum date selection in the picker */
  min: PropTypes.instanceOf(Date),

  /** Date, maximum date selection in the picker */
  max: PropTypes.instanceOf(Date),

  /** Minute to add when click on the top arrow of the picker */
  minutesAddPad: PropTypes.number,

  /** Minute to subtract when click on the bottom arrow of the picker */
  minutesSubtractPad: PropTypes.number,

  /** Hours to add when click on the top arrow of the picker */
  hoursAddPad: PropTypes.number,

  /** Hours to subtract when click on the bottom arrow of the picker */
  hoursSubtractPad: PropTypes.number
};

var fontSizeBase$d = 16;
var minWidth$2 = 112 / fontSizeBase$d;
var selectorHeight$1 = 36 / fontSizeBase$d;
var selectorHeightL$1 = 46 / fontSizeBase$d;

function _typeof$m(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$m = function _typeof(obj) { return typeof obj; }; } else { _typeof$m = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$m(obj); }

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

function _classCallCheck$o(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$o(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$o(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$o(Constructor.prototype, protoProps); if (staticProps) _defineProperties$o(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$m(self, call) { if (call && (_typeof$m(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$m(self); }

function _getPrototypeOf$m(o) { _getPrototypeOf$m = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$m(o); }

function _assertThisInitialized$m(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$m(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$m(subClass, superClass); }

function _setPrototypeOf$m(o, p) { _setPrototypeOf$m = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$m(o, p); }

function _templateObject3$m() {
  var data = _taggedTemplateLiteral$13(["\n  & > input {\n    border: none;\n    width: 100%;\n    padding: 0;\n    text-align: center;\n  }\n"]);

  _templateObject3$m = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$v() {
  var data = _taggedTemplateLiteral$13(["\n  height: ", ";\n  width: ", ";\n\n  border: none;\n  min-width: 0;\n\n  background: ", ";\n  padding: 0;\n\n  &:disabled {\n    background: ", ";\n    border-color: ", ";\n    p {\n      color: ", ";\n    }\n  }\n\n  &:not([disabled]) {\n    &:focus, &:hover {\n      background: ", ";\n      border-color: ", ";\n      p {\n        color: ", ";\n      }\n    }\n\n    &:active {\n      background: ", ";\n      border-color: ", ";\n      p {\n        color: ", ";\n      }\n    }\n  }\n"]);

  _templateObject2$v = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$13() {
  var data = _taggedTemplateLiteral$13(["\n  flex: 1 1 0rem;\n  display: flex;\n  position: relative;\n  border: ", "rem solid;\n  border-color: ", ";\n  min-width: ", "rem;\n\n  input[type=\"number\"] {\n    -webkit-appearance: textfield;\n       -moz-appearance: textfield;\n            appearance: textfield;\n  }\n  input[type=number]::-webkit-inner-spin-button,\n  input[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n  }\n"]);

  _templateObject$13 = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$13(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container$h = styled('div')(_templateObject$13(), borderInput, function (props) {
  return props.hasFocus ? black : grey4;
}, minWidth$2);
var Operator$1 = styled(Button$1)(_templateObject2$v(), function (props) {
  var heightV;

  switch (props.size) {
    case 'l':
      heightV = selectorHeightL$1;
      break;

    case 'm':
    default:
      heightV = selectorHeight$1;
      break;
  }

  return "".concat(heightV, "rem");
}, function (props) {
  var widthV;

  switch (props.size) {
    case 'l':
      widthV = selectorHeightL$1;
      break;

    case 'm':
    default:
      widthV = selectorHeight$1;
      break;
  }

  return "".concat(widthV, "rem");
}, white, grey6, grey6, grey4, black, black, white, orange1, orange1, white);
var QuantityInput = styled(Input$3)(_templateObject3$m());

var QuantityPicker =
/*#__PURE__*/
function (_Component) {
  _inherits$m(QuantityPicker, _Component);

  function QuantityPicker(props) {
    var _this;

    _classCallCheck$o(this, QuantityPicker);

    _this = _possibleConstructorReturn$m(this, _getPrototypeOf$m(QuantityPicker).call(this, props));
    _this.state = {
      hasFocus: false
    };
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized$m(_this));
    _this.decrement = _this.decrement.bind(_assertThisInitialized$m(_this));
    _this.increment = _this.increment.bind(_assertThisInitialized$m(_this));
    return _this;
  }

  _createClass$o(QuantityPicker, [{
    key: "onBlur",
    value: function onBlur(event) {
      var field = this.props.field;
      field.onBlur(event);
      this.setState({
        hasFocus: false
      });
    }
  }, {
    key: "setFocus",
    value: function setFocus(hasFocus) {
      this.setState({
        hasFocus: hasFocus
      });
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage() {
      var _this$props = this.props,
          form = _this$props.form,
          field = _this$props.field;
      var touched = form.touched,
          errors = form.errors;

      if (!(touched[field.name] && errors[field.name])) {
        return undefined;
      }

      return errors[field.name];
    }
  }, {
    key: "changeValue",
    value: function changeValue(operation) {
      var _this$props2 = this.props,
          form = _this$props2.form,
          field = _this$props2.field,
          step = _this$props2.step;
      var value = field.value,
          name = field.name;
      form.setFieldTouched(name, true);

      if (operation === 'increment') {
        form.setFieldValue(name, value + step);
      } else if (operation === 'decrement') {
        form.setFieldValue(name, value - step);
      }
    }
  }, {
    key: "decrement",
    value: function decrement() {
      this.changeValue('decrement');
    }
  }, {
    key: "increment",
    value: function increment() {
      this.changeValue('increment');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          field = _this$props3.field,
          id = _this$props3.id,
          disabled = _this$props3.disabled,
          size = _this$props3.size,
          mandatory = _this$props3.mandatory,
          label = _this$props3.label,
          labelPosition = _this$props3.labelPosition,
          labelWidth = _this$props3.labelWidth,
          labelOffsetTop = _this$props3.labelOffsetTop,
          min = _this$props3.min,
          max = _this$props3.max,
          step = _this$props3.step;
      var hasFocus = this.state.hasFocus;
      var error = this.getErrorMessage();
      return React.createElement(Label$2, {
        id: id,
        label: label,
        labelPosition: labelPosition,
        labelWidth: labelWidth,
        labelOffsetTop: labelOffsetTop,
        size: size,
        mandatory: mandatory,
        error: error
      }, React.createElement(Container$h, {
        hasFocus: hasFocus
      }, React.createElement(Operator$1, {
        position: "left",
        onClick: this.decrement,
        onFocus: function onFocus() {
          return _this2.setFocus(true);
        },
        onBlur: function onBlur() {
          return _this2.setFocus(false);
        },
        size: size,
        disabled: this.isDecrementDisabled || disabled
      }, React.createElement(Text, {
        bold: true,
        size: size
      }, "-")), React.createElement(QuantityInput, _extends$h({
        id: id,
        type: "number",
        disabled: disabled,
        size: size,
        required: mandatory,
        min: min,
        max: max,
        step: step,
        onFocus: function onFocus() {
          return _this2.setFocus(true);
        }
      }, field, {
        onBlur: this.onBlur
      })), React.createElement(Operator$1, {
        position: "right",
        onClick: this.increment,
        onFocus: function onFocus() {
          return _this2.setFocus(true);
        },
        onBlur: function onBlur() {
          return _this2.setFocus(false);
        },
        size: size,
        disabled: this.isIncrementDisabled || disabled
      }, React.createElement(Text, {
        bold: true,
        size: size
      }, "+"))));
    }
  }, {
    key: "isIncrementDisabled",
    get: function get() {
      var _this$props4 = this.props,
          field = _this$props4.field,
          max = _this$props4.max,
          step = _this$props4.step;
      var value = field.value;
      return max !== undefined && value + step > max;
    }
  }, {
    key: "isDecrementDisabled",
    get: function get() {
      var _this$props5 = this.props,
          field = _this$props5.field,
          min = _this$props5.min,
          step = _this$props5.step;
      var value = field.value;
      return min !== undefined && value - step < min;
    }
  }]);

  return QuantityPicker;
}(Component);

QuantityPicker.defaultProps = {
  mandatory: false,
  size: 'm',
  label: undefined,
  labelPosition: 'top',
  labelWidth: 30,
  labelOffsetTop: null,
  disabled: false,
  max: undefined,
  min: undefined,
  step: 1
};
QuantityPicker.propTypes = {
  /** Formik form prop */
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    setFieldTouched: PropTypes.func,
    setFieldValue: PropTypes.func
  }).isRequired,

  /** Formik field prop */
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.number,
    onBlur: PropTypes.func.isRequired
  }).isRequired,

  /** Label of the field */
  label: PropTypes.node,

  /** Id of the input */
  id: PropTypes.string.isRequired,

  /** Boolean indicating if the field is mandatory */
  mandatory: PropTypes.bool,

  /** String indicating the size of the input */
  size: PropTypes.oneOf(['m', 'l']),

  /** String indicating the position of the label */
  labelPosition: PropTypes.oneOf(['top', 'left']),

  /** Number indicating the width of label (percentage) */
  labelWidth: PropTypes.number,

  /* Number indicating the top offset to apply for the label */
  labelOffsetTop: PropTypes.number,

  /** Boolean indicating if the input is disabled */
  disabled: PropTypes.bool,

  /** Number indicating maximum value */
  max: PropTypes.number,

  /** Number indicating minimum value */
  min: PropTypes.number,

  /** Number indicating step value */
  step: PropTypes.number
};

function _typeof$n(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$n = function _typeof(obj) { return typeof obj; }; } else { _typeof$n = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$n(obj); }

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

function _objectWithoutProperties$n(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$n(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$n(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$p(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$n(self, call) { if (call && (_typeof$n(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$n(self); }

function _getPrototypeOf$n(o) { _getPrototypeOf$n = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$n(o); }

function _assertThisInitialized$n(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties$p(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$p(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$p(Constructor.prototype, protoProps); if (staticProps) _defineProperties$p(Constructor, staticProps); return Constructor; }

function _inherits$n(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$n(subClass, superClass); }

function _setPrototypeOf$n(o, p) { _setPrototypeOf$n = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$n(o, p); }

function _templateObject4$l() {
  var data = _taggedTemplateLiteral$14(["\n  position: fixed;\n  top: 0rem;\n  right: 0rem;\n  bottom: 0rem;\n  left: 0rem;\n"]);

  _templateObject4$l = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$n() {
  var data = _taggedTemplateLiteral$14(["\n  position: absolute;\n  top: ", ";\n  z-index: 2;\n"]);

  _templateObject3$n = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$w() {
  var data = _taggedTemplateLiteral$14(["\n  width: ", ";\n  height: ", ";\n  border-radius: 0.1rem;\n  background: ", ";\n"]);

  _templateObject2$w = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$14() {
  var data = _taggedTemplateLiteral$14(["\n  height: ", ";\n  width: ", ";\n  padding: 0.3rem;\n  background: #fff;\n  border-radius: 0.1rem;\n  box-shadow: 0 0 0 1px rgba(0,0,0,.1);\n  display: inline-block;\n  cursor: pointer;\n  background-color: ", "\n"]);

  _templateObject$14 = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral$14(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var MyButton$1 = styled('div')(_templateObject$14(), function (props) {
  var heightV;

  switch (props.size) {
    case 'l':
      heightV = heightL$1;
      break;

    case 'xl':
      heightV = heightXL;
      break;

    case 'm':
    default:
      heightV = height;
      break;
  }

  return "".concat(heightV, "rem");
}, function (props) {
  var heightV;

  switch (props.size) {
    case 'l':
      heightV = heightL$1;
      break;

    case 'xl':
      heightV = heightXL;
      break;

    case 'm':
    default:
      heightV = height;
      break;
  }

  return "".concat(heightV, "rem");
}, function (props) {
  return props.disabled ? grey6 : undefined;
});
var Color$2 = styled('div')(_templateObject2$w(), function (props) {
  var heightV;

  switch (props.size) {
    case 'xl':
      heightV = heightXL;
      break;

    case 'l':
      heightV = heightL$1;
      break;

    case 'm':
    default:
      heightV = height;
      break;
  }

  return "".concat(heightV, "rem");
}, function (props) {
  var heightV;

  switch (props.size) {
    case 'xl':
      heightV = heightXL;
      break;

    case 'l':
      heightV = heightL$1;
      break;

    case 'm':
    default:
      heightV = height;
      break;
  }

  return "".concat(heightV, "rem");
}, function (props) {
  return props.color;
});
var PopOver$1 = styled('div')(_templateObject3$n(), function (props) {
  var heightV;

  switch (props.size) {
    case 'xl':
      heightV = heightXL * 1.3;
      break;

    case 'l':
      heightV = heightL$1 * 1.4;
      break;

    case 'm':
    default:
      heightV = height * 1.5;
      break;
  }

  return "".concat(heightV, "rem");
});
var Cover$1 = styled('div')(_templateObject4$l());

var FormikColorPicker =
/*#__PURE__*/
function (_Component) {
  _inherits$n(FormikColorPicker, _Component);

  _createClass$p(FormikColorPicker, null, [{
    key: "checkColorFormat",
    value: function checkColorFormat(color) {
      if (typeof color === 'string') {
        return /^#([A-F0-9]{6}|[A-F0-9]{3})$/.exec(color.toUpperCase());
      }

      return false;
    }
  }]);

  function FormikColorPicker(props) {
    var _this;

    _classCallCheck$p(this, FormikColorPicker);

    _this = _possibleConstructorReturn$n(this, _getPrototypeOf$n(FormikColorPicker).call(this, props));
    var field = props.field;
    _this.state = {
      displayColorPicker: false,
      value: FormikColorPicker.checkColorFormat(field.value) ? field.value : props.defaultColor
    };
    _this.handleButtonClick = _this.handleButtonClick.bind(_assertThisInitialized$n(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized$n(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized$n(_this));
    return _this;
  }

  _createClass$p(FormikColorPicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var field = this.props.field;
      var value = field.value;

      if (prevProps.field !== field) {
        if (value && FormikColorPicker.checkColorFormat(value)) {
          this.setState({
            value: value
          });
        }
      }
    }
  }, {
    key: "handleButtonClick",
    value: function handleButtonClick() {
      var disabled = this.props.disabled;
      var displayColorPicker = this.state.displayColorPicker;

      if (!disabled) {
        this.setState({
          displayColorPicker: !displayColorPicker
        });
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        displayColorPicker: false
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(color) {
      var _this$props = this.props,
          form = _this$props.form,
          field = _this$props.field;
      var name = field.name;
      form.setFieldTouched(name, true);
      form.setFieldValue(name, color.hex);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          field = _this$props2.field,
          labelPosition = _this$props2.labelPosition,
          label = _this$props2.label,
          labelWidth = _this$props2.labelWidth,
          mandatory = _this$props2.mandatory,
          size = _this$props2.size,
          id = _this$props2.id,
          disabled = _this$props2.disabled,
          colors = _this$props2.colors,
          rest = _objectWithoutProperties$n(_this$props2, ["field", "labelPosition", "label", "labelWidth", "mandatory", "size", "id", "disabled", "colors"]);

      var _this$state = this.state,
          displayColorPicker = _this$state.displayColorPicker,
          value = _this$state.value;
      return React.createElement(Flex, _extends$i({}, rest, {
        flexDirection: "column"
      }), React.createElement(Label$2, {
        id: id,
        label: label,
        labelPosition: labelPosition,
        labelWidth: labelWidth,
        size: size,
        mandatory: mandatory
      }, React.createElement(MyButton$1, {
        onClick: this.handleButtonClick,
        size: size,
        disabled: disabled,
        id: "".concat(field.name, "-id-color")
      }, React.createElement(Color$2, {
        color: value,
        size: size
      })), displayColorPicker ? React.createElement(PopOver$1, {
        size: size
      }, React.createElement(Cover$1, {
        onClick: this.handleClose
      }), React.createElement(lib_2$1, {
        color: value,
        onChange: this.handleChange,
        colors: colors
      })) : null));
    }
  }]);

  return FormikColorPicker;
}(Component);

FormikColorPicker.defaultProps = {
  label: undefined,
  labelPosition: 'top',
  labelWidth: 30,
  disabled: false,
  mandatory: false,
  size: 'm',
  colors: [functionalRed, orange2, supportingGold, functionalYellow, supportingDarkerGold, supportingLighterGold, supportingLighterEmerald, supportingLighterBlue, supportingLavender, supportingLighterLavender, supportingLighterCandy, supportingCandy, supportingDarkerCandy, supportingDarkerLavender, supportingDarkerBlue, functionalBlue, supportingBlue, supportingEmerald, functionalGreen, supportingDarkerEmerald, grey3],
  defaultColor: orange2
};
FormikColorPicker.propTypes = {
  /** Formik form prop */
  form: PropTypes.shape({
    setFieldTouched: PropTypes.func,
    setFieldValue: PropTypes.func
  }).isRequired,

  /** Formik field prop */
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string
  }).isRequired,

  /** Label of the input */
  label: PropTypes.node,

  /** Id of the input */
  id: PropTypes.string.isRequired,

  /** String indicating the position of the label */
  labelPosition: PropTypes.oneOf(['top', 'left']),

  /** Number indicating the width of label (percentage) */
  labelWidth: PropTypes.number,

  /** Boolean indicating if the input is disabled */
  disabled: PropTypes.bool,

  /** Boolean indicating if the field is mandatory */
  mandatory: PropTypes.bool,

  /** String indicating the size of the input */
  size: PropTypes.oneOf(['m', 'l', 'xl']),

  /** Array of string color */
  colors: PropTypes.arrayOf(PropTypes.string),

  /** String, default color */
  defaultColor: PropTypes.string
};

export { Accordion, Button$1 as Button, ButtonModal, Calendar, CalendarCard, index as Card, Checkbox, ColorPicker, DatePicker, Dropdown, DropdownMenu, DropdownMenuButton, Flex, Input$3 as FormInput, Checkbox$1 as FormikCheckbox, FormikColorPicker, DateTimePicker as FormikDateTimePicker, Input$4 as FormikInput, QuantityPicker as FormikQuantityPicker, Radio$1 as FormikRadio, Select$1 as FormikSelect, Headline, Icon, Label$2 as Label, Button$3 as LinkButton, LinkListItem, Modal, NavLinkListItem, Overlay, QuantitySelector, Radio, Select, Switch, Text, TextInput, Textarea, TimePicker, Toast, ToastService$1 as ToastService, Tooltip, colors, hexToHSL };
